angular.module('config', [])

.constant('ENVIRONMENT', )

.constant('ENVIRONMENTS', {local:'local',platform:'platform',gravity:'gravity',staging:'staging','admin-staging':'staging',admin:'production',production:'production',ro:'production-ro','admin-ro':'production-ro','production-ro':'production-ro',ro2:'production-ro2','admin-ro2':'production-ro2','production-ro2':'production-ro2',rs:'production-rs','admin-rs':'production-rs','production-rs':'production-rs',rs2:'production-rs2','admin-rs2':'production-rs2','production-rs2':'production-rs2',de:'production-de','admin-de':'production-de','production-de':'production-de'})

.constant('MODULES', [{name:'seven-admin-walletmgmt',files:['app/walletMgmt/apph/apph-deposits.controller.js','app/walletMgmt/apph/apph-plugin-configuration.controller.js','app/walletMgmt/apph/apph-withdrawals.controller.js','app/walletMgmt/apph/apph.service.js','app/walletMgmt/bank-account-settings/bank-account-settings.controller.js','app/walletMgmt/bank-account-settings/bank-account-settings.service.js','app/walletMgmt/bank-accounts/bank-account-verification.controller.js','app/walletMgmt/bank-accounts/delete-bank-account-modal.controller.js','app/walletMgmt/bank-accounts/bank-accounts.controller.js','app/walletMgmt/bank-accounts/bank-accounts.service.js','app/walletMgmt/bankwire-configuration/bankwire-configuration.controller.js','app/walletMgmt/bankwireDeposits/bankwireDepositsCtrl.js','app/walletMgmt/bankwireWithdrawals/bankwireWithdrawalsCtrl.js','app/walletMgmt/cash-register-transfer-types/cash-register.service.js','app/walletMgmt/cash-register-transfer-types/cash-register-transfer-types.controller.js','app/walletMgmt/cash-register-shifts/cash-register-shifts.controller.js','app/walletMgmt/cash-register-shifts/cash-register-shifts.service.js','app/walletMgmt/cashRegisterLog/cashRegisterLogCtrl.js','app/walletMgmt/device-cash-deposit-configuration/device-cash-deposit-configuration.controller.js','app/walletMgmt/device-cash-deposits/device-cash-deposits.controller.js','app/walletMgmt/direct-deposit-configuration/direct-deposit-configuration.controller.js','app/walletMgmt/directDeposits/directDepositsCtrl.js','app/walletMgmt/fasthub/fasthub-configuration.controller.js','app/walletMgmt/fasthub/fasthub-transactions.controller.js','app/walletMgmt/ipay/ipay-configuration.controller.js','app/walletMgmt/ipay/ipay-transactions.controller.js','app/walletMgmt/mpesa/mpesa-configuration.controller.js','app/walletMgmt/mtn/mtn-configuration.controller.js','app/walletMgmt/nestpay-configuration/nestpay-configuration.controller.js','app/walletMgmt/nestpay-deposits/nestpay-deposits.controller.js','app/walletMgmt/paysafe/paysafe-configuration.controller.js','app/walletMgmt/paysafe/paysafe-transactions.controller.js','app/walletMgmt/payten/payten-configuration.controller.js','app/walletMgmt/payten/payten-transactions.controller.js','app/walletMgmt/player-balance-adjustment-configuration/player-balance-adjustment-configuration.controller.js','app/walletMgmt/player-balance-adjustment-transactions/bulk-payments/bulk-payment-transactions.controller.js','app/walletMgmt/player-balance-adjustment-transactions/bulk-payments/bulk-payments.controller.js','app/walletMgmt/player-balance-adjustment-transactions/bulk-payments/bulk-payments.service.js','app/walletMgmt/player-balance-adjustment-transactions/bulk-payments/new-bulk-payment.controller.js','app/walletMgmt/player-balance-adjustment-transactions/player-balance-adjustment-transactions.controller.js','app/walletMgmt/quickteller/quickteller-configuration.controller.js','app/walletMgmt/quickteller/quickteller-transactions.controller.js','app/walletMgmt/retail-withdrawal-configuration/retail-withdrawal-configuration.js','app/walletMgmt/retail-withdrawals/retail-withdrawals.controller.js','app/walletMgmt/seven-ipay/seven-ipay.controller.js','app/walletMgmt/seven-ipay/seven-ipay.service.js','app/walletMgmt/skrill-configuration/skrill-configuration.controller.js','app/walletMgmt/skrillDeposits/skrillDepositsCtrl.js','app/walletMgmt/skrillWithdrawals/skrillWithdrawalsCtrl.js','app/walletMgmt/voucher-configuration/voucher-configuration.controller.js','app/walletMgmt/vouchers/vouchersCtrl.js','app/walletMgmt/wallet-audit.service.js','app/walletMgmt/walletMgmtCtrl.js','app/walletMgmt/walletMgmtSvc.js','app/walletMgmt/walletPlugins/walletPluginsCtrl.js','app/walletMgmt/webpay/webpay-configuration.controller.js','app/walletMgmt/webpay/webpay-deposits.controller.js','app/walletMgmt/withdrawalRequests/withdrawalRequestsCtrl.js']},{name:'seven-admin-usersettings',files:['app/userSettings/company/companySettingsCtrl.js','app/userSettings/profile/profileCtrl.js','app/userSettings/userSettingsSvc.js']},{name:'seven-admin-usermgmt',files:['app/userMgmt/administrator-groups/administrator-groups.controller.js','app/userMgmt/administrator-groups/default-administrator-groups.controller.js','app/userMgmt/administrator-groups/edit-administrator-group.controller.js','app/userMgmt/administrator-groups/new-administrator-group.controller.js','app/userMgmt/administrators/adminListCtrl.js','app/userMgmt/administrators/administrators.controller.js','app/userMgmt/administrators/edit-administrator.controller.js','app/userMgmt/administrators/new-administrator.controller.js','app/userMgmt/operator-groups/default-operator-groups.controller.js','app/userMgmt/operator-groups/edit-operator-group.controller.js','app/userMgmt/operator-groups/new-operator-group.controller.js','app/userMgmt/operator-groups/operator-groups.controller.js','app/userMgmt/operators/edit-operator.controller.js','app/userMgmt/operators/new-operator.controller.js','app/userMgmt/operators/operatorConfigCtrl.js','app/userMgmt/operators/operatorConfigNgs.js','app/userMgmt/operators/operators.controller.js','app/userMgmt/provider/ngs/ngsProductInstancesSvc.js','app/userMgmt/user-audit.service.js','app/userMgmt/user-roles.service.js','app/userMgmt/userMgmtCtrl.js','app/userMgmt/usersSvc.js']},{name:'seven-admin.tools',files:['app/tools/maintenance/maintenance.controller.js','app/tools/maintenance/maintenance.message.controller.js','app/tools/maintenance/maintenance.schedule.controller.js','app/tools/maintenance/maintenance.service.js','app/tools/notifications/new-notification.controller.js','app/tools/notifications/notifications.controller.js','app/tools/support/support.controller.js','app/tools/tags/tags.controller.js','app/tools/tools.controller.js','app/tools/tools.service.js']},{name:'seven-admin.audit',files:['app/audit/audit.controller.js']},{name:'seven-admin-shopmgmt',files:['app/shopMgmt/betshop-limits/betshop-limits.controller.js','app/shopMgmt/betshop-strategies.service.js','app/shopMgmt/betshopSvc.js','app/shopMgmt/betshops/betshopConfigCtrl.js','app/shopMgmt/betshops/betshopConfigNgsCtrl.js','app/shopMgmt/provider/ngs/ngsSvc.js','app/shopMgmt/betshops/betshopDetailsCtrl.js','app/shopMgmt/betshops/betshopListCtrl.js','app/shopMgmt/betshops/betshopNewCtrl.js','app/shopMgmt/betshops/deviceConfig/deviceConfigCtrl.js','app/shopMgmt/bih-rs-tax/bih-rs-tax-identifiers.controller.js','app/shopMgmt/bih-rs-tax/bih-rs-tax-identifiers-details.controller.js','app/shopMgmt/bih-tax/bih-tax-identifiers.contorller.js','app/shopMgmt/bih-tax/bih-tax-location-identifier.controller.js','app/shopMgmt/groups/betshopGroupConfig.js','app/shopMgmt/groups/betshopGroupConfigNgs.js','app/shopMgmt/groups/betshopGroupDetailsCtrl.js','app/shopMgmt/groups/betshopGroupsListCtrl.js','app/shopMgmt/groups/betshopGroupsNewCtrl.js','app/shopMgmt/mne-tax/mne-tax-devices.controller.js','app/shopMgmt/payment-restrictions/payment-restriction.service.js','app/shopMgmt/payment-restrictions/payment-restrictions.controller.js','app/shopMgmt/shopMgmtCtrl.js','app/shopMgmt/terminals/terminalDetailsCtrl.js','app/shopMgmt/terminals/terminalsListCtrl.js','app/shopMgmt/ticket-security/ticket-security.controller.js','app/shopMgmt/ticket-security/aml.controller.js','app/shopMgmt/ticket-security/aml.service.js','app/shopMgmt/serbian-tax/serbian-tax-identifiers.controller.js','app/shopMgmt/serbian-tax/serbian-tax-identifiers-details.controller.js','app/shopMgmt/device-overview/device-overview.controller.js','app/shopMgmt/provinces/provinces.controller.js','app/shopMgmt/provinces/provinces.service.js','app/shopMgmt/betshop-licences/betshop-licences.controller.js','app/shopMgmt/betshop-licences/betshop-licences.service.js','app/shopMgmt/merkur-ssbt-integration/create-merkur-ssbt.controller.js','app/shopMgmt/merkur-ssbt-integration/edit-merkur-ssbt.controller.js','app/shopMgmt/merkur-ssbt-integration/merkur-ssbt.service.js','app/shopMgmt/merkur-ssbt-integration/merkur-ssbts.controller.js','app/shopMgmt/merkur-ssbt-integration/auto-logout-merkur-ssbts.controller.js','app/shopMgmt/mne-v2-tax/mne-v2-tax-identifiers.controller.js','app/shopMgmt/mne-v2-tax/mne-v2-tax-identifiers-details.controller.js']},{name:'seven-admin-settings',files:['app/settings/accessControlSettings/emailRestriction/email-restriction-form.component.js','app/settings/accessControlSettings/emailRestriction/email-restriction.service.js','app/settings/accessControlSettings/accessControlSettingsCtrl.js','app/settings/application-settings/application-settings.controller.js','app/settings/platformSettings/generalPlatformSettings/generalPlatformSettingsCtrl.js','app/settings/platformSettings/ticket-pin-settings/ticket-pin-settings.controller.js','app/settings/platformSettings/workingTimeSettings/platform-working-time-settings.controller.js','app/settings/settingsCtrl.js','app/settings/settingsSvc.js']},{name:'seven-admin-reports',files:['app/reports/betshopGroupReport/betshopGroupReportController.js','app/reports/bih-monthly-tax-report/bih-monthly-tax-export.controller.js','app/reports/bih-monthly-tax-report/bih-monthly-tax-report.controller.js','app/reports/casinoReport/casinoReportController.js','app/reports/clientReport/clientReportController.js','app/reports/location-balance-report/location-balance-report.controller.js','app/reports/location-cash-balance-report/location-cash-balance-report.controller.js','app/reports/location-cash-report/location-cash-report.controller.js','app/reports/location-report/location-report.controller.js','app/reports/mkd-locations-tax-report/mkd-general-tax-report.contorller.js','app/reports/mkd-locations-tax-report/mkd-location-tax-report.controller.js','app/reports/mkd-locations-tax-report/mkd-locations-tax-report.controller.js','app/reports/operatorReport/operator-report.controller.js','app/reports/playerReport/playerReportController.js','app/reports/productReport/product-report.controller.js','app/reports/promotions-expenses-report/promotions-expenses-report.controller.js','app/reports/reportingSvc.js','app/reports/reportsCtrl.js','app/reports/serbian-tax-device-report/serbian-tax-device-report.controller.js','app/reports/shiftReport/shiftReportCtrl.js','app/reports/sportsbookReports/sportsbook-report-tickets/sportstbook-report-tickets.controller.js','app/reports/sportsbookReports/sportsbookReportsController.js','app/reports/terminalCashBalanceReport/terminalCashBalanceReport.js','app/reports/belgium-tax/belgium-tax-ticket-report.controller.js']},{name:'seven-admin.promotions',files:['app/promotions/bonuses/bonus-creator.controller.js','app/promotions/bonuses/bonus-list.controller.js','app/promotions/bonuses/bonus.service.js','app/promotions/bonuses/details/bonus-details.controller.js','app/promotions/bonuses/edit/bonus-edit.controller.js','app/promotions/bonuses/edit/bonus-configuration.controller.js','app/promotions/loyalty/competition/loyalty-competition.controller.js','app/promotions/loyalty/competition/new-loyalty-competition.contorller.js','app/promotions/loyalty/loyalty.controller.js','app/promotions/loyalty/loyalty.service.js','app/promotions/promotions.controller.js']},{name:'seven-admin-productstore',files:['app/productStore/productStoreCtrl.js','app/productStore/productStoreSvc.js','app/productStore/products/productStoreListCtrl.js']},{name:'seven-admin-playermgmt',files:['app/playerMgmt/player-cnp/player-cnp.controller.js','app/playerMgmt/player-pol-tax-payouts/payouts.controller.js','app/playerMgmt/player-rom-tax-high-payout-winnings/rom-tax-high-payout-winnings.controller.js','app/playerMgmt/player-rom-tax-payouts/rom-tax-payouts.controller.js','app/playerMgmt/playerDetails/delete-identity-document-modal.controller.js','app/playerMgmt/playerDetails/delete-player-limit.controller.js','app/playerMgmt/playerDetails/edit-product-limit.controller.js','app/playerMgmt/playerDetails/playerDetailsController.js','app/playerMgmt/playerMgmtController.js','app/playerMgmt/playerService.js','app/playerMgmt/playerVerificationQueue/playerVerificationQueueController.js','app/playerMgmt/players/playerListController.js','app/playerMgmt/zamba-login-cards/zamba-login-cards.controller.js','app/playerMgmt/zamba-login-cards/zamba-login-cards.service.js','app/playerMgmt/balkan-klub/balkan-klub.controller.js','app/playerMgmt/blinking-player-verification/blinking-player-verification.controller.js']},{name:'seven-admin.operations',files:['app/operations/operations.controller.js','app/operations/operations.service.js','app/operations/ticket-resolve/list/resolve-list.controller.js','app/operations/ticket-resolve/resolve/resolve-action.controller.js','app/operations/ticket-resolve/payout-check/payout-check.controller.js','app/operations/ticket-resolve/ticket-resolve.controller.js','app/operations/ticket-resolve/ticket-resolve.service.js','app/operations/translations/translations.controller.js']},{name:'seven-admin-dashboard',files:['app/dashboard/empty-modules.controller.js']},{name:'seven-admin-crm',files:['app/crm/activationQueue/productActivationConfig.js','app/crm/activationQueue/productActivationCtrl.js','app/crm/companies/compaines-list.controller.js','app/crm/companies/edit-company-betshop-strategy.controller.js','app/crm/companies/edit-company.controller.js','app/crm/companies/new-company.controller.js','app/crm/crmCtrl.js','app/crm/crmSvc.js','app/crm/productAccounts/productAccountConfigCtrl.js','app/crm/productAccounts/productAccountListCtrl.js','app/crm/players/players.controller.js','app/crm/players/players.service.js']},{name:'seven-admin.auth',files:['app/auth/auth.service.js','app/auth/device-install/device-install.controller.js','app/auth/forbidden-page/forbidden-page.controller.js','app/auth/forbidden-page/login-company-switch.controller.js','app/auth/forgot-password/forgot-pass.controller.js','app/auth/logout/logout.controller.js','app/auth/reset-password/reset-pass.controller.js','app/auth/token-auth/token-auth.service.js','app/auth/user-login/login.controller.js','app/auth/verify-email/verify-account.controller.js','app/auth/verify-email/verify-email.directive.js']},{name:'login.controller',files:['app/auth/user-login/login.controller.js']},{name:'seven-admin-productmgmt',files:['app/products/product-config.factory.js','app/products/productMgmtCtrl.js','app/products/productMgmtSvc.js','app/products/products/productsCtrl.js','app/products/products/sportsbook-service.js','app/products/products/ngs-service.js','app/products/products/ticketListService.js']},{name:'seven-admin-inspired-productmgmt',files:['app/products/products/inspired/bets/bet-list-controller.js','app/products/products/inspired/bets/betDetailsCtrl.js','app/products/products/inspired/events/event-list-controller.js','app/products/products/inspired/inspired-product-mgmt-svc.js','app/products/products/inspired/outcomes/outcome-list-controller.js','app/products/products/inspired/outcomes/outcomeDetailsCtrl.js','app/products/products/inspired/tickets/ticket-list-controller.js']},{name:'seven-admin-ngs-productmgmt',files:['app/products/products/ngs/config/product-details-controller.js','app/products/products/ngs/events/event-list-controller.js','app/products/products/ngs/events-schedule/events-schedule-controller.js','app/products/products/ngs/jackpots/jackpot-list-controller.js','app/products/products/ngs/ngs-product-mgmt-svc.js','app/products/products/ngs/tickets/ticket-list-controller.js','app/products/products/ngs/bonuses/bonuses-list-controller.js']},{name:'seven-admin-poolbet',files:['app/products/products/poolbet/competitions/poolbet-competition-detail.controller.js','app/products/products/poolbet/competitions/poolbet-competition.controller.js','app/products/products/poolbet/competitions/poolbet-competition.service.js','app/products/products/poolbet/competitions/poolbet-competitions.controller.js','app/products/products/poolbet/reporting/poolbet-reporting.controller.js','app/products/products/poolbet/reporting/poolbet-reporting.service.js','app/products/products/poolbet/settings/poolbet-product-settings.controller.js','app/products/products/poolbet/settings/poolbet-setting.service.js']},{name:'seven-admin-quickbet-productmgmt',files:['app/products/products/quickbet/operations/competitions/quickbet-ticket-list.controller.js','app/products/products/quickbet/quickbet-product-mgmt.service.js','app/products/products/quickbet/settings/quickbet-product-settings.controller.js']},{name:'seven-admin-sportbook-productmgmt',files:['app/products/products/sportbook/common/common-service.js','app/products/products/sportbook/common/icons-service.js','app/products/products/sportbook/common/tournament-flags.js','app/products/products/sportbook/common/multi-select-directive.js','app/products/products/sportbook/common/multi-level-select-directive.js','app/products/products/sportbook/common/notifications.js','app/products/products/sportbook/common/numbers-only-directive.js','app/products/products/sportbook/common/socket.service.js','app/products/products/sportbook/common/socket.gateway-service.js','app/products/products/sportbook/common/sports-audit.service.js','app/products/products/sportbook/operations/bet-classes/bet-class-factory.js','app/products/products/sportbook/operations/bet-classes/edit/bet-class-edit-controller.js','app/products/products/sportbook/operations/bet-classes/grid/bet-class-controller.js','app/products/products/sportbook/operations/bet-classes/new/bet-class-new-controller.js','app/products/products/sportbook/operations/custom-selection/custom-selection-factory.js','app/products/products/sportbook/operations/custom-selection/edit/custom-selection-edit-controller.js','app/products/products/sportbook/operations/custom-selection/grid/custom-selection-controller.js','app/products/products/sportbook/operations/match-selection/match-selection-controller.js','app/products/products/sportbook/operations/match-selection-new/match-selection-controller.js','app/products/products/sportbook/operations/match-selection/selection-chart-service.js','app/products/products/sportbook/operations/match-selection-new/selection-chart-service.js','app/products/products/sportbook/operations/match-selection/selection-grid-service.js','app/products/products/sportbook/operations/matches/matches-list-controller.js','app/products/products/sportbook/operations/react-prematch-offer/prematch-offer-controller.js','app/products/products/sportbook/operations/react-prematch-offer/prematch-offer-factory.js','app/products/products/sportbook/operations/stream-matches/stream-matches-list-controller.js','app/products/products/sportbook/operations/tickets/ticket-list-controller.js','app/products/products/sportbook/operations/visualization-links/visualization-links.js','app/products/products/sportbook/operations/visualization-layout/visualization-layout.js','app/products/products/sportbook/operations/cashout/cashout-controller.js','app/products/products/sportbook/settings/bet-groups/betGroupNewCtrl.js','app/products/products/sportbook/settings/bet-groups/betGroupsDetailsCtrl.js','app/products/products/sportbook/settings/bet-groups/betGroupsListCtrl.js','app/products/products/sportbook/settings/bets/betDetailsCtrl.js','app/products/products/sportbook/settings/bets/betListCtrl.js','app/products/products/sportbook/settings/categories/categoryDetailsCtrl.js','app/products/products/sportbook/settings/categories/categoryListCtrl.js','app/products/products/sportbook/settings/limits/limitNewCtrl.js','app/products/products/sportbook/settings/limits/limitsListCtrl.js','app/products/products/sportbook/settings/manual-resolve/manual-resolve-controller.js','app/products/products/sportbook/settings/outcomes/outcomeDetailsCtrl.js','app/products/products/sportbook/settings/outcomes/outcomeListCtrl.js','app/products/products/sportbook/settings/players/playersListCtrl.js','app/products/products/sportbook/settings/results/resultListCtrl.js','app/products/products/sportbook/settings/sportradar-groups/group-detail-controller.js','app/products/products/sportbook/settings/sportradar-groups/groups-list-controller.js','app/products/products/sportbook/settings/sports/sportDetailsCtrl.js','app/products/products/sportbook/settings/sports/sportListCtrl.js','app/products/products/sportbook/settings/teams/teamDetailsCtrl.js','app/products/products/sportbook/settings/teams/teamListCtrl.js','app/products/products/sportbook/settings/tournaments/tournament-details-controller.js','app/products/products/sportbook/settings/tournaments/tournament-list-controller.js','app/products/products/sportbook/sm-prematch/cashout-rules/cashout-rules.controller.js','app/products/products/sportbook/sm-prematch/cashout-rules/cashout-rules.service.js','app/products/products/sportbook/sm-prematch/cashout-rules/general-settings/general-settings.controller.js','app/products/products/sportbook/sm-prematch/cashout-rules/additional-settings/additional-settings.controller.js','app/products/products/sportbook/sm-prematch/cashout-rules/tickets/tickets.controller.js','app/products/products/sportbook/sm-prematch/cashout-rules/punters/punters.controller.js','app/products/products/sportbook/sm-prematch/categories/categories.controller.js','app/products/products/sportbook/sm-prematch/categories/categories.service.js','app/products/products/sportbook/sm-prematch/categories/components/details.component.js','app/products/products/sportbook/sm-prematch/categories/components/new.component.js','app/products/products/sportbook/sm-prematch/categories/components/popup/directives.js','app/products/products/sportbook/sm-prematch/categories/components/rules.component.js','app/products/products/sportbook/sm-prematch/categories/components/translations.component.js','app/products/products/sportbook/sm-prematch/custom-selection/custom-selection-controller.js','app/products/products/sportbook/sm-prematch/custom-selection/edit/custom-selection-edit-controller.js','app/products/products/sportbook/sm-prematch/custom-selection/edit/popup/statistics-config-directive.js','app/products/products/sportbook/sm-prematch/custom-selection/service.js','app/products/products/sportbook/sm-prematch/events/components/details.component.js','app/products/products/sportbook/sm-prematch/events/components/event.market.outcome.rules.js','app/products/products/sportbook/sm-prematch/events/components/event.rules.component.js','app/products/products/sportbook/sm-prematch/events/components/match-target.component.js','app/products/products/sportbook/sm-prematch/events/components/new.component.js','app/products/products/sportbook/sm-prematch/events/components/popup/directives.js','app/products/products/sportbook/sm-prematch/events/events.controller.js','app/products/products/sportbook/sm-prematch/events/events.service.js','app/products/products/sportbook/sm-prematch/events/model/event-market-model.js','app/products/products/sportbook/sm-prematch/events/model/events-model.js','app/products/products/sportbook/sm-prematch/events/model/tournaments-model.js','app/products/products/sportbook/sm-prematch/liability-monitoring/liability.controller.js','app/products/products/sportbook/sm-prematch/market-groups/components/directives.js','app/products/products/sportbook/sm-prematch/market-groups/components/market-group-edit.js','app/products/products/sportbook/sm-prematch/market-groups/components/market-group-new.js','app/products/products/sportbook/sm-prematch/market-groups/components/translations.controller.js','app/products/products/sportbook/sm-prematch/market-groups/market-groups.js','app/products/products/sportbook/sm-prematch/market-groups/market-groups.service.js','app/products/products/sportbook/sm-prematch/market-templates/components/market-template-edit.js','app/products/products/sportbook/sm-prematch/market-templates/components/market-template-new.js','app/products/products/sportbook/sm-prematch/market-templates/market-templates.controller.js','app/products/products/sportbook/sm-prematch/market-templates/market-templates.service.js','app/products/products/sportbook/sm-prematch/markets/components/details.component.js','app/products/products/sportbook/sm-prematch/markets/components/display-modes.js','app/products/products/sportbook/sm-prematch/markets/components/new.component.js','app/products/products/sportbook/sm-prematch/markets/components/outcomes.resolve.component.js','app/products/products/sportbook/sm-prematch/markets/components/popup/directives.js','app/products/products/sportbook/sm-prematch/markets/components/rules.component.js','app/products/products/sportbook/sm-prematch/markets/components/source.mapping.component.js','app/products/products/sportbook/sm-prematch/markets/components/translations.component.js','app/products/products/sportbook/sm-prematch/markets/markets.controller.js','app/products/products/sportbook/sm-prematch/markets/markets.service.js','app/products/products/sportbook/sm-prematch/odds-scheme/odds-scheme.controller.js','app/products/products/sportbook/sm-prematch/odds-scheme/scheme-assigns/sport-assign/controller.js','app/products/products/sportbook/sm-prematch/odds-scheme/scheme-assigns/tournament-assign/controller.js','app/products/products/sportbook/sm-prematch/odds-scheme/scheme-creator/components/edit.component.js','app/products/products/sportbook/sm-prematch/odds-scheme/scheme-creator/components/new.component.js','app/products/products/sportbook/sm-prematch/odds-scheme/scheme-creator/controller.js','app/products/products/sportbook/sm-prematch/odds-scheme/scheme-types/components/edit-market-mappings.component.js','app/products/products/sportbook/sm-prematch/odds-scheme/scheme-types/components/edit-scheme-ref-bets.component.js','app/products/products/sportbook/sm-prematch/odds-scheme/scheme-types/components/edit-scheme-type.component.js','app/products/products/sportbook/sm-prematch/odds-scheme/scheme-types/components/edit-special-value-mappings.component.js','app/products/products/sportbook/sm-prematch/odds-scheme/scheme-types/components/new-scheme-type.component.js','app/products/products/sportbook/sm-prematch/odds-scheme/scheme-types/components/popup/directives.js','app/products/products/sportbook/sm-prematch/odds-scheme/scheme-types/controller.js','app/products/products/sportbook/sm-prematch/odds-scheme/service.js','app/products/products/sportbook/sm-prematch/offer-templates/components/configuration.component.js','app/products/products/sportbook/sm-prematch/offer-templates/components/edit.component.js','app/products/products/sportbook/sm-prematch/offer-templates/components/new.component.js','app/products/products/sportbook/sm-prematch/offer-templates/components/popup/directives.js','app/products/products/sportbook/sm-prematch/offer-templates/offer-template-controller.js','app/products/products/sportbook/sm-prematch/offer-templates/service.js','app/products/products/sportbook/sm-prematch/outcomes/components/details-grid.component.js','app/products/products/sportbook/sm-prematch/outcomes/components/details.component.js','app/products/products/sportbook/sm-prematch/outcomes/components/new.component.js','app/products/products/sportbook/sm-prematch/outcomes/components/popup/directives.js','app/products/products/sportbook/sm-prematch/outcomes/components/source.mapping.component.js','app/products/products/sportbook/sm-prematch/outcomes/components/translations.component.js','app/products/products/sportbook/sm-prematch/outcomes/components/winning.correlations.component.js','app/products/products/sportbook/sm-prematch/outcomes/outcomes.controller.js','app/products/products/sportbook/sm-prematch/outcomes/outcomes.service.js','app/products/products/sportbook/sm-prematch/players/components/details.component.js','app/products/products/sportbook/sm-prematch/players/components/new.component.js','app/products/products/sportbook/sm-prematch/players/components/popup/directives.js','app/products/products/sportbook/sm-prematch/players/components/translations.controller.js','app/products/products/sportbook/sm-prematch/players/players.controller.js','app/products/products/sportbook/sm-prematch/players/players.service.js','app/products/products/sportbook/sm-prematch/reports/bet-type/bet-type-controller.js','app/products/products/sportbook/sm-prematch/reports/betshops/betshops-controller.js','app/products/products/sportbook/sm-prematch/reports/events/events-controller.js','app/products/products/sportbook/sm-prematch/reports/load-progression/load-progression-controller.js','app/products/products/sportbook/sm-prematch/reports/markets/markets-controller.js','app/products/products/sportbook/sm-prematch/reports/players/players-controller.js','app/products/products/sportbook/sm-prematch/reports/reports-controller.js','app/products/products/sportbook/sm-prematch/reports/reports.service.js','app/products/products/sportbook/sm-prematch/reports/sports/sports-controller.js','app/products/products/sportbook/sm-prematch/reports/tickets/tickets-controller.js','app/products/products/sportbook/sm-prematch/reports/tournament-market/tournament-market-controller.js','app/products/products/sportbook/sm-prematch/reports/tournaments/tournaments-controller.js','app/products/products/sportbook/sm-prematch/reports/cashout/cashout-controller.js','app/products/products/sportbook/sm-prematch/results/results.controller.js','app/products/products/sportbook/sm-prematch/results/results.service.js','app/products/products/sportbook/sm-prematch/results-settings/assignment/formula-assignment.controller.js','app/products/products/sportbook/sm-prematch/results-settings/components/popup/directive.js','app/products/products/sportbook/sm-prematch/results-settings/resolve-formula/resolve-formula.controller.js','app/products/products/sportbook/sm-prematch/results-settings/results.controller.js','app/products/products/sportbook/sm-prematch/results-settings/results.service.js','app/products/products/sportbook/sm-prematch/risk-management/betshops-assignment/betshops.controller.js','app/products/products/sportbook/sm-prematch/risk-management/categories-assignment/categories.controller.js','app/products/products/sportbook/sm-prematch/risk-management/markets-assignment/markets.controller.js','app/products/products/sportbook/sm-prematch/risk-management/punters-assignment/punters.controller.js','app/products/products/sportbook/sm-prematch/risk-management/risk-controller.js','app/products/products/sportbook/sm-prematch/risk-management/risk-settings/risk-settings.controller.js','app/products/products/sportbook/sm-prematch/risk-management/service.js','app/products/products/sportbook/sm-prematch/risk-management/sports-assignment/sports.controller.js','app/products/products/sportbook/sm-prematch/risk-management/tournaments-assignment/tournaments.controller.js','app/products/products/sportbook/sm-prematch/rules/market-selection-rules/controller.js','app/products/products/sportbook/sm-prematch/rules/market-selection-rules/game-pattern/directive.js','app/products/products/sportbook/sm-prematch/rules/market-selection-rules/game-pattern/service.js','app/products/products/sportbook/sm-prematch/rules/meta-rules/controller.js','app/products/products/sportbook/sm-prematch/rules/rules-groups/components/new.component.js','app/products/products/sportbook/sm-prematch/rules/rules-groups/components/popup/directives.js','app/products/products/sportbook/sm-prematch/rules/rules-groups/controller.js','app/products/products/sportbook/sm-prematch/rules/rules-types/controller.js','app/products/products/sportbook/sm-prematch/rules/rules.controller.js','app/products/products/sportbook/sm-prematch/rules/service.js','app/products/products/sportbook/sm-prematch/rules/tickets/new-ticket-rule-view.js','app/products/products/sportbook/sm-prematch/rules/tickets/directives.js','app/products/products/sportbook/sm-prematch/sports/components/details.component.js','app/products/products/sportbook/sm-prematch/sports/components/new.component.js','app/products/products/sportbook/sm-prematch/sports/components/popup/directives.js','app/products/products/sportbook/sm-prematch/sports/components/rules.component.js','app/products/products/sportbook/sm-prematch/sports/components/translations.component.js','app/products/products/sportbook/sm-prematch/sports/sports.controller.js','app/products/products/sportbook/sm-prematch/sports/sports.service.js','app/products/products/sportbook/sm-prematch/teams/components/details.component.js','app/products/products/sportbook/sm-prematch/teams/components/new.component.js','app/products/products/sportbook/sm-prematch/teams/components/popup/directives.js','app/products/products/sportbook/sm-prematch/teams/components/rules.component.js','app/products/products/sportbook/sm-prematch/teams/components/translations.common.js','app/products/products/sportbook/sm-prematch/teams/teams.controller.js','app/products/products/sportbook/sm-prematch/teams/teams.service.js','app/products/products/sportbook/sm-prematch/ticket-authorization/service.js','app/products/products/sportbook/sm-prematch/ticket-authorization/ticket-authorization.controller.js','app/products/products/sportbook/sm-prematch/tickets/tickets.controller.js','app/products/products/sportbook/sm-prematch/tickets/tickets.service.js','app/products/products/sportbook/sm-prematch/tickets-v2/tickets.controller.js','app/products/products/sportbook/sm-prematch/tickets-v2/tickets.service.js','app/products/products/sportbook/sm-prematch/tournaments/components/details.component.js','app/products/products/sportbook/sm-prematch/tournaments/components/new.component.js','app/products/products/sportbook/sm-prematch/tournaments/components/popup/directives.js','app/products/products/sportbook/sm-prematch/tournaments/components/rules.component.js','app/products/products/sportbook/sm-prematch/tournaments/components/tournament-groups/edit.group.component.js','app/products/products/sportbook/sm-prematch/tournaments/components/tournament-groups/group.translations.js','app/products/products/sportbook/sm-prematch/tournaments/components/tournament-groups/new.group.component.js','app/products/products/sportbook/sm-prematch/tournaments/components/tournament-groups/tournament.group.popup.js','app/products/products/sportbook/sm-prematch/tournaments/components/tournament-groups/tournament.groups.component.js','app/products/products/sportbook/sm-prematch/tournaments/components/translations.component.js','app/products/products/sportbook/sm-prematch/tournaments/tournaments.controller.js','app/products/products/sportbook/sm-prematch/tournaments/tournaments.service.js','app/products/products/sportbook/common/match-results/match-results.directive.js']},{name:'seven-admin-certifications',files:['app/certifications/certificationsCtrl.js','app/certifications/list/certificationListCtrl.js']}])

.constant('APP', {version:'1.140.18',build:'dd959de01'})

.value('ENV_CFG', {})

;;
/**
 * Main app module/container
 *
 * @module  npAdmin
 */
var app = angular.module('npAdmin', [
    'angulartics',
    'angulartics.google.analytics',
    'ui.router',
    'vs-repeat',
    'ngAnimate',
    'ui.bootstrap',
    'ui.bootstrap.datetimepicker',
    'ui.mask',
    'nabAuth',
    'seven-admin.shared',
    'react.grid.module',
    'app.controllers',
    'ngCookies',
    'ng-context-menu',
    'ngSanitize',
    'ui.select',
    'ui.select.seven-decorator',
    'pascalprecht.translate',
    'ngFileSaver',
    'ngFileUpload',
    'sun.scrollable',
    'ngclipboard',
    'tmh.dynamicLocale',
    'ngMessages',
    'config',
    'seven-admin.components',
    'seven-admin-usermgmt',
    'seven-admin-dashboard',
    'seven-admin-crm',
    'seven-admin-productstore',
    'seven-admin-reports',
    'seven-admin-productmgmt',
    'seven-admin-settings',
    'seven-admin-shopmgmt',
    'seven-admin-usersettings',
    'seven-admin-walletmgmt',
    'seven-admin-playermgmt',
    'seven-admin.promotions',
    'seven-admin-settings',
    'seven-admin.auth',
    'seven-admin.operations',
    'seven-admin.tools',
    'seven-admin.operations',
    'seven-admin-inspired-productmgmt',
    'seven-admin.zodiac',
    'seven-admin-certifications',
    'seven-admin.audit',
    'gravity.calendar',
    'oc.lazyLoad'
]);

app.config(['$httpProvider', '$locationProvider', '$ocLazyLoadProvider', '$qProvider', '$stateProvider', '$urlRouterProvider', 'NabAuthConfigProvider', 'NabAuthType', 'ENV_CFG', 'MODULES', '$translateProvider', 'tmhDynamicLocaleProvider', '$compileProvider', function (
    $httpProvider, $locationProvider, $ocLazyLoadProvider, $qProvider, $stateProvider, $urlRouterProvider, NabAuthConfigProvider, NabAuthType, ENV_CFG, MODULES, $translateProvider, tmhDynamicLocaleProvider, $compileProvider) {

    NabAuthConfigProvider.set({
        url: ENV_CFG.api.backend,
        type: NabAuthType.jwt_rt
    });

    tmhDynamicLocaleProvider.localeLocationPattern('./locale/{{locale}}.js?v=[RAND_VER]');

    if (!ENV_CFG.debugSet) {
        if (!ENV_CFG.enableConsoleLogWithDisabledDebug) {
            console = console || {};
            console.log = function(){};
        }
        $compileProvider.debugInfoEnabled(false);
    }

    $locationProvider.hashPrefix('');

    $ocLazyLoadProvider.config({
        debug: false,
        modules: _.map(MODULES, function(module) {
            return {
                name: module.name,
                files: module.files,
                serie: true
            }
        })
    });

    $qProvider.errorOnUnhandledRejections(false);

    $translateProvider.useLoader('translationSvc');
    $translateProvider.preferredLanguage('en');
    $translateProvider.useSanitizeValueStrategy(null);
    $translateProvider.forceAsyncReload(true);

    // Default route, done this way to prevent infinite digest loop
    $urlRouterProvider.otherwise( function($injector, $location) {
        var $state = $injector.get('$state');
        $state.go('login');
    });

    // Enable cross domain calls
    $httpProvider.defaults.useXDomain = true;

    // By default, in cross-site XMLHttpRequests browsers will not send credentials
    $httpProvider.defaults.withCredentials = true;

    // PATCH method for Angular doesn't have a default Content-Type header
    $httpProvider.defaults.headers.patch = {'Content-Type': 'application/json;charset=utf-8'};
    $httpProvider.defaults.headers.put = {'Content-Type': 'application/json;charset=utf-8'};

    // Remove the header used to identify ajax call that would prevent CORS from working
    delete $httpProvider.defaults.headers.common['X-Requested-With'];

    /**
     * Global $http error handling
     * allows to intercept/manipulate requests before they are sent to the server
     * and responses before they are processed in the application (login check in our case)
     */
    $httpProvider.interceptors.push(function ($q, $location, $rootScope) {

        return {
            request: function (request) {
                //request.url = request.url + '?v=' + new Date().getTime();
                if (localStorage.getItem('SevenAccessToken') !== null && !request.headers['Authorization']) {
                    request.headers['Authorization'] = 'Bearer ' + localStorage.getItem('SevenAccessToken');
                }

                return request;
            },

            response: function (response) {
                return response;
            },

            responseError: function (response) {
                var COMPANY_MISMATCH = 19000;
                var BAD_IP = 12025;

                if (response.status === 401 || response.status === 403) {
                    if ($location.path() === '/login' && response.status === 401) {
                        $rootScope.loginInfoMsg = response.data.message || 'Login failed, try again!';
                    } else if ( response.status === 401 && response.data.code && response.data.code === BAD_IP) {
                        $rootScope.loginInfoMsg = response.data.message;
                        $location.path('/forbidden');
                    } else if (response.status === 403 && response.data.code && response.data.code === COMPANY_MISMATCH) {
                        $rootScope.forbiddenError = response.data;
                        $location.path('/forbidden');
                    }
                }

                return $q.reject(response);
            }
        };
    });

    $httpProvider.interceptors.push(function () {
        var baseIAMUrl = ENV_CFG.api.iam;

        var isIAMUrl = function (url) {
            return url.toString().indexOf(baseIAMUrl) >= 0;
        };

        return {
            request: function (request) {
                if (isIAMUrl(request.url)) {
                    delete request.headers['SEVEN-LOCALE'];
                }

                return request;
            }
        }
    });

    $httpProvider.interceptors.push(function () {
        var baseGravityUrl = ENV_CFG.api.gravity;
        var baseSevenMuleUrl = ENV_CFG.api.sevenMule;

        var isGravityUrl = function (url) {
            return url.toString().indexOf(baseGravityUrl) >= 0;
        };

        var isSevenMuleUrl = function(url) {
            return baseSevenMuleUrl && url.toString().indexOf(baseSevenMuleUrl) >= 0;
        };

        return {
            request: function (request) {
                if (isGravityUrl(request.url)) {
                    request.headers['X-Nsft-SCD-DC'] = ENV_CFG.dc;
                }

                if (isSevenMuleUrl(request.url)) {
                    request.headers['X-Nsft-Seven-DC'] = ENV_CFG.dc;
                }

                return request;
            }
        }
    });

    $httpProvider.interceptors.push(function($injector) {
        return {
            response: function (response) {
                if (!response.config.auditData || !response.config.auditData.audit) {
                    return response;
                }

                var audit = $injector.get('auditSvc');
                audit.recordInterceptor(response);
                return response;
            },
        }

    });

    $httpProvider.interceptors.push(function requestCancelerInterceptor($q) {
        var requestCancelers = {};

        return {
            request: function (request) {
                var cancelerId = request.canceler;

                if (cancelerId && typeof cancelerId === 'string') {
                    var url = request.url;

                    if (requestCancelers[cancelerId]) {
                        requestCancelers[cancelerId].resolve({
                            canceled: true
                        });
                        requestCancelers[url] = null;
                    }

                    var requestCanceler = $q.defer();

                    requestCancelers[cancelerId] = requestCanceler;
                    request.timeout = requestCanceler.promise;
                }

                return request;
            },
            responseError: function (response) {
                var requestConfig = response.config;

                if (_.get(requestConfig, 'canceler') && _.get(requestConfig, 'timeout.$$state.value.canceled')) {
                    response.canceled = true;
                }

                return $q.reject(response);
            }
        }
    })
    
    $httpProvider.defaults.headers.delete = { "Content-Type": "application/json;charset=utf-8" };
}]).run(function (
    $rootScope,
    $state,
    $window,
    $filter,
    $location,
    $stateParams,
    $document,
    $templateCache,
    userInitData,
    userSvc,
    appSettingsSvc,
    gatewayService,
    tokenAuthService,
    GravityMenusService,
    GravitySettingsService,
    NabAuth,
    $http,
    tmhDynamicLocale,
    companyIdentitySvc,
    widgetService,
    auditSvc
) {
    if (userInitData) {
        GravityMenusService.setMenus(userInitData.menus);
        GravitySettingsService.setSettings(userInitData.settings.application);
        auditSvc.init();

        // send oauth login audit log
        if (localStorage.getItem('oAuthLoginAudit')) {
            auditSvc.record({
                url: appSettingsSvc.loginApi.oauth,
                method: 'GET',
                domain: 'Administrators',
                resourceType: 'UserLogin',
                resourceId: userInitData.user.id,
                resourceDisplayId: userInitData.user.email,
                context: {
                    username: userInitData.user.email
                },
                audit: true
            })
            localStorage.removeItem('oAuthLoginAudit');
        }
    }

    tokenAuthService.setTokenRefreshCheck();

    // if we have user data from bootstrap module we logged in
    var defaultTheme = 'blue_dark';

    $rootScope.pageTitle = '7Admin';

    if (userInitData) {
        widgetService.registerWidgetsFromAppSettings(userInitData.settings.application);
        NabAuth.setData(userInitData);
        tmhDynamicLocale.set(userInitData.user.language);
        $http.defaults.headers.common['SEVEN-LOCALE'] = userInitData.user.language;
        if (!userInitData.user.adminThemeColor) {
            userInitData.user.adminThemeColor = defaultTheme;
        }
        if (userInitData.user.language) {
            moment.locale(userInitData.user.language.split('-')[0]);
        }
        setUserTheme(userInitData.user.adminThemeColor);
        //setFullStory(userInitData.user);
        gatewayService.init();
    } else {
        setUserTheme(defaultTheme);
    }


    if (NabAuth.loggedIn && localStorage.getItem('firstLogin')) {
        var landingPage = localStorage.getItem('landingPage');

        if (landingPage && ['/login', '/device-install'].indexOf(landingPage) === -1 && landingPage.indexOf('verify-account') === -1) {
            $location.path(localStorage.getItem('landingPage'));
            localStorage.removeItem('firstLogin');
            localStorage.removeItem('landingPage');
            $rootScope.$apply();
        }
    }

    if (NabAuth.loggedIn && companyIdentitySvc.redirectPathExists()) {
        $location.url(companyIdentitySvc.getRedirectPath());
        companyIdentitySvc.removeRedirectPath();
    }

    if (userInitData.currentCompany) {
        $http.defaults.headers.common['X-NSFT-SEVEN-ACCOUNT-ID'] = userInitData.currentCompany.uuid;
    }

    $rootScope.filters = $location.search();

    $rootScope.$state = $state;
    $rootScope.$stateParams = $stateParams;

    $rootScope.globalClick = function (event) {
        $rootScope.$emit('globalClickEvt', {clickEvent: event});
    };

    function setUserTheme(theme) {
        $rootScope.userTheme = theme;
    }

    function setFullStory(user) {
        var body = document.body,
            fullStoryScript = document.createElement('script'),
            fullStoryUserScript = document.createElement('script');

        fullStoryScript.text =
            "window['_fs_debug'] = false;" +
            "window['_fs_host'] = 'www.fullstory.com';" +
            "window['_fs_org'] = '1XRM7';" +
            "window['_fs_namespace'] = 'FS';" +
            "(function(m,n,e,t,l,o,g,y){" +
            "if (e in m && m.console && m.console.log) { m.console.log('FullStory namespace conflict. Please set window[_fs_namespace].'); return;}" +
            "g=m[e]=function(a,b){g.q?g.q.push([a,b]):g._api(a,b);};g.q=[];" +
            "o=n.createElement(t);o.async=1;o.src='https://'+_fs_host+'/s/fs.js';" +
            "y=n.getElementsByTagName(t)[0];y.parentNode.insertBefore(o,y);" +
            "g.identify=function(i,v){g(l,{uid:i});if(v)g(l,v)};g.setUserVars=function(v){g(l,v)};" +
            "g.identifyAccount=function(i,v){o='account';v=v||{};v.acctId=i;g(o,v)};" +
            "g.clearUserCookie=function(c,d,i){if(!c || document.cookie.match('fs_uid=[`;`]*`[`;`]*`[`;`]*`')){" +
            "d=n.domain;while(1){n.cookie='fs_uid=;domain='+d+" +
            "';path=/;expires='+new Date(0);i=d.indexOf('.');if(i<0)break;d=d.slice(i+1)}}};" +
            "})(window,document,window['_fs_namespace'],'script','user');";

        fullStoryUserScript.text = "FS.identify('" + user.email+ "', {" +
            "displayName: '" + user.firstname + " " + user.lastname + "'," +
            "email: '" + user.email + "'" +
            "});";

        body.appendChild(fullStoryScript);
        body.appendChild(fullStoryUserScript);
    }

    $rootScope.$on('$stateChangeStart', function (event, toState, toParams, fromState) {
        $rootScope.productClass = null;

        // if no data skip everything below
        if (!toState.data) {
            return;
        }

        // In case of missing clientAppModules or empty array (User without any permissions) redirect to page containing message
        if (
            NabAuth.loggedIn &&
            (
                !userInitData.clientAppModules ||
                (
                    _.isArray(userInitData.clientAppModules) &&
                    _.isEmpty(userInitData.clientAppModules)
                )
            ) &&
            toState.name !== "dashboard"
        ) {
            event.preventDefault();
            $state.go("dashboard");
            return;
        }

        if (toState.name === 'forbidden') {
            NabAuth.isLoggedIn().then(function (response) {
                if (!response) {
                    $state.go('login');
                }
            })
        }

        if (localStorage.getItem('oAuthLogin') !== null) {
            $rootScope.loginInfoMsg = 'Login failed, try again!';
            localStorage.removeItem('oAuthLogin');
        }

        // if logged out and not going to public state redirect to login
        if (!NabAuth.loggedIn && ['login', 'oauth', 'forgot', 'resetting', 'reset', 'verifyAccount', 'deviceInstall', 'loginCompanySwitch'].indexOf(toState.name) === -1) {
            event.preventDefault();
            $state.go('login', {}, {reload: false});
            return;
        }

        // if logged in prevent going to public pages
        if (NabAuth.loggedIn && ['login', 'oauth', 'forgot', 'resetting', 'reset', 'verifyAccount', 'loginCompanySwitch'].indexOf(toState.name) !== -1) {
            event.preventDefault();
            var firstState = $filter('orderObjectBy')(appSettingsSvc.modules, 'priority');
            $state.go(firstState[0].state, {}, {reload: false});
        }

        // save current state for company mismatch
        if (NabAuth.loggedIn && toState.name === 'forbidden' && $rootScope.forbiddenError) {
            $rootScope.companyState = fromState.parentView;
        }

        if (toState.name === fromState.name && $state.current && $state.current.data && $state.current.data.forceReload) {
            event.preventDefault();
            delete $state.current.data.forceReload;
            $window.location.reload();
        }

        // redirectTo property of state is used in separate controller sub-tabs to redirect to default sub-tab
        if (!(toState.data && toState.data.forceReload) && toState.redirectTo) {
            event.preventDefault();
            $state.go(toState.redirectTo, toParams);
        }
    });

    $rootScope.$on('$stateChangeError', function (event, toState, toParams, fromState, fromParams, error) {
        if (error.code === 'COMPANY_PRODUCT_INSTANCE_MISMATCH') {
            console.warn(`State change error. ${error.message}. Redirecting to: ${toState.parentView}`);
            $state.go(toState.parentView);
        } else {
            console.warn('State change error', error)
        }
    })

    $rootScope.$on('$locationChangeSuccess', function (event) {
            // Used to reload page after company change, done in this way to prevent error 403 if we switch company when
            // we're on device in betshop and to reload in views whose parrentView prop isn't same as their state name
            if ($state.current && $state.current.data && $state.current.data.forceReload) {
                event.preventDefault();
                delete $state.current.data.forceReload;
                $window.location.reload();
            }
        });


}).config(function($provide) {
    $provide.decorator("$exceptionHandler", function ($log) {
        if (window.Sentry) {
            return function (exception) {
                $log.error(exception);
                Sentry.captureException(exception);
            };
        } else {
            return function (exception) {
                console.error(exception.stack);
            };
        }
    })
});

// bootstrap app module for get config before main app loads
var bootstrapModule = angular.module('bootstrapModule', ['config']);

// container of the bootstrap app
var bootstrapContainer = document.createElement('div');

bootstrapModule
    // the bootstrapper service loads the config and bootstraps the main app
    .factory('bootstrapper', function ($http, $q, $location, ENV_CFG, ENVIRONMENT, ENVIRONMENTS) {
        var checkEnvironment = function() {
            var queryEnv = $location.search()['environment'];
            if (queryEnv) return queryEnv;
            
            var host = $location.host();
            if (ENVIRONMENTS[host.split('.')[0]]) {
                return ENVIRONMENTS[host.split('.')[0]];
            }

            var storageEnv = localStorage.getItem('environment');
            if (storageEnv) return storageEnv;
            
            return false;
        };

        var getEnvironment = function() {
            var environment = checkEnvironment() || ENVIRONMENT;
            
            localStorage.setItem('environment', environment);
            
            var fileName = ENVIRONMENTS[environment];

            return $http.get('[DIST_PATH]env/' + fileName + '.json')
            .then(function (res) {
                return res.data;
            });
        };

        var getAdminSettings = function() {
            var appTemplateName = 'seven_admin';
            var url = ENV_CFG.api.gravity + '/app-templates/' + appTemplateName + '/settings';

            return $http.get(url).then(function(response) {
                return response.data.appTemplateSettings;
            });
        };

        var getAdminBootstrap = function(bootstrapUrl, headers) {
            return $http.get(bootstrapUrl, {
               withCredentials: true,
               headers: headers
           }).then(function(response) {
               return response.data;
           });
        };

        var parseUserSettings = function(rawSettings) {
            var userSettings = {};
            var adminKeyRegEx = /^admin\.(.*)$/;

            _.forEach(rawSettings, function(value, key) {
                var match = adminKeyRegEx.exec(key);

                if (match) {
                    userSettings[match[1]] = value;
                }
            });

            return userSettings;
        };

        var getUserSettings = function(headers) {
            var url = ENV_CFG.api.gravity + '/settings/users';

            return $http.get(url, {
                withCredentials: true,
                headers: headers
            }).then(function(response) {
                return parseUserSettings(response.data);
            });
        };

        var addApplicationSettingsToBootstrapData = function(bootstrapData, applicationSettings) {
            var companyUUID = _.get(bootstrapData, 'currentCompany.uuid');
            var currency = _.get(applicationSettings, 'currencyDisplayOverrides["' + companyUUID + '"]');

            bootstrapData.settings.application = applicationSettings;

            // Check if company has currency display override and add it to company data
            if (currency) {
                bootstrapData.settings.company.currencyDisplayValue =  currency;
            }
        };

        var addUserMomentDateFormatToBootstrapData = function(bootstrapData) {
            if (bootstrapData && bootstrapData.user && bootstrapData.user.dateFormat) {
                // Replace jquery-dateFormat tokens with moment tokens
                bootstrapData.user.momentDateFormat = bootstrapData.user.dateFormat.replace(/y/g, 'Y').replace(/d/g, 'D');
                bootstrapData.user.momentTimeFormat = bootstrapData.user.timeFormat24 ? 'HH:mm' : 'hh:mm a';
                bootstrapData.user.momentDateTimeFormat = bootstrapData.user.momentDateFormat + ' ' + bootstrapData.user.momentTimeFormat;
            }
        };

        var addAnalyticsTag = function (analyticsId) {
            $http.get('[DIST_PATH]plugins/ga.html')
                .then(function (pluginScript) {
                    if (pluginScript.data) {
                        angular.element('body').append(pluginScript.data.replace('${trackingID}', analyticsId));
                    }
                });
        };

        return {
            initializeErrorReporter: function(environmentConfiguration, applicationInfo) {
                const localHostCheckRegex = /.*:[0-9]*/g;
                const shouldEnableErrorReporter = !location.host.match(localHostCheckRegex);

                if (shouldEnableErrorReporter) {
                    Sentry.init({
                        dsn: 'https://f3adfeaf8dc14e33aeb8a82d3f0ea33e@o73276.ingest.sentry.io/159707',
                        integrations: [new Sentry.Integrations.Angular()],
                        release: `7Admin-v${applicationInfo.version} ${applicationInfo.build}`,
                        environment: environmentConfiguration.env,
                        ignoreErrors: ['Invalid state ref'],
                    });
                }
            },
            setEnvironmentVariables: function () {
                return getEnvironment().then(function(environments) {
                    if (environments) {
                        angular.module('bootstrapModule').constant('ENV_CFG', environments);
                        angular.module('npAdmin').constant('ENV_CFG', environments);
                        angular.extend(ENV_CFG, environments);
                    }
                });
            },
            bootstrap: function (appName) {
                var loginUrl = '',
                    mainApp = angular.module(appName),
                    refreshUserBootstrap = localStorage.getItem('refreshUserBootstrap'),
                    accessToken = '',
                    headers = {
                        'X-Nsft-SCD-Version': 2
                    };

                if (ENV_CFG.analytics) {
                    addAnalyticsTag(ENV_CFG.analytics);
                }

                if (ENV_CFG.api.gravity) { // check if there's a defined gravity API for the env
                    loginUrl = ENV_CFG.api.gravity + '/admin/bootstrap';

                    if (!ENV_CFG.bootstrapCacheEnabled || refreshUserBootstrap) {
                        headers['X-Nsft-SCD-No-Cache'] = 'true';
                        localStorage.removeItem('refreshUserBootstrap');
                    }
                } else {
                    loginUrl = ENV_CFG.api.backend + '/jwt/login_check';
                }

                if (ENV_CFG.dc) { // check if there should be explicit DC
                    headers['X-Nsft-SCD-DC'] = ENV_CFG.dc;
                }

                /**
                 * @namespace
                 * @property {object} user
                */
                mainApp.value('userInitData', '');

                if ($location.search()['Access-Token']) {
                    accessToken = 'Bearer ' + $location.search()['Access-Token'];
                    localStorage.setItem('SevenAccessToken', $location.search()['Access-Token']);
                    localStorage.setItem('SevenRefreshToken', $location.search()['Refresh-Token']);
                } else {
                    accessToken = 'Bearer ' + localStorage.getItem('SevenAccessToken');
                }

                headers['Authorization'] = accessToken;

                return $q.all({
                    bootstrap: getAdminBootstrap(loginUrl, headers),
                    appSettings: getAdminSettings()
                }).then(function(response) {
                    var bootstrapData = _.cloneDeep(response.bootstrap);

                    addApplicationSettingsToBootstrapData(bootstrapData, response.appSettings);
                    addUserMomentDateFormatToBootstrapData(bootstrapData);

                    // Add empty translations object to prevent errors in translationSvc,
                    // TODO: move this check to translationSvc
                    if (!bootstrapData.translations) {
                        bootstrapData.translations = {};
                    }

                    return getUserSettings(headers).then(function(userSettings) {
                        bootstrapData.settings.user = userSettings;
                        mainApp.value('userInitData', bootstrapData);
                        localStorage.removeItem('oAuthLogin');
                        // bootstrap the main app
                        angular.bootstrap(document, [appName]);
                    }).catch(function() {
                        mainApp.value('userInitData', bootstrapData);
                        localStorage.removeItem('oAuthLogin');
                        // bootstrap the main app
                        angular.bootstrap(document, [appName]);
                    })

                }).catch(function() {
                    if ($location.path() === "/forbidden") {
                        $location.path("/login");
                    } else if (!$location.path().match('\/forgot|\/reset|\/reseting|\/logout')) {
                        localStorage.setItem('landingPage', $location.path());
                    }

                    localStorage.removeItem('userDetails');
                    angular.bootstrap(document, [appName]);
                });
            }
        };
    })
    .config(['$locationProvider', function($locationProvider) {
        $locationProvider.hashPrefix('');
    }])
    // uses the bootstrapper service and shutdown the bootstrapping app after initialization of main app
    .run(function ($log, bootstrapper, ENV_CFG, APP) {
        bootstrapper.setEnvironmentVariables()
            .then(function () {
                bootstrapper.initializeErrorReporter(ENV_CFG, APP);
                bootstrapper.bootstrap('npAdmin')
                    .then(function () {
                        // removing the container will destroy the bootstrap app
                        bootstrapContainer.remove();
                    });
            })
            .catch(function (err) {
                $log.error(err);
            });
    });

// bootstrapModule is bootstrapped after DOM is loaded
angular.element(document).ready(function () {
    angular.bootstrap(bootstrapContainer, ['bootstrapModule']);
});
;
var sevenAdminCrm = angular.module('seven-admin-crm', [
    ]);

sevenAdminCrm.config(['$stateProvider', function ($stateProvider) {
    $stateProvider
        .state('crm', {
            url: '/crm',
            templateUrl: '/app/crm/crm.index.html',
            parent: 'main',
            controller: 'crmCtrl',
            resolve: {
                loadController: ['$ocLazyLoad', function($ocLazyLoad) {
                    return $ocLazyLoad.load('[DIST_PATH]js/seven-admin-crm.js')
                }]
            },
            data: {
                module: 'crm'
            }
        })
        .state('crm.crmCompanies', {
            url: '/companies',
            parentView: 'crm.crmCompanies',
            views: {
                '': {
                    templateUrl: '/app/crm/companies/company.index.html',
                    controller: 'CompaniesList'
                }
            },
            resolve: {
                loadController: ['$ocLazyLoad', function($ocLazyLoad) {
                    return $ocLazyLoad.load('[DIST_PATH]js/seven-admin-crm.js')
                }]
            },
            data: {
                subModule: 'crmCompanies'
            }
        })
        .state('crm.editCompany', {
            url: '/companies/:id',
            redirectTo: 'crm.editCompany.general',
            views: {
                '': {
                    template: '<div ui-view></div>'
                }
            },

        })
        .state('crm.editCompany.general', {
            url: '/general?tab',
            parentView: 'crm.crmCompanies',
            reloadOnSearch: false,
            views: {
                '': {
                    templateUrl: '/app/crm/companies/company.index.html',
                    controller: 'EditCompanyGeneralController'
                }
            },
            resolve: {
                loadController: ['$ocLazyLoad', function($ocLazyLoad) {
                    return $ocLazyLoad.load('[DIST_PATH]js/seven-admin-crm.js')
                }]
            }
        })
        .state('crm.editCompany.betshopStrategy', {
            url: '/betshop-strategy',
            parentView: 'crm.crmCompanies',
            views: {
                '': {
                    templateUrl: 'app/crm/companies/edit-company-betshop-strategy.template.html',
                    controller: 'EditCompanyBetshopStrategy',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                loadController: ['$ocLazyLoad', function($ocLazyLoad) {
                    return $ocLazyLoad.load([
                        '[DIST_PATH]js/seven-admin-shopmgmt.js',
                        '[DIST_PATH]js/seven-admin-crm.js'
                    ])
                }]
            }
        })
        .state('crm.addCompany', {
            url: '/add-new',
            parentView: 'crm.crmCompanies',
            views: {
                '': {
                    templateUrl: '/app/crm/companies/company.index.html',
                    controller: 'NewCompanyController'
                }
            },
            resolve: {
                loadController: ['$ocLazyLoad', function($ocLazyLoad) {
                    return $ocLazyLoad.load('[DIST_PATH]js/seven-admin-crm.js')
                }]
            },
            data: {
                subModule: 'crmCompanies'
            }
        })
                                    /****Activation queue*****/
                                    /*************************/
        .state('crm.productActivation', {
            url: '/product-activate-list',
            parentView: 'crm.productActivation',
            views: {
                '': {
                    templateUrl: '/app/crm/activationQueue/productActivation.index.html',
                    controller: 'productActivationCtrl'
                }
            },
            resolve: {
                loadController: ['$ocLazyLoad', function($ocLazyLoad) {
                    return $ocLazyLoad.load('[DIST_PATH]js/seven-admin-crm.js')
                }]
            },
            data: {
                subModule: 'productActivation'
            }
        })
        .state('crm.productActivationConfig', {
            url: '/product-config/:id',
            parentView: 'crm.productActivation',
            views: {
                '': {
                    templateUrl: '/app/crm/activationQueue/productActivation.index.html',
                    controller: 'productActivationConfigCtrl'
                }
            },
            resolve: {
                loadController: ['$ocLazyLoad', function($ocLazyLoad) {
                    return $ocLazyLoad.load('[DIST_PATH]js/seven-admin-crm.js')
                }]
            },
            data: {
                subModule: 'productActivationConfig'
            }
        })
        .state('crm.productAccounts', {
            url: '/product-accounts',
            parentView: 'crm.productAccounts',
            views: {
                '': {
                    templateUrl: '/app/crm/productAccounts/productAccounts.index.html',
                    controller: 'productAccountListCtrl'
                }
            },
            resolve: {
                loadController: ['$ocLazyLoad', function($ocLazyLoad) {
                    return $ocLazyLoad.load('[DIST_PATH]js/seven-admin-crm.js')
                }]
            },
            data: {
                subModule: 'productAccounts'
            }
        })
        .state('crm.productAccountConfig', {
            url: '/product-account-config/:id',
            parentView: 'crm.productAccounts',
            views: {
                '': {
                    templateUrl: '/app/crm/productAccounts/productAccounts.index.html',
                    controller: 'productAccountConfigCtrl'
                }
            },
            resolve: {
                loadController: ['$ocLazyLoad', function($ocLazyLoad) {
                    return $ocLazyLoad.load('[DIST_PATH]js/seven-admin-crm.js')
                }]
            }
        })
        .state('crm.players', {
            url: '/players',
            parentView: 'crm.players',
            views: {
                '': {
                    template:
                        '<react-grid data-view-name="{{vm.viewName}}"></react-grid>' +
                        '<info-message></info-message>',
                    controller: 'CRMPlayersController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                loadController: ['$ocLazyLoad', function($ocLazyLoad) {
                    return $ocLazyLoad.load('[DIST_PATH]js/seven-admin-crm.js')
                }]
            }
        });
}]);
;
var sevenAdminDashboard = angular.module('seven-admin-dashboard', []);

sevenAdminDashboard.config(['$stateProvider', function ($stateProvider) {
    $stateProvider
        .state('dashboard', {
            url: '/empty',
            templateUrl: '/app/dashboard/empty-modules.template.html',
            parent: 'main',
            parentView: 'dashboard',
            controller: 'EmptyModulesController',
            resolve: {
                loadController: ['$ocLazyLoad', function($ocLazyLoad) {
                    return $ocLazyLoad.load('[DIST_PATH]js/seven-admin-dashboard.js')
                }]
            },
            data: {
                module: 'dashboard'
            }
        });
}]);
;
var sevenAdminPlayerMgmt = angular.module('seven-admin-playermgmt', []);

sevenAdminPlayerMgmt.config(['$stateProvider', function ($stateProvider) {

    $stateProvider
        .state('playerMgmt', {
            url: '/player-mgmt',
            templateUrl: '/app/playerMgmt/playerMgmt.index.html',
            parent: 'main',
            controller: 'playerMgmtController',
            resolve: {
                loadController: ['$ocLazyLoad', function($ocLazyLoad) {
                    return $ocLazyLoad.load('[DIST_PATH]js/seven-admin-playermgmt.js')
                }]
            },
            data: {
                module: 'playerMgmt'
            }
        })
        .state('playerMgmt.players', {
            url: '/players',
            parentView: 'playerMgmt.players',
            views: {
                '': {
                    templateUrl: '/app/playerMgmt/players/playerList.index.html',
                    controller: 'playerListController'
                }
            },
            resolve: {
                loadController: ['$ocLazyLoad', function($ocLazyLoad) {
                    return $ocLazyLoad.load('[DIST_PATH]js/seven-admin-playermgmt.js')
                }]
            }
        })
        .state('playerMgmt.playerDetails', {
            url: '/players/:id',
            parentView: 'playerMgmt.players',
            views: {
                '': {
                    templateUrl: '/app/playerMgmt/playerDetails/playerDetails.html',
                    controller: 'playerDetailsController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                loadController: ['$ocLazyLoad', function($ocLazyLoad) {
                    return $ocLazyLoad.load([
                        '[DIST_PATH]js/seven-admin-playermgmt.js',
                        '[DIST_PATH]js/seven-admin-productmgmt.js',
                        '[DIST_PATH]js/seven-admin-walletmgmt.js',
                        '[DIST_PATH]js/seven-admin.tools.js'
                    ])
                }]
            },
            params: {
                tab: undefined
            }
        })
        .state('playerMgmt.playerVerificationQueue', {
            url: '/verification-queue',
            parentView: 'playerMgmt.playerVerificationQueue',
            views: {
                '': {
                    templateUrl: '/app/playerMgmt/playerVerificationQueue/playerVerificationQueue.index.html',
                    controller: 'playerVerificationQueueController'
                }
            },
            resolve: {
                loadController: ['$ocLazyLoad', function($ocLazyLoad) {
                    return $ocLazyLoad.load('[DIST_PATH]js/seven-admin-playermgmt.js')
                }]
            }
        })
        .state('playerMgmt.balkanKlub', {
            url: '/balkan-klub',
            parentView: 'playerMgmt.balkanKlub',
            views: {
                '': {
                    templateUrl: '/app/playerMgmt/balkan-klub/balkan-klub.index.html',
                    controller: 'balkanKlubController'
                }
            },
            resolve: {
                loadController: ['$ocLazyLoad', function($ocLazyLoad) {
                    return $ocLazyLoad.load('[DIST_PATH]js/seven-admin-playermgmt.js')
                }]
            }
        })
        .state('playerMgmt.cnpSystem', {
            url: '/cnp-system',
            parentView: 'playerMgmt.cnpSystem',
            views: {
                '': {
                    templateUrl: '/app/playerMgmt/player-cnp/player-cnp.html',
                    controller: 'playerCNPController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                loadController: ['$ocLazyLoad', function($ocLazyLoad) {
                    return $ocLazyLoad.load('[DIST_PATH]js/seven-admin-playermgmt.js')
                }]
            }
        })
        .state('playerMgmt.polTaxPayouts', {
            url: '/payouts?page&size&startDate&endDate',
            reloadOnSearch: false,
            parentView: 'playerMgmt.polTaxPayouts',
            views: {
                '': {
                    templateUrl: '/app/playerMgmt/player-pol-tax-payouts/payouts.template.html',
                    controller: 'PolTaxPayoutsController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                loadController: ['$ocLazyLoad', function($ocLazyLoad) {
                    return $ocLazyLoad.load('[DIST_PATH]js/seven-admin-playermgmt.js')
                }]
            },
            params: {
                page: '1',
                size: '25',
                startDate: moment.utc().startOf('d').add(-1, 'M').format('Y-MM-DD*HH:mm:ss'),
                endDate: moment.utc().endOf('d').format('Y-MM-DD*HH:mm:ss')
            }
        })
        .state('playerMgmt.romTaxPayouts', {
            url: '/rom-tax-payouts',
            reloadOnSearch: false,
            parentView: 'playerMgmt.romTaxPayouts',
            views: {
                '': {
                    template: '<view-templates></view-templates>',
                    controller: 'RomTaxPayoutsController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                loadController: ['$ocLazyLoad', function($ocLazyLoad) {
                    return $ocLazyLoad.load('[DIST_PATH]js/seven-admin-playermgmt.js')
                }]
            }
        })
        .state('playerMgmt.romTaxHighPayoutWinnings', {
            url: '/rom-tax-high-payout-winnings',
            reloadOnSearch: false,
            parentView: 'playerMgmt.romTaxHighPayoutWinnings',
            views: {
                '': {
                    template: '<view-templates></view-templates>',
                    controller: 'RomTaxHighPayoutWinningsController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                loadController: ['$ocLazyLoad', function($ocLazyLoad) {
                    return $ocLazyLoad.load('[DIST_PATH]js/seven-admin-playermgmt.js')
                }]
            }
        })
        .state('playerMgmt.zambaPlayerCards', {
            url: '/zamba-player-cards',
            reloadOnSearch: false,
            parentView: 'playerMgmt.zambaPlayerCards',
            views: {
                '': {
                    templateUrl: 'app/playerMgmt/zamba-login-cards/zamba-login-cards.template.html',
                    controller: 'ZambaLoginCardsCtrl',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                loadController: ['$ocLazyLoad', function($ocLazyLoad) {
                    return $ocLazyLoad.load('[DIST_PATH]js/seven-admin-playermgmt.js')
                }]
            }
        }).state('playerMgmt.blinkingPlayerVerification', {
            url: '/blinking-player-verification',
            parentView: 'playerMgmt.blinkingPlayerVerification',
            views: {
                '': {
                    templateUrl: '/app/playerMgmt/blinking-player-verification/blinking-player-verification.template.html',
                    controller: 'BlinkingPlayerVerificationController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                loadController: ['$ocLazyLoad', function($ocLazyLoad) {
                    return $ocLazyLoad.load('[DIST_PATH]js/seven-admin-playermgmt.js')
                }]
            }
        });
}]);
;
var sevenAdminProductMgmt = angular.module('seven-admin-productmgmt', [
    'seven-admin-ngs-productmgmt',
    'seven-admin-sportbook-productmgmt',
    'seven-admin-quickbet-productmgmt',
    'seven-admin-poolbet',
    'react.grid.module',
    'seven-admin-products-integration'
]);

sevenAdminProductMgmt.config(['$stateProvider', function ($stateProvider) {
    $stateProvider
        .state('productMgmt', {
            url: '/product-mgmt',
            templateUrl: '/app/products/productMgmt.index.html',
            parent: 'main',
            controller: 'productMgmtCtrl',
            resolve: {
                resolvedProductMgmtBundle: ['$ocLazyLoad', function($ocLazyLoad) {
                    return $ocLazyLoad.load('[DIST_PATH]js/seven-admin-productmgmt.js')
                }]
            },
            data: {
                module: 'productMgmt'
            }
        })
        .state('productMgmt.products', {
            url: '/products',
            parentView: 'productMgmt.products',
            views: {
                '': {
                    templateUrl: '/app/products/products/products.html',
                    controller: 'productsCtrl'
                }
            },
            resolve: {
                resolvedProductMgmtBundle: ['$ocLazyLoad', function($ocLazyLoad) {
                    return $ocLazyLoad.load('[DIST_PATH]js/seven-admin-productmgmt.js')
                }]
            }
        });
}]);
;
var sevenAdminInspiredProductmgmt = angular.module('seven-admin-inspired-productmgmt', []);

sevenAdminInspiredProductmgmt.config(['$stateProvider', function ($stateProvider) {
    $stateProvider
        .state('productMgmt.inspired', {
            url: '/inspired/products/:id/:mainProductState',
            parentView: '',
            views: {
                '': {
                    templateUrl: '/app/products/products/inspired/inspiredProductMgmt.html'
                }
            }
        })
        .state('productMgmt.inspired.tickets', {
            url: '/tickets',
            parentView: 'productMgmt.inspired.tickets',
            views: {
                '': {
                    templateUrl: '/app/products/products/inspired/tickets/ticket-list.html',
                    controller: 'inspiredTicketListCtrl'
                }
            },
            resolve: {
                loadController: ['$ocLazyLoad', function($ocLazyLoad) {
                    return $ocLazyLoad.load('[DIST_PATH]js/seven-admin-inspired-productmgmt.js')
                }]
            }
        })
        .state('productMgmt.inspired.events', {
            url: '/events',
            parentView: 'productMgmt.inspired.events',
            views: {
                '': {
                    templateUrl: '/app/products/products/inspired/events/event-list.html',
                    controller: 'inspiredEventListCtrl'
                }
            },
            resolve: {
                loadController: ['$ocLazyLoad', function($ocLazyLoad) {
                    return $ocLazyLoad.load('[DIST_PATH]js/seven-admin-inspired-productmgmt.js')
                }]
            }
        })
        .state('productMgmt.inspired.bets', {
            url: '/bets',
            parentView: 'productMgmt.inspired.bets',
            views: {
                '': {
                    templateUrl: '/app/products/products/inspired/bets/bet-list.html',
                    controller: 'inspiredBetListCtrl'
                }
            },
            resolve: {
                loadController: ['$ocLazyLoad', function($ocLazyLoad) {
                    return $ocLazyLoad.load('[DIST_PATH]js/seven-admin-inspired-productmgmt.js')
                }]
            }
        })
        .state('productMgmt.inspired.betsDetails', {
            url: '/bets/:detailId',
            parentView: 'productMgmt.inspired.bets',
            views: {
                '': {
                    templateUrl: '/app/products/products/inspired/inspired-view-template.html',
                    controller: 'inspiredBetDetailsCtrl'
                }
            },
            resolve: {
                loadController: ['$ocLazyLoad', function($ocLazyLoad) {
                    return $ocLazyLoad.load('[DIST_PATH]js/seven-admin-inspired-productmgmt.js')
                }]
            }
        })
        .state('productMgmt.inspired.outcomes', {
            url: '/outcomes',
            parentView: 'productMgmt.inspired.outcomes',
            views: {
                '': {
                    templateUrl: '/app/products/products/inspired/outcomes/outcome-list.html',
                    controller: 'inspiredOutcomeListCtrl'
                }
            },
            resolve: {
                loadController: ['$ocLazyLoad', function($ocLazyLoad) {
                    return $ocLazyLoad.load('[DIST_PATH]js/seven-admin-inspired-productmgmt.js')
                }]
            }
        })
        .state('productMgmt.inspired.outcomesDetails', {
            url: '/outcomes/:detailId',
            parentView: 'productMgmt.inspired.outcomes',
            views: {
                '': {
                    templateUrl: '/app/products/products/inspired/inspired-view-template.html',
                    controller: 'inspiredOutcomeDetailsCtrl'
                }
            },
            resolve: {
                loadController: ['$ocLazyLoad', function($ocLazyLoad) {
                    return $ocLazyLoad.load('[DIST_PATH]js/seven-admin-inspired-productmgmt.js')
                }]
            }
        })
        .state('productMgmt.inspired.configuration', {
            url: '/config/:cpvUuid',
            parentView: 'productMgmt.settings.configuration',
            views: {
                '': {
                    templateUrl: '/app/products/products/inspired/config/inspired-product-data-details.html',
                    controller: 'inspiredProductDetailsCtrl'
                }
            },
            resolve: {
                loadController: ['$ocLazyLoad', function($ocLazyLoad) {
                    return $ocLazyLoad.load('[DIST_PATH]js/seven-admin-inspired-productmgmt.js')
                }]
            }
        })
}]);








;
var sevenAdminNgsProductmgmt = angular.module('seven-admin-ngs-productmgmt', []);

sevenAdminNgsProductmgmt.config(['$stateProvider', function ($stateProvider) {

    $stateProvider
        .state('productMgmt.ngs', {
            url: '/ngs/products/:id/:mainProductState',
            parentView: 'productMgmt.products',
            views: {
                '': {
                    templateUrl: '/app/products/products/ngs/ngsProductMgmt.html'
                }
            },
            resolve: {
                loadController: ['$ocLazyLoad', function($ocLazyLoad) {
                    return $ocLazyLoad.load('[DIST_PATH]js/seven-admin-ngs-productmgmt.js')
                }]
            }
        })
        .state('productMgmt.ngs.tickets', {
            url: '/tickets',
            parentView: 'productMgmt.ngs.tickets',
            views: {
                '': {
                    templateUrl: '/app/products/products/ngs/tickets/ticket-list.html',
                    controller: 'ngsTicketListCtrl'
                }
            },
            resolve: {
                loadController: ['$ocLazyLoad', function($ocLazyLoad) {
                    return $ocLazyLoad.load('[DIST_PATH]js/seven-admin-ngs-productmgmt.js')
                }]
            }
        })
        .state('productMgmt.ngs.events', {
            url: '/events',
            parentView: 'productMgmt.ngs.events',
            views: {
                '': {
                    templateUrl: '/app/products/products/ngs/events/event-list.html',
                    controller: 'ngsEventListCtrl'
                }
            },
            resolve: {
                loadController: ['$ocLazyLoad', function($ocLazyLoad) {
                    return $ocLazyLoad.load('[DIST_PATH]js/seven-admin-ngs-productmgmt.js')
                }]
            }
        })
        .state('productMgmt.ngs.jackpots', {
            url: '/jackpots',
            parentView: 'productMgmt.ngs.jackpots',
            views: {
                '': {
                    templateUrl: '/app/products/products/ngs/jackpots/jackpots-list.html',
                    controller: 'ngsJackpotListCtrl'
                }
            },
            resolve: {
                loadController: ['$ocLazyLoad', function($ocLazyLoad) {
                    return $ocLazyLoad.load('[DIST_PATH]js/seven-admin-ngs-productmgmt.js')
                }]
            }
        })
        .state('productMgmt.ngs.eventsSchedule', {
            url: '/events-schedule',
            parentView: 'productMgmt.ngs.eventsSchedule',
            views: {
                '': {
                    templateUrl: '/app/products/products/ngs/events-schedule/events-schedule.html',
                    controller: 'ngsEventsScheduleCtrl'
                }
            },
            resolve: {
                loadController: ['$ocLazyLoad', function($ocLazyLoad) {
                    return $ocLazyLoad.load('[DIST_PATH]js/seven-admin-ngs-productmgmt.js')
                }]
            }
        })
        .state('productMgmt.ngs.configuration', {
            url: '/config/:cpvUuid',
            parentView: 'productMgmt.settings.configuration',
            views: {
                '': {
                    templateUrl: '/app/products/products/ngs/config/ngs-product-data-details.html',
                    controller: 'ngsProductDetailsCtrl'
                }
            },
            resolve: {
                loadController: ['$ocLazyLoad', function($ocLazyLoad) {
                    return $ocLazyLoad.load('[DIST_PATH]js/seven-admin-ngs-productmgmt.js')
                }]
            }
        })
        .state('productMgmt.ngs.bonuses', {
            url: '/bonuses',
            parentView: 'productMgmt.ngs.bonuses',
            views: {
                '': {
                    templateUrl: '/app/products/products/ngs/bonuses/bonuses-list.html',
                    controller: 'ngsBonusesListCtrl'
                }
            },
            resolve: {
                loadController: ['$ocLazyLoad', function($ocLazyLoad) {
                    return $ocLazyLoad.load('[DIST_PATH]js/seven-admin-ngs-productmgmt.js')
                }]
            }
        })
}]);
;
angular.module('seven-admin-poolbet', []).config([
    '$stateProvider',
function (
    $stateProvider
) {
    $stateProvider
        .state('productMgmt.poolbet', {
            url: '/poolbet/products/:id/:mainProductState',
            parentView: 'productMgmt.products',
            templateUrl: '/app/products/products/poolbet/poolbet-product.template.html',
            resolve: {
                loadController: ["$ocLazyLoad", function($ocLazyLoad) {
                    return $ocLazyLoad.load("[DIST_PATH]js/seven-admin-poolbet.js");
                }],
                poolbetTranslations: [
                    "loadController",
                    "poolbetCompetitionSvc",
                function(
                    loadController,
                    poolbetCompetitionSvc
                ) {
                    // loadController is listed as dependency since this is the way to do nested resolves, and it's
                    // required since poolbetCompetitionSvc is in that bundle
                    return poolbetCompetitionSvc.getTranslations();
                }]
            }
        })
        .state('productMgmt.poolbet.configuration', {
            url: '/config/:cpvUuid',
            parentView: 'productMgmt.settings.configuration',
            templateUrl: '/app/products/products/poolbet/settings/poolbet-product-settings.template.html',
            controller: 'poolbetProductSettingsCtrl',
            resolve: {
                loadController: ['$ocLazyLoad', function($ocLazyLoad) {
                    return $ocLazyLoad.load('[DIST_PATH]js/seven-admin-poolbet.js')
                }]
            }
        })
        .state('productMgmt.poolbet.competitions', {
            url: '/competitions',
            parentView: 'productMgmt.poolbet',
            templateUrl: '/app/products/products/poolbet/competitions/poolbet-competitions.template.html',
            controller: 'poolbetCompetitionsCtrl',
            resolve: {
                loadController: ['$ocLazyLoad', function($ocLazyLoad) {
                    return $ocLazyLoad.load('[DIST_PATH]js/seven-admin-poolbet.js')
                }]
            },
            data: {
                visible: true,
                title: 'tab_competitions',
                tabs: [
                    'productMgmt.poolbet.competitions',
                    'productMgmt.poolbet.reporting'
                ]
            }
        })
        .state('productMgmt.poolbet.competition', {
            url: '/competitions/:competitionId',
            parentView: 'productMgmt.poolbet',
            templateUrl: '/app/products/products/poolbet/competitions/poolbet-competition.template.html',
            controller: 'poolbetCompetitionCtrl',
            controllerAs: 'model',
            resolve: {
                loadController: ['$ocLazyLoad', function($ocLazyLoad) {
                    return $ocLazyLoad.load('[DIST_PATH]js/seven-admin-poolbet.js')
                }]
            },
            data: {
                visible: true,
                title: 'tab_competition',
                parent: 'productMgmt.poolbet.competitions',
                tabs: [
                    'productMgmt.poolbet.competitions',
                    'productMgmt.poolbet.reporting'
                ]
            }
        })
        .state('productMgmt.poolbet.reporting', {
            url: '/reporting',
            parentView: 'productMgmt.poolbet',
            templateUrl: '/app/products/products/poolbet/reporting/poolbet-reporting.template.html',
            controller: 'poolbetReportingCtrl',
            controllerAs: 'model',
            resolve: {
                loadController: ['$ocLazyLoad', function($ocLazyLoad) {
                    return $ocLazyLoad.load('[DIST_PATH]js/seven-admin-poolbet.js')
                }]
            },
            data: {
                visible: true,
                title: 'tab_reporting',
                tabs: [
                    'productMgmt.poolbet.competitions',
                    'productMgmt.poolbet.reporting'
                ]
            }
        });
}]);
;
angular.module('seven-admin-quickbet-productmgmt', []).config([
    '$stateProvider',
function (
    $stateProvider
) {
    $stateProvider
        .state('productMgmt.quickbet', {
            url: '/quickbet/products/:id/:mainProductState',
            parentView: 'productMgmt.products',
            templateUrl: '/app/products/products/quickbet/quickbet-product-mgmt.template.html'
        })
        .state('productMgmt.quickbet.configuration', {
            url: '/config/:cpvUuid',
            parentView: 'productMgmt.settings.configuration',
            templateUrl: '/app/products/products/quickbet/settings/quickbet-product-settings.template.html',
            controller: 'quickbetProductSettingsCtrl',
            resolve: {
                loadController: ["$ocLazyLoad", function($ocLazyLoad) {
                    return $ocLazyLoad.load("[DIST_PATH]js/seven-admin-quickbet-productmgmt.js");
                }]
            }
        })
        .state('productMgmt.quickbet.tickets', {
            url: '/tickets',
            parentView: 'productMgmt.quickbet.tickets',
            views: {
                '': {
                    templateUrl: '/app/products/products/quickbet/quickbet-view.template.html',
                    controller: 'quickbetTicketListCtrl'
                }
            },
            resolve: {
                loadController: ["$ocLazyLoad", function($ocLazyLoad) {
                    return $ocLazyLoad.load("[DIST_PATH]js/seven-admin-quickbet-productmgmt.js");
                }]
            }
        });
}]);
;
angular.module('seven-admin-sportbook-productmgmt', ['react.grid.module']);

angular.module('seven-admin-sportbook-productmgmt').config(['$httpProvider', '$stateProvider', function ($httpProvider, $stateProvider) {

    $stateProvider
        .state('productMgmt.sportbook', {
            url: '/sportbook/products/:id/:mainProductState',
            parentView: 'productMgmt.products',
            views: {
                '': {
                    templateUrl: '/app/products/products/sportbook/sportbook-product-mgmt.html'
                }
            },
            resolve: {
                loadController: ['$ocLazyLoad', function($ocLazyLoad) {
                    return $ocLazyLoad.load('[DIST_PATH]js/seven-admin-sportbook-productmgmt.js')
                }]
            }
        })
        // TICKETS
        .state('productMgmt.sportbook.tickets', {
            url: '/tickets',
            parentView: 'productMgmt.sportbook.tickets',
            views: {
                '': {
                    templateUrl: '/app/products/products/sportbook/sportbook-view-template.html',
                    controller: 'sportbookTicketListCtrl'
                }
            },
            resolve: {
                loadController: ['$ocLazyLoad', function($ocLazyLoad) {
                    return $ocLazyLoad.load('[DIST_PATH]js/seven-admin-sportbook-productmgmt.js')
                }]
            }
        })
        // MATCHES
        .state('productMgmt.sportbook.matches', {
            url: '/matches',
            parentView: 'productMgmt.sportbook.matches',
            views: {
                '': {
                    templateUrl: '/app/products/products/sportbook/operations/matches/matches.html',
                    controller: 'sportbookMatchesListCtrl'
                }
            },
            resolve: {
                loadController: ['$ocLazyLoad', function($ocLazyLoad) {
                    return $ocLazyLoad.load('[DIST_PATH]js/seven-admin-sportbook-productmgmt.js')
                }]
            }
        })
        // MATCH SELECTION
        .state('productMgmt.sportbook.matchSelection', {
            url: '/match-selection',
            parentView: 'productMgmt.sportbook.matchSelection',
            views: {
                '': {
                    templateUrl: '/app/products/products/sportbook/sportbook-view-template.html',
                    controller: 'sportbookMatchSelectionListCtrl'
                }
            },
            resolve: {
                loadController: ['$ocLazyLoad', function($ocLazyLoad) {
                    return $ocLazyLoad.load('[DIST_PATH]js/seven-admin-sportbook-productmgmt.js')
                }]
            }
        })
        .state('productMgmt.sportbook.matchSelectionNew', {
            url: '/match-selection-new',
            parentView: 'productMgmt.sportbook.matchSelectionNew',
            views: {
                '': {
                    templateUrl: '/app/products/products/sportbook/operations/match-selection-new/match-selection-view.html',
                    controller: 'sportbookMatchSelectionListCtrlNew'
                }
            },
            resolve: {
                loadController: ['$ocLazyLoad', function($ocLazyLoad) {
                    return $ocLazyLoad.load('[DIST_PATH]js/seven-admin-sportbook-productmgmt.js')
                }]
            }
        })
        // STREAM MATCHES
        .state('productMgmt.sportbook.streamMatches', {
            url: '/stream-matches',
            parentView: 'productMgmt.sportbook.streamMatches',
            views: {
                '': {
                    templateUrl: '/app/products/products/sportbook/sportbook-view-template.html',
                    controller: 'streamMatchesListCtrl'
                }
            },
            resolve: {
                loadController: ['$ocLazyLoad', function($ocLazyLoad) {
                    return $ocLazyLoad.load('[DIST_PATH]js/seven-admin-sportbook-productmgmt.js')
                }]
            }
        })
        // PREMATCH
        .state('productMgmt.sportbook.prematchOffer', {
            url: '/prematch-offer',
            parentView: 'productMgmt.sportbook.prematchOffer',
            views: {
                '': {
                    templateUrl: '/app/products/products/sportbook/operations/react-prematch-offer/prematch-offer.html',
                    controller: 'prematchOfferListCtrl'
                }
            },
            resolve: {
                loadController: ['$ocLazyLoad', function($ocLazyLoad) {
                    return $ocLazyLoad.load('[DIST_PATH]js/seven-admin-sportbook-productmgmt.js')
                }],
                isOutright: function () {
                    return { is_outright: 0};
                }
            }
        })
        // OUTRIGHTS
        .state('productMgmt.sportbook.outrights', {
            url: '/outrights',
            parentView: 'productMgmt.sportbook.outrights',
            views: {
                '': {
                    templateUrl: '/app/products/products/sportbook/operations/react-prematch-offer/prematch-offer.html',
                    controller: 'prematchOfferListCtrl'
                }
            },
            resolve: {
                loadController: ['$ocLazyLoad', function($ocLazyLoad) {
                    return $ocLazyLoad.load('[DIST_PATH]js/seven-admin-sportbook-productmgmt.js')
                }],
                isOutright: function () {
                    return { is_outright: 1};
                }
            }
        })
        // CUSTOM SELECTION
        .state('productMgmt.sportbook.customSelection', {
            url: '/custom-selection',
            parentView: 'productMgmt.sportbook.customSelection',
            views: {
                '': {
                    templateUrl: '/app/products/products/sportbook/operations/custom-selection/grid/custom-selection-view.html',
                    controller: 'customSelectionListCtrl'
                }
            },
            resolve: {
                loadController: ['$ocLazyLoad', function($ocLazyLoad) {
                    return $ocLazyLoad.load('[DIST_PATH]js/seven-admin-sportbook-productmgmt.js')
                }]
            }
        })
        .state('productMgmt.sportbook.customSelectionEdit', {
            url: '/custom-selection/edit/:idSelection/:name/:config/:configType/:type',
            parentView: 'productMgmt.sportbook.customSelection',
            views: {
                '': {
                    templateUrl: '/app/products/products/sportbook/operations/custom-selection/edit/custom-selection-edit-view.html',
                    controller: 'customSelectionEditCtrl'
                }
            },
            resolve: {
                loadController: ['$ocLazyLoad', function($ocLazyLoad) {
                    return $ocLazyLoad.load('[DIST_PATH]js/seven-admin-sportbook-productmgmt.js')
                }]
            },
            params: {
                startDate: '',
                endDate: '',
                content: {},
                active: false
            }
        })
        // BET CLASSES
        .state('productMgmt.sportbook.betClass', {
            url: '/bet-class',
            parentView: 'productMgmt.sportbook.betClass',
            views: {
                '': {
                    templateUrl: '/app/products/products/sportbook/operations/bet-classes/grid/bet-class-view.html',
                    controller: 'betClassListCtrl'
                }
            },
            resolve: {
                loadController: ['$ocLazyLoad', function($ocLazyLoad) {
                    return $ocLazyLoad.load('[DIST_PATH]js/seven-admin-sportbook-productmgmt.js')
                }]
            }
        })
        .state('productMgmt.sportbook.betClassEdit', {
            url: '/bet-class/edit/:betClassId',
            parentView: 'productMgmt.sportbook.betClass',
            views: {
                '': {
                    templateUrl: '/app/products/products/sportbook/operations/bet-classes/new/bet-class-new-view.html',
                    controller: 'betClassEditCtrl'
                }
            },
            resolve: {
                loadController: ['$ocLazyLoad', function($ocLazyLoad) {
                    return $ocLazyLoad.load('[DIST_PATH]js/seven-admin-sportbook-productmgmt.js')
                }]
            }
        })
        .state('productMgmt.sportbook.betClassNew', {
            url: '/bet-class/new',
            parentView: 'productMgmt.sportbook.betClass',
            views: {
                '': {
                    templateUrl: '/app/products/products/sportbook/operations/bet-classes/new/bet-class-new-view.html',
                    controller: 'betClassNewCtrl'
                }
            },
            resolve: {
                loadController: ['$ocLazyLoad', function($ocLazyLoad) {
                    return $ocLazyLoad.load('[DIST_PATH]js/seven-admin-sportbook-productmgmt.js')
                }]
            }
        })
        .state('productMgmt.sportbook.visualizationLayout', {
            url: '/visualization-layout',
            parentView: 'productMgmt.sportbook.visualizationLayout',
            templateUrl: '/app/products/products/sportbook/operations/visualization-layout/visualization-layout.html',
            controller: 'visualizationLayoutController',
            resolve: {
                loadController: ['$ocLazyLoad', function($ocLazyLoad) {
                    return $ocLazyLoad.load('[DIST_PATH]js/seven-admin-sportbook-productmgmt.js')
                }]
            }
        })

        /*
        * SETTINGS
        * */

        // SPORT STATE
        .state('productMgmt.sportbook.sports', {
            url: '/sports',
            parentView: 'productMgmt.sportbook.sports',
            views: {
                '': {
                    templateUrl: '/app/products/products/sportbook/sportbook-view-template.html',
                    controller: 'sportListCtrl'
                }
            },
            resolve: {
                loadController: ['$ocLazyLoad', function($ocLazyLoad) {
                    return $ocLazyLoad.load('[DIST_PATH]js/seven-admin-sportbook-productmgmt.js')
                }]
            }
        })
        .state('productMgmt.sportbook.sportsDetails', {
            url: '/sports/:detailId/:providerId',
            parentView: 'productMgmt.sportbook.sports',
            views: {
                '': {
                    templateUrl: '/app/products/products/sportbook/sportbook-view-template.html',
                    controller: 'sportDetailsCtrl'
                }
            },
            resolve: {
                loadController: ['$ocLazyLoad', function($ocLazyLoad) {
                    return $ocLazyLoad.load('[DIST_PATH]js/seven-admin-sportbook-productmgmt.js')
                }]
            },
            params: { activeProduct: null }
        })
        // CATEGORY STATE
        .state('productMgmt.sportbook.categories', {
            url: '/categories',
            parentView: 'productMgmt.sportbook.categories',
            views: {
                '': {
                    templateUrl: '/app/products/products/sportbook/sportbook-view-template.html',
                    controller: 'categoryListCtrl'
                }
            },
            resolve: {
                loadController: ['$ocLazyLoad', function($ocLazyLoad) {
                    return $ocLazyLoad.load('[DIST_PATH]js/seven-admin-sportbook-productmgmt.js')
                }]
            }
        })
        .state('productMgmt.sportbook.categoriesDetails', {
            url: '/categories/:detailId/:providerId',
            parentView: 'productMgmt.sportbook.categories',
            views: {
                '': {
                    templateUrl: '/app/products/products/sportbook/sportbook-view-template.html',
                    controller: 'categoryDetailsCtrl'
                }
            }
        })
        // TEAMS STATE
        .state('productMgmt.sportbook.teams', {
            url: '/teams',
            parentView: 'productMgmt.sportbook.teams',
            views: {
                '': {
                    templateUrl: '/app/products/products/sportbook/sportbook-view-template.html',
                    controller: 'teamListCtrl'
                }
            },
            resolve: {
                loadController: ['$ocLazyLoad', function($ocLazyLoad) {
                    return $ocLazyLoad.load('[DIST_PATH]js/seven-admin-sportbook-productmgmt.js')
                }]
            }
        })
        .state('productMgmt.sportbook.teamsDetails', {
            url: '/teams/:detailId/:providerId',
            parentView: 'productMgmt.sportbook.teams',
            views: {
                '': {
                    templateUrl: '/app/products/products/sportbook/sportbook-view-template.html',
                    controller: 'teamDetailsCtrl'
                }
            },
            resolve: {
                loadController: ['$ocLazyLoad', function($ocLazyLoad) {
                    return $ocLazyLoad.load('[DIST_PATH]js/seven-admin-sportbook-productmgmt.js')
                }]
            }
        })
        // BETS STATE
        .state('productMgmt.sportbook.bets', {
            url: '/bets',
            parentView: 'productMgmt.sportbook.bets',
            views: {
                '': {
                    templateUrl: '/app/products/products/sportbook/settings/bets/bet-list.template.html',
                    controller: 'betListCtrl'
                }
            },
            resolve: {
                loadController: ['$ocLazyLoad', function($ocLazyLoad) {
                    return $ocLazyLoad.load('[DIST_PATH]js/seven-admin-sportbook-productmgmt.js')
                }]
            }
        })
        .state('productMgmt.sportbook.betsDetails', {
            url: '/bets/:detailId/:providerId',
            parentView: 'productMgmt.sportbook.bets',
            views: {
                '': {
                    templateUrl: '/app/products/products/sportbook/sportbook-view-template.html',
                    controller: 'betDetailsCtrl'
                }
            },
            resolve: {
                loadController: ['$ocLazyLoad', function($ocLazyLoad) {
                    return $ocLazyLoad.load('[DIST_PATH]js/seven-admin-sportbook-productmgmt.js')
                }]
            }
        })
        // BET GROUPS
        .state('productMgmt.sportbook.betGroups', {
            url: '/bet-groups',
            parentView: 'productMgmt.sportbook.betGroups',
            views: {
                '': {
                    templateUrl: '/app/products/products/sportbook/sportbook-view-template.html',
                    controller: 'betGroupsListCtrl'
                }
            },
            resolve: {
                loadController: ['$ocLazyLoad', function($ocLazyLoad) {
                    return $ocLazyLoad.load('[DIST_PATH]js/seven-admin-sportbook-productmgmt.js')
                }]
            }
        })
        .state('productMgmt.sportbook.betGroupNew', {
            url: '/bet-groups/add-new',
            parentView: 'productMgmt.sportbook.betGroups',
            views: {
                '': {
                    templateUrl: '/app/products/products/sportbook/sportbook-view-template.html',
                    controller: 'betGroupsNewCtrl'
                }
            },
            resolve: {
                loadController: ['$ocLazyLoad', function($ocLazyLoad) {
                    return $ocLazyLoad.load('[DIST_PATH]js/seven-admin-sportbook-productmgmt.js')
                }]
            }
        })
        .state('productMgmt.sportbook.betGroupsDetails', {
            url: '/bet-groups/:detailId',
            parentView: 'productMgmt.sportbook.betGroups',
            views: {
                '': {
                    templateUrl: '/app/products/products/sportbook/sportbook-view-template.html',
                    controller: 'betGroupsDetailsCtrl'
                }
            },
            resolve: {
                loadController: ['$ocLazyLoad', function($ocLazyLoad) {
                    return $ocLazyLoad.load('[DIST_PATH]js/seven-admin-sportbook-productmgmt.js')
                }]
            }
        })
        // SPORTRADAR BET GROUPS
        .state('productMgmt.sportbook.groups', {
            url: '/groups',
            parentView: 'productMgmt.sportbook.groups',
            views: {
                '': {
                    templateUrl: '/app/products/products/sportbook/sportbook-view-template.html',
                    controller: 'virtualGroupsController'
                }
            },
            resolve: {
                loadController: ['$ocLazyLoad', function($ocLazyLoad) {
                    return $ocLazyLoad.load('[DIST_PATH]js/seven-admin-sportbook-productmgmt.js')
                }]
            }
        })
        .state('productMgmt.sportbook.groupsDetails', {
            url: '/groups/:detailId/:providerId',
            parentView: 'productMgmt.sportbook.groups',
            views: {
                '': {
                    templateUrl: '/app/products/products/sportbook/sportbook-view-template.html',
                    controller: 'groupDetailsController'
                }
            },
            resolve: {
                loadController: ['$ocLazyLoad', function($ocLazyLoad) {
                    return $ocLazyLoad.load('[DIST_PATH]js/seven-admin-sportbook-productmgmt.js')
                }]
            }
        })
        // TOURNAMENTS STATE
        .state('productMgmt.sportbook.tournaments', {
            url: '/tournaments',
            parentView: 'productMgmt.sportbook.tournaments',
            views: {
                '': {
                    templateUrl: '/app/products/products/sportbook/sportbook-view-template.html',
                    controller: 'tournamentListCtrl'
                }
            },
            resolve: {
                loadController: ['$ocLazyLoad', function($ocLazyLoad) {
                    return $ocLazyLoad.load('[DIST_PATH]js/seven-admin-sportbook-productmgmt.js')
                }]
            }
        })
        .state('productMgmt.sportbook.tournamentsDetails', {
            url: '/tournaments/:detailId/:providerId',
            parentView: 'productMgmt.sportbook.tournaments',
            views: {
                '': {
                    templateUrl: '/app/products/products/sportbook/sportbook-view-template.html',
                    controller: 'tournamentDetailsCtrl'
                }
            }
        })
        // OUTCOMES STATE
        .state('productMgmt.sportbook.outcomes', {
            url: '/outcomes',
            parentView: 'productMgmt.sportbook.outcomes',
            views: {
                '': {
                    templateUrl: '/app/products/products/sportbook/sportbook-view-template.html',
                    controller: 'outcomeListCtrl'
                }
            },
            resolve: {
                loadController: ['$ocLazyLoad', function($ocLazyLoad) {
                    return $ocLazyLoad.load('[DIST_PATH]js/seven-admin-sportbook-productmgmt.js')
                }]
            }
        })
        .state('productMgmt.sportbook.outcomesDetails', {
            url: '/outcomes/:detailId',
            parentView: 'productMgmt.sportbook.outcomes',
            views: {
                '': {
                    templateUrl: '/app/products/products/sportbook/sportbook-view-template.html',
                    controller: 'outcomeDetailsCtrl'
                }
            },
            resolve: {
                loadController: ['$ocLazyLoad', function($ocLazyLoad) {
                    return $ocLazyLoad.load('[DIST_PATH]js/seven-admin-sportbook-productmgmt.js')
                }]
            }
        })
        // LIMITS STATE
        .state('productMgmt.sportbook.limits', {
            url: '/limits',
            parentView: 'productMgmt.sportbook.limits',
            views: {
                '': {
                    templateUrl: '/app/products/products/sportbook/sportbook-view-template.html',
                    controller: 'limitsListCtrl'
                }
            },
            resolve: {
                loadController: ['$ocLazyLoad', function($ocLazyLoad) {
                    return $ocLazyLoad.load('[DIST_PATH]js/seven-admin-sportbook-productmgmt.js')
                }]
            }
        })
        .state('productMgmt.sportbook.limitNew', {
            url: '/limits/new-limit',
            parentView: 'productMgmt.sportbook.limits',
            views: {
                '': {
                    templateUrl: '/app/products/products/sportbook/sportbook-view-template.html',
                    controller: 'limitsNewCtrl'
                }
            },
            resolve: {
                loadController: ['$ocLazyLoad', function($ocLazyLoad) {
                    return $ocLazyLoad.load('[DIST_PATH]js/seven-admin-sportbook-productmgmt.js')
                }]
            }
        })
        // RESULTS STATE
        .state('productMgmt.sportbook.results', {
            url: '/results',
            parentView: 'productMgmt.sportbook.results',
            views: {
                '': {
                    templateUrl: '/app/products/products/sportbook/sportbook-view-template.html',
                    controller: 'resultsListCtrl'
                }
            },
            resolve: {
                loadController: ['$ocLazyLoad', function($ocLazyLoad) {
                    return $ocLazyLoad.load('[DIST_PATH]js/seven-admin-sportbook-productmgmt.js')
                }]
            }
        })
        // MANUAL RESOLVE
        .state('productMgmt.sportbook.manualResolveMatches', {
            url: '/manual-resolve',
            parentView: 'productMgmt.sportbook.manualResolveMatches',
            views: {
                '': {
                    templateUrl: '/app/products/products/sportbook/settings/manual-resolve/manual-resolve-view.html',
                    controller: 'ManualResolveController'
                }
            },
            resolve: {
                loadController: ['$ocLazyLoad', function($ocLazyLoad) {
                    return $ocLazyLoad.load('[DIST_PATH]js/seven-admin-sportbook-productmgmt.js')
                }]
            }
        })


        // SM STATES

        // RISK MANAGEMENT
        .state('productMgmt.sportbook.sm_risk_management', {
            url: '/sm-risk-management',
            parentView: 'productMgmt.sportbook.sm-risk-management',
            templateUrl: '/app/products/products/sportbook/sm-prematch/risk-management/risk-view.html',
            controller: 'smPrematchRiskManagement',
            redirectTo: 'productMgmt.sportbook.sm_risk_management.settings',
            resolve: {
                loadController: ['$ocLazyLoad', function($ocLazyLoad) {
                    return $ocLazyLoad.load('[DIST_PATH]js/seven-admin-sportbook-productmgmt.js')
                }]
            }
        })
        .state('productMgmt.sportbook.sm_risk_management.settings', {
            url: '/settings',
            parentView: 'productMgmt.sportbook.sm_risk_management',
            templateUrl: '/app/products/products/sportbook/sm-prematch/risk-management/risk-settings/risk-settings.view.html',
            controller: 'smPrematchRiskSettingsCtrl',
            resolve: {
                loadController: ['$ocLazyLoad', function($ocLazyLoad) {
                    return $ocLazyLoad.load('[DIST_PATH]js/seven-admin-sportbook-productmgmt.js')
                }]
            }
        })
        .state('productMgmt.sportbook.sm_risk_management.sports', {
            url: '/sports-assignment',
            parentView: 'productMgmt.sportbook.sm_risk_management',
            templateUrl: '/app/products/products/sportbook/sm-prematch/risk-management/sports-assignment/sports.view.html',
            controller: 'smPrematchSportsAssignmentCtrl',
            resolve: {
                loadController: ['$ocLazyLoad', function($ocLazyLoad) {
                    return $ocLazyLoad.load('[DIST_PATH]js/seven-admin-sportbook-productmgmt.js')
                }]
            }
        })
        .state('productMgmt.sportbook.sm_risk_management.categories', {
            url: '/categories-assignment',
            parentView: 'productMgmt.sportbook.sm_risk_management',
            templateUrl: '/app/products/products/sportbook/sm-prematch/risk-management/categories-assignment/categories.view.html',
            controller: 'smPrematchCategoriesAssignmentCtrl',
            resolve: {
                loadController: ['$ocLazyLoad', function($ocLazyLoad) {
                    return $ocLazyLoad.load('[DIST_PATH]js/seven-admin-sportbook-productmgmt.js')
                }]
            }
        })
        .state('productMgmt.sportbook.sm_risk_management.tournaments', {
            url: '/tournaments-assignment',
            parentView: 'productMgmt.sportbook.sm_risk_management',
            templateUrl: '/app/products/products/sportbook/sm-prematch/risk-management/tournaments-assignment/tournaments.view.html',
            controller: 'smPrematchTournamentsAssignmentCtrl',
            resolve: {
                loadController: ['$ocLazyLoad', function($ocLazyLoad) {
                    return $ocLazyLoad.load('[DIST_PATH]js/seven-admin-sportbook-productmgmt.js')
                }]
            }
        })
        .state('productMgmt.sportbook.sm_risk_management.markets', {
            url: '/markets-assignment',
            parentView: 'productMgmt.sportbook.sm_risk_management',
            templateUrl: '/app/products/products/sportbook/sm-prematch/risk-management/markets-assignment/markets.view.html',
            controller: 'smPrematchMarketsAssignmentCtrl',
            resolve: {
                loadController: ['$ocLazyLoad', function($ocLazyLoad) {
                    return $ocLazyLoad.load('[DIST_PATH]js/seven-admin-sportbook-productmgmt.js')
                }]
            }
        })
        .state('productMgmt.sportbook.sm_risk_management.betshops', {
            url: '/betshops-assignment',
            parentView: 'productMgmt.sportbook.sm_risk_management',
            templateUrl: '/app/products/products/sportbook/sm-prematch/risk-management/betshops-assignment/betshops.view.html',
            controller: 'smPrematchBetshopsAssignmentCtrl',
            resolve: {
                loadController: ['$ocLazyLoad', function($ocLazyLoad) {
                    return $ocLazyLoad.load('[DIST_PATH]js/seven-admin-sportbook-productmgmt.js')
                }]
            }
        })
        .state('productMgmt.sportbook.sm_risk_management.punters', {
            url: '/punters-assignment',
            parentView: 'productMgmt.sportbook.sm_risk_management',
            templateUrl: '/app/products/products/sportbook/sm-prematch/risk-management/punters-assignment/punters.view.html',
            controller: 'smPrematchPuntersAssignmentCtrl',
            resolve: {
                loadController: ['$ocLazyLoad', function($ocLazyLoad) {
                    return $ocLazyLoad.load('[DIST_PATH]js/seven-admin-sportbook-productmgmt.js')
                }]
            }
        })

        // RULES MANAGEMENT
        .state('productMgmt.sportbook.sm_rules', {
            url: '/sm-rules',
            parentView: 'productMgmt.sportbook.sm_rules',
            templateUrl: '/app/products/products/sportbook/sm-prematch/rules/rules.html',
            controller: 'smRulesCtrl',
            redirectTo: 'productMgmt.sportbook.sm_rules.rules_types',
            resolve: {
                loadController: ['$ocLazyLoad', function($ocLazyLoad) {
                    return $ocLazyLoad.load('[DIST_PATH]js/seven-admin-sportbook-productmgmt.js')
                }]
            }
        })
        .state('productMgmt.sportbook.sm_rules.rules_types', {
            url: '/rules-types',
            parentView: 'productMgmt.sportbook.sm_rules',
            templateUrl: '/app/products/products/sportbook/sm-prematch/rules/rules-types/view.html',
            controller: 'smRulesTypesCtrl',
            resolve: {
                loadController: ['$ocLazyLoad', function($ocLazyLoad) {
                    return $ocLazyLoad.load('[DIST_PATH]js/seven-admin-sportbook-productmgmt.js')
                }]
            }
        })
        .state('productMgmt.sportbook.sm_rules.rules_groups', {
            url: '/rules-groups',
            parentView: 'productMgmt.sportbook.sm_rules',
            templateUrl: '/app/products/products/sportbook/sm-prematch/rules/rules-groups/view.html',
            controller: 'smRulesGroupsCtrl',
            resolve: {
                loadController: ['$ocLazyLoad', function($ocLazyLoad) {
                    return $ocLazyLoad.load('[DIST_PATH]js/seven-admin-sportbook-productmgmt.js')
                }]
            }
        })
        .state('productMgmt.sportbook.sm_rules.rules_betshops', {
            url: '/betshops',
            parentView: 'productMgmt.sportbook.sm_rules',
            templateUrl: '/app/products/products/sportbook/sm-prematch/rules/market-selection-rules/view.html',
            controller: 'smMarketSelectionRulesCtrl',
            resolve: {
                loadController: ['$ocLazyLoad', function($ocLazyLoad) {
                    return $ocLazyLoad.load('[DIST_PATH]js/seven-admin-sportbook-productmgmt.js')
                }]
            },
            params: {tab: 'betshops'}
        })
        .state('productMgmt.sportbook.sm_rules.rules_punters', {
            url: '/punters',
            parentView: 'productMgmt.sportbook.sm_rules',
            templateUrl: '/app/products/products/sportbook/sm-prematch/rules/market-selection-rules/view.html',
            controller: 'smMarketSelectionRulesCtrl',
            resolve: {
                loadController: ['$ocLazyLoad', function($ocLazyLoad) {
                    return $ocLazyLoad.load('[DIST_PATH]js/seven-admin-sportbook-productmgmt.js')
                }]
            },
            params: {tab: 'punters'}
        })
        .state('productMgmt.sportbook.sm_rules.rules_sports', {
            url: '/sports',
            parentView: 'productMgmt.sportbook.sm_rules',
            templateUrl: '/app/products/products/sportbook/sm-prematch/rules/meta-rules/view.html',
            controller: 'smMetaRulesCtrl',
            resolve: {
                loadController: ['$ocLazyLoad', function($ocLazyLoad) {
                    return $ocLazyLoad.load('[DIST_PATH]js/seven-admin-sportbook-productmgmt.js')
                }]
            },
            params: {tab: 'sports'}
        })
        .state('productMgmt.sportbook.sm_rules.rules_categories', {
            url: '/categories',
            parentView: 'productMgmt.sportbook.sm_rules',
            templateUrl: '/app/products/products/sportbook/sm-prematch/rules/meta-rules/view.html',
            controller: 'smMetaRulesCtrl',
            resolve: {
                loadController: ['$ocLazyLoad', function($ocLazyLoad) {
                    return $ocLazyLoad.load('[DIST_PATH]js/seven-admin-sportbook-productmgmt.js')
                }]
            },
            params: {tab: 'categories'}
        })
        .state('productMgmt.sportbook.sm_rules.rules_tournaments', {
            url: '/tournaments',
            parentView: 'productMgmt.sportbook.sm_rules',
            templateUrl: '/app/products/products/sportbook/sm-prematch/rules/meta-rules/view.html',
            controller: 'smMetaRulesCtrl',
            resolve: {
                loadController: ['$ocLazyLoad', function($ocLazyLoad) {
                    return $ocLazyLoad.load('[DIST_PATH]js/seven-admin-sportbook-productmgmt.js')
                }]
            },
            params: {tab: 'tournaments'}
        })
        .state('productMgmt.sportbook.sm_rules.rules_markets', {
            url: '/markets',
            parentView: 'productMgmt.sportbook.sm_rules',
            templateUrl: '/app/products/products/sportbook/sm-prematch/rules/meta-rules/view.html',
            controller: 'smMetaRulesCtrl as model',
            resolve: {
                loadController: ['$ocLazyLoad', function($ocLazyLoad) {
                    return $ocLazyLoad.load('[DIST_PATH]js/seven-admin-sportbook-productmgmt.js')
                }]
            },
            params: {tab: 'markets'}
        })
        .state('productMgmt.sportbook.sm_rules.rules_tickets', {
            url: '/tickets',
            parentView: 'productMgmt.sportbook.sm_rules',
            templateUrl: '/app/products/products/sportbook/sm-prematch/rules/tickets/view.html',
            controller: 'smMetaRulesCtrl as model',
            resolve: {
                loadController: ['$ocLazyLoad', function($ocLazyLoad) {
                    return $ocLazyLoad.load('[DIST_PATH]js/seven-admin-sportbook-productmgmt.js')
                }]
            },
            params: {tab: 'tickets'}
        })

        // SPORTS
        .state('productMgmt.sportbook.sm_sports', {
            url: '/sm-sports',
            parentView: 'productMgmt.sportbook.sm_sports',
            templateUrl: '/app/products/products/sportbook/sm-prematch/sports/sports.html',
            controller: 'smPrematchSportsList',
            resolve: {
                loadController: ['$ocLazyLoad', function($ocLazyLoad) {
                    return $ocLazyLoad.load('[DIST_PATH]js/seven-admin-sportbook-productmgmt.js')
                }]
            }
        })

        // REPORTS
        .state('productMgmt.sportbook.sm_reports', {
            url: '/sm-reports',
            parentView: 'productMgmt.sportbook.sm_reports',
            templateUrl: '/app/products/products/sportbook/sm-prematch/reports/reports.view.html',
            controller: 'smReportsCtrl',
            redirectTo: 'productMgmt.sportbook.sm_reports.sports',
            resolve: {
                loadController: ['$ocLazyLoad', function($ocLazyLoad) {
                    return $ocLazyLoad.load('[DIST_PATH]js/seven-admin-sportbook-productmgmt.js')
                }]
            }
        })
        .state('productMgmt.sportbook.sm_reports.sports', {
            url: '/sports',
            parentView: 'productMgmt.sportbook.sm_reports',
            templateUrl: '/app/products/products/sportbook/sm-prematch/reports/sports/sports-view.html',
            controller: 'smSportsReportCtrl',
            resolve: {
                loadController: ['$ocLazyLoad', function($ocLazyLoad) {
                    return $ocLazyLoad.load('[DIST_PATH]js/seven-admin-sportbook-productmgmt.js')
                }]
            },
            params: {
                tickets: false,
                queryParams: ''
            }
        })
        .state('productMgmt.sportbook.sm_reports.markets', {
            url: '/markets',
            parentView: 'productMgmt.sportbook.sm_reports',
            templateUrl: '/app/products/products/sportbook/sm-prematch/reports/markets/markets-view.html',
            controller: 'smMarketsReportCtrl',
            resolve: {
                loadController: ['$ocLazyLoad', function($ocLazyLoad) {
                    return $ocLazyLoad.load('[DIST_PATH]js/seven-admin-sportbook-productmgmt.js')
                }]
            },
            params: {
                tickets: false,
                queryParams: ''
            }
        })
        .state('productMgmt.sportbook.sm_reports.tournaments', {
            url: '/tournaments',
            parentView: 'productMgmt.sportbook.sm_reports',
            templateUrl: '/app/products/products/sportbook/sm-prematch/reports/tournaments/tournaments-view.html',
            controller: 'smTournamentsReportCtrl',
            resolve: {
                loadController: ['$ocLazyLoad', function($ocLazyLoad) {
                    return $ocLazyLoad.load('[DIST_PATH]js/seven-admin-sportbook-productmgmt.js')
                }]
            },
            params: {
                tickets: false,
                queryParams: ''
            }
        })
        .state('productMgmt.sportbook.sm_reports.tournament-market', {
            url: '/tournament-market',
            parentView: 'productMgmt.sportbook.sm_reports',
            templateUrl: '/app/products/products/sportbook/sm-prematch/reports/tournament-market/tournament-market-view.html',
            controller: 'smTournamentMarketReportCtrl',
            resolve: {
                loadController: ['$ocLazyLoad', function($ocLazyLoad) {
                    return $ocLazyLoad.load('[DIST_PATH]js/seven-admin-sportbook-productmgmt.js')
                }]
            },
            params: {
                tickets: false,
                queryParams: ''
            }
        })
        .state('productMgmt.sportbook.sm_reports.bet-type', {
            url: '/bet-type',
            parentView: 'productMgmt.sportbook.sm_reports',
            templateUrl: '/app/products/products/sportbook/sm-prematch/reports/bet-type/bet-type-view.html',
            controller: 'smBetTypeReportCtrl',
            resolve: {
                loadController: ['$ocLazyLoad', function($ocLazyLoad) {
                    return $ocLazyLoad.load('[DIST_PATH]js/seven-admin-sportbook-productmgmt.js')
                }]
            },
            params: {
                tickets: false,
                queryParams: ''
            }
        })
        .state('productMgmt.sportbook.sm_reports.events', {
            url: '/events',
            parentView: 'productMgmt.sportbook.sm_reports',
            templateUrl: '/app/products/products/sportbook/sm-prematch/reports/events/events-view.html',
            controller: 'smEventsReportCtrl',
            resolve: {
                loadController: ['$ocLazyLoad', function($ocLazyLoad) {
                    return $ocLazyLoad.load('[DIST_PATH]js/seven-admin-sportbook-productmgmt.js')
                }]
            },
            params: {
                tickets: false,
                queryParams: ''
            }
        })
        .state('productMgmt.sportbook.sm_reports.load-progression', {
            url: '/load-progression',
            parentView: 'productMgmt.sportbook.sm_reports',
            templateUrl: '/app/products/products/sportbook/sm-prematch/reports/load-progression/load-progression-view.html',
            controller: 'smLoadProgressionReportCtrl as model',
            resolve: {
                loadController: ['$ocLazyLoad', function($ocLazyLoad) {
                    return $ocLazyLoad.load('[DIST_PATH]js/seven-admin-sportbook-productmgmt.js')
                }]
            },
            params: {
                tickets: false,
                queryParams: ''
            }
        })
        .state('productMgmt.sportbook.sm_reports.betshops', {
            url: '/betshops',
            parentView: 'productMgmt.sportbook.sm_reports',
            templateUrl: '/app/products/products/sportbook/sm-prematch/reports/betshops/betshops-view.html',
            controller: 'smBetshopsReportCtrl',
            resolve: {
                loadController: ['$ocLazyLoad', function($ocLazyLoad) {
                    return $ocLazyLoad.load('[DIST_PATH]js/seven-admin-sportbook-productmgmt.js')
                }]
            },
            params: {
                tickets: false,
                queryParams: ''
            }
        })
        .state('productMgmt.sportbook.sm_reports.players', {
            url: '/players',
            parentView: 'productMgmt.sportbook.sm_reports',
            templateUrl: '/app/products/products/sportbook/sm-prematch/reports/players/players-view.html',
            controller: 'smPlayersReportCtrl',
            resolve: {
                loadController: ['$ocLazyLoad', function($ocLazyLoad) {
                    return $ocLazyLoad.load('[DIST_PATH]js/seven-admin-sportbook-productmgmt.js')
                }]
            },
            params: {
                tickets: false,
                queryParams: ''
            }
        })
        .state('productMgmt.sportbook.sm_reports.cashout', {
            url: '/cashout',
            parentView: 'productMgmt.sportbook.sm_reports',
            templateUrl: '/app/products/products/sportbook/sm-prematch/reports/cashout/cashout-view.html',
            controller: 'smCashoutReportCtrl',
            resolve: {
                loadController: ['$ocLazyLoad', function($ocLazyLoad) {
                    return $ocLazyLoad.load('[DIST_PATH]js/seven-admin-sportbook-productmgmt.js')
                }]
            }
        })
        .state('productMgmt.sportbook.sm_reports.tickets', {
            url: '/report-tickets',
            parentView: 'productMgmt.sportbook.sm_reports',
            templateUrl: '/app/products/products/sportbook/sm-prematch/reports/tickets/tickets-view.html',
            controller: 'smTicketsReportCtrl',
            resolve: {
                loadController: ['$ocLazyLoad', function($ocLazyLoad) {
                    return $ocLazyLoad.load('[DIST_PATH]js/seven-admin-sportbook-productmgmt.js')
                }]
            }
        })
        .state('productMgmt.sportbook.sm_eventsload_v2', {
            url: '/eventloadv2',
            templateUrl: '/app/products/products/sportbook/sm-prematch/reports/load-progression/eventloadv2-view.html',
            controller: 'smLoadProgressionReportCtrlv2 as model',
            resolve: {
                loadController: ['$ocLazyLoad', function($ocLazyLoad) {
                    return $ocLazyLoad.load('[DIST_PATH]js/seven-admin-sportbook-productmgmt.js')
                }]
            }
        })

        // RESULTS
        .state('productMgmt.sportbook.sm_results', {
            url: '/sm-results',
            parentView: 'productMgmt.sportbook.sm_results',
            templateUrl: '/app/products/products/sportbook/sm-prematch/results/results.view.html',
            controller: 'smPrematchResultsCtrl',
            resolve: {
                loadController: ['$ocLazyLoad', function($ocLazyLoad) {
                    return $ocLazyLoad.load('[DIST_PATH]js/seven-admin-sportbook-productmgmt.js')
                }]
            }
        })

        .state('productMgmt.sportbook.sm_results_settings', {
            url: '/sm-results-settings',
            parentView: 'productMgmt.sportbook.sm_results_settings',
            templateUrl: '/app/products/products/sportbook/sm-prematch/results-settings/results.view.html',
            controller: 'smPrematchResultsSettingsCtrl',
            redirectTo: 'productMgmt.sportbook.sm_results_settings.resolve_formula',
            resolve: {
                loadController: ['$ocLazyLoad', function($ocLazyLoad) {
                    return $ocLazyLoad.load('[DIST_PATH]js/seven-admin-sportbook-productmgmt.js')
                }]
            }
        })

        .state('productMgmt.sportbook.sm_results_settings.resolve_formula', {
            url: '/resolve-formula',
            parentView: 'productMgmt.sportbook.sm_results_settings',
            templateUrl: '/app/products/products/sportbook/sm-prematch/results-settings/resolve-formula/resolve-formula.view.html',
            controller: 'smPrematchResolveFormulaCtrl',
            resolve: {
                loadController: ['$ocLazyLoad', function($ocLazyLoad) {
                    return $ocLazyLoad.load('[DIST_PATH]js/seven-admin-sportbook-productmgmt.js')
                }]
            }
        })

        .state('productMgmt.sportbook.sm_results_settings.resolve_formula_assignment', {
            url: '/resolve-formula-assign',
            parentView: 'productMgmt.sportbook.sm_results_settings',
            templateUrl: '/app/products/products/sportbook/sm-prematch/results-settings/assignment/formula-assignment.view.html',
            controller: 'smPrematchResolveFormulaAssignCtrl',
            resolve: {
                loadController: ['$ocLazyLoad', function($ocLazyLoad) {
                    return $ocLazyLoad.load('[DIST_PATH]js/seven-admin-sportbook-productmgmt.js')
                }]
            }
        })

        // CATEGORIES
        .state('productMgmt.sportbook.sm_categories', {
            url: '/sm-categories',
            parentView: 'productMgmt.sportbook.sm_categories',
            templateUrl: '/app/products/products/sportbook/sm-prematch/categories/categories.html',
            controller: 'smPrematchCategoryList',
            resolve: {
                loadController: ['$ocLazyLoad', function($ocLazyLoad) {
                    return $ocLazyLoad.load('[DIST_PATH]js/seven-admin-sportbook-productmgmt.js')
                }]
            }
        })

        // TOURNAMENTS
        .state('productMgmt.sportbook.sm_tournaments', {
            url: '/sm-tournaments',
            parentView: 'productMgmt.sportbook.sm_tournaments',
            templateUrl: '/app/products/products/sportbook/sm-prematch/tournaments/tournament.template.html',
            controller: 'smPrematchTournamentList',
            resolve: {
                loadController: ['$ocLazyLoad', function($ocLazyLoad) {
                    return $ocLazyLoad.load('[DIST_PATH]js/seven-admin-sportbook-productmgmt.js')
                }]
            }
        })
        // TEAMS
        .state('productMgmt.sportbook.sm_teams', {
            url: '/sm-teams',
            parentView: 'productMgmt.sportbook.sm_teams',
            templateUrl: '/app/products/products/sportbook/sm-prematch/teams/teams.template.html',
            controller: 'smPrematchTeamList',
            resolve: {
                loadController: ['$ocLazyLoad', function($ocLazyLoad) {
                    return $ocLazyLoad.load('[DIST_PATH]js/seven-admin-sportbook-productmgmt.js')
                }]
            }
        })
        // PLAYERS
        .state('productMgmt.sportbook.sm_players', {
            url: '/sm-players',
            parentView: 'productMgmt.sportbook.sm_players',
            templateUrl: '/app/products/products/sportbook/sm-prematch/players/players.template.html',
            controller: 'smPrematchPlayerList',
            resolve: {
                loadController: ['$ocLazyLoad', function($ocLazyLoad) {
                    return $ocLazyLoad.load('[DIST_PATH]js/seven-admin-sportbook-productmgmt.js')
                }]
            }
        })
        // Markets
        .state('productMgmt.sportbook.sm_markets', {
            url: '/sm-markets',
            parentView: 'productMgmt.sportbook.sm_markets',
            templateUrl: '/app/products/products/sportbook/sm-prematch/markets/markets.template.html',
            controller: 'smPrematchMarketList',
            resolve: {
                loadController: ['$ocLazyLoad', function($ocLazyLoad) {
                    return $ocLazyLoad.load('[DIST_PATH]js/seven-admin-sportbook-productmgmt.js')
                }]
            }
        })
        // Outcomes
        .state('productMgmt.sportbook.sm_outcomes', {
            url: '/sm-outcomes',
            parentView: 'productMgmt.sportbook.sm_outcomes',
            templateUrl: '/app/products/products/sportbook/sm-prematch/outcomes/outcomes.template.html',
            controller: 'smPrematchOutcomeList',
            resolve: {
                loadController: ['$ocLazyLoad', function($ocLazyLoad) {
                    return $ocLazyLoad.load('[DIST_PATH]js/seven-admin-sportbook-productmgmt.js')
                }]
            }
        })
        .state('productMgmt.sportbook.sm_market_templates', {
            url: '/sm-market-templates',
            parentView: 'productMgmt.sportbook.sm_market_templates',
            templateUrl: '/app/products/products/sportbook/sm-prematch/market-templates/market-templates.html',
            controller: 'smMarketTemplateController',
            resolve: {
                loadController: ['$ocLazyLoad', function($ocLazyLoad) {
                    return $ocLazyLoad.load('[DIST_PATH]js/seven-admin-sportbook-productmgmt.js')
                }]
            }
        })
        .state('productMgmt.sportbook.sm_market_groups', {
            url: '/sm-market-groups',
            parentView: 'productMgmt.sportbook.sm_market_groups',
            templateUrl: '/app/products/products/sportbook/sm-prematch/market-groups/market-groups.html',
            controller: 'smMarketGroupsController',
            resolve: {
                loadController: ['$ocLazyLoad', function($ocLazyLoad) {
                    return $ocLazyLoad.load('[DIST_PATH]js/seven-admin-sportbook-productmgmt.js')
                }]
            }
        })
        // Events
        .state('productMgmt.sportbook.sm_events', {
            url: '/sm-events',
            parentView: 'productMgmt.sportbook.sm_events',
            templateUrl: '/app/products/products/sportbook/sm-prematch/events/events.template.html',
            controller: 'SmEventList as smEvents',
            resolve: {
                loadController: ['$ocLazyLoad', function($ocLazyLoad) {
                    return $ocLazyLoad.load('[DIST_PATH]js/seven-admin-sportbook-productmgmt.js')
                }]
            }
        })
        // Events Specials
        .state('productMgmt.sportbook.sm_events_specials', {
            url: '/sm-events-specials',
            parentView: 'productMgmt.sportbook.sm_events_specials',
            templateUrl: 'app/products/products/sportbook/sm-prematch/events/events.template.html',
            controller: 'SmEventList as smEvents'
        })
        // Ticket authorization
        .state('productMgmt.sportbook.sm_ticket_authorization', {
            url: '/sm-ticket-authorization',
            parentView: 'productMgmt.sportbook.sm_ticketAuthorization',
            templateUrl: '/app/products/products/sportbook/sm-prematch/ticket-authorization/ticket-authorization.html',
            controller: 'smPrematchTicketAuthorization as model',
            resolve: {
                loadController: ['$ocLazyLoad', function($ocLazyLoad) {
                    return $ocLazyLoad.load('[DIST_PATH]js/seven-admin-sportbook-productmgmt.js')
                }]
            }
        })

        // Liability monitoring
        .state('productMgmt.sportbook.sm_liability_monitoring', {
            url: '/liability-monitoring',
            parentView: 'productMgmt.sportbook.sm_liability_monitoring',
            templateUrl: '/app/products/products/sportbook/sm-prematch/liability-monitoring/liability.view.html',
            controller: 'smPrematchLiabilityMonitoringCtrl',
            resolve: {
                loadController: ['$ocLazyLoad', function($ocLazyLoad) {
                    return $ocLazyLoad.load('[DIST_PATH]js/seven-admin-sportbook-productmgmt.js')
                }]
            }
        })

        // Tickets
        .state('productMgmt.sportbook.sm_tickets', {
            url: '/sm-tickets',
            parentView: 'productMgmt.sportbook.sm_tickets',
            templateUrl: '/app/products/products/sportbook/sm-prematch/tickets/tickets.html',
            controller: 'smPrematchTicketsCtrl',
            params: {
                reports: false,
                queryParams: ''
            },
            resolve: {
                loadController: ['$ocLazyLoad', function($ocLazyLoad) {
                    return $ocLazyLoad.load('[DIST_PATH]js/seven-admin-sportbook-productmgmt.js')
                }]
            }
        })
        .state('productMgmt.sportbook.sm_tickets_v2', {
            url: '/sm-tickets-v2',
            parentView: 'productMgmt.sportbook.sm_tickets_v2',
            templateUrl: '/app/products/products/sportbook/sm-prematch/tickets-v2/tickets.html',
            controller: 'smPrematchTicketsV2Ctrl',
            params: {
                reports: false,
                queryParams: '',
                fromState: ''
            },
            resolve: {
                loadController: ['$ocLazyLoad', function($ocLazyLoad) {
                    return $ocLazyLoad.load('[DIST_PATH]js/seven-admin-sportbook-productmgmt.js')
                }]
            }
        })

        // Odds scheme
        .state('productMgmt.sportbook.sm_odds_scheme', {
            url: '/sm-odds-scheme',
            parentView: 'productMgmt.sportbook.sm_odds_scheme',
            templateUrl: '/app/products/products/sportbook/sm-prematch/odds-scheme/odds-scheme.html',
            controller: 'smOddsSchemeCtrl',
            resolve: {
                loadController: ['$ocLazyLoad', function($ocLazyLoad) {
                    return $ocLazyLoad.load('[DIST_PATH]js/seven-admin-sportbook-productmgmt.js')
                }]
            },
            redirectTo: 'productMgmt.sportbook.sm_odds_scheme.scheme_types'
        })
        .state('productMgmt.sportbook.sm_odds_scheme.scheme_types', {
            url: '/scheme-types',
            templateUrl: '/app/products/products/sportbook/sm-prematch/odds-scheme/scheme-types/view.html',
            controller: 'smSchemeTypesCtrl',
            resolve: {
                loadController: ['$ocLazyLoad', function($ocLazyLoad) {
                    return $ocLazyLoad.load('[DIST_PATH]js/seven-admin-sportbook-productmgmt.js')
                }]
            }
        })
        .state('productMgmt.sportbook.sm_odds_scheme.scheme_creator', {
            url: '/scheme-creator',
            templateUrl: '/app/products/products/sportbook/sm-prematch/odds-scheme/scheme-creator/view.html',
            controller: 'smSchemeCreatorCtrl',
            resolve: {
                loadController: ['$ocLazyLoad', function($ocLazyLoad) {
                    return $ocLazyLoad.load('[DIST_PATH]js/seven-admin-sportbook-productmgmt.js')
                }]
            }
        })
        .state('productMgmt.sportbook.sm_odds_scheme.sport_scheme_assigns', {
            url: '/sport-scheme-assigns',
            templateUrl: '/app/products/products/sportbook/sm-prematch/odds-scheme/scheme-assigns/sport-assign/view.html',
            controller: 'smSportSchemeAssignsCtrl',
            resolve: {
                loadController: ['$ocLazyLoad', function($ocLazyLoad) {
                    return $ocLazyLoad.load('[DIST_PATH]js/seven-admin-sportbook-productmgmt.js')
                }]
            }
        })
        .state('productMgmt.sportbook.sm_odds_scheme.tournament_scheme_assigns', {
            url: '/tournament-scheme-assigns',
            templateUrl: '/app/products/products/sportbook/sm-prematch/odds-scheme/scheme-assigns/tournament-assign/view.html',
            controller: 'smTournamentSchemeAssignsCtrl',
            resolve: {
                loadController: ['$ocLazyLoad', function($ocLazyLoad) {
                    return $ocLazyLoad.load('[DIST_PATH]js/seven-admin-sportbook-productmgmt.js')
                }]
            }
        })

        // Offer templates
        .state('productMgmt.sportbook.sm_offer_templates', {
            url: '/sm-offer-templates',
            parentView: 'productMgmt.sportbook.sm_offer_templates',
            templateUrl: '/app/products/products/sportbook/sm-prematch/offer-templates/offer-template.html',
            controller: 'smOfferTemplatesCtrl',
            resolve: {
                loadController: ['$ocLazyLoad', function($ocLazyLoad) {
                    return $ocLazyLoad.load('[DIST_PATH]js/seven-admin-sportbook-productmgmt.js')
                }]
            }
        })

        .state('productMgmt.sportbook.visualizationLinks', {
            url: '/visualization-links',
            parentView: 'productMgmt.sportbook.visualizationLinks',
            templateUrl: '/app/products/products/sportbook/operations/visualization-links/visualization-links.html',
            controller: 'visualizationLinksController',
            resolve: {
                loadController: ['$ocLazyLoad', function($ocLazyLoad) {
                    return $ocLazyLoad.load('[DIST_PATH]js/seven-admin-sportbook-productmgmt.js')
                }]
            }
        })

        .state('productMgmt.sportbook.cashout', {
            url: '/cashout',
            parentView: 'productMgmt.sportbook.cashout',
            templateUrl: '/app/products/products/sportbook/operations/cashout/cashout.html',
            controller: 'cashoutController',
            resolve: {
                loadController: ['$ocLazyLoad', function($ocLazyLoad) {
                    return $ocLazyLoad.load('[DIST_PATH]js/seven-admin-sportbook-productmgmt.js')
                }]
            }
        })

        // SM Custom selection
        .state('productMgmt.sportbook.sm_custom_selection', {
            url: '/sm-custom-selection',
            parentView: 'productMgmt.sportbook.sm_custom_selection',
            templateUrl: '/app/products/products/sportbook/sm-prematch/custom-selection/custom-selection.html',
            controller: 'smCustomSelectionCtrl',
            resolve: {
                loadController: ['$ocLazyLoad', function($ocLazyLoad) {
                    return $ocLazyLoad.load('[DIST_PATH]js/seven-admin-sportbook-productmgmt.js')
                }]
            }
        })

        .state('productMgmt.sportbook.sm_custom_selection_edit', {
            url: '/sm-custom-selection/edit/:idSelection',
            parentView: 'productMgmt.sportbook.sm_custom_selection',
            templateUrl: '/app/products/products/sportbook/sm-prematch/custom-selection/edit/custom-selection-edit.html',
            controller: 'smCustomSelectionEditCtrl',
            params: {
                startDate: '',
                endDate: '',
                typeId: '',
                typeName: '',
                orientationId: '',
                name: ''
            }
        })

        // Cashout Rules
        .state('productMgmt.sportbook.sm_cashout_rules', {
            url: '/sm-cashout-rules',
            parentView: 'productMgmt.sportbook.sm_cashout_rules',
            templateUrl: '/app/products/products/sportbook/sm-prematch/cashout-rules/cashout-rules.view.html',
            controller: 'smPrematchCashoutRulesCtrl',
            redirectTo: 'productMgmt.sportbook.sm_cashout_rules.general_settings',
            resolve: {
                loadController: ['$ocLazyLoad', function($ocLazyLoad) {
                    return $ocLazyLoad.load('[DIST_PATH]js/seven-admin-sportbook-productmgmt.js')
                }]
            }
        })
        .state('productMgmt.sportbook.sm_cashout_rules.general_settings', {
            url: '/general-settings',
            parentView: 'productMgmt.sportbook.sm_cashout_rules',
            templateUrl: '/app/products/products/sportbook/sm-prematch/cashout-rules/general-settings/general-settings.view.html',
            controller: 'smPrematchCashoutRulesGeneralSettingsCtrl',
            resolve: {
                loadController: ['$ocLazyLoad', function($ocLazyLoad) {
                    return $ocLazyLoad.load('[DIST_PATH]js/seven-admin-sportbook-productmgmt.js')
                }]
            }
        })
        .state('productMgmt.sportbook.sm_cashout_rules.additional_settings', {
            url: '/additional-settings',
            parentView: 'productMgmt.sportbook.sm_cashout_rules',
            templateUrl: '/app/products/products/sportbook/sm-prematch/cashout-rules/additional-settings/additional-settings.view.html',
            controller: 'smPrematchCashoutRulesAdditionalSettingsCtrl',
            resolve: {
                loadController: ['$ocLazyLoad', function($ocLazyLoad) {
                    return $ocLazyLoad.load('[DIST_PATH]js/seven-admin-sportbook-productmgmt.js')
                }]
            }
        })
        .state('productMgmt.sportbook.sm_cashout_rules.tickets', {
            url: '/tickets',
            parentView: 'productMgmt.sportbook.sm_cashout_rules',
            templateUrl: '/app/products/products/sportbook/sm-prematch/cashout-rules/tickets/tickets.view.html',
            controller: 'smPrematchCashoutRulesTicketsCtrl',
            resolve: {
                loadController: ['$ocLazyLoad', function($ocLazyLoad) {
                    return $ocLazyLoad.load('[DIST_PATH]js/seven-admin-sportbook-productmgmt.js')
                }]
            }
        })
        .state('productMgmt.sportbook.sm_cashout_rules.punters', {
            url: '/punters',
            parentView: 'productMgmt.sportbook.sm_cashout_rules',
            templateUrl: '/app/products/products/sportbook/sm-prematch/cashout-rules/punters/punters.view.html',
            controller: 'smPrematchCashoutRulesPuntersCtrl',
            resolve: {
                loadController: ['$ocLazyLoad', function($ocLazyLoad) {
                    return $ocLazyLoad.load('[DIST_PATH]js/seven-admin-sportbook-productmgmt.js')
                }]
            }
        });

    $httpProvider.interceptors.push('SMInterceptor');
    $httpProvider.interceptors.push('SBInterceptor');
    $httpProvider.interceptors.push('SBGatewayInterceptor');
}]);
;
(function () {
    angular
        .module('seven-admin-products-integration', []);
})()
;
(function () {
    angular
        .module('seven-admin-products-integration')
        .config(config);

    config.$inject = [
        '$stateProvider',
    ];

    function config(
        $stateProvider,
    ) {
        const PRODUCT_VIEW_STATE = 'productMgmt.products';
        const PRODUCTS_BREADCRUMB = {
            name: 'general.products',
            link: 'productMgmt.products'
        };

        companyProductMismatchGuard.$inject = [
            'resolvedProductMgmtBundle',
            'ENV_CFG',
            '$http',
            '$stateParams',
            '$q',
            'productMgmtSvc'
        ];

        function companyProductMismatchGuard(
            resolvedProductMgmtBundle,
            ENV_CFG,
            $http,
            $stateParams,
            $q,
            productMgmtSvc
        ) {
            return productMgmtSvc.getProductVersions().then(function (response) {
                const product = _.find(response.data, {'cpvUuid': $stateParams.productId});

                if (!product) {
                    return $q.reject({
                        code: 'COMPANY_PRODUCT_INSTANCE_MISMATCH',
                        message: `Company product instance with UUID ${$stateParams.productId} doesn't exist`
                    })
                }

                return true;
            })
        }
        const resolve = {
            canLoad: companyProductMismatchGuard
        };

        $stateProvider
            .state('productMgmt.kolor', {
                url: '/kolor/:productId/:path',
                parentView: PRODUCT_VIEW_STATE,
                views: {
                    '': {
                        templateUrl: '/app/shared/integration/integration.template.html',
                        controller: 'IntegrationController',
                        controllerAs: 'vm'
                    }
                },
                params: {
                    productId: undefined
                },
                data: {
                    widgetKey: 'Kolor',
                    breadcrumbs: [
                        PRODUCTS_BREADCRUMB,
                        {
                            name: 'product.Kolor',
                            link: 'productMgmt.kolor'
                        }
                    ]
                },
                resolve,
            })
            .state('productMgmt.lightningroulette', {
                url: '/lightning-roulette/:productId/:path',
                parentView: PRODUCT_VIEW_STATE,
                views: {
                    '': {
                        templateUrl: '/app/shared/integration/integration.template.html',
                        controller: 'IntegrationController',
                        controllerAs: 'vm'
                    }
                },
                params: {
                    productId: undefined
                },
                data: {
                    widgetKey: 'LightningRoulette',
                    breadcrumbs: [
                        PRODUCTS_BREADCRUMB,
                        {
                            name: 'product.LightningRoulette',
                            link: 'productMgmt.lightningroulette'
                        }
                    ]
                },
                resolve,
            })
            .state('productMgmt.spinandwin', {
                url: '/spin-and-win/:productId/:path',
                parentView: PRODUCT_VIEW_STATE,
                views: {
                    '': {
                        templateUrl: '/app/shared/integration/integration.template.html',
                        controller: 'IntegrationController',
                        controllerAs: 'vm'
                    }
                },
                params: {
                    productId: undefined
                },
                data: {
                    widgetKey: 'SpinAndWin',
                    breadcrumbs: [
                        PRODUCTS_BREADCRUMB,
                        {
                            name: 'product.spin_and_win',
                            link: 'productMgmt.spinAndWin'
                        }
                    ]
                },
                resolve,
            })
            .state('productMgmt.roulette', {
                url: '/roulette/:productId/:path',
                parentView: PRODUCT_VIEW_STATE,
                views: {
                    '': {
                        templateUrl: '/app/shared/integration/integration.template.html',
                        controller: 'IntegrationController',
                        controllerAs: 'vm'
                    }
                },
                params: {
                    productId: undefined
                },
                data: {
                    widgetKey: 'Roulette',
                    breadcrumbs: [
                        PRODUCTS_BREADCRUMB,
                        {
                            name: 'product.roulette',
                            link: 'productMgmt.roulette'
                        }
                    ]
                },
                resolve
            })
            .state('productMgmt.vermantiahorseracingroulette', {
                url: '/vermantiahorseracingroulette/:name/:productId/:path',
                parentView: PRODUCT_VIEW_STATE,
                views: {
                    '': {
                        templateUrl: '/app/shared/integration/integration.template.html',
                        controller: 'IntegrationController',
                        controllerAs: 'vm'
                    }
                },
                params: {
                    productId: undefined
                },
                data: {
                    widgetKey: 'VermantiaHorseRacingRoulette',
                    breadcrumbs: [
                        PRODUCTS_BREADCRUMB,
                        {
                            name: 'admin.product_VermantiaHorseRacingRoulette',
                            link: 'productMgmt.vermantiahorseracingroulette'
                        }
                    ]
                },
                resolve,
            })
            .state('productMgmt.sportradarvirtualfootball', {
                url: '/sportradarvirtualfootball/:name/:productId/:path',
                parentView: PRODUCT_VIEW_STATE,
                views: {
                    '': {
                        templateUrl: '/app/shared/integration/integration.template.html',
                        controller: 'IntegrationController',
                        controllerAs: 'vm'
                    }
                },
                params: {
                    productId: undefined
                },
                data: {
                    widgetKey: 'SportradarVirtualFootball',
                    breadcrumbs: [
                        PRODUCTS_BREADCRUMB,
                        {
                            name: 'admin.product_SportradarVirtualFootball',
                            link: 'productMgmt.sportradarvirtualfootball'
                        }
                    ]
                },
                resolve,
            })
            .state('productMgmt.virtualSoccerDev', {
                url: '/virtualsoccerdev/:productId/:path',
                parentView: PRODUCT_VIEW_STATE,
                views: {
                    '': {
                        templateUrl: '/app/shared/integration/integration.template.html',
                        controller: 'IntegrationController',
                        controllerAs: 'vm'
                    }
                },
                params: {
                    productId: undefined
                },
                data: {
                    widgetKey: 'VirtualSoccerDev',
                    breadcrumbs: [
                        PRODUCTS_BREADCRUMB,
                        {
                            name: 'admin.product_VirtualSoccerDev',
                            link: 'productMgmt.virtualSoccerDev'
                        }
                    ]
                },
                resolve,
            })
            .state('productMgmt.virtualSoccer', {
                url: '/virtualsoccer/:productId/:path',
                parentView: PRODUCT_VIEW_STATE,
                views: {
                    '': {
                        templateUrl: '/app/shared/integration/integration.template.html',
                        controller: 'IntegrationController',
                        controllerAs: 'vm'
                    }
                },
                params: {
                    productId: undefined
                },
                data: {
                    widgetKey: 'VirtualSoccer',
                    breadcrumbs: [
                        PRODUCTS_BREADCRUMB,
                        {
                            name: 'admin.product_VirtualSoccer',
                            link: 'productMgmt.virtualSoccer'
                        }
                    ]
                },
                resolve,
            })
            .state('productMgmt.betradarVirtualGames', {
                url: '/betradarvirtualgames/:productId/:path',
                parentView: PRODUCT_VIEW_STATE,
                views: {
                    '': {
                        templateUrl: '/app/shared/integration/integration.template.html',
                        controller: 'IntegrationController',
                        controllerAs: 'vm'
                    }
                },
                params: {
                    productId: undefined
                },
                data: {
                    widgetKey: 'BetradarVG',
                    breadcrumbs: [
                        PRODUCTS_BREADCRUMB,
                        {
                            name: 'admin.product_BetradarVG',
                            link: 'productMgmt.betradarVirtualGames'
                        }
                    ]
                },
                resolve,
            })
            .state('productMgmt.numbersbetting', {
                url: '/numbersbetting/:name/:productId/:path/',
                parentView: PRODUCT_VIEW_STATE,
                views: {
                    '': {
                        templateUrl: '/app/shared/integration/integration.template.html',
                        controller: 'IntegrationController',
                        controllerAs: 'vm'
                    }
                },
                params: {
                    productId: undefined
                },
                data: {
                    addPathToFrameURL: true,
                    widgetKey: 'NumbersBetting',
                    breadcrumbs: [
                        PRODUCTS_BREADCRUMB,
                        {
                            name: 'admin.product_NumbersBetting',
                            link: 'productMgmt.numbersbetting'
                        }
                    ]
                },
                resolve,
            })
            .state('productMgmt.crashCash', {
                url: '/crashcash/:name/:productId/:path/',
                parentView: PRODUCT_VIEW_STATE,
                views: {
                    '': {
                        templateUrl: '/app/shared/integration/integration.template.html',
                        controller: 'IntegrationController',
                        controllerAs: 'vm'
                    }
                },
                params: {
                    productId: undefined
                },
                data: {
                    addPathToFrameURL: true,
                    widgetKey: 'CrashCash',
                    breadcrumbs: [
                        PRODUCTS_BREADCRUMB,
                        {
                            name: 'admin.product_CrashCash',
                            link: 'productMgmt.crashCash'
                        }
                    ]
                },
                resolve,
            })
            .state('productMgmt.virtualDragRaces', {
                url: '/virtualdragraces/:productId/:path/',
                parentView: PRODUCT_VIEW_STATE,
                views: {
                    '': {
                        templateUrl: '/app/shared/integration/integration.template.html',
                        controller: 'IntegrationController',
                        controllerAs: 'vm'
                    }
                },
                params: {
                    productId: undefined
                },
                data: {
                    addPathToFrameURL: true,
                    widgetKey: 'VirtualDragRaces',
                    breadcrumbs: [
                        PRODUCTS_BREADCRUMB,
                        {
                            name: 'product.VirtualDragRaces',
                            link: 'productMgmt.virtualDragRaces'
                        }
                    ]
                },
                resolve,
            })
            .state('productMgmt.pocketRocket', {
                url: '/pocketrocket/:name/:productId/:path/',
                parentView: PRODUCT_VIEW_STATE,
                views: {
                    '': {
                        templateUrl: '/app/shared/integration/integration.template.html',
                        controller: 'IntegrationController',
                        controllerAs: 'vm'
                    }
                },
                params: {
                    productId: undefined
                },
                data: {
                    addPathToFrameURL: true,
                    widgetKey: 'PocketRocket',
                    breadcrumbs: [
                        PRODUCTS_BREADCRUMB,
                        {
                            name: 'admin.product_PocketRocket',
                            link: 'productMgmt.pocketRocket'
                        }
                    ]
                },
                resolve,
            });
    }
})()
;
angular.module('seven-admin-sportbook-productmgmt').factory('SMInterceptor', [
    'userInitData',
    'ENV_CFG',
    function (
    userInitData,
    ENV_CFG
) {
    var tenantId = userInitData.currentCompany && userInitData.currentCompany.uuid;
    var baseUrl = ENV_CFG.api.smGateway[tenantId] || ENV_CFG.api.smGateway.default;

    var isValidUrl = function (url) {
        return url.toString().indexOf(baseUrl) >= 0;
    };

    return {
        request: function (request) {
            if (isValidUrl(request.url)) {
                request.headers['X-NSFT-SEVEN-DC'] = userInitData.dataCenter;
                request.headers['X-NSFT-SEVEN-COMPANY-UUID'] = userInitData.currentCompany.uuid;
                request.headers['X-NSFT-SEVEN-COMPANY-TIMEZONE'] = userInitData.currentCompany.timezone.name;
                request.headers['USER-TIMEZONE'] = userInitData.mode !== 'SUPER' ? userInitData.user.timezone ?  userInitData.user.timezone : userInitData.currentCompany.timezone.name : '';
                request.headers['USER-UUID'] = userInitData.user.uuid;
                request.headers['USER-DATE-FORMAT'] = userInitData.user.dateFormat ? userInitData.user.dateFormat : 'yyyy-MM-dd';

                if (localStorage.getItem('smToken') !== null) {
                    request.headers['X-NSFT-SM-AUTH'] = localStorage.getItem('smToken');
                }
            }

            return request;
        },

        response: function (response) {
            if (response.headers('sm-token')) {
                localStorage.setItem('smToken', response.headers('sm-token'));
            }

            return response;
        }
    };
}]);

angular.module('seven-admin-sportbook-productmgmt').factory('SBGatewayInterceptor', [
    'userInitData',
    'ENV_CFG',
    function (
        userInitData,
        ENV_CFG
    ) {
        var baseUrl = ENV_CFG.api.sbGateway;

        var isValidUrl = function (url) {
            return url.toString().indexOf(baseUrl) >= 0;
        };

        return {
            request: function (request) {
                if (isValidUrl(request.url)) {
                    request.headers['USER-TIMEZONE'] = userInitData.mode !== 'SUPER' ? userInitData.user.timezone ?  userInitData.user.timezone : userInitData.currentCompany.timezone.name : '';
                    request.headers['X-NSFT-SEVEN-DC'] = userInitData.dataCenter;
                    request.headers['X-NSFT-SEVEN-COMPANY-UUID'] = userInitData.mode !== 'SUPER' ?  userInitData.currentCompany.uuid : '';
                }

                return request;
            }
        };
    }]);

angular.module('seven-admin-sportbook-productmgmt').factory('SBInterceptor', [
    'userInitData',
    'ENV_CFG',
    function (
        userInitData,
        ENV_CFG
    ) {
        var tenantId = userInitData.currentCompany && userInitData.currentCompany.uuid;
        var baseUrl = ENV_CFG.api.sportsbook[tenantId] || ENV_CFG.api.sportsbook.default;

        var isValidUrl = function (url) {
            return url.toString().indexOf(baseUrl) >= 0;
        };

        return {
            request: function (request) {
                if (isValidUrl(request.url)) {
                    request.headers['COMPANY_UUID'] = userInitData.mode !== 'SUPER' ? userInitData.currentCompany.uuid : 'root_account';
                    request.headers['SEVEN_LOCALE'] = userInitData.user.language ? userInitData.user.language : userInitData.currentCompany.language;
                    request.headers['SEVEN_TIMEZONE'] = userInitData.user.timezone ?  userInitData.user.timezone : userInitData.currentCompany.timezone.name;
                }

                return request;
            }
        };
    }]);
;
angular.module('seven-admin-productmgmt').factory('LIVEBettingApiService', [
    '$http',
    '$q',
    'appSettingsSvc',
    'userInitData',
function (
    $http,
    $q,
    appSettingsSvc,
    userInitData
) {
    var baseUrl = appSettingsSvc.urls.sportsbookApi,
        adminMode = userInitData.mode === 'COMPANY' ? '/liveCompanyAdmin/v1/' : '/liveBookmakerAdmin/v1/';

    var tabMappedNames = {

    };

    var tabTranslationMappedNames = {
        sport: 'sports',
        category: 'categories',
        team: 'teams',
        bet: 'bets',
        outcome: 'outcomes',
        tournament: 'tournaments',
        betgroup: 'betGroups'
    };

    var tabTranslationUpdateMappedNames = {
        SportTranslation: 'sports',
        CategoryTranslation: 'categories',
        TeamTranslation: 'teams',
        BetTranslation: 'bets',
        OutcomeTranslation: 'outcomes',
        TournamentTranslation: 'tournaments',
        BetGroupTranslation: 'betGroups'
    };

    var translationsIdMappedValues = {
        betGroups: 'id_bet_group'
    };
    var detailsMappedNames = {
        sport: 'sports',
        category: 'categories',
        team: 'teams',
        bet: 'bets',
        tournament: 'tournaments',
        betgroup: 'betGroups',
        outcome: 'outcomes'
    };

    var limitsMappedNames = {
        player: 'players',
        betshop: 'betshops'
    };

    var getMatchDataCanceler = null;
    var getMatchResultsCanceler = null;
    var getTicketBetsCanceler = null;

    var mapTranslationsIdName = function (tab, data) {
        return translationsIdMappedValues[tab] ? data[translationsIdMappedValues[tab]] : data.id;
    };

    var lowerCaseFirstLetter = function(string) {
        return string.charAt(0).toLowerCase() + string.slice(1);
    };

    var getRequest = function (url, params) {
        return $http({
            url: url,
            method: 'GET',
            params: params
        }).then(function (response) {
            return response;
        }, function (error) {
            return error;
        });
    };

    var postRequest = function (url, data) {
        return $http({
            url: url,
            method: 'POST',
            data: data
        }).then(function (response) {
            return response;
        }, function (error) {
            return error;
        });
    };

    var putRequest = function (url, data) {
        return $http({
            url: url,
            method: 'PUT',
            data: data
        }).then(function (response) {
            return response;
        }, function (error) {
            return error;
        });
    };

    var deleteRequest = function (url) {
        return $http({
            url: url,
            method: 'DELETE'
        }).then(function (response) {
            return response;
        }, function (error) {
            return error;
        });
    };

    var mapTabName = function (value) {
        value = lowerCaseFirstLetter(value);
        return tabMappedNames[value] ? tabMappedNames[value] : value;
    };

    var mapTranslationsTabName = function (value) {
        value = value.toLowerCase();
        return tabTranslationMappedNames[value] ? tabTranslationMappedNames[value] : value;
    };

    var mapTranslationsUpdateTabName = function (value) {
        return tabTranslationUpdateMappedNames[value] ? tabTranslationUpdateMappedNames[value] : value;
    };

    var mapDetailsUpdateTabName = function (value) {
        value = value.toLowerCase();
        return detailsMappedNames[value] ? detailsMappedNames[value] : value;
    };

    var mapLimitsUpdateTabName = function (value) {
        value = value.toLowerCase();
        return limitsMappedNames[value] ? limitsMappedNames[value] : value
    };

    var formatTranslationsPostData = function (data) {
        return {
            name: data.name,
            display_name: data.display_name,
            short_name: data.short_name,
            prefix: data.prefix,
            display_formula: data.display_formula,
            display_formula_short: data.display_formula_short
        };
    };

    var formatPostId = function (tab, id) {
        var decodedIds = ['outcomes', 'bets'];
        return decodedIds.indexOf(tab) === -1 ? id : encodeURI(encodeURIComponent(id));
    };

    return {
        /**
         * Get table data
         * @param params - query params (filters)
         * @param tab - (sports, bets, teams)
         */
        commonTableDataRequest: function (params, tab) {
            var url = baseUrl + adminMode + mapTabName(tab);
            return getRequest(url, params);
        },

        /**
         * Fetch translations
         * @param id
         * @param tab
         * @returns {*}
         */
        commonTranslationsGetRequest: function (id, tab) {
            var url = baseUrl + adminMode + mapTranslationsTabName(tab) + '/' + id + '/translations';
            return getRequest(url, {});
        },

        /**
         * Update translations
         * @param data
         * @param tab
         * @returns {*}
         */
        updateTranslations: function (data, tab) {
            var mappedTab = mapTranslationsUpdateTabName(tab),
                formattedId = mapTranslationsIdName(mappedTab, data),
                id = formatPostId(mappedTab, formattedId),
                url = baseUrl + adminMode + mappedTab + '/' + id + '/translations/' + data.language,
                postData = formatTranslationsPostData(data);
            return postRequest(url, postData);
        },

        updateDetails: function (data, tab) {
            var mappedTab = mapDetailsUpdateTabName(tab),
                id = formatPostId(mappedTab, data.id),
                url = baseUrl + adminMode + mappedTab + '/' + id;
            return postRequest(url, data);
        },

        getTicketBets: function (params) {
            if(getTicketBetsCanceler !== null) {
                getTicketBetsCanceler.resolve();
            }

            getTicketBetsCanceler = $q.defer();

            var url = baseUrl + adminMode + 'tickets/' + params.id + '/bets';

            return $http({
                url: url,
                method: 'GET',
                params: {},
                timeout: getTicketBetsCanceler.promise
            }).then(function (response) {
                return response;
            }, function (error) {
                return error;
            });
        },

        getLimitList: function () {
            var url = baseUrl + adminMode + 'limits';
            return getRequest(url, {});
        },

        getLimitsCalculationTypes: function () {
            var url = baseUrl + adminMode + 'limits/calculationTypes';
            return getRequest(url, {});
        },

        getMatchSelection: function (params) {
            var url = baseUrl + adminMode + 'matchesSelections';
            return getRequest(url, params);
        },

        getMatchData: function (id) {
            if(getMatchDataCanceler !== null) {
                getMatchDataCanceler.resolve();
            }

            getMatchDataCanceler = $q.defer();

            var url = baseUrl + adminMode + 'matches';

            return $http({
                url: url,
                method: 'GET',
                params: id,
                timeout: getMatchDataCanceler.promise
            }).then(function (response) {
                return response;
            }, function (error) {
                return error;
            });
        },

        getMatchResults: function (id) {
            if (getMatchResultsCanceler !== null) {
                getMatchResultsCanceler.resolve();
            }

            getMatchResultsCanceler = $q.defer();

            var url = baseUrl + adminMode + 'results';

            return $http({
                url: url,
                method: 'GET',
                params: id,
                timeout: getMatchResultsCanceler.promise
            }).then(function (response) {
                return response;
            }, function (error) {
                return error;
            });
        },

        addMatchFTResult: function (id, result) {
            var url = baseUrl + adminMode + 'results';

            var data = {
                data: {
                    id_match: parseInt(id),
                    id_result: 90,
                    result_team: 'FT',
                    result_value: result
                }
            };

            return postRequest(url, data);
        },

        updateMatch: function (data) {
            var url = baseUrl + adminMode + 'matches/' + data.id;
            return postRequest(url, data);
        },

        updateMatchBets: function (data) {
            var url = baseUrl + adminMode + 'matchBets';
            return postRequest(url, data);
        },

        getCashoutDeductionFactors: function () {
            var url = baseUrl + adminMode + 'deductionFactors';
            return getRequest(url);
        },

        getCashoutConfigs: function() {
            var url = baseUrl + adminMode + 'cashoutConfigs';
            return getRequest(url);
        },

        updateCashoutDeductionFactor(id, data) {
            var url = baseUrl + adminMode + 'deductionFactors/' + id;
            return putRequest(url, data);
        },

        updateCashoutConfigs(id, data) {
            var url = baseUrl + adminMode + 'cashoutConfigs/' + id;
            return putRequest(url, data);
        },

        addCashoutDeductionFactor(data) {
            var url = baseUrl + adminMode + 'deductionFactors';
            return postRequest(url, data);
        },

        deleteCashoutDeductionFactor(id) {
            var url = baseUrl + adminMode + 'deductionFactors/' + id;
            return deleteRequest(url);
        },

        updatePlayerCashoutRule(data) {
            var url = baseUrl + adminMode + 'playerCashoutRules';
            return putRequest(url, data);
        },

        addCashoutDelay(data, type, typeId) {
            var url = baseUrl + adminMode + 'cashoutDelay/' + type + '/' + typeId;
            return postRequest(url, data);
        },
        updateCashoutDelay(data, type, typeId) {
            var url = baseUrl + adminMode + 'cashoutDelay/' + type + '/' + typeId;
            return putRequest(url, data);
        },
        deleteCashoutDelay(type, typeId) {
            var url = baseUrl + adminMode + 'cashoutDelay/' + type + '/' + typeId;
            return deleteRequest(url);
        },

        updateMatchCashoutRules: function (data) {
            var url = baseUrl + adminMode + 'matchCashoutRules';
            return putRequest(url, data);
        },

        updateBetCashoutRules: function (data) {
            var url = baseUrl + adminMode + 'betCashoutRules';
            return putRequest(url, data);
        },

        updateBetOutcomeCashoutRules: function (data) {
            var url = baseUrl + adminMode + 'betOutcomeCashoutRules';
            return putRequest(url, data);
        },

        updateTicketCashoutAvailability: function (data) {
            var url = baseUrl + adminMode + 'ticketCashoutAvailabilities';
            return putRequest(url, data);
        },

        getLayoutsTemplates: function () {
            var url = baseUrl + adminMode + 'matchesSelections/filters';
            return getRequest(url, {});
        },

        updateMatchSelection: function (data) {
            var url = baseUrl + adminMode + 'matchesSelections';
            return postRequest(url, data);
        },

        updateLimits: function (data, tab) {
            var url = baseUrl + adminMode + mapLimitsUpdateTabName(tab);
            return postRequest(url, data);
        },

        createLimit: function (data) {
            var url = baseUrl + adminMode + 'limits';
            return postRequest(url, data);
        },

        getMatchMeta: function (id) {
            var url = baseUrl + adminMode + 'requestMeta';
            return getRequest(url, { id_match: id });
        },
        createBetGroups: function (data) {
            var url = baseUrl + adminMode + 'betGroups';
            return postRequest(url, data);
        },
        getBetGroupDetails: function (id) {
            var url = baseUrl + adminMode + 'betGroups/' + id;
            return getRequest(url, {});
        },
        getTournamentEntities: function(id) {
            var url = baseUrl + adminMode + 'tournaments/' + id + '/exclusivitySetting';
            return getRequest(url, {});
        },
        updateTournamentEntities: function(id, data) {
            var url = baseUrl + adminMode + 'tournaments/' + id + '/exclusivitySetting';
            return postRequest(url, data);
        },
        deleteTournamentEntities: function(id) {
            var url = baseUrl + adminMode + 'tournaments/' + id + '/exclusivitySetting';
            return deleteRequest(url, {});
        }
    };
}]);
;
angular.module('seven-admin-productmgmt').factory('PREMATCHBettingApiService', [
    '$http',
    '$q',
    'appSettingsSvc',
    'userInitData',
function (
    $http,
    $q,
    appSettingsSvc,
    userInitData
) {
    var baseUrl = appSettingsSvc.urls.sportsbookApi,
        adminMode = userInitData.mode === 'COMPANY' ? '/prematchCompanyAdmin/v1/' : '/prematchBookmakerAdmin/v1/',
        betClassBetsCanceler = null,
        betClassTournamentsCanceler = null,
        offerMatchesCanceler = null,
        getMatchDataCanceler = null,
        getTicketBetsCanceler = null,
        getManualResolveMatchBetsCanceler = null,
        getPrematchVisualizationSettingsCanceler = null,
        getPrematchVisualizationTemplatesCanceler = null;

    var tabMappedNames = {

    };

    var tabTranslationMappedNames = {
        sport: 'sports',
        category: 'categories',
        team: 'teams',
        bet: 'bets',
        outcome: 'outcomes',
        tournament: 'tournaments',
        betgroup: 'betGroups'
    };

    var tabTranslationUpdateMappedNames = {
        SportTranslation: 'sports',
        CategoryTranslation: 'categories',
        TeamTranslation: 'teams',
        BetTranslation: 'bets',
        OutcomeTranslation: 'outcomes',
        TournamentTranslation: 'tournaments',
        BetGroupTranslation: 'betGroups'
    };

    var detailsMappedNames = {
        sport: 'sports',
        category: 'categories',
        team: 'teams',
        bet: 'bets',
        tournament: 'tournaments',
        betgroup: 'betGroups',
        outcome: 'outcomes'
    };

    var translationsIdMappedValues = {
        sports: 'id_sport',
        categories: 'id_category',
        tournaments: 'id_tournament',
        teams: 'id_team',
        bets: 'id_bet',
        betGroups: 'id_bet_group',
        outcomes: 'id_bet_outcome'
    };

    var limitsMappedNames = {
        player: 'players',
        betshop: 'betshops'
    };

    var lowerCaseFirstLetter = function(string) {
        return string.charAt(0).toLowerCase() + string.slice(1);
    };

    var getRequest = function (url, params) {
        return $http({
            url: url,
            method: 'GET',
            params: params
        }).then(function (response) {
            return response;
        }, function (error) {
            return error;
        });
    };

    var postRequest = function (url, data) {
        return $http({
            url: url,
            method: 'POST',
            data: data
        }).then(function (response) {
            return response;
        }, function (error) {
            return error;
        });
    };

    var mapTabName = function (value) {
        value = lowerCaseFirstLetter(value);
        return tabMappedNames[value] ? tabMappedNames[value] : value;
    };

    var mapTranslationsTabName = function (value) {
        value = value.toLowerCase();
        return tabTranslationMappedNames[value] ? tabTranslationMappedNames[value] : value;
    };

    var mapTranslationsUpdateTabName = function (value) {
        return tabTranslationUpdateMappedNames[value] ? tabTranslationUpdateMappedNames[value] : value;
    };

    var mapTranslationsIdName = function (tab, data) {
        return translationsIdMappedValues[tab] ? data[translationsIdMappedValues[tab]] : data.id;
    };


    var mapDetailsUpdateTabName = function (value) {
        value = value.toLowerCase();
        return detailsMappedNames[value] ? detailsMappedNames[value] : value;
    };

    var mapLimitsUpdateTabName = function (value) {
        value = value.toLowerCase();
        return limitsMappedNames[value] ? limitsMappedNames[value] : value
    };

    var formatTranslationsPostData = function (data) {
        return {
            name: data.name,
            display_name: data.display_name,
            short_name: data.short_name,
            prefix: data.prefix,
            display_formula: data.display_formula,
            short_display_formula: data.short_display_formula
        };
    };

    var formatPostId = function (tab, id) {
        var decodedIds = ['outcomes', 'bets'];
        return decodedIds.indexOf(tab) === -1 ? id : encodeURI(encodeURIComponent(id));
    };

    return {
        /**
         * Get table data
         * @param params - query params (filters)
         * @param tab - (sports, bets, teams)
         */
        commonTableDataRequest: function (params, tab) {
            var url = baseUrl + adminMode + mapTabName(tab);
            return getRequest(url, params);
        },

        /**
         * Fetch translations
         * @param id
         * @param tab
         * @returns {*}
         */
        commonTranslationsGetRequest: function (id, tab) {
            var url = baseUrl + adminMode + mapTranslationsTabName(tab) + '/' + id + '/translations';
            return getRequest(url, {});
        },

        /**
         * Update translations
         * @param data
         * @param tab
         * @returns {*}
         */
        updateTranslations: function (data, tab) {
            var mappedTab = mapTranslationsUpdateTabName(tab),
                formattedId = mapTranslationsIdName(mappedTab, data),
                id = formatPostId(mappedTab, formattedId),
                url = baseUrl + adminMode + mappedTab + '/' + id + '/translations/' + data.language,
                postData = formatTranslationsPostData(data);
            return postRequest(url, postData);
        },

        updateDetails: function (data, tab) {
            var mappedTab = mapDetailsUpdateTabName(tab),
                id = formatPostId(mappedTab, data.id),
                url = baseUrl + adminMode + mappedTab + '/' + id;
            return postRequest(url, data);
        },

        getTicketBets: function (params) {
            if(getTicketBetsCanceler !== null) {
                getTicketBetsCanceler.resolve();
            }

            getTicketBetsCanceler = $q.defer();

            var url = baseUrl + adminMode + 'tickets/' + params.id + '/bets';

            return $http({
                url: url,
                method: 'GET',
                params: {},
                timeout: getTicketBetsCanceler.promise
            }).then(function (response) {
                return response;
            }, function (error) {
                return error;
            });
        },

        getMatchSelection: function (params) {
            var url = baseUrl + adminMode + 'matchesSelections';
            return getRequest(url, params);
        },

        getMatchData: function (id) {
            if(getMatchDataCanceler !== null) {
                getMatchDataCanceler.resolve();
            }

            getMatchDataCanceler = $q.defer();

            var url = baseUrl + adminMode + 'matches';

            return $http({
                url: url,
                method: 'GET',
                params: id,
                timeout: getMatchDataCanceler.promise
            }).then(function (response) {
                return response;
            }, function (error) {
                return error;
            });
        },

        getLayoutsTemplates: function () {
            var url = baseUrl + adminMode + 'matchesSelections/filters';
            return getRequest(url, {});
        },

        updateMatchSelection: function (data) {
            var url = baseUrl + adminMode + 'matchesSelections';
            return postRequest(url, data);
        },

        updateLimits: function (data, tab) {
            var url = baseUrl + adminMode + mapLimitsUpdateTabName(tab);
            return postRequest(url, data);
        },

        createLimit: function (data) {
            var url = baseUrl + adminMode + 'limits';
            return postRequest(url, data);
        },

        getLimitsCalculationTypes: function () {
            var url = baseUrl + adminMode + 'limits/calculationTypes';
            return getRequest(url, {});
        },

        getCustomSelections: function (params) {
            var url = baseUrl + adminMode + 'customSelection';
            return getRequest(url, params);
        },

        createCustomSelections: function (params) {
            var url = baseUrl + adminMode + 'customSelection';
            return postRequest(url, params);
        },

        updateCustomSelections: function (params) {
            var url = baseUrl + adminMode + 'customSelection/multiRequest';
            return postRequest(url, params);
        },

        getOfferSelection: function (params) {
            var url = baseUrl + adminMode + 'offerSelection/tournaments';
            return getRequest(url, params);
        },

        getOfferBets: function (params) {
            var url = baseUrl + adminMode + 'offerSelection/tournaments/' + params.id_tournament + '/bets';
            return getRequest(url, params);
        },

        getOfferTranslations: function (params) {
            var url = baseUrl + adminMode + 'offerSelection/tournaments/' + params.id_tournament + '/translations';
            return getRequest(url, params);
        },

        getOfferMatchesBets: function (params) {
            var url = baseUrl + adminMode + 'offerSelection/matches/' + params.id_match + '/bets';
            return getRequest(url, params);
        },

        getOfferMatchesTranslations: function (params, isOutright) {
            var offerTypeFragment = isOutright ? 'outright/' : 'matches/';
            var url = baseUrl + adminMode + 'offerSelection/' + offerTypeFragment + params.id_match + '/translations';
            return getRequest(url, params);
        },

        updatePrematchOffer: function (data) {
            var url = baseUrl + adminMode + 'offerSelection/multiRequest';
            return postRequest(url, data);
        },

        getOfferMatches: function (params) {
            var url = baseUrl + adminMode + 'offerSelection/tournaments/' + params.id_tournament + '/matches';
            if (offerMatchesCanceler !== null) {
                offerMatchesCanceler.resolve();
            }
            offerMatchesCanceler = $q.defer();
            return $http({
                url: url,
                method: 'GET',
                timeout: offerMatchesCanceler.promise,
                params: params
            }).then(function (response) {
                return response;
            }, function (error) {
               return error;
            });
        },

        getBetClassesBets: function (params) {
            var url = baseUrl + adminMode + 'betClasses/' + params.id + '/bets/' + params.id_sport;
            if (betClassBetsCanceler !== null) {
                betClassBetsCanceler.resolve();
            }
            betClassBetsCanceler = $q.defer();
            return $http({
                url: url,
                method: 'GET',
                timeout: betClassBetsCanceler.promise
            }).then(function (response) {
                return response;
            }, function (error) {
                return error;
            });
        },

        getBetClassesTournaments: function (params) {
            var url = baseUrl + adminMode + 'betClasses/' + params.id + '/tournaments/' + params.id_sport;
            if (betClassTournamentsCanceler !== null) {
                betClassTournamentsCanceler.resolve();
            }
            betClassTournamentsCanceler = $q.defer();
            return $http({
                url: url,
                method: 'GET',
                timeout: betClassTournamentsCanceler.promise
            }).then(function (response) {
                return response;
            }, function (error) {
                return error;
            });
        },

        updateBetClasses: function (data, id) {
            var url = baseUrl + adminMode + 'betClasses/' + id;
            return postRequest(url, data);
        },

        createNewBetClass: function (data) {
            var url = baseUrl + adminMode + 'betClasses';
            return postRequest(url, data);
        },

        createBetGroups: function (data) {
            var url = baseUrl + adminMode + 'betGroups';
            return postRequest(url, data);
        },

        getManualResolveMatches: function (params) {
            var url = baseUrl + adminMode + 'manualResolve/matches';
            return getRequest(url, params);
        },

        getManualResolveMatchBets: function (id) {
            if(getManualResolveMatchBetsCanceler !== null) {
                getManualResolveMatchBetsCanceler.resolve();
            }

            getManualResolveMatchBetsCanceler = $q.defer();

            var url = baseUrl + adminMode + 'manualResolve/matches/' + id + '/bets';

            return $http({
                url: url,
                method: 'GET',
                timeout: getManualResolveMatchBetsCanceler.promise
            }).then(function (response) {
                return response;
            }, function (error) {
                return error;
            });
        },

        updateManualResolve: function (params) {
            var url = baseUrl + adminMode + 'manualResolve/resolve';
            return postRequest(url, params);
        },

        getLimitList: function () {
            var url = baseUrl + adminMode + 'limits';
            return getRequest(url, {});
        },

        getSportList: function () {
            var url = baseUrl + adminMode + 'sports/list';
            return getRequest(url, {});
        },

        getPrematchVisualizationSettings: function (params) {
            if(getPrematchVisualizationSettingsCanceler !== null) {
                getPrematchVisualizationSettingsCanceler.resolve();
            }

            getPrematchVisualizationSettingsCanceler = $q.defer();

            var url = baseUrl + adminMode +  'visualization/displays-settings';

            return $http({
                url: url,
                method: 'GET',
                params: params,
                timeout: getPrematchVisualizationSettingsCanceler.promise
            }).then(function (response) {
                return response;
            }, function (error) {
                return error;
            });
        },

        getPrematchVisualizationTemplates: function (params) {
            if(getPrematchVisualizationTemplatesCanceler !== null) {
                getPrematchVisualizationTemplatesCanceler.resolve();
            }

            getPrematchVisualizationTemplatesCanceler = $q.defer();

            var url = baseUrl + adminMode +  'betTemplates';

            return $http({
                url: url,
                method: 'GET',
                timeout: getPrematchVisualizationTemplatesCanceler.promise,
                params: params,
            }).then(function (response) {
                return response;
            }, function (error) {
                return error;
            });
        },

        updatePrematchVisualizationSettings: function (data) {
            var url = baseUrl + adminMode +  'visualization/displays-settings';
            return $http({
                url: url,
                method: 'PUT',
                data: data,
            }).then(function (response) {
                return response;
            }, function (error) {
                return error;
            });
        },
    }
}]);;
var sevenAdminProductStore = angular.module('seven-admin-productstore', [
    ]);

sevenAdminProductStore.config(['$stateProvider', function ($stateProvider) {

    $stateProvider
        .state('productStore', {
            url: '/product-store',
            templateUrl: '/app/productStore/productStore.index.html',
            parent: 'main',
            controller: 'productStoreCtrl',
            resolve: {
                loadController: ['$ocLazyLoad', function($ocLazyLoad) {
                    return $ocLazyLoad.load('[DIST_PATH]js/seven-admin-productstore.js')
                }]
            },
            data: {
                module: 'productStore'
            }
        })
        .state('productStore.products', {
            url: '/products',
            parentView: 'productStore.products',
            views: {
                '': {
                    templateUrl: '/app/productStore/products/productStoreList.html',
                    controller: 'productStoreListCtrl'
                }
            },
            resolve: {
                loadController: ['$ocLazyLoad', function($ocLazyLoad) {
                    return $ocLazyLoad.load('[DIST_PATH]js/seven-admin-productstore.js')
                }]
            },
            data: {
                subModule: 'products'
            }
        })
}]);
;
var sevenAdminShopMgmt = angular.module('seven-admin-shopmgmt', []);

sevenAdminShopMgmt.config(['$stateProvider', function ($stateProvider) {
    var shopManagementBundle = '[DIST_PATH]js/seven-admin-shopmgmt.js';
    var lazyLoadShopManagementBundle = {
        loadBundle: ['$ocLazyLoad', function($ocLazyLoad) {
            return $ocLazyLoad.load(shopManagementBundle)
        }]
    };

    $stateProvider
        .state('shopMgmt', {
            url: '/shop-mgmt',
            templateUrl: '/app/shopMgmt/shopMgmt.index.html',
            parent: 'main',
            controller: 'shopMgmtCtrl',
            data: {
                module: 'shopMgmt'
            }
        })
        .state('shopMgmt.shopMgmtBetshop', {
            url: '/betshops',
            parentView: 'shopMgmt.shopMgmtBetshop',
            views: {
                '': {
                    templateUrl: '/app/shopMgmt/betshops/betshop.index.html',
                    controller: 'betshopListCtrl'
                }
            },
            resolve: {
                loadController: ['$ocLazyLoad', function($ocLazyLoad) {
                    return $ocLazyLoad.load('[DIST_PATH]js/seven-admin-shopmgmt.js')
                }]
            },
            data: {
                subModule: 'shopMgmtBetshop'
            }
        })
        .state('shopMgmt.betshopDetails', {
            url: '/betshop/details/:betshopId',
            parentView: 'shopMgmt.shopMgmtBetshop',
            views: {
                '': {
                    templateUrl: '/app/shopMgmt/betshops/betshop.index.html',
                    controller: 'betshopDetailsCtrl',
                    controllerAs: 'betshopDetailsVm'
                }
            },
            resolve: {
                loadController: ['$ocLazyLoad', function($ocLazyLoad) {
                    return $ocLazyLoad.load([
                        '[DIST_PATH]js/seven-admin-shopmgmt.js',
                        '[DIST_PATH]js/seven-admin-productmgmt.js'
                    ])
                }]
            },
            params: {
                deviceConfig: false
            }
        })
        .state('shopMgmt.addBetshop', {
            url: '/add-new',
            parentView: 'shopMgmt.shopMgmtBetshop',
            views: {
                '': {
                    template: '<view-templates></view-templates>',
                    controller: 'NewBetshopController'
                }
            },
            resolve: {
                loadController: ['$ocLazyLoad', function($ocLazyLoad) {
                    return $ocLazyLoad.load('[DIST_PATH]js/seven-admin-shopmgmt.js')
                }]
            }
        })
        .state('shopMgmt.betshopDetails.deviceConfig', {
            url: '/device-config/:deviceId?:deviceUuid',
            parentView: 'shopMgmt.shopMgmtBetshop',
            views: {
                '@shopMgmt': {
                    templateUrl: '/app/shopMgmt/betshops/deviceConfig/deviceConfig.html',
                    controller: 'deviceConfigCtrl'
                }
            },
            resolve: {
                loadController: ['$ocLazyLoad', function($ocLazyLoad) {
                    return $ocLazyLoad.load('[DIST_PATH]js/seven-admin-shopmgmt.js')
                }]
            },
            params: {
                deviceInstall: false
            }
        })
        .state('shopMgmt.shopMgmtBetshopGroups', {
            url: '/betshop-groups',
            parentView: 'shopMgmt.shopMgmtBetshopGroups',
            views: {
                '': {
                    templateUrl: '/app/shopMgmt/groups/betshopGroups.index.html',
                    controller: 'betshopGroupsListCtrl'
                }
            },
            resolve: {
                loadController: ['$ocLazyLoad', function($ocLazyLoad) {
                    return $ocLazyLoad.load('[DIST_PATH]js/seven-admin-shopmgmt.js')
                }]
            },
            data: {
                subModule: 'shopMgmtBetshopGroups'
            }
        })
        .state('shopMgmt.betshopGroupDetails', {
            url: '/betshop-groups/details/:id',
            parentView: 'shopMgmt.shopMgmtBetshopGroups',
            views: {
                '': {
                    templateUrl: '/app/shopMgmt/groups/betshopGroups.index.html',
                    controller: 'betshopGroupsDetailsCtrl'
                }
            },
            resolve: {
                loadController: ['$ocLazyLoad', function($ocLazyLoad) {
                    return $ocLazyLoad.load([
                        '[DIST_PATH]js/seven-admin-shopmgmt.js',
                        '[DIST_PATH]js/seven-admin-productmgmt.js'
                    ])
                }]
            }
        })
        .state('shopMgmt.addBetshopGroup', {
            url: '/betshop-groups/add-new',
            parentView: 'shopMgmt.shopMgmtBetshopGroups',
            views: {
                '': {
                    templateUrl: '/app/shopMgmt/groups/betshopGroups.index.html',
                    controller: 'betshopGroupsNewCtrl'
                }
            },
            resolve: {
                loadController: ['$ocLazyLoad', function($ocLazyLoad) {
                    return $ocLazyLoad.load('[DIST_PATH]js/seven-admin-shopmgmt.js')
                }]
            }
        })
        .state('shopMgmt.betshopConfiguration', {
            url: '/betshop/configuration/:id',
            parentView: 'shopMgmt.shopMgmtBetshop',
            views: {
                '': {
                    templateUrl: '/app/shopMgmt/betshops/betshop.index.html',
                    controller: 'betshopConfigCtrl'
                }
            },
            resolve: {
                loadController: ['$ocLazyLoad', function($ocLazyLoad) {
                    return $ocLazyLoad.load('[DIST_PATH]js/seven-admin-shopmgmt.js')
                }]
            }
        })
        .state('shopMgmt.betshopConfigurationNgs', {
            url: '/betshop/configuration/ngs/:id',
            parentView: 'shopMgmt.shopMgmtBetshop',
            views: {
                '': {
                    templateUrl: '/app/shopMgmt/betshops/betshop.index.html',
                    controller: 'betshopConfigNgsCtrl'
                }
            },
            resolve: {
                loadController: ['$ocLazyLoad', function($ocLazyLoad) {
                    return $ocLazyLoad.load(['[DIST_PATH]js/seven-admin-shopmgmt.js', '[DIST_PATH]js/seven-admin-productmgmt.js'])
                }]
            }
        })
        .state('shopMgmt.betshopGroupConfiguration', {
            url: '/betshop-group/configuration/:id',
            parentView: 'shopMgmt.shopMgmtBetshopGroups',
            views: {
                '': {
                    templateUrl: '/app/shopMgmt/groups/betshopGroups.index.html',
                    controller: 'betshopGroupConfigCtrl'
                }
            },
            resolve: {
                loadController: ['$ocLazyLoad', function($ocLazyLoad) {
                    return $ocLazyLoad.load('[DIST_PATH]js/seven-admin-shopmgmt.js')
                }]
            }
        })
        .state('shopMgmt.betshopGroupConfigurationNgs', {
            url: '/betshop-group/configuration/ngs/:id',
            parentView: 'shopMgmt.shopMgmtBetshopGroups',
            views: {
                '': {
                    templateUrl: '/app/shopMgmt/groups/betshopGroups.index.html',
                    controller: 'betshopGroupConfigNgsCtrl'
                }
            },
            resolve: {
                loadController: ['$ocLazyLoad', function($ocLazyLoad) {
                    return $ocLazyLoad.load(['[DIST_PATH]js/seven-admin-shopmgmt.js', '[DIST_PATH]js/seven-admin-productmgmt.js'])
                }]
            }
        })
        .state('shopMgmt.shopMgmtTerminals', {
            url: '/betshop/terminals',
            parentView: 'shopMgmt.shopMgmtTerminals',
            views: {
                '': {
                    templateUrl: '/app/shopMgmt/terminals/terminalsList.index.html',
                    controller: 'terminalsListCtrl'
                }
            },
            resolve: {
                loadController: ['$ocLazyLoad', function($ocLazyLoad) {
                    return $ocLazyLoad.load('[DIST_PATH]js/seven-admin-shopmgmt.js')
                }]
            }
        })
        .state('shopMgmt.terminalDetails', {
            url: '/betshop/terminals/details/:id',
            parentView: 'shopMgmt.shopMgmtTerminals',
            views: {
                '': {
                    templateUrl: '/app/shopMgmt/terminals/terminalsList.index.html',
                    controller: 'terminalDetailsCtrl'
                }
            },
            resolve: {
                loadController: ['$ocLazyLoad', function($ocLazyLoad) {
                    return $ocLazyLoad.load('[DIST_PATH]js/seven-admin-shopmgmt.js')
                }]
            }
        })
        .state('shopMgmt.cashRegisterWallets', {
            url: '/betshop/cash-register-wallets',
            parentView: 'shopMgmt.cashRegisterWallets',
            views: {
                '': {
                    templateUrl: '/app/shopMgmt/cashRegisterWallets/cashRegisterWallets.index.html',
                    controller: 'cashRegisterWalletCtrl'
                }
            },
            resolve: {
                loadController: ['$ocLazyLoad', function($ocLazyLoad) {
                    return $ocLazyLoad.load('[DIST_PATH]js/seven-admin-shopmgmt.js')
                }]
            }
        })
        .state('shopMgmt.shopMgmtTicketSecurity', {
            url: '/ticket-security?tab',
            parentView: 'shopMgmt.shopMgmtTicketSecurity',
            views: {
                '': {
                    templateUrl: '/app/shopMgmt/ticket-security/ticket-security.template.html',
                    controller: 'TicketSecurityController'
                }
            },
            resolve: {
                loadController: ['$ocLazyLoad', function($ocLazyLoad) {
                    return $ocLazyLoad.load('[DIST_PATH]js/seven-admin-shopmgmt.js')
                }]
            },
            params: {
                tab: null
            },
            data: {
                subModule: 'shopMgmtTicketSecurity'
            }
        })
        .state('shopMgmt.shopMgmtTicketSecurityAml', {
            url: '/ticket-security/aml',
            parentView: 'shopMgmt.shopMgmtTicketSecurity',
            views: {
                '': {
                    templateUrl: '/app/shopMgmt/ticket-security/aml.template.html',
                    controller: 'amlController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                loadController: ['$ocLazyLoad', function($ocLazyLoad) {
                    return $ocLazyLoad.load('[DIST_PATH]js/seven-admin-shopmgmt.js')
                }]
            },
            data: {
                subModule: 'shopMgmtTicketSecurityAml'
            }
        })
        .state('shopMgmt.shopMgmtLimits', {
            url: '/limits',
            parentView: 'shopMgmt.shopMgmtLimits',
            views: {
                '': {
                    templateUrl: '/app/shopMgmt/betshop-limits/betshop-limits.template.html',
                    controller: 'BetshopLimitsController'
                }
            },
            resolve: {
                loadController: ['$ocLazyLoad', function($ocLazyLoad) {
                    return $ocLazyLoad.load([
                        '[DIST_PATH]js/seven-admin-shopmgmt.js',
                        '[DIST_PATH]js/seven-admin-productmgmt.js'
                    ])
                }]
            },
            data: {
                subModule: 'limits'
            }
        })
        .state('shopMgmt.paymentRestrictions', {
            url: '/payment-restrictions',
            parentView: 'shopMgmt.paymentRestrictions',
            views: {
                '': {
                    templateUrl: '/app/shopMgmt/payment-restrictions/payment-restrictions.template.html',
                    controller: 'PaymentRestrictionsController as model',
                    controllerAs: 'model'
                }
            },
            resolve: {
                loadController: ['$ocLazyLoad', function($ocLazyLoad) {
                    return $ocLazyLoad.load([
                        '[DIST_PATH]js/seven-admin-shopmgmt.js',
                        '[DIST_PATH]js/seven-admin-productmgmt.js'
                    ])
                }]
            }
        })
        .state('shopMgmt.bihTaxIdentifiers', {
            url: '/bih-tax-identifiers',
            parentView: 'shopMgmt.bihTaxIdentifiers',
            views: {
               '': {
                   templateUrl: '/app/shopMgmt/bih-tax/bih-tax-identifiers.template.html',
                   controller: 'BihTaxIdentifiersController',
                   controllerAs: 'vm'
               }
            },
            resolve: {
                loadController: ['$ocLazyLoad', function($ocLazyLoad) {
                    return $ocLazyLoad.load('[DIST_PATH]js/seven-admin-shopmgmt.js')
                }]
            }
        })
        .state('shopMgmt.mneTaxDevices', {
            url: '/mne-tax-devices',
            parentView: 'shopMgmt.mneTaxDevices',
            views: {
                '': {
                    controller: 'MneTaxDevicesController',
                    template: '<view-templates></view-templates>'
                }
            },
            resolve: {
                loadController: ['$ocLazyLoad', function($ocLazyLoad) {
                    return $ocLazyLoad.load('[DIST_PATH]js/seven-admin-shopmgmt.js')
                }]
            }
        })
        .state('shopMgmt.serbianTaxIdentifiers', {
            url: '/serbian-tax-identifiers',
            parentView: 'shopMgmt.serbianTaxIdentifiers',
            views: {
               '': {
                   templateUrl: '/app/shopMgmt/serbian-tax/serbian-tax-identifiers.template.html',
                   controller: 'SerbianTaxIdentifiersController',
                   controllerAs: 'vm'
               }
            },
            resolve: {
                loadController: ['$ocLazyLoad', function($ocLazyLoad) {
                    return $ocLazyLoad.load('[DIST_PATH]js/seven-admin-shopmgmt.js')
                }]
            }
        })
        .state('shopMgmt.serbianTaxIdentifiersDetails', {
            url: '/serbian-tax-identifiers/details/:locationUuid',
            parentView: 'shopMgmt.serbianTaxIdentifiers',
            views: {
                '': {
                    templateUrl: '/app/shopMgmt/serbian-tax/serbian-tax-identifiers-details.template.html',
                    controller: 'SerbianTaxIdentifiersDetailsController'
                }
            }
        }).state('shopMgmt.deviceOverview', {
            url: '/device-overview',
            parentView: 'shopMgmt.deviceOverview',
            views: {
                '': {
                    controller: 'DeviceOverviewController',
                    templateUrl: '/app/shopMgmt/device-overview/device-overview.template.html'
                }
            },
            resolve: {
                loadController: ['$ocLazyLoad', function($ocLazyLoad) {
                    return $ocLazyLoad.load('[DIST_PATH]js/seven-admin-shopmgmt.js')
                }]
            }
        }).state('shopMgmt.plaTaxLocationProvinces', {
            url: '/pla-tax-location-provinces',
            parentView: 'shopMgmt.plaTaxLocationProvinces',
            views: {
                '': {
                    controller: 'PlaTaxProvincesController',
                    templateUrl: '/app/shopMgmt/provinces/provinces.template.html',
                    controllerAs: 'vm'
                }
            },
            resolve: lazyLoadShopManagementBundle
        }).state('shopMgmt.belgiumTaxBetshopLicences', {
            url: '/belgium-tax-betshop-licences',
            parentView: 'shopMgmt.belgiumTaxBetshopLicences',
            views: {
                '': {
                    controller: 'BelgiumTaxBetshopLicencesController',
                    templateUrl: '/app/shopMgmt/betshop-licences/betshop-licences.template.html',
                    controllerAs: 'vm'
                }
            },
            resolve: lazyLoadShopManagementBundle
        }).state('shopMgmt.BiHRSTaxIdentifiers', {
            url: '/bih-rs-tax-identifiers',
            parentView: 'shopMgmt.BiHRSTaxIdentifiers',
            views: {
                '': {
                    template:
                        '<react-grid data-view-name="{{vm.viewName}}"></react-grid>' +
                        '<info-message></info-message>',
                    controller: 'BiHRSTaxIdentifiersController',
                    controllerAs: 'vm'
                }
            },
            resolve: lazyLoadShopManagementBundle
        }).state('shopMgmt.BiHRSTaxIdentifiersDetails', {
            url: '/bih-rs-tax-identifiers/details/:locationUUID',
            parentView: 'shopMgmt.BiHRSTaxIdentifiers',
            views: {
                '': {
                    templateUrl: '/app/shopMgmt/bih-rs-tax/bih-rs-tax-identifiers-details.template.html',
                    controller: 'BiHRSTaxIdentifiersDetailsController',
                    controllerAs: 'vm'
                }
            },
            resolve: lazyLoadShopManagementBundle
        }).state('shopMgmt.MerkurSSBTs', {
            url: '/merkur-ssbts',
            parentView: 'shopMgmt.MerkurSSBTs',
            views: {
                '': {
                    templateUrl: '/app/shopMgmt/merkur-ssbt-integration/merkur-ssbts.template.html',
                    controller: 'MerkurSSBTsController',
                    controllerAs: 'vm'
                }
            },
            resolve: lazyLoadShopManagementBundle
        }).state('shopMgmt.AutoLogoutMerkurSSBTs', {
            url: '/auto-logout-merkur-ssbts',
            parentView: 'shopMgmt.MerkurSSBTs',
            views: {
                '': {
                    templateUrl: '/app/shopMgmt/merkur-ssbt-integration/auto-logout-merkur-ssbts.template.html',
                    controller: 'AutoLogoutMerkurSSBTsController',
                    controllerAs: 'vm'
                }
            },
            resolve: lazyLoadShopManagementBundle
        }).state('shopMgmt.createMerkurSSBT', {
            url: '/create-merkur-ssbt',
            parentView: 'shopMgmt.MerkurSSBTs',
            views: {
                '': {
                    templateUrl: 'app/shopMgmt/merkur-ssbt-integration/create-merkur-ssbt.template.html',
                    controller: 'CreateMerkurSSBTController',
                    controllerAs: 'vm'
                }
            },
            resolve: lazyLoadShopManagementBundle
        }).state('shopMgmt.editMerkurSSBT', {
            url: '/merkur-ssbts/:id',
            parentView: 'shopMgmt.MerkurSSBTs',
            views: {
                '': {
                    templateUrl: 'app/shopMgmt/merkur-ssbt-integration/edit-merkur-ssbt.template.html',
                    controller: 'EditMerkurSSBTController',
                    controllerAs: 'vm'
                }
            },
            resolve: lazyLoadShopManagementBundle
        }).state('shopMgmt.mneV2TaxIdentifiers', {
            url: '/mne-tax-identifiers',
            parentView: 'shopMgmt.mneV2TaxIdentifiers',
            views: {
               '': {
                   templateUrl: '/app/shopMgmt/mne-v2-tax/mne-v2-tax-identifiers.template.html',
                   controller: 'MneV2TaxIdentifiersController',
                   controllerAs: 'vm'
               }
            },
            resolve: lazyLoadShopManagementBundle
        })
        .state('shopMgmt.mneV2TaxIdentifiersDetails', {
            url: '/mne-tax-identifiers/details/:locationUuid',
            parentView: 'shopMgmt.mneV2TaxIdentifiers',
            views: {
                '': {
                    templateUrl: '/app/shopMgmt/mne-v2-tax/mne-v2-tax-identifiers-details.template.html',
                    controller: 'MneV2TaxIdentifiersDetailsController',
                    controllerAs: 'vm'
                }
            },
            resolve: lazyLoadShopManagementBundle
        });
}]);
;
var sevenAdminReports = angular.module('seven-admin-reports', [
    ]);

sevenAdminReports.config(['$httpProvider', '$stateProvider', function ($httpProvider, $stateProvider) {
    const lazyLoadReportsBundle = {
        loadController: ['$ocLazyLoad', function ($ocLazyLoad) {
            return $ocLazyLoad.load('[DIST_PATH]js/seven-admin-reports.js')
        }]
    };

    $stateProvider
        .state('nrm', {
            url: '/reports',
            templateUrl: '/app/reports/reports.index.html',
            parent: 'main',
            controller: 'reportsCtrl',
            resolve: {
                loadController: ['$ocLazyLoad', function($ocLazyLoad) {
                    return $ocLazyLoad.load('[DIST_PATH]js/seven-admin-reports.js')
                }]
            },
            data: {
                module: 'nrm'
            }
        })

        /*Super admin sportsbook reports*/
        .state('reports', {
            url: '/sa-reports',
            templateUrl: '/app/reports/reports.index.html',
            parent: 'main',
            controller: 'reportsCtrl',
            resolve: {
                loadController: ['$ocLazyLoad', function($ocLazyLoad) {
                    return $ocLazyLoad.load('[DIST_PATH]js/seven-admin-reports.js')
                }]
            },
            data: {
                module: 'reports'
            }
        })
        .state('reports.sportsbookReports', {
            url: '/sportsbook-reports',
            parentView: 'reports.sportsbookReports',
            views: {
                '': {
                    templateUrl: '/app/reports/sa-sportsbook-reports/view.html',
                    controller: 'SportsbookReportController as sportsbookReports'
                }
            },
            resolve: {
                loadController: ['$ocLazyLoad', function($ocLazyLoad) {
                    return $ocLazyLoad.load('[DIST_PATH]js/seven-admin-reports.js')
                }]
            },
            data: {
                subModule: 'sportsbookReports'
            }
        })

        .state('nrm.betshopReport', {
            url: '/betshopreport',
            parentView: 'nrm.betshopReport',
            views: {
                '': {
                    templateUrl: '/app/reports/reportsTemplate.index.html',
                    controller: 'LocationReportController'
                }
            },
            resolve: {
                loadController: ['$ocLazyLoad', function($ocLazyLoad) {
                    return $ocLazyLoad.load('[DIST_PATH]js/seven-admin-reports.js')
                }]
            },
            data: {
                subModule: 'betshopReport'
            },
            params: {
                columnSaveStrategy: 'expandWithUrlParameter'
            }
        })
        .state('nrm.locationBalanceReport', {
            url: '/location-balance-report',
            parentView: 'nrm.locationBalanceReport',
            views: {
                '': {
                    template: '<view-templates></view-templates>',
                    controller: 'LocationBalanceReportController'
                }
            },
            resolve: {
                loadController: ['$ocLazyLoad', function($ocLazyLoad) {
                    return $ocLazyLoad.load('[DIST_PATH]js/seven-admin-reports.js')
                }]
            }
        })
        .state('nrm.betshopGroupReport', {
            url: '/betshopgroupreport',
            parentView: 'nrm.betshopGroupReport',
            views: {
                '': {
                    templateUrl: '/app/reports/reportsTemplate.index.html',
                    controller: 'betshopGroupReportCtrl'
                }
            },
            resolve: {
                loadController: ['$ocLazyLoad', function($ocLazyLoad) {
                    return $ocLazyLoad.load('[DIST_PATH]js/seven-admin-reports.js')
                }]
            },
            data: {
                subModule: 'betshopGroupReport'
            }
        })
        .state('nrm.operatorReport', {
            url: '/operatorreport',
            parentView: 'nrm.operatorReport',
            views: {
                '': {
                    templateUrl: '/app/reports/reportsTemplate.index.html',
                    controller: 'OperatorReportController'
                }
            },
            resolve: {
                loadController: ['$ocLazyLoad', function($ocLazyLoad) {
                    return $ocLazyLoad.load('[DIST_PATH]js/seven-admin-reports.js')
                }]
            },
            data: {
                subModule: 'operatorReport'
            }
        })
        .state('nrm.productReport', {
            url: '/productreport',
            parentView: 'nrm.productReport',
            views: {
                '': {
                    templateUrl: '/app/reports/reportsTemplate.index.html',
                    controller: 'ProductReportController'
                }
            },
            resolve: {
                loadController: ['$ocLazyLoad', function($ocLazyLoad) {
                    return $ocLazyLoad.load('[DIST_PATH]js/seven-admin-reports.js')
                }]
            },
            data: {
                subModule: 'productReport'
            }
        })
        .state('nrm.clientReport', {
            url: '/clientreport',
            parentView: 'nrm.clientReport',
            views: {
                '': {
                    templateUrl: '/app/reports/reportsTemplate.index.html',
                    controller: 'clientReportCtrl'
                }
            },
            resolve: {
                loadController: ['$ocLazyLoad', function($ocLazyLoad) {
                    return $ocLazyLoad.load('[DIST_PATH]js/seven-admin-reports.js')
                }]
            },
            data: {
                subModule: 'clientReport'
            }
        })
        .state('nrm.shiftReport', {
            url: '/shift-report',
            parentView: 'nrm.shiftReport',
            views: {
                '': {
                    templateUrl: '/app/reports/reportsTemplate.index.html',
                    controller: 'shiftReport'
                }
            },
            resolve: {
                loadController: ['$ocLazyLoad', function($ocLazyLoad) {
                    return $ocLazyLoad.load('[DIST_PATH]js/seven-admin-reports.js')
                }]
            },
            data: {
                subModule: 'shiftReport'
            }
        })
        .state('nrm.cashRegisterLog', {
            url: '/cash-register-log',
            parentView: 'nrm.cashRegisterLog',
            views: {
                '': {
                    templateUrl: '/app/reports/reportsTemplate.index.html',
                    controller: 'cashRegisterLogCtrl'
                }
            },
            resolve: {
                loadController: ['$ocLazyLoad', function($ocLazyLoad) {
                    return $ocLazyLoad.load('[DIST_PATH]js/seven-admin-reports.js')
                }]
            },
            data: {
                subModule: 'cashRegisterLog'
            }
        })
        .state('nrm.playerReport', {
            url: '/playerreport',
            parentView: 'nrm.playerReport',
            views: {
                '': {
                    templateUrl: '/app/reports/reportsTemplate.index.html',
                    controller: 'playerReportCtrl'
                }
            },
            resolve: {
                loadController: ['$ocLazyLoad', function($ocLazyLoad) {
                    return $ocLazyLoad.load('[DIST_PATH]js/seven-admin-reports.js')
                }]
            },
            data: {
                subModule: 'playerReport'
            },
            params: {
                columnSaveStrategy: 'expandwithtab'
            }
        })
        .state('nrm.casinoReport', {
            url: '/casino-report',
            parentView: 'nrm.casinoReport',
            views: {
                '': {
                    templateUrl: '/app/reports/reportsTemplate.index.html',
                    controller: 'casinoReportCtrl'
                }
            },
            resolve: {
                loadController: ['$ocLazyLoad', function($ocLazyLoad) {
                    return $ocLazyLoad.load('[DIST_PATH]js/seven-admin-reports.js')
                }]
            },
            data: {
                subModule: 'casinoReport'
            }
        })
        .state('nrm.terminalCashBalance', {
            url: '/terminal-cash-balance-report',
            parentView: 'nrm.terminalCashBalance',
            views: {
                '': {
                    templateUrl: '/app/reports/reportsTemplate.index.html',
                    controller: 'terminalCashBalanceReportCtrl'
                }
            },
            resolve: {
                loadController: ['$ocLazyLoad', function($ocLazyLoad) {
                    return $ocLazyLoad.load('[DIST_PATH]js/seven-admin-reports.js')
                }]
            },
            data: {
                subModule: 'terminalCashBalance'
            }
        })
        .state('nrm.sportbookReports', {
            url: '/sportsbook-reports/:report',
            parentView: 'nrm.sportbookReports',
            views: {
                '': {
                    templateUrl: '/app/reports/reportsTemplate.index.html',
                    controller: 'sportsbookReportCtrl'
                }
            },
            resolve: {
                loadController: ['$ocLazyLoad', function($ocLazyLoad) {
                    return $ocLazyLoad.load('[DIST_PATH]js/seven-admin-reports.js')
                }]
            },
            data: {
                subModule: 'sportbookReports'
            },
            params: {
                columnSaveStrategy: 'expandwithtab',
                tab: undefined
            }
        })
        .state('nrm.sportbookReportsTickets', {
            url: '/sportsbook-reports/{reportName}-tickets/{id}?{startDate}&{endDate}',
            parentView: 'nrm.sportbookReports',
            views: {
                '': {
                    templateUrl: '/app/reports/sportsbookReports/sportsbook-report-tickets/sportsbook-report-tickets.html',
                    controller: 'SportsbookReportTicketsController'
                }
            },
            resolve: {
                loadController: ['$ocLazyLoad', function($ocLazyLoad) {
                    return $ocLazyLoad.load('[DIST_PATH]js/seven-admin-reports.js')
                }]
            },
            data: {
                parentView: 'nrm.sportbookReports'
            },
            params: {
                columnSaveStrategy: 'strip'
            }

        }).state('nrm.taxMkdReport', {
            url: '/mkd-tax-report',
            parentView: 'nrm.taxMkdReport',
            redirectTo: 'nrm.taxMkdReport.general',
            views: {
                '': {
                    template: '<div ui-view></div>',
                    controller: function () {}
                }
            },
            resolve: {
                loadController: ['$ocLazyLoad', function($ocLazyLoad) {
                    return $ocLazyLoad.load('[DIST_PATH]js/seven-admin-reports.js')
                }]
            }
        }).state('nrm.taxMkdReport.general', {
            url: '/general',
            parentView: 'nrm.taxMkdReport',
            views: {
                '': {
                    templateUrl: '/app/reports/reportsTemplate.index.html',
                    controller: 'MkdGeneralReportController'
                }
            },
            resolve: {
                loadController: ['$ocLazyLoad', function($ocLazyLoad) {
                    return $ocLazyLoad.load('[DIST_PATH]js/seven-admin-reports.js')
                }]
            },
            data: {
                parentView: 'nrm.taxMkdReport'
            }
        }).state('nrm.taxMkdReport.locations', {
            url: '/locations',
            parentView: 'nrm.taxMkdReport',
            views: {
                '': {
                    templateUrl: '/app/reports/reportsTemplate.index.html',
                    controller: 'MkdLocationsTaxReportController'
                }
            },
            resolve: {
                loadController: ['$ocLazyLoad', function($ocLazyLoad) {
                    return $ocLazyLoad.load('[DIST_PATH]js/seven-admin-reports.js')
                }]
            },
            data: {
                parentView: 'nrm.taxMkdReport'
            }
        }).state('nrm.taxMkdLocationReport', {
            url: '/mkd-tax-report/locations/location/{locationUuid}?{startDate}&{endDate}&{locationName}',
            parentView: 'nrm.taxMkdReport',
            views: {
                '': {
                    templateUrl: '/app/reports/reportsTemplate.index.html',
                    controller: 'MkdLocationTaxReportController'
                }
            },
            resolve: {
                loadController: ['$ocLazyLoad', function($ocLazyLoad) {
                    return $ocLazyLoad.load('[DIST_PATH]js/seven-admin-reports.js')
                }]
            },
            params: {
                columnSaveStrategy: 'strip'
            },
            data: {
                parentView: 'nrm.taxMkdReport'
            }
        }).state('nrm.locationCashFlowReport', {
            url: '/location-cash-report',
            parentView: 'nrm.locationCashFlowReport',
            views: {
                '': {
                    template: '<view-templates></view-templates>',
                    controller: 'LocationCashFlowReportController'
                }
            },
            resolve: {
                loadController: ['$ocLazyLoad', function($ocLazyLoad) {
                    return $ocLazyLoad.load('[DIST_PATH]js/seven-admin-reports.js')
                }]
            }
        }).state('nrm.promotionExpensesReport', {
            url: '/promotions-expenses-report',
            parentView: 'nrm.promotionExpensesReport',
            views: {
                '': {
                    template: '<div><react-grid data-view-name="promotionsExpenses"></react-grid><info-message></info-message></div>',
                    controller: 'PromotionsExpensesReport'
                }
            },
            resolve: {
                loadController: ['$ocLazyLoad', function($ocLazyLoad) {
                    return $ocLazyLoad.load('[DIST_PATH]js/seven-admin-reports.js')
                }]
            }
        })
        .state('nrm.bihMonthlyTaxReport', {
            url: '/monthly-tax-report',
            parentView: 'nrm.bihMonthlyTaxReport',
            views: {
                '': {
                    templateUrl: '/app/reports/bih-monthly-tax-report/bih-monthly-tax-report.template.html',
                    controller: 'BiHMonthlyTaxReport',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                loadController: ['$ocLazyLoad', function($ocLazyLoad) {
                    return $ocLazyLoad.load('[DIST_PATH]js/seven-admin-reports.js')
                }]
            },
            data: {
                parentView: 'nrm.bihMonthlyTaxReport'
            }
        })
        .state('nrm.lutrijaBiHReports', {
            url: '/lutrija-bih-reports',
            params: {
                integratedPath: '/reports/'
            },
            parentView: 'nrm.lutrijaBiHReports',
            views: {
                '': {
                    templateUrl: '/app/shared/integration/integration.template.html',
                    controller: 'IntegrationController',
                    controllerAs: 'vm'
                }
            },
            data: {
                parentView: 'nrm.lutrijaBiHReports',
                widgetKey: 'LutrijaBihAdmin'
            }
        })
        .state('nrm.visionReport', {
            url: '/analytics-report',
            parentView: 'nrm.visionReport',
            views: {
                '': {
                    templateUrl: '/app/shared/integration/integration.template.html',
                    controller: 'IntegrationController',
                    controllerAs: 'vm'
                }
            },
            data: {
                parentView: 'nrm.visionReport',
                widgetKey: 'VisionReport'
            }
        })
        .state('nrm.visionLiveReport', {
            url: '/live-analytics-report',
            parentView: 'nrm.visionLiveReport',
            views: {
                '': {
                    templateUrl: '/app/shared/integration/integration.template.html',
                    controller: 'IntegrationController',
                    controllerAs: 'vm'
                }
            },
            data: {
                parentView: 'nrm.visionLiveReport',
                widgetKey: 'VisionLiveReport'
            }
        })
        .state('nrm.locationCashBalanceReport', {
            url: '/location-cash-balance-report',
            parentView:'nrm.locationCashBalanceReport',
            views:{
                '': {
                    template:
                        '<react-grid data-view-name="{{vm.viewName}}"></react-grid>' +
                        '<info-message></info-message>',
                    controller: 'LocationCashBalanceReportController',
                    controllerAs: 'vm'
                }
            },
            resolve: lazyLoadReportsBundle
        })
        .state('nrm.serbianTaxDeviceReport', {
            url: '/serbian-tax-device-report',
            parentView: 'nrm.serbianTaxDeviceReport',
            views: {
                '': {
                    template:
                        '<react-grid data-view-name="{{vm.viewName}}"></react-grid>' +
                        '<info-message></info-message>',
                    controller: 'SerbianTaxDeviceReportController',
                    controllerAs: 'vm',
                }
            }
        }).state('nrm.belgiumTaxTicketsReport', {
            url: '/belgium-tax-tickets-report',
            parentView:'nrm.belgiumTaxTicketsReport',
            views:{
                '': {
                    template:
                        '<react-grid data-view-name="{{vm.viewName}}"></react-grid>' +
                        '<info-message></info-message>',
                    controller: 'BelgiumTaxTicketsReportController',
                    controllerAs: 'vm'
                }
            },
            resolve: lazyLoadReportsBundle
        });

    $httpProvider.interceptors.push('ReportingInterceptor');
}]);
;
(function () {
    angular
        .module('seven-admin-reports')
        .factory('ReportingInterceptor', ReportingInterceptorFactory);

    ReportingInterceptorFactory.$inject = [
        'ENV_CFG',
        'userInitData'
    ];

    function ReportingInterceptorFactory(
        ENV_CFG,
        userInitData
    ) {
        var baseSevenReportingUrl = ENV_CFG.api.reporting;

        var isSevenReportingUrl = function (url) {
            return url.toString().indexOf(baseSevenReportingUrl) >= 0;
        };

        return {
            request: function (request) {
                if (isSevenReportingUrl(request.url)) {
                    request.headers['X-NSFT-SEVEN-COMPANY-UUID'] = userInitData.currentCompany ? userInitData.currentCompany.uuid : ''
                }
                return request;
            }
        }

    }
}());
;
var sevenAdminUserMgmt = angular.module('seven-admin-usermgmt', []);

sevenAdminUserMgmt.config(['$stateProvider', function ($stateProvider) {

    $stateProvider
        .state('userMgmt', {
            url: '/user-mgmt',
            templateUrl: '/app/userMgmt/userMgmt.index.html',
            parent: 'main',
            controller: 'userMgmtCtrl',
            resolve: {
                loadController: ['$ocLazyLoad', function($ocLazyLoad) {
                    return $ocLazyLoad.load('[DIST_PATH]js/seven-admin-usermgmt.js')
                }]
            },
            data: {
                module: 'userMgmt'
            }
        })
        .state('userMgmt.admins', {
            url: '/admins?isEnabled',
            parentView: 'userMgmt.admins',
            views: {
                '': {
                    template: '<view-templates></view-templates>',
                    controller: 'AdministratorsController'
                }
            },
            resolve: {
                loadController: ['$ocLazyLoad', function($ocLazyLoad) {
                    return $ocLazyLoad.load('[DIST_PATH]js/seven-admin-usermgmt.js')
                }]
            },
            data: {
                subModule: 'admins'
            },
            params: {
                isEnabled: '1'
            }
        })
        .state('userMgmt.adminDetails', {
            url: '/admins/details/:id',
            parentView: 'userMgmt.admins',
            views: {
                '': {
                    templateUrl: '/app/userMgmt/administrators/edit-administrator.template.html',
                    controller: 'EditAdministratorController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                loadController: ['$ocLazyLoad', function($ocLazyLoad) {
                    return $ocLazyLoad.load('[DIST_PATH]js/seven-admin-usermgmt.js')
                }]
            }
        })
        .state('userMgmt.adminGroups', {
            url: '/groups',
            parentView: 'userMgmt.adminGroups',
            views: {
                '': {
                    templateUrl: '/app/userMgmt/administrator-groups/administrator-groups.template.html',
                    controller: 'AdministratorGroupsController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                loadController: ['$ocLazyLoad', function($ocLazyLoad) {
                    return $ocLazyLoad.load('[DIST_PATH]js/seven-admin-usermgmt.js')
                }]
            },
            data: {
                subModule: 'adminGroups'
            }
        })
        .state('userMgmt.groupDetails', {
            url: '/groups/details/:id',
            parentView: 'userMgmt.adminGroups',
            views: {
                '': {
                    templateUrl: '/app/userMgmt/administrator-groups/edit-administrator-group.template.html',
                    controller: 'EditAdministratorGroupController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                loadController: ['$ocLazyLoad', function($ocLazyLoad) {
                    return $ocLazyLoad.load('[DIST_PATH]js/seven-admin-usermgmt.js')
                }]
            }
        })
        .state('userMgmt.addGroup', {
            url: '/groups/add-new',
            parentView: 'userMgmt.adminGroups',
            views: {
                '': {
                    templateUrl: '/app/userMgmt/administrator-groups/new-administrator-group.template.html',
                    controller: 'NewAdministratorGroupController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                loadController: ['$ocLazyLoad', function($ocLazyLoad) {
                    return $ocLazyLoad.load('[DIST_PATH]js/seven-admin-usermgmt.js')
                }]
            }
        })
        .state('userMgmt.automaticAdministratorGroups', {
            url: '/default-administrator-groups',
            parentView: 'userMgmt.automaticAdministratorGroups',
            views: {
                '': {
                    templateUrl: '/app/userMgmt/administrator-groups/default-administrator-groups.template.html',
                    controller: 'DefaultAdministratorGroupsController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                loadController: ['$ocLazyLoad', function($ocLazyLoad) {
                    return $ocLazyLoad.load('[DIST_PATH]js/seven-admin-usermgmt.js')
                }]
            },
            data: {
                subModule: 'automaticAdministratorGroups'
            }
        })
        .state('userMgmt.operators', {
            url: '/operators',
            parentView: 'userMgmt.operators',
            views: {
                '': {
                    templateUrl: '/app/userMgmt/operators/operators.template.html',
                    controller: 'OperatorsController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                loadController: ['$ocLazyLoad', function($ocLazyLoad) {
                    return $ocLazyLoad.load('[DIST_PATH]js/seven-admin-usermgmt.js')
                }]
            },
            data: {
                subModule: 'operators'
            }
        })
        .state('userMgmt.operatorDetails', {
            url: '/operators/details/:id',
            parentView: 'userMgmt.operators',
            views: {
                '': {
                    templateUrl: '/app/userMgmt/operators/edit-operator.template.html',
                    controller: 'EditOperatorController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                loadController: ['$ocLazyLoad', function($ocLazyLoad) {
                    return $ocLazyLoad.load([
                        '[DIST_PATH]js/seven-admin-usermgmt.js',
                        '[DIST_PATH]js/seven-admin-productmgmt.js'
                    ])
                }]
            }
        })
        .state('userMgmt.addOperator', {
            url: '/operators/add-new',
            parentView: 'userMgmt.operators',
            views: {
                '': {
                    templateUrl: '/app/userMgmt/operators/new-operator.template.html',
                    controller: 'NewOperatorController',
                    controllerAs: 'vm'
                }
            }
        })
        .state('userMgmt.operatorConfiguration', {
            url: '/operator/configuration/:id',
            parentView: 'userMgmt.operators',
            views: {
                '': {
                    template: '<view-templates></view-templates>',
                    controller: 'operatorsConfigCtrl'
                }
            },
            resolve: {
                loadController: ['$ocLazyLoad', function($ocLazyLoad) {
                    return $ocLazyLoad.load('[DIST_PATH]js/seven-admin-usermgmt.js')
                }]
            },
            params: {
                operatorId: undefined
            }
        })
        .state('userMgmt.operatorConfigurationNgs', {
            url: '/operator/configuration/ngs/:id',
            parentView: 'userMgmt.operators',
            views: {
                '': {
                    template: '<view-templates></view-templates>',
                    controller: 'operatorsConfigNgsCtrl'
                }
            },
            resolve: {
                loadController: ['$ocLazyLoad', function($ocLazyLoad) {
                    return $ocLazyLoad.load(['[DIST_PATH]js/seven-admin-usermgmt.js', '[DIST_PATH]js/seven-admin-productmgmt.js'])
                }]
            },
            params: {
                operatorId: undefined
            }
        })
        .state('userMgmt.operatorGroups', {
            url: '/operator-groups',
            parentView: 'userMgmt.operatorGroups',
            views: {
                '': {
                    templateUrl: '/app/userMgmt/operator-groups/operator-groups.template.html',
                    controller: 'OperatorsGroupsController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                loadController: ['$ocLazyLoad', function($ocLazyLoad) {
                    return $ocLazyLoad.load('[DIST_PATH]js/seven-admin-usermgmt.js')
                }]
            },
            data: {
                subModule: 'operatorGroups'
            }
        })
        .state('userMgmt.editOperatorGroup', {
            url: '/operator-groups/:id',
            parentView: 'userMgmt.operatorGroups',
            views: {
                '': {
                    templateUrl: '/app/userMgmt/operator-groups/edit-operator-group.template.html',
                    controller: 'EditOperatorGroupController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                loadController: ['$ocLazyLoad', function($ocLazyLoad) {
                    return $ocLazyLoad.load('[DIST_PATH]js/seven-admin-usermgmt.js')
                }]
            },
            data: {
                subModule: 'operatorGroups'
            }
        })
        .state('userMgmt.newOperatorGroup', {
            url: '/new-operator-group',
            parentView: 'userMgmt.operatorGroups',
            views: {
                '': {
                    templateUrl: '/app/userMgmt/operator-groups/new-operator-group.template.html',
                    controller: 'NewOperatorGroupController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                loadController: ['$ocLazyLoad', function($ocLazyLoad) {
                    return $ocLazyLoad.load('[DIST_PATH]js/seven-admin-usermgmt.js')
                }]
            },
            data: {
                subModule: 'operatorGroups'
            }
        })
        .state('userMgmt.automaticOperatorGroups', {
            url: '/default-operator-groups',
            parentView: 'userMgmt.automaticOperatorGroups',
            views: {
                '': {
                    templateUrl: '/app/userMgmt/operator-groups/default-operator-groups.template.html',
                    controller: 'DefaultOperatorGroupsController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                loadController: ['$ocLazyLoad', function($ocLazyLoad) {
                    return $ocLazyLoad.load('[DIST_PATH]js/seven-admin-usermgmt.js')
                }]
            },
            data: {
                subModule: 'automaticOperatorGroups'
            }
        })
}]);
;
var sevenAdminUserSettings = angular.module('seven-admin-usersettings', [
]);

sevenAdminUserSettings.config(['$stateProvider', function ($stateProvider) {

    $stateProvider
        .state('userSettings', {
            url: '/settings',
            templateUrl: '/app/userSettings/userSettings.index.html',
            parent: 'main',
            controller: '',
            data: {
                module: 'userSettings'
            }
        })
        .state('userSettings.companySettings', {
            url: '/company-settings',
            parentView: 'userSettings.companySettings',
            views: {
                '': {
                    templateUrl: '/app/userSettings/company/companySettings.html',
                    controller: 'companySettingsController'
                }
            },
            resolve: {
                loadController: ['$ocLazyLoad', function($ocLazyLoad) {
                    return $ocLazyLoad.load('[DIST_PATH]js/seven-admin-usersettings.js')
                }]
            },
            additionalTitle: 'company.settings'
        })
        .state('userSettings.profile', {
            url: '/profile',
            parentView: 'userSettings.profile',
            views: {
                '': {
                    templateUrl: '/app/userSettings/profile/profile.html',
                    controller: 'profileCtrl'
                }
            },
            resolve: {
                loadController: ['$ocLazyLoad', function($ocLazyLoad) {
                    return $ocLazyLoad.load([
                        '[DIST_PATH]js/seven-admin-usersettings.js',
                        '[DIST_PATH]js/seven-admin-usermgmt.js'
                    ])
                }]
            },
            additionalTitle: 'user.profile_settings'
        });
}]);
;
var sevenAdminWalletMgmt = angular.module('seven-admin-walletmgmt', [
]);

sevenAdminWalletMgmt.config(['$stateProvider', function ($stateProvider) {
    var walletManagementModuleBundle = '[DIST_PATH]js/seven-admin-walletmgmt.js';
    var lazyLoadWalletManagementBundle = {
        loadBundle: ['$ocLazyLoad', function($ocLazyLoad) {
            return $ocLazyLoad.load(walletManagementModuleBundle)
        }]
    }
    var NOT_DECIMAL_SEPARATOR_REGEX = /^[^.,]*$/;
    var TWO_DECIMAL_PLACES_REGEX = /^\d+(\.\d{1,2})?$/;
    var MAX_RELIABLY_PARSABLE_NUMBER = 999999999999999;

    $stateProvider
        .state('walletMgmt', {
            url: '/wallet-mgmt',
            templateUrl: '/app/walletMgmt/walletMgmt.index.html',
            parent: 'main',
            controller: 'walletMgmtCtrl',
            data: {
                module: 'walletMgmt'
            }
        })
        .state('walletMgmt.walletPlugins', {
            url: '/wallet-plugins',
            parentView: 'walletMgmt.walletPlugins',
            views: {
                '': {
                    templateUrl: '/app/walletMgmt/walletPlugins/walletPlugins.html',
                    controller: 'walletPluginsCtrl'
                    }
            },
            resolve: {
                loadController: ['$ocLazyLoad', function($ocLazyLoad) {
                    return $ocLazyLoad.load(walletManagementModuleBundle)
                }]
            }
        })
        .state('walletMgmt.walletPluginDetails', {
            url: '/wallet-plugins/:type',
            parentView: 'walletMgmt.walletPlugins',
            views: {
                '': {
                    templateUrl: '/app/walletMgmt/walletPlugins/walletPlugins.html',
                    controller: 'walletPluginDetailsCtrl'
                    }
            },
            resolve: {
                loadController: ['$ocLazyLoad', function($ocLazyLoad) {
                    return $ocLazyLoad.load(walletManagementModuleBundle)
                }]
            }
        })
        .state('walletMgmt.vouchers', {
            url: '/vouchers',
            parentView: 'walletMgmt.walletPlugins',
            views: {
                '': {
                    templateUrl: '/app/walletMgmt/vouchers/vouchers.html',
                    controller: 'vouchersCtrl'
                    }
            },
            resolve: {
                loadController: ['$ocLazyLoad', function($ocLazyLoad) {
                    return $ocLazyLoad.load(walletManagementModuleBundle)
                }]
            }
        })
        .state('walletMgmt.voucherConfiguration', {
            url: '/voucher-configuration',
            parentView: 'walletMgmt.walletPlugins',
            views: {
                '': {
                    templateUrl: '/app/walletMgmt/voucher-configuration/voucher-configuration.html',
                    controller: 'VoucherConfigurationController'
                    }
            },
            resolve: {
                loadController: ['$ocLazyLoad', function($ocLazyLoad) {
                    return $ocLazyLoad.load(walletManagementModuleBundle)
                }]
            }
        })
        .state('walletMgmt.skrillDeposits', {
            url: '/skrill-deposits',
            parentView: 'walletMgmt.walletPlugins',
            views: {
                '': {
                    templateUrl: '/app/walletMgmt/skrillDeposits/skrillDeposits.html',
                    controller: 'skrillDepositsCtrl'
                    }
            },
            resolve: {
                loadController: ['$ocLazyLoad', function($ocLazyLoad) {
                    return $ocLazyLoad.load(walletManagementModuleBundle)
                }]
            }
        })
        .state('walletMgmt.skrillWithdrawals', {
            url: '/skrill-withdrawals',
            parentView: 'walletMgmt.walletPlugins',
            views: {
                '': {
                    templateUrl: '/app/walletMgmt/skrillWithdrawals/skrillWithdrawals.html',
                    controller: 'skrillWithdrawalsCtrl'
                    }
            },
            resolve: {
                loadController: ['$ocLazyLoad', function($ocLazyLoad) {
                    return $ocLazyLoad.load(walletManagementModuleBundle)
                }]
            }
        })
        .state('walletMgmt.skrillConfiguration', {
            url: '/skrill-configuration',
            parentView: 'walletMgmt.walletPlugins',
            views: {
                '': {
                    templateUrl: '/app/walletMgmt/skrill-configuration/skrill-configuration.html',
                    controller: 'SkrillConfigurationController'
                    }
            },
            resolve: {
                loadController: ['$ocLazyLoad', function($ocLazyLoad) {
                    return $ocLazyLoad.load(walletManagementModuleBundle)
                }]
            }
        })
        .state('walletMgmt.bankwireDeposits', {
            url: '/bankwire-deposits',
            parentView: 'walletMgmt.walletPlugins',
            views: {
                '': {
                    templateUrl: '/app/walletMgmt/bankwireDeposits/bankwireDeposits.html',
                    controller: 'bankwireDepositsCtrl'
                    }
            },
            resolve: {
                loadController: ['$ocLazyLoad', function($ocLazyLoad) {
                    return $ocLazyLoad.load(walletManagementModuleBundle)
                }]
            }
        })
        .state('walletMgmt.bankwireWithdrawals', {
            url: '/bankwire-withdrawals',
            parentView: 'walletMgmt.walletPlugins',
            views: {
                '': {
                    templateUrl: '/app/walletMgmt/bankwireWithdrawals/bankwireWithdrawals.html',
                    controller: 'bankwireWithdrawalsCtrl'
                    }
            },
            resolve: {
                loadController: ['$ocLazyLoad', function($ocLazyLoad) {
                    return $ocLazyLoad.load(walletManagementModuleBundle)
                }]
            }
        })
        .state('walletMgmt.bankwireConfiguration', {
            url: '/bankwire-configuration',
            parentView: 'walletMgmt.walletPlugins',
            views: {
                '': {
                    templateUrl: '/app/walletMgmt/bankwire-configuration/bankwire-configuration.html',
                    controller: 'BankwireConfigurationController',
                    controllerAs: 'model'
                    }
            },
            resolve: {
                loadController: ['$ocLazyLoad', function($ocLazyLoad) {
                    return $ocLazyLoad.load(walletManagementModuleBundle)
                }]
            }
        })
        .state('walletMgmt.withdrawalRequests', {
            url: '/withdrawal-requests',
            parentView: 'walletMgmt.withdrawalRequests',
            views: {
                '': {
                    templateUrl: '/app/walletMgmt/withdrawalRequests/withdrawalRequests.html',
                    controller: 'withdrawalRequestsCtrl'
                    }
            },
            resolve: {
                loadController: ['$ocLazyLoad', function($ocLazyLoad) {
                    return $ocLazyLoad.load(walletManagementModuleBundle)
                }]
            }
        })
        .state('walletMgmt.directDeposits', {
            url: '/direct-deposits',
            parentView: 'walletMgmt.walletPlugins',
            views: {
                '': {
                    templateUrl: '/app/walletMgmt/directDeposits/directDeposits.html',
                    controller: 'directDepositsCtrl'
                    }
            },
            resolve: {
                loadController: ['$ocLazyLoad', function($ocLazyLoad) {
                    return $ocLazyLoad.load(walletManagementModuleBundle)
                }]
            }
        })
        .state('walletMgmt.directdepositConfiguration', {
            url: '/direct-deposit-configuration',
            parentView: 'walletMgmt.walletPlugins',
            views: {
                '': {
                    templateUrl: '/app/walletMgmt/direct-deposit-configuration/direct-deposit-configuration.html',
                    controller: 'DirectDepositConfigurationController'
                    }
            },
            resolve: {
                loadController: ['$ocLazyLoad', function($ocLazyLoad) {
                    return $ocLazyLoad.load(walletManagementModuleBundle)
                }]
            }
        })
        .state('walletMgmt.cashRegisterLog', {
            url: '/cash-register-log',
            parentView: 'walletMgmt.cashRegisterLog',
            views: {
                '': {
                    templateUrl: '/app/walletMgmt/cashRegisterLog/cashRegisterLog.html',
                    controller: 'cashRegisterLogsCtrl'
                    }
            },
            resolve: {
                loadController: ['$ocLazyLoad', function($ocLazyLoad) {
                    return $ocLazyLoad.load(walletManagementModuleBundle)
                }]
            }
        })
        .state('walletMgmt.cashRegisterTransferTypes', {
            url: '/cash-register-transfer-types',
            parentView: 'walletMgmt.cashRegisterLog',
            views: {
                '': {
                    templateUrl: '/app/walletMgmt/cash-register-transfer-types/cash-register-transfer-types.template.html',
                    controller: 'CashRegisterTransferTypesController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                loadController: ['$ocLazyLoad', function($ocLazyLoad) {
                    return $ocLazyLoad.load(walletManagementModuleBundle)
                }]
            }
        })
        .state('walletMgmt.cashRegisterShifts', {
            url: '/cash-register-shifts',
            parentView: 'walletMgmt.cashRegisterLog',
            views: {
                '': {
                    templateUrl: '/app/walletMgmt/cash-register-shifts/cash-register-shifts.template.html',
                    controller: 'CashRegisterShiftsController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                loadController: ['$ocLazyLoad', function($ocLazyLoad) {
                    return $ocLazyLoad.load(walletManagementModuleBundle)
                }]
            }
        })
        .state('walletMgmt.retailWithdrawals', {
            url: '/retail-withdrawals',
            parentView: 'walletMgmt.walletPlugins',
            views: {
                '': {
                    templateUrl: '/app/walletMgmt/retail-withdrawals/retail-withdrawals.html',
                    controller: 'RetailWithdrawalsController'
                    }
            },
            resolve: {
                loadController: ['$ocLazyLoad', function($ocLazyLoad) {
                    return $ocLazyLoad.load(walletManagementModuleBundle)
                }]
            }
        })
        .state('walletMgmt.retailwithdrawalConfiguration', {
            url: '/retail-withdrawal-configuration',
            parentView: 'walletMgmt.walletPlugins',
            views: {
                '': {
                    templateUrl: '/app/walletMgmt/retail-withdrawal-configuration/retail-withdrawal-configuration.html',
                    controller: 'RetailWithdrawalConfigurationController'
                    }
            },
            resolve: {
                loadController: ['$ocLazyLoad', function($ocLazyLoad) {
                    return $ocLazyLoad.load(walletManagementModuleBundle)
                }]
            }
        })
        .state('walletMgmt.nestPayDeposits', {
            url: '/nestpay-deposits',
            parentView: 'walletMgmt.walletPlugins',
            views: {
                '': {
                    templateUrl: '/app/walletMgmt/nestpay-deposits/nestpay-deposits.html',
                    controller: 'NestPayDepositsController'
                    }
            },
            resolve: {
                loadController: ['$ocLazyLoad', function($ocLazyLoad) {
                    return $ocLazyLoad.load(walletManagementModuleBundle)
                }]
            }
        })
        .state('walletMgmt.nestpayConfiguration', {
            url: '/nestpay-configuration',
            parentView: 'walletMgmt.walletPlugins',
            views: {
                '': {
                    templateUrl: '/app/walletMgmt/nestpay-configuration/nestpay-configuration.html',
                    controller: 'NestpayConfigurationController'
                    }
            },
            resolve: {
                loadController: ['$ocLazyLoad', function($ocLazyLoad) {
                    return $ocLazyLoad.load(walletManagementModuleBundle)
                }]
            }
        })
        .state('walletMgmt.deviceCashDeposits', {
            url: '/device-cash-deposits',
            parentView: 'walletMgmt.walletPlugins',
            views: {
                '': {
                    templateUrl: '/app/walletMgmt/device-cash-deposits/device-cash-deposits.html',
                    controller: 'DeviceCashDepositsController'
                    }
            },
            resolve: {
                loadController: ['$ocLazyLoad', function($ocLazyLoad) {
                    return $ocLazyLoad.load(walletManagementModuleBundle)
                }]
            }
        })
        .state('walletMgmt.devicecashdepositConfiguration', {
            url: '/device-cash-deposit-configuration',
            parentView: 'walletMgmt.walletPlugins',
            views: {
                '': {
                    templateUrl: '/app/walletMgmt/device-cash-deposit-configuration/device-cash-deposit-configuration.html',
                    controller: 'DeviceCashDepositConfigurationController'
                    }
            },
            resolve: {
                loadController: ['$ocLazyLoad', function($ocLazyLoad) {
                    return $ocLazyLoad.load(walletManagementModuleBundle)
                }]
            }
        })
        .state('walletMgmt.balanceadjustmentConfiguration', {
            url: '/player-balance-adjustment-configuration',
            parentView: 'walletMgmt.walletPlugins',
            views: {
                '': {
                    templateUrl: '/app/walletMgmt/player-balance-adjustment-configuration/player-balance-adjustment-configuration.html',
                    controller: 'PlayerBalanceAdjustmentConfigurationController'
                    }
            },
            resolve: {
                loadController: ['$ocLazyLoad', function($ocLazyLoad) {
                    return $ocLazyLoad.load(walletManagementModuleBundle)
                }]
            }
        })
        .state('walletMgmt.playerBalanceAdjustmentTransactions', {
            url: '/player-balance-adjustment-transactions',
            parentView: 'walletMgmt.walletPlugins',
            views: {
                '': {
                    templateUrl: '/app/walletMgmt/player-balance-adjustment-transactions/player-balance-adjustment-transactions.html',
                    controller: 'PlayerBalanceAdjustmentTransactionsController'
                    }
            },
            resolve: {
                loadController: ['$ocLazyLoad', function($ocLazyLoad) {
                    return $ocLazyLoad.load(walletManagementModuleBundle)
                }]
            }
        })
        .state('walletMgmt.bulkPayments', {
            url: '/bulk-payments',
            parentView: 'walletMgmt.walletPlugins',
            views: {
                '': {
                    templateUrl: '/app/walletMgmt/player-balance-adjustment-transactions/bulk-payments/bulk-payments.template.html',
                    controller: 'BulkPaymentsController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                loadController: ['$ocLazyLoad', function($ocLazyLoad) {
                    return $ocLazyLoad.load(walletManagementModuleBundle)
                }]
            }
        }).state('walletMgmt.bulkPaymentTransactions', {
            url: '/bulk-payment-transactions/{bulkPaymentId}',
            parentView: 'walletMgmt.bulkPayments',
            views: {
                '': {
                    templateUrl: '/app/walletMgmt/player-balance-adjustment-transactions/bulk-payments/bulk-payment-transactions.template.html',
                    controller: 'BulkPaymentTransactions',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                loadController: ['$ocLazyLoad', function($ocLazyLoad) {
                    return $ocLazyLoad.load(walletManagementModuleBundle)
                }]
            }
        })
        .state('walletMgmt.webpayConfiguration', {
            url: '/webpay-configuration',
            parentView: 'walletMgmt.walletPlugins',
            views: {
                '': {
                    template: '<view-templates></view-templates>',
                    controller: 'WebPayConfigurationController'
                    }
            },
            resolve: {
                loadController: ['$ocLazyLoad', function($ocLazyLoad) {
                    return $ocLazyLoad.load(walletManagementModuleBundle)
                }]
            }
        })
        .state('walletMgmt.webpayDeposits', {
            url: '/webpay-deposits',
            parentView: 'walletMgmt.walletPlugins',
            views: {
                '': {
                    template: '<view-templates></view-templates>',
                    controller: 'WebPayDepositsController'
                    }
            },
            resolve: {
                loadController: ['$ocLazyLoad', function($ocLazyLoad) {
                    return $ocLazyLoad.load(walletManagementModuleBundle)
                }]
            }
        })
        .state('walletMgmt.paysafecardConfiguration', {
            url: '/paysafe-configuration',
            parentView: 'walletMgmt.walletPlugins',
            views: {
                '': {
                    template: '<view-templates></view-templates>',
                    controller: 'PaysafeConfigurationController'
                    }
            },
            resolve: {
                loadController: ['$ocLazyLoad', function($ocLazyLoad) {
                    return $ocLazyLoad.load(walletManagementModuleBundle)
                }]
            }
        })
        .state('walletMgmt.paysafecardTransactions', {
            url: '/paysafe-transactions',
            parentView: 'walletMgmt.walletPlugins',
            views: {
                '': {
                    template: '<view-templates></view-templates>',
                    controller: 'PaysafeTransactionsController'
                    }
            },
            resolve: {
                loadController: ['$ocLazyLoad', function($ocLazyLoad) {
                    return $ocLazyLoad.load(walletManagementModuleBundle)
                }]
            }
        })
        .state('walletMgmt.ipayConfiguration', {
            url: '/ipay-configuration',
            parentView: 'walletMgmt.walletPlugins',
            views: {
                '': {
                    template: '<view-templates></view-templates>',
                    controller: 'IpayConfigurationController'
                    }
            },
            resolve: {
                loadController: ['$ocLazyLoad', function($ocLazyLoad) {
                    return $ocLazyLoad.load(walletManagementModuleBundle)
                }]
            }
        })
        .state('walletMgmt.ipayTransactions', {
            url: '/ipay-transactions',
            parentView: 'walletMgmt.walletPlugins',
            views: {
                '': {
                    template: '<view-templates></view-templates>',
                    controller: 'IpayTransactionsController'
                    }
            },
            resolve: {
                loadController: ['$ocLazyLoad', function($ocLazyLoad) {
                    return $ocLazyLoad.load(walletManagementModuleBundle)
                }]
            }
        })
        .state('walletMgmt.quicktellerConfiguration', {
            url: '/quickteller-configuration',
            parentView: 'walletMgmt.walletPlugins',
            views: {
                '': {
                    template: '<view-templates></view-templates>',
                    controller: 'QuicktellerConfigurationController'
                    }
            },
            resolve: {
                loadController: ['$ocLazyLoad', function($ocLazyLoad) {
                    return $ocLazyLoad.load(walletManagementModuleBundle)
                }]
            }
        })
        .state('walletMgmt.quicktellerTransactions', {
            url: '/quickteller-transactions',
            parentView: 'walletMgmt.walletPlugins',
            views: {
                '': {
                    template: '<view-templates></view-templates>',
                    controller: 'QuicktellerTransactionsController'
                    }
            },
            resolve: {
                loadController: ['$ocLazyLoad', function($ocLazyLoad) {
                    return $ocLazyLoad.load(walletManagementModuleBundle)
                }]
            }
        })
        .state('walletMgmt.fastHubTransactions', {
            url: '/fasthub-transactions',
            parentView: 'walletMgmt.walletPlugins',
            views: {
                '': {
                    template:
                        '<react-grid data-view-name="{{viewName}}"></react-grid>' +
                        '<info-message></info-message>',
                    controller: 'FastHubTransactionsController'
                }
            },
            resolve: {
                loadController: ['$ocLazyLoad', function($ocLazyLoad) {
                    return $ocLazyLoad.load(walletManagementModuleBundle)
                }]
            }
        })
        .state('walletMgmt.fasthubConfiguration', {
            url: '/fasthub-configuration',
            parentView: 'walletMgmt.walletPlugins',
            views: {
                '': {
                    template: '<view-templates></view-templates>',
                    controller: 'FastHubConfigurationController'
                }
            },
            resolve: {
                loadController: ['$ocLazyLoad', function($ocLazyLoad) {
                    return $ocLazyLoad.load(walletManagementModuleBundle)
                }]
            }
        })
        .state('walletMgmt.paytenTransactions', {
            url: '/payten-transactions',
            parentView: 'walletMgmt.walletPlugins',
            views: {
                '': {
                    template:
                        '<react-grid data-view-name="{{viewName}}"></react-grid>' +
                        '<info-message></info-message>',
                    controller: 'PaytenTransactionsController',
                }
            },
            resolve: {
                loadController: ['$ocLazyLoad', function($ocLazyLoad) {
                    return $ocLazyLoad.load('[DIST_PATH]js/seven-admin-walletmgmt.js')
                }]
            }
        })
        .state('walletMgmt.paytenConfiguration', {
            url: '/payten-configuration/:pluginIdentifier',
            parentView: 'walletMgmt.walletPlugins',
            views: {
                '': {
                    templateUrl: '/app/walletMgmt/payten/payten-configuration.template.html',
                    controller: 'PaytenConfigurationController',
                    controllerAs: 'vm',
                }
            },
            resolve: {
                loadController: ['$ocLazyLoad', function($ocLazyLoad) {
                    return $ocLazyLoad.load('[DIST_PATH]js/seven-admin-walletmgmt.js')
                }]
            }
        })
        .state('walletMgmt.mtnDeposits', {
            url: '/mtn-deposits',
            parentView: 'walletMgmt.walletPlugins',
            views: {
                '': {
                    template:
                        '<react-grid data-view-name="{{viewName}}"></react-grid>' +
                        '<info-message></info-message>',
                    controller: 'APPHDepositsController',
                }
            },
            data: {
                tabTranslationKey: 'wallet.mtn_deposits',
                viewName: 'MTNDepositsGrid',
                pluginName: 'mtn-mobile-payment',
                tabs: [
                    { translationKey: 'wallet.mtn_deposits', state: 'walletMgmt.mtnDeposits' },
                    { translationKey: 'wallet.mtn_withdrawals', state: 'walletMgmt.mtnWithdrawals' }
                ]
            },
            resolve: {
                loadController: ['$ocLazyLoad', function ($ocLazyLoad) {
                    return $ocLazyLoad.load('[DIST_PATH]js/seven-admin-walletmgmt.js')
                }]
            }
        })
        .state('walletMgmt.mtnWithdrawals', {
            url: '/mtn-withdrawals',
            parentView: 'walletMgmt.walletPlugins',
            views: {
                '': {
                    template:
                        '<react-grid data-view-name="{{viewName}}"></react-grid>' +
                        '<info-message></info-message>',
                    controller: 'APPHWithdrawalsController',
                }
            },
            data: {
                tabTranslationKey: 'wallet.mtn_withdrawals',
                viewName: 'MTNWithdrawalsGrid',
                pluginName: 'mtn-mobile-payment',
                tabs: [
                    { translationKey: 'wallet.mtn_deposits', state: 'walletMgmt.mtnDeposits' },
                    { translationKey: 'wallet.mtn_withdrawals', state: 'walletMgmt.mtnWithdrawals' }
                ]
            },
            resolve: {
                loadController: ['$ocLazyLoad', function ($ocLazyLoad) {
                    return $ocLazyLoad.load('[DIST_PATH]js/seven-admin-walletmgmt.js')
                }]
            }
        })
        .state('walletMgmt.vodafone m-pesaConfiguration', {
            url: '/mpesa-configuration/:pluginIdentifier',
            parentView: 'walletMgmt.walletPlugins',
            params: {
                pluginName: 'Vodafone M-Pesa'
            },
            views: {
                '': {
                    templateUrl: 'app/walletMgmt/apph/apph-plugin-configuration.template.html',
                    controller: 'APPHPluginConfigurationController',
                    controllerAs: 'vm'
                }
            },
            data: {
                tabTranslationKey: 'wallet.mpesa_configuration',
                tabs: [
                    {
                        translationKey: 'wallet.mpesa_configuration',
                        state: 'walletMgmt.m-pesaConfiguration'
                    }
                ],
                fields: [
                    {
                        label: 'general.enabled',
                        id: 'enabled',
                        type: 'checkbox',
                        model: 'enabled',
                        name: 'enabled',
                        paymentPluginConfigurationModel: 'enabled'
                    },
                    {
                        label: 'wallet.deposit_enabled',
                        id: 'deposit-enabled',
                        type: 'checkbox',
                        model: 'depositEnabled',
                        name: 'depositEnabled',
                        paymentPluginConfigurationModel: 'depositEnabled'
                    },
                    {
                        label: 'wallet.min_deposit',
                        id: 'min-deposit',
                        type: 'number',
                        model: 'minDeposit',
                        name: 'minDeposit',
                        paymentPluginConfigurationModel: 'minDeposit',
                        validators: {
                            required: {
                                error: 'general.required_field'
                            },
                            min: {
                                value: 1,
                                error: 'general.minimum_value_is',
                                errorInterpolationParams: {
                                    min: 1
                                }
                            },
                            pattern: {
                                value: NOT_DECIMAL_SEPARATOR_REGEX,
                                error: 'validation.decimal_numbers_not_allowed',
                            },
                            max: {
                                value: MAX_RELIABLY_PARSABLE_NUMBER,
                                error: 'general.maximum_value_is',
                                errorInterpolationParams: {
                                    max: MAX_RELIABLY_PARSABLE_NUMBER
                                }
                            },
                            lessThan: {
                                value: 'maxDeposit',
                                error: 'validation.messages.must_be_less_than',
                                errorInterpolationParams: {
                                    field: 'wallet.min_deposit',
                                    dependency: 'wallet.max_deposit'
                                }
                            }
                        }
                    },
                    {
                        label: 'wallet.max_deposit',
                        id: 'max-deposit',
                        type: 'number',
                        model: 'maxDeposit',
                        name: 'maxDeposit',
                        paymentPluginConfigurationModel: 'maxDeposit',
                        validators: {
                            required: {
                                error: 'general.required_field'
                            },
                            pattern: {
                                value: NOT_DECIMAL_SEPARATOR_REGEX,
                                error: 'validation.decimal_numbers_not_allowed',
                            },
                            greaterThan: {
                                value: 'minDeposit',
                                error: 'validation.messages.must_be_greater_than',
                                errorInterpolationParams: {
                                    field: 'wallet.max_deposit',
                                    dependency: 'wallet.min_deposit'
                                }
                            }
                        }
                    },
                    {
                        label: 'wallet.withdrawal_enabled',
                        id: 'withdraw-enabled',
                        type: 'checkbox',
                        model: 'withdrawEnabled',
                        name: 'withdrawEnabled',
                        paymentPluginConfigurationModel: 'withdrawEnabled'
                    },
                    {
                        label: 'wallet.min_withdrawal',
                        id: 'min-withdraw',
                        type: 'number',
                        model: 'minWithdraw',
                        name: 'minWithdraw',
                        paymentPluginConfigurationModel: 'minWithdraw',
                        validators: {
                            required: {
                                error: 'general.required_field'
                            },
                            min: {
                                value: 1,
                                error: 'general.minimum_value_is',
                                errorInterpolationParams: {
                                    min: 1
                                }
                            },
                            pattern: {
                                value: NOT_DECIMAL_SEPARATOR_REGEX,
                                error: 'validation.decimal_numbers_not_allowed',
                            },
                            max: {
                                value: MAX_RELIABLY_PARSABLE_NUMBER,
                                error: 'general.maximum_value_is',
                                errorInterpolationParams: {
                                    max: MAX_RELIABLY_PARSABLE_NUMBER
                                }
                            },
                            lessThan: {
                                value: 'maxWithdraw',
                                error: 'validation.messages.must_be_less_than',
                                errorInterpolationParams: {
                                    field: 'wallet.min_withdraw',
                                    dependency: 'wallet.max_withdraw'
                                }
                            }
                        }
                    },
                    {
                        label: 'wallet.max_withdrawal',
                        id: 'max-withdraw',
                        type: 'number',
                        model: 'maxWithdraw',
                        name: 'maxWithdraw',
                        paymentPluginConfigurationModel: 'maxWithdraw',
                        validators: {
                            required: {
                                error: 'general.required_field'
                            },
                            pattern: {
                                value: NOT_DECIMAL_SEPARATOR_REGEX,
                                error: 'validation.decimal_numbers_not_allowed',
                            },
                            greaterThan: {
                                value: 'minWithdraw',
                                error: 'validation.messages.must_be_greater_than',
                                errorInterpolationParams: {
                                    field: 'wallet.max_withdraw',
                                    dependency: 'wallet.min_withdraw'
                                }
                            }
                        }
                    },
                    {
                        label: 'wallet.withdrawal_approve_limit',
                        id: 'withdraw-approve-limit',
                        type: 'number',
                        model: 'withdrawApproveLimit',
                        name: 'withdrawApproveLimit',
                        paymentPluginConfigurationModel: 'withdrawApproveLimit',
                        validators: {
                            required: {
                                error: 'general.required_field',
                                dependencyModel: 'withdrawEnabled'
                            },
                            lessThan: {
                                value: 'maxWithdraw',
                                error: 'validation.messages.must_be_less_than',
                                errorInterpolationParams: {
                                    field: 'wallet.withdrawal_approve_limit',
                                    dependency: 'wallet.max_withdraw'
                                }
                            },
                            greaterThan: {
                                value: 'minWithdraw',
                                error: 'validation.messages.must_be_greater_than',
                                errorInterpolationParams: {
                                    field: 'wallet.withdrawal_approve_limit',
                                    dependency: 'wallet.min_withdraw'
                                }
                            }
                        }
                    },
                    {
                        label: 'wallet.api_url',
                        id: 'api_url',
                        type: 'text',
                        model: 'apiUrl',
                        name: 'apiUrl',
                        paymentPluginConfigurationModel: 'details.apiUrl',
                        validators: {
                            required: {
                                error: 'general.required_field'
                            }
                        }
                    },
                    {
                        label: 'wallet.api_key',
                        id: 'api_key',
                        type: 'text',
                        model: 'apiKey',
                        name: 'apiKey',
                        paymentPluginConfigurationModel: 'details.apiKey',
                        validators: {
                            required: {
                                error: 'general.required_field'
                            }
                        }
                    },
                    {
                        label: 'wallet.public_key',
                        id: 'public_key',
                        type: 'text',
                        model: 'publicKey',
                        name: 'publicKey',
                        paymentPluginConfigurationModel: 'details.publicKey',
                        validators: {
                            required: {
                                error: 'general.required_field'
                            }
                        }
                    },
                    {
                        label: 'wallet.api_country',
                        id: 'api_country',
                        type: 'text',
                        model: 'apiCountry',
                        name: 'apiCountry',
                        paymentPluginConfigurationModel: 'details.apiCountry',
                        validators: {
                            required: {
                                error: 'general.required_field'
                            }
                        }
                    },
                    {
                        label: 'wallet.mpesa_service_provider_code',
                        id: 'provider-code',
                        type: 'text',
                        model: 'providerCode',
                        name: 'providerCode',
                        paymentPluginConfigurationModel: 'details.serviceProviderCode',
                        validators: {
                            required: {
                                error: 'general.required_field'
                            }
                        }
                    },
                    {
                        label: 'wallet.mpesa_purchased_items_description',
                        id: 'purchased-items',
                        type: 'text',
                        model: 'purchasedItems',
                        name: 'purchasedItems',
                        paymentPluginConfigurationModel: 'details.purchasedItemsDescription',
                        validators: {
                            required: {
                                error: 'general.required_field'
                            }
                        }
                    },
                    {
                        label: 'wallet.mpesa_payment_items_description',
                        id: 'payment-items',
                        type: 'text',
                        model: 'paymentItems',
                        name: 'paymentItems',
                        paymentPluginConfigurationModel: 'details.paymentItemsDescription',
                        validators: {
                            required: {
                                error: 'general.required_field'
                            }
                        }
                    },
                    {
                        label: 'wallet.mpesa_mobile_number_pattern',
                        id: 'mobile-phone-pattern',
                        type: 'text',
                        model: 'mobileNumberPattern',
                        name: 'mobileNumberPattern',
                        paymentPluginConfigurationModel: 'details.mobileNumberPattern',
                        validators: {},
                        hideFromCAUsers: true
                    }
                ]
            },
            resolve: lazyLoadWalletManagementBundle
        })
        .state('walletMgmt.vodafone m-pesaDeposits', {
            url: '/M-Pesa/deposits',
            parentView: 'walletMgmt.walletPlugins',
            params: {
                pluginName: 'Vodafone M-Pesa'
            },
            views: {
                '': {
                    template:
                        '<react-grid data-view-name="{{viewName}}"></react-grid>' +
                        '<info-message></info-message>',
                    controller: 'APPHDepositsController',
                }
            },
            data: {
                tabTranslationKey: 'wallet.mpesa_deposits',
                viewName: 'MPesaDepositsGrid',
                tabs: [
                    {
                        translationKey: 'wallet.mpesa_deposits',
                        state: 'walletMgmt.vodafone m-pesaDeposits'
                    },
                    {
                        translationKey: 'wallet.mpesa_withdrawals',
                        state: 'walletMgmt.vodafone m-pesaWithdrawals'
                    }
                ]
            },
            resolve: lazyLoadWalletManagementBundle
        })
        .state('walletMgmt.vodafone m-pesaWithdrawals', {
            url: '/M-Pesa/withdrawals',
            parentView: 'walletMgmt.walletPlugins',
            params: {
                pluginName: 'Vodafone M-Pesa'
            },
            views: {
                '': {
                    template:
                        '<react-grid data-view-name="{{viewName}}"></react-grid>' +
                        '<info-message></info-message>',
                    controller: 'APPHWithdrawalsController',
                }
            },
            data: {
                tabTranslationKey: 'wallet.mpesa_withdrawals',
                viewName: 'MPesaWithdrawalsGrid',
                tabs: [
                     {
                        translationKey: 'wallet.mpesa_deposits',
                        state: 'walletMgmt.vodafone m-pesaDeposits'
                    },
                    {
                        translationKey: 'wallet.mpesa_withdrawals',
                        state: 'walletMgmt.vodafone m-pesaWithdrawals'
                    }
                ]
            },
            resolve: lazyLoadWalletManagementBundle
        })
        .state('walletMgmt.chapaConfiguration', {
            url: '/chapa-configuration/:pluginIdentifier',
            parentView: 'walletMgmt.walletPlugins',
            params: {
                pluginName: 'Chapa'
            },
            views: {
                '': {
                    templateUrl: 'app/walletMgmt/apph/apph-plugin-configuration.template.html',
                    controller: 'APPHPluginConfigurationController',
                    controllerAs: 'vm'
                }
            },
            data: {
                tabTranslationKey: 'wallet.chapa_configuration',
                tabs: [
                    {
                        translationKey: 'wallet.chapa_configuration',
                        state: 'walletMgmt.chapaConfiguration'
                    }
                ],
                fields: [
                    {
                        label: 'general.enabled',
                        id: 'enabled',
                        type: 'checkbox',
                        model: 'enabled',
                        name: 'enabled',
                        paymentPluginConfigurationModel: 'enabled'
                    },
                    {
                        label: 'wallet.deposit_enabled',
                        id: 'deposit-enabled',
                        type: 'checkbox',
                        model: 'depositEnabled',
                        name: 'depositEnabled',
                        paymentPluginConfigurationModel: 'depositEnabled'
                    },
                    {
                        label: 'wallet.min_deposit',
                        id: 'min-deposit',
                        type: 'number',
                        model: 'minDeposit',
                        name: 'minDeposit',
                        paymentPluginConfigurationModel: 'minDeposit',
                        validators: {
                            required: {
                                error: 'general.required_field'
                            },
                            min: {
                                value: 1,
                                error: 'general.minimum_value_is',
                                errorInterpolationParams: {
                                    min: 1
                                }
                            },
                            pattern: {
                                value: NOT_DECIMAL_SEPARATOR_REGEX,
                                error: 'validation.decimal_numbers_not_allowed',
                            },
                            max: {
                                value: MAX_RELIABLY_PARSABLE_NUMBER,
                                error: 'general.maximum_value_is',
                                errorInterpolationParams: {
                                    max: MAX_RELIABLY_PARSABLE_NUMBER
                                }
                            },
                            lessThan: {
                                value: 'maxDeposit',
                                error: 'validation.messages.must_be_less_than',
                                errorInterpolationParams: {
                                    field: 'wallet.min_deposit',
                                    dependency: 'wallet.max_deposit'
                                }
                            }
                        }
                    },
                    {
                        label: 'wallet.max_deposit',
                        id: 'max-deposit',
                        type: 'number',
                        model: 'maxDeposit',
                        name: 'maxDeposit',
                        paymentPluginConfigurationModel: 'maxDeposit',
                        validators: {
                            required: {
                                error: 'general.required_field'
                            },
                            pattern: {
                                value: NOT_DECIMAL_SEPARATOR_REGEX,
                                error: 'validation.decimal_numbers_not_allowed',
                            },
                            greaterThan: {
                                value: 'minDeposit',
                                error: 'validation.messages.must_be_greater_than',
                                errorInterpolationParams: {
                                    field: 'wallet.max_deposit',
                                    dependency: 'wallet.min_deposit'
                                }
                            }
                        }
                    },
                    {
                        label: 'wallet.withdrawal_enabled',
                        id: 'withdraw-enabled',
                        type: 'checkbox',
                        model: 'withdrawEnabled',
                        name: 'withdrawEnabled',
                        paymentPluginConfigurationModel: 'withdrawEnabled'
                    },
                    {
                        label: 'wallet.min_withdrawal',
                        id: 'min-withdraw',
                        type: 'number',
                        model: 'minWithdraw',
                        name: 'minWithdraw',
                        paymentPluginConfigurationModel: 'minWithdraw',
                        validators: {
                            required: {
                                error: 'general.required_field'
                            },
                            min: {
                                value: 1,
                                error: 'general.minimum_value_is',
                                errorInterpolationParams: {
                                    min: 1
                                }
                            },
                            pattern: {
                                value: NOT_DECIMAL_SEPARATOR_REGEX,
                                error: 'validation.decimal_numbers_not_allowed',
                            },
                            max: {
                                value: MAX_RELIABLY_PARSABLE_NUMBER,
                                error: 'general.maximum_value_is',
                                errorInterpolationParams: {
                                    max: MAX_RELIABLY_PARSABLE_NUMBER
                                }
                            },
                            lessThan: {
                                value: 'maxWithdraw',
                                error: 'validation.messages.must_be_less_than',
                                errorInterpolationParams: {
                                    field: 'wallet.min_withdraw',
                                    dependency: 'wallet.max_withdraw'
                                }
                            }
                        }
                    },
                    {
                        label: 'wallet.max_withdrawal',
                        id: 'max-withdraw',
                        type: 'number',
                        model: 'maxWithdraw',
                        name: 'maxWithdraw',
                        paymentPluginConfigurationModel: 'maxWithdraw',
                        validators: {
                            required: {
                                error: 'general.required_field'
                            },
                            pattern: {
                                value: NOT_DECIMAL_SEPARATOR_REGEX,
                                error: 'validation.decimal_numbers_not_allowed',
                            },
                            greaterThan: {
                                value: 'minWithdraw',
                                error: 'validation.messages.must_be_greater_than',
                                errorInterpolationParams: {
                                    field: 'wallet.max_withdraw',
                                    dependency: 'wallet.min_withdraw'
                                }
                            }
                        }
                    },
                    {
                        label: 'wallet.withdrawal_approve_limit',
                        id: 'withdraw-approve-limit',
                        type: 'number',
                        model: 'withdrawApproveLimit',
                        name: 'withdrawApproveLimit',
                        paymentPluginConfigurationModel: 'withdrawApproveLimit',
                        validators: {
                            required: {
                                error: 'general.required_field',
                                dependencyModel: 'withdrawEnabled'
                            },
                            lessThan: {
                                value: 'maxWithdraw',
                                error: 'validation.messages.must_be_less_than',
                                errorInterpolationParams: {
                                    field: 'wallet.withdrawal_approve_limit',
                                    dependency: 'wallet.max_withdraw'
                                }
                            },
                            greaterThan: {
                                value: 'minWithdraw',
                                error: 'validation.messages.must_be_greater_than',
                                errorInterpolationParams: {
                                    field: 'wallet.withdrawal_approve_limit',
                                    dependency: 'wallet.min_withdraw'
                                }
                            }
                        }
                    },
                    {
                        label: 'wallet.api_key',
                        id: 'secret_api_key',
                        type: 'text',
                        model: 'secretApiKey',
                        name: 'secretApiKey',
                        paymentPluginConfigurationModel: 'details.secretApiKey',
                        validators: {
                            required: {
                                error: 'general.required_field'
                            }
                        }
                    },
                    {
                        label: 'wallet.secret_hash',
                        id: 'secret-hash',
                        type: 'text',
                        model: 'secretHash',
                        name: 'secretHash',
                        paymentPluginConfigurationModel: 'details.secretHash',
                        validators: {
                            required: {
                                error: 'general.required_field'
                            }
                        }
                    },
                    {
                        label: 'wallet.chapa_message_title',
                        id: 'message-title',
                        type: 'text',
                        model: 'messageTitle',
                        name: 'messageTitle',
                        paymentPluginConfigurationModel: 'details.messageTitle',
                        validators: {
                            required: {
                                error: 'general.required_field'
                            }
                        }
                    },
                    {
                        label: 'wallet.chapa_message_description',
                        id: 'message-description',
                        type: 'text',
                        model: 'messageDescription',
                        name: 'messageDescription',
                        paymentPluginConfigurationModel: 'details.messageDescription',
                        validators: {
                            required: {
                                error: 'general.required_field'
                            }
                        }
                    },
                ]
            },
            resolve: lazyLoadWalletManagementBundle
        })
        .state('walletMgmt.chapaDeposits', {
            url: '/chapa/deposits',
            parentView: 'walletMgmt.walletPlugins',
            params: {
                pluginName: 'Chapa'
            },
            views: {
                '': {
                    template:
                        '<react-grid data-view-name="{{viewName}}"></react-grid>' +
                        '<info-message></info-message>',
                    controller: 'APPHDepositsController',
                }
            },
            data: {
                tabTranslationKey: 'wallet.chapa_deposits',
                viewName: 'ChapaDepositsGrid',
                tabs: [
                    {
                        translationKey: 'wallet.chapa_deposits',
                        state: 'walletMgmt.chapaDeposits'
                    },
                    {
                        translationKey: 'wallet.chapa_withdrawals',
                        state: 'walletMgmt.chapaWithdrawals'
                    }
                ]
            },
            resolve: lazyLoadWalletManagementBundle
        })
        .state('walletMgmt.chapaWithdrawals', {
            url: '/chapa/withdrawals',
            parentView: 'walletMgmt.walletPlugins',
            params: {
                pluginName: 'Chapa'
            },
            views: {
                '': {
                    template:
                        '<react-grid data-view-name="{{viewName}}"></react-grid>' +
                        '<info-message></info-message>',
                    controller: 'APPHWithdrawalsController',
                }
            },
            data: {
                tabTranslationKey: 'wallet.chapa_withdrawals',
                viewName: 'ChapaWithdrawalsGrid',
                tabs: [
                     {
                        translationKey: 'wallet.chapa_deposits',
                        state: 'walletMgmt.chapaDeposits'
                    },
                    {
                        translationKey: 'wallet.chapa_withdrawals',
                        state: 'walletMgmt.chapaWithdrawals'
                    }
                ]
            },
            resolve: lazyLoadWalletManagementBundle
        })
        .state('walletMgmt.nova bankaConfiguration', {
            url: '/nova-banka-configuration/:pluginIdentifier',
            parentView: 'walletMgmt.walletPlugins',
            params: {
                pluginName: 'Nova Banka'
            },
            views: {
                '': {
                    templateUrl: 'app/walletMgmt/apph/apph-plugin-configuration.template.html',
                    controller: 'APPHPluginConfigurationController',
                    controllerAs: 'vm'
                }
            },
            data: {
                tabTranslationKey: 'wallet.nova_banka_configuration',
                tabs: [
                    {
                        translationKey: 'wallet.nova_banka_configuration',
                        state: 'walletMgmt.nova bankaConfiguration'
                    }
                ],
                fields: [
                    {
                        label: 'general.enabled',
                        id: 'enabled',
                        type: 'checkbox',
                        model: 'enabled',
                        name: 'enabled',
                        paymentPluginConfigurationModel: 'enabled'
                    },
                    {
                        label: 'wallet.deposit_enabled',
                        id: 'deposit-enabled',
                        type: 'checkbox',
                        model: 'depositEnabled',
                        name: 'depositEnabled',
                        paymentPluginConfigurationModel: 'depositEnabled'
                    },
                    {
                        label: 'wallet.min_deposit',
                        id: 'min-deposit',
                        type: 'number',
                        model: 'minDeposit',
                        name: 'minDeposit',
                        paymentPluginConfigurationModel: 'minDeposit',
                        validators: {
                            required: {
                                error: 'general.required_field'
                            },
                            min: {
                                value: 1,
                                error: 'general.minimum_value_is',
                                errorInterpolationParams: {
                                    min: 1
                                }
                            },
                            pattern: {
                                value: NOT_DECIMAL_SEPARATOR_REGEX,
                                error: 'validation.decimal_numbers_not_allowed',
                            },
                            max: {
                                value: MAX_RELIABLY_PARSABLE_NUMBER,
                                error: 'general.maximum_value_is',
                                errorInterpolationParams: {
                                    max: MAX_RELIABLY_PARSABLE_NUMBER
                                }
                            },
                            lessThan: {
                                value: 'maxDeposit',
                                error: 'validation.messages.must_be_less_than',
                                errorInterpolationParams: {
                                    field: 'wallet.min_deposit',
                                    dependency: 'wallet.max_deposit'
                                }
                            }
                        }
                    },
                    {
                        label: 'wallet.max_deposit',
                        id: 'max-deposit',
                        type: 'number',
                        model: 'maxDeposit',
                        name: 'maxDeposit',
                        paymentPluginConfigurationModel: 'maxDeposit',
                        validators: {
                            required: {
                                error: 'general.required_field'
                            },
                            pattern: {
                                value: NOT_DECIMAL_SEPARATOR_REGEX,
                                error: 'validation.decimal_numbers_not_allowed',
                            },
                            greaterThan: {
                                value: 'minDeposit',
                                error: 'validation.messages.must_be_greater_than',
                                errorInterpolationParams: {
                                    field: 'wallet.max_deposit',
                                    dependency: 'wallet.min_deposit'
                                }
                            }
                        }
                    },
                    {
                        label: 'wallet.nova_banka_tran_portal_id',
                        id: 'tran-portal-id',
                        type: 'text',
                        model: 'tranPortalId',
                        name: 'tranPortalId',
                        paymentPluginConfigurationModel: 'details.tranPortalId',
                        validators: {
                            required: {
                                error: 'general.required_field'
                            }
                        }
                    },
                    {
                        label: 'wallet.nova_banka_tran_portal_id_password',
                        id: 'tran-portal-id-password',
                        type: 'text',
                        model: 'tranPortalIdPassword',
                        name: 'tranPortalIdPassword',
                        paymentPluginConfigurationModel: 'details.tranPortalIdPassword',
                        validators: {
                            required: {
                                error: 'general.required_field'
                            }
                        }
                    },
                    {
                        label: 'wallet.api_key',
                        id: 'secret_api_key',
                        type: 'text',
                        model: 'secretApiKey',
                        name: 'secretApiKey',
                        paymentPluginConfigurationModel: 'details.secret',
                        validators: {
                            required: {
                                error: 'general.required_field'
                            }
                        }
                    }
                ]
            },
            resolve: lazyLoadWalletManagementBundle
        })
        .state('walletMgmt.nova bankaDeposits', {
            url: '/nova-banka/deposits',
            parentView: 'walletMgmt.walletPlugins',
            params: {
                pluginName: 'Nova Banka'
            },
            views: {
                '': {
                    template:
                        '<react-grid data-view-name="{{viewName}}"></react-grid>' +
                        '<info-message></info-message>',
                    controller: 'APPHDepositsController',
                }
            },
            data: {
                tabTranslationKey: 'wallet.nova_banka_deposits',
                viewName: 'NovaBankaDepositsGrid',
                tabs: [
                    {
                        translationKey: 'wallet.nova_banka_deposits',
                        state: 'walletMgmt.nova bankaDeposits'
                    }
                ]
            },
            resolve: lazyLoadWalletManagementBundle
        })
        .state('walletMgmt.mtn-mobile-paymentConfiguration', {
            url: '/mtn-configuration',
            parentView: 'walletMgmt.walletPlugins',
            views: {
                '': {
                    templateUrl: '/app/walletMgmt/mtn/mtn-configuration.template.html',
                    controller: 'MTNConfigurationController',
                    controllerAs: 'vm',
                }
            },
            resolve: {
                loadController: ['$ocLazyLoad', function($ocLazyLoad) {
                    return $ocLazyLoad.load('[DIST_PATH]js/seven-admin-walletmgmt.js')
                }]
            }
        })
        .state('walletMgmt.mtsTransactions', {
            url: '/MTS-Mobile-Payment/transactions',
            parentView: 'walletMgmt.walletPlugins',
            params: {
                pluginName: 'MTS-Mobile-Payment'
            },
            views: {
                '': {
                    template:
                        '<react-grid data-view-name="{{viewName}}"></react-grid>' +
                        '<info-message></info-message>',
                    controller: 'APPHDepositsController',
                }
            },
            data: {
                tabTranslationKey: 'wallet.mts_transactions',
                viewName: 'MTSTransactionsGrid',
                tabs: [
                    {
                        translationKey: 'wallet.mts_transactions',
                        state: 'walletMgmt.mtsTransactions'
                    }
                ]
            },
            resolve: {
                loadController: ['$ocLazyLoad', function ($ocLazyLoad) {
                    return $ocLazyLoad.load('[DIST_PATH]js/seven-admin-walletmgmt.js')
                }]
            }
        })
        .state('walletMgmt.mts-mobile-paymentConfiguration', {
            url: '/MTS-Mobile-Payment/configuration/:pluginIdentifier',
            parentView: 'walletMgmt.walletPlugins',
            params: {
                pluginName: "MTS-Mobile-Payment"
            },
            views: {
                '': {
                    templateUrl: 'app/walletMgmt/apph/apph-plugin-configuration.template.html',
                    controller: 'APPHPluginConfigurationController',
                    controllerAs: 'vm'
                }
            },
            /** @type APPHPluginConfigurationStateData */
            data: {
                tabTranslationKey: 'walletMgmt.mts_configuration',
                tabs: [
                    {
                        translationKey: 'walletMgmt.mts_configuration',
                        state: 'walletMgmt.mts-mobile-paymentConfiguration'
                    }
                ],
                fields: [
                    {
                        label: 'general.enabled',
                        id: 'enabled',
                        type: 'checkbox',
                        model: 'enabled',
                        name: 'enabled',
                        paymentPluginConfigurationModel: 'enabled'
                    },
                    {
                        label: 'wallet.deposit_enabled',
                        id: 'deposit-enabled',
                        type: 'checkbox',
                        model: 'depositEnabled',
                        name: 'depositEnabled',
                        paymentPluginConfigurationModel: 'depositEnabled'
                    },
                    {
                        label: 'wallet.min_deposit',
                        id: 'min-deposit',
                        type: 'number',
                        model: 'minDeposit',
                        name: 'minDeposit',
                        paymentPluginConfigurationModel: 'minDeposit',
                        validators: {
                            required: {
                                error: 'general.required_field'
                            },
                            min: {
                                value: 1,
                                error: 'general.minimum_value_is',
                                errorInterpolationParams: {
                                    min: 1
                                }
                            },
                            pattern: {
                                value: NOT_DECIMAL_SEPARATOR_REGEX,
                                error: 'validation.decimal_numbers_not_allowed',
                            },
                            max: {
                                value: MAX_RELIABLY_PARSABLE_NUMBER,
                                error: 'general.maximum_value_is',
                                errorInterpolationParams: {
                                    max: MAX_RELIABLY_PARSABLE_NUMBER
                                }
                            },
                            lessThan: {
                                value: 'maxDeposit',
                                error: 'validation.messages.must_be_less_than',
                                errorInterpolationParams: {
                                    field: 'wallet.min_deposit',
                                    dependency: 'wallet.max_deposit'
                                }
                            }
                        }
                    },
                    {
                        label: 'wallet.max_deposit',
                        id: 'max-deposit',
                        type: 'number',
                        model: 'maxDeposit',
                        name: 'maxDeposit',
                        paymentPluginConfigurationModel: 'maxDeposit',
                        validators: {
                            required: {
                                error: 'general.required_field'
                            },
                            pattern: {
                                value: NOT_DECIMAL_SEPARATOR_REGEX,
                                error: 'validation.decimal_numbers_not_allowed',
                            },
                            greaterThan: {
                                value: 'minDeposit',
                                error: 'validation.messages.must_be_greater_than',
                                errorInterpolationParams: {
                                    field: 'wallet.max_deposit',
                                    dependency: 'wallet.min_deposit'
                                }
                            }
                        }
                    },
                    {

                        label: 'walletMgmt.mts_voucher',
                        labelInterpolationParams: {
                            voucherNumber: 1
                        },
                        id: 'voucher-1',
                        type: 'number',
                        model: 'vouchers1',
                        name: 'vouchers1',
                        paymentPluginConfigurationModel: 'details.vouchers[0]',
                        validators: {
                            required: {
                                error: 'general.required_field'
                            },
                            min: {
                                value: 1,
                                error: 'general.minimum_value_is',
                                errorInterpolationParams: {
                                    min: 1
                                }
                            },
                            pattern: {
                                value: NOT_DECIMAL_SEPARATOR_REGEX,
                                error: 'validation.decimal_numbers_not_allowed',
                            },
                            equalOrGreaterThan: {
                                value: 'minDeposit',
                                error: 'validation.messages.must_be_equal_or_greater_than',
                                errorInterpolationParams: {
                                    field: 'walletMgmt.mts_voucher',
                                    dependency: 'wallet.min_deposit'
                                }
                            },
                            equalOrLessThan: {
                                value: 'maxDeposit',
                                error: 'validation.messages.must_be_equal_or_less_than',
                                errorInterpolationParams: {
                                    field: 'walletMgmt.mts_voucher',
                                    dependency: 'wallet.max_deposit'
                                }
                            },
                            distinctFrom: {
                                value: [
                                    'vm.fieldValues.vouchers2',
                                    'vm.fieldValues.vouchers3',
                                    'vm.fieldValues.vouchers4',
                                    'vm.fieldValues.vouchers5',
                                    'vm.fieldValues.vouchers6',
                                    'vm.fieldValues.vouchers7',
                                    'vm.fieldValues.vouchers8',
                                    'vm.fieldValues.vouchers9'
                                ],
                                error: 'walletMgmt.mts_voucher_amounts_unique'
                            }
                        }
                    },
                    {
                        label: 'walletMgmt.mts_voucher',
                        labelInterpolationParams: {
                            voucherNumber: 2
                        },
                        id: 'voucher-2',
                        type: 'number',
                        model: 'vouchers2',
                        name: 'vouchers2',
                        paymentPluginConfigurationModel: 'details.vouchers[1]',
                        validators: {
                            min: {
                                value: 1,
                                error: 'general.minimum_value_is',
                                errorInterpolationParams: {
                                    min: 1
                                }
                            },
                            pattern: {
                                value: NOT_DECIMAL_SEPARATOR_REGEX,
                                error: 'validation.decimal_numbers_not_allowed',
                            },
                            equalOrGreaterThan: {
                                value: 'minDeposit',
                                error: 'validation.messages.must_be_equal_or_greater_than',
                                errorInterpolationParams: {
                                    field: 'walletMgmt.mts_voucher',
                                    dependency: 'wallet.min_deposit'
                                }
                            },
                            equalOrLessThan: {
                                value: 'maxDeposit',
                                error: 'validation.messages.must_be_equal_or_less_than',
                                errorInterpolationParams: {
                                    field: 'walletMgmt.mts_voucher',
                                    dependency: 'wallet.max_deposit'
                                }
                            },
                            distinctFrom: {
                                value: [
                                    'vm.fieldValues.vouchers1',
                                    'vm.fieldValues.vouchers3',
                                    'vm.fieldValues.vouchers4',
                                    'vm.fieldValues.vouchers5',
                                    'vm.fieldValues.vouchers6',
                                    'vm.fieldValues.vouchers7',
                                    'vm.fieldValues.vouchers8',
                                    'vm.fieldValues.vouchers9',
                                    'vm.fieldValues.vouchers10'
                                ],
                                error: 'walletMgmt.mts_voucher_amounts_unique'
                            }
                        }
                    },
                    {
                        label: 'walletMgmt.mts_voucher',
                        labelInterpolationParams: {
                            voucherNumber: 3
                        },
                        id: 'voucher-3',
                        type: 'number',
                        model: 'vouchers3',
                        name: 'vouchers3',
                        paymentPluginConfigurationModel: 'details.vouchers[2]',
                        validators: {
                            min: {
                                value: 1,
                                error: 'general.minimum_value_is',
                                errorInterpolationParams: {
                                    min: 1
                                }
                            },
                            pattern: {
                                value: NOT_DECIMAL_SEPARATOR_REGEX,
                                error: 'validation.decimal_numbers_not_allowed',
                            },
                            equalOrGreaterThan: {
                                value: 'minDeposit',
                                error: 'validation.messages.must_be_equal_or_greater_than',
                                errorInterpolationParams: {
                                    field: 'walletMgmt.mts_voucher',
                                    dependency: 'wallet.min_deposit'
                                }
                            },
                            equalOrLessThan: {
                                value: 'maxDeposit',
                                error: 'validation.messages.must_be_equal_or_less_than',
                                errorInterpolationParams: {
                                    field: 'walletMgmt.mts_voucher',
                                    dependency: 'wallet.max_deposit'
                                }
                            },
                            distinctFrom: {
                                value: [
                                    'vm.fieldValues.vouchers1',
                                    'vm.fieldValues.vouchers2',
                                    'vm.fieldValues.vouchers4',
                                    'vm.fieldValues.vouchers5',
                                    'vm.fieldValues.vouchers6',
                                    'vm.fieldValues.vouchers7',
                                    'vm.fieldValues.vouchers8',
                                    'vm.fieldValues.vouchers9',
                                    'vm.fieldValues.vouchers10'
                                ],
                                error: 'walletMgmt.mts_voucher_amounts_unique'
                            }
                        }
                    },
                    {
                        label: 'walletMgmt.mts_voucher',
                        labelInterpolationParams: {
                            voucherNumber: 4
                        },
                        id: 'voucher-4',
                        type: 'number',
                        model: 'vouchers4',
                        name: 'vouchers4',
                        paymentPluginConfigurationModel: 'details.vouchers[3]',
                        validators: {
                            min: {
                                value: 1,
                                error: 'general.minimum_value_is',
                                errorInterpolationParams: {
                                    min: 1
                                }
                            },
                            pattern: {
                                value: NOT_DECIMAL_SEPARATOR_REGEX,
                                error: 'validation.decimal_numbers_not_allowed',
                            },
                            equalOrGreaterThan: {
                                value: 'minDeposit',
                                error: 'validation.messages.must_be_equal_or_greater_than',
                                errorInterpolationParams: {
                                    field: 'walletMgmt.mts_voucher',
                                    dependency: 'wallet.min_deposit'
                                }
                            },
                            equalOrLessThan: {
                                value: 'maxDeposit',
                                error: 'validation.messages.must_be_equal_or_less_than',
                                errorInterpolationParams: {
                                    field: 'walletMgmt.mts_voucher',
                                    dependency: 'wallet.max_deposit'
                                }
                            },
                            distinctFrom: {
                                value: [
                                    'vm.fieldValues.vouchers1',
                                    'vm.fieldValues.vouchers2',
                                    'vm.fieldValues.vouchers3',
                                    'vm.fieldValues.vouchers5',
                                    'vm.fieldValues.vouchers6',
                                    'vm.fieldValues.vouchers7',
                                    'vm.fieldValues.vouchers8',
                                    'vm.fieldValues.vouchers9',
                                    'vm.fieldValues.vouchers10'
                                ],
                                error: 'walletMgmt.mts_voucher_amounts_unique'
                            }
                        }
                    },
                    {
                        label: 'walletMgmt.mts_voucher',
                        labelInterpolationParams: {
                            voucherNumber: 5
                        },
                        id: 'voucher-5',
                        type: 'number',
                        model: 'vouchers5',
                        name: 'vouchers5',
                        paymentPluginConfigurationModel: 'details.vouchers[4]',
                        validators: {
                            min: {
                                value: 1,
                                error: 'general.minimum_value_is',
                                errorInterpolationParams: {
                                    min: 1
                                }
                            },
                            pattern: {
                                value: NOT_DECIMAL_SEPARATOR_REGEX,
                                error: 'validation.decimal_numbers_not_allowed',
                            },
                            equalOrGreaterThan: {
                                value: 'minDeposit',
                                error: 'validation.messages.must_be_equal_or_greater_than',
                                errorInterpolationParams: {
                                    field: 'walletMgmt.mts_voucher',
                                    dependency: 'wallet.min_deposit'
                                }
                            },
                            equalOrLessThan: {
                                value: 'maxDeposit',
                                error: 'validation.messages.must_be_equal_or_less_than',
                                errorInterpolationParams: {
                                    field: 'walletMgmt.mts_voucher',
                                    dependency: 'wallet.max_deposit'
                                }
                            },
                            distinctFrom: {
                                value: [
                                    'vm.fieldValues.vouchers1',
                                    'vm.fieldValues.vouchers2',
                                    'vm.fieldValues.vouchers3',
                                    'vm.fieldValues.vouchers4',
                                    'vm.fieldValues.vouchers6',
                                    'vm.fieldValues.vouchers7',
                                    'vm.fieldValues.vouchers8',
                                    'vm.fieldValues.vouchers9',
                                    'vm.fieldValues.vouchers10'
                                ],
                                error: 'walletMgmt.mts_voucher_amounts_unique'
                            }
                        }
                    },
                    {
                        label: 'walletMgmt.mts_voucher',
                        labelInterpolationParams: {
                            voucherNumber: 6
                        },
                        id: 'voucher-6',
                        type: 'number',
                        model: 'vouchers6',
                        name: 'vouchers6',
                        paymentPluginConfigurationModel: 'details.vouchers[5]',
                        validators: {
                            min: {
                                value: 1,
                                error: 'general.minimum_value_is',
                                errorInterpolationParams: {
                                    min: 1
                                }
                            },
                            pattern: {
                                value: NOT_DECIMAL_SEPARATOR_REGEX,
                                error: 'validation.decimal_numbers_not_allowed',
                            },
                            equalOrGreaterThan: {
                                value: 'minDeposit',
                                error: 'validation.messages.must_be_equal_or_greater_than',
                                errorInterpolationParams: {
                                    field: 'walletMgmt.mts_voucher',
                                    dependency: 'wallet.min_deposit'
                                }
                            },
                            equalOrLessThan: {
                                value: 'maxDeposit',
                                error: 'validation.messages.must_be_equal_or_less_than',
                                errorInterpolationParams: {
                                    field: 'walletMgmt.mts_voucher',
                                    dependency: 'wallet.max_deposit'
                                }
                            },
                            distinctFrom: {
                                value: [
                                    'vm.fieldValues.vouchers1',
                                    'vm.fieldValues.vouchers2',
                                    'vm.fieldValues.vouchers3',
                                    'vm.fieldValues.vouchers4',
                                    'vm.fieldValues.vouchers5',
                                    'vm.fieldValues.vouchers7',
                                    'vm.fieldValues.vouchers8',
                                    'vm.fieldValues.vouchers9',
                                    'vm.fieldValues.vouchers10'
                                ],
                                error: 'walletMgmt.mts_voucher_amounts_unique'
                            }
                        }
                    },
                    {
                        label: 'walletMgmt.mts_voucher',
                        labelInterpolationParams: {
                            voucherNumber: 7
                        },
                        id: 'voucher-7',
                        type: 'number',
                        model: 'vouchers7',
                        name: 'vouchers7',
                        paymentPluginConfigurationModel: 'details.vouchers[6]',
                        validators: {
                            min: {
                                value: 1,
                                error: 'general.minimum_value_is',
                                errorInterpolationParams: {
                                    min: 1
                                }
                            },
                            pattern: {
                                value: NOT_DECIMAL_SEPARATOR_REGEX,
                                error: 'validation.decimal_numbers_not_allowed',
                            },
                            equalOrGreaterThan: {
                                value: 'minDeposit',
                                error: 'validation.messages.must_be_equal_or_greater_than',
                                errorInterpolationParams: {
                                    field: 'walletMgmt.mts_voucher',
                                    dependency: 'wallet.min_deposit'
                                }
                            },
                            equalOrLessThan: {
                                value: 'maxDeposit',
                                error: 'validation.messages.must_be_equal_or_less_than',
                                errorInterpolationParams: {
                                    field: 'walletMgmt.mts_voucher',
                                    dependency: 'wallet.max_deposit'
                                }
                            },
                            distinctFrom: {
                                value: [
                                    'vm.fieldValues.vouchers1',
                                    'vm.fieldValues.vouchers2',
                                    'vm.fieldValues.vouchers3',
                                    'vm.fieldValues.vouchers4',
                                    'vm.fieldValues.vouchers5',
                                    'vm.fieldValues.vouchers6',
                                    'vm.fieldValues.vouchers8',
                                    'vm.fieldValues.vouchers9',
                                    'vm.fieldValues.vouchers10'
                                ],
                                error: 'walletMgmt.mts_voucher_amounts_unique'
                            }
                        }
                    },
                    {
                        label: 'walletMgmt.mts_voucher',
                        labelInterpolationParams: {
                            voucherNumber: 8
                        },
                        id: 'voucher-8',
                        type: 'number',
                        model: 'vouchers8',
                        name: 'vouchers8',
                        paymentPluginConfigurationModel: 'details.vouchers[7]',
                        validators: {
                            min: {
                                value: 1,
                                error: 'general.minimum_value_is',
                                errorInterpolationParams: {
                                    min: 1
                                }
                            },
                            pattern: {
                                value: NOT_DECIMAL_SEPARATOR_REGEX,
                                error: 'validation.decimal_numbers_not_allowed',
                            },
                            equalOrGreaterThan: {
                                value: 'minDeposit',
                                error: 'validation.messages.must_be_equal_or_greater_than',
                                errorInterpolationParams: {
                                    field: 'walletMgmt.mts_voucher',
                                    dependency: 'wallet.min_deposit'
                                }
                            },
                            equalOrLessThan: {
                                value: 'maxDeposit',
                                error: 'validation.messages.must_be_equal_or_less_than',
                                errorInterpolationParams: {
                                    field: 'walletMgmt.mts_voucher',
                                    dependency: 'wallet.max_deposit'
                                }
                            },
                            distinctFrom: {
                                value: [
                                    'vm.fieldValues.vouchers1',
                                    'vm.fieldValues.vouchers2',
                                    'vm.fieldValues.vouchers3',
                                    'vm.fieldValues.vouchers4',
                                    'vm.fieldValues.vouchers5',
                                    'vm.fieldValues.vouchers6',
                                    'vm.fieldValues.vouchers7',
                                    'vm.fieldValues.vouchers9',
                                    'vm.fieldValues.vouchers10'
                                ],
                                error: 'walletMgmt.mts_voucher_amounts_unique'
                            }
                        }

                    },
                    {
                        label: 'walletMgmt.mts_voucher',
                        labelInterpolationParams: {
                            voucherNumber: 9
                        },
                        id: 'voucher-9',
                        type: 'number',
                        model: 'vouchers9',
                        name: 'vouchers9',
                        paymentPluginConfigurationModel: 'details.vouchers[8]',
                        validators: {
                            min: {
                                value: 1,
                                error: 'general.minimum_value_is',
                                errorInterpolationParams: {
                                    min: 1
                                }
                            },
                            pattern: {
                                value: NOT_DECIMAL_SEPARATOR_REGEX,
                                error: 'validation.decimal_numbers_not_allowed',
                            },
                            equalOrGreaterThan: {
                                value: 'minDeposit',
                                error: 'validation.messages.must_be_equal_or_greater_than',
                                errorInterpolationParams: {
                                    field: 'walletMgmt.mts_voucher',
                                    dependency: 'wallet.min_deposit'
                                }
                            },
                            equalOrLessThan: {
                                value: 'maxDeposit',
                                error: 'validation.messages.must_be_equal_or_less_than',
                                errorInterpolationParams: {
                                    field: 'walletMgmt.mts_voucher',
                                    dependency: 'wallet.max_deposit'
                                }
                            },
                            distinctFrom: {
                                value: [
                                    'vm.fieldValues.vouchers1',
                                    'vm.fieldValues.vouchers2',
                                    'vm.fieldValues.vouchers3',
                                    'vm.fieldValues.vouchers4',
                                    'vm.fieldValues.vouchers5',
                                    'vm.fieldValues.vouchers6',
                                    'vm.fieldValues.vouchers7',
                                    'vm.fieldValues.vouchers8',
                                    'vm.fieldValues.vouchers10'
                                ],
                                error: 'walletMgmt.mts_voucher_amounts_unique'
                            }
                        }
                    },
                    {
                        label: 'walletMgmt.mts_voucher',
                        labelInterpolationParams: {
                            voucherNumber: 10
                        },
                        id: 'voucher-10',
                        type: 'number',
                        model: 'vouchers10',
                        name: 'vouchers10',
                        paymentPluginConfigurationModel: 'details.vouchers[9]',
                        validators: {
                            min: {
                                value: 1,
                                error: 'general.minimum_value_is',
                                errorInterpolationParams: {
                                    min: 1
                                }
                            },
                            pattern: {
                                value: NOT_DECIMAL_SEPARATOR_REGEX,
                                error: 'validation.decimal_numbers_not_allowed',
                            },
                            equalOrGreaterThan: {
                                value: 'minDeposit',
                                error: 'validation.messages.must_be_equal_or_greater_than',
                                errorInterpolationParams: {
                                    field: 'walletMgmt.mts_voucher',
                                    dependency: 'wallet.min_deposit'
                                }
                            },
                            equalOrLessThan: {
                                value: 'maxDeposit',
                                error: 'validation.messages.must_be_equal_or_less_than',
                                errorInterpolationParams: {
                                    field: 'walletMgmt.mts_voucher',
                                    dependency: 'wallet.max_deposit'
                                }
                            },
                            distinctFrom: {
                                value: [
                                    'vm.fieldValues.vouchers1',
                                    'vm.fieldValues.vouchers2',
                                    'vm.fieldValues.vouchers3',
                                    'vm.fieldValues.vouchers4',
                                    'vm.fieldValues.vouchers5',
                                    'vm.fieldValues.vouchers6',
                                    'vm.fieldValues.vouchers7',
                                    'vm.fieldValues.vouchers8',
                                    'vm.fieldValues.vouchers9'
                                ],
                                error: 'walletMgmt.mts_voucher_amounts_unique'
                            }
                        }
                    },
                    {
                        label: 'walletMgmt.mts_provider_id',
                        id: 'provider-id',
                        type: 'text',
                        model: 'providerId',
                        name: 'providerId',
                        paymentPluginConfigurationModel: 'details.credentials.providerId',
                        validators: {
                            required: {
                                error: 'general.required_field'
                            }
                        }
                    },
                    {
                        label: 'walletMgmt.mts_send_sms_id',
                        id: 'send-sms-id',
                        type: 'text',
                        model: 'sendSmsId',
                        name: 'sendSmsId',
                        paymentPluginConfigurationModel: 'details.credentials.sendSmsId',
                        validators: {
                            required: {
                                error: 'general.required_field'
                            }
                        }
                    },
                    {
                        label: 'walletMgmt.mts_charge_id',
                        id: 'charge-id',
                        type: 'text',
                        model: 'chargeId',
                        name: 'chargeId',
                        paymentPluginConfigurationModel: 'details.credentials.chargeId',
                        validators: {
                            required: {
                                error: 'general.required_field'
                            }
                        }
                    },
                    {
                        label: 'walletMgmt.mts_password',
                        id: 'password',
                        type: 'text',
                        model: 'password',
                        name: 'password',
                        paymentPluginConfigurationModel: 'details.credentials.password',
                        validators: {
                            required: {
                                error: 'general.required_field'
                            }
                        }
                    },
                    {
                        label: 'walletMgmt.mts_message_text',
                        id: 'message-text',
                        type: 'textarea',
                        model: 'messageText',
                        name: 'messageText',
                        paymentPluginConfigurationModel: 'details.message.text',
                        validators: {
                            required: {
                                error: 'general.required_field'
                            }
                        }
                    },
                    {
                        label: 'walletMgmt.mts_message_sender',
                        id: 'message-sender',
                        type: 'text',
                        model: 'messageSender',
                        name: 'messageSender',
                        paymentPluginConfigurationModel: 'details.message.sender',
                        validators: {
                            required: {
                                error: 'general.required_field'
                            }
                        }
                    }
                ]
            },
            resolve: lazyLoadWalletManagementBundle
        })
        .state('walletMgmt.bankAccounts', {
            url: '/bank-accounts',
            parentView: 'walletMgmt.bankAccounts',
            views: {
                '': {
                    template:
                        '<react-grid data-view-name="{{::viewName}}"></react-grid>' +
                        '<info-message></info-message>',
                    controller: 'BankAccountsController'
                }
            },
            resolve: lazyLoadWalletManagementBundle
        })
        .state('walletMgmt.bankAccountVerification', {
            url: '/bank-accounts/:bankAccountId/players/:playerId',
            parentView: 'walletMgmt.bankAccounts',
            views: {
                '': {
                    templateUrl: '/app/walletMgmt/bank-accounts/bank-account-verification.templete.html',
                    controller: 'BankAccountVerificationController',
                    controllerAs: 'vm'
                }
            },
            resolve: lazyLoadWalletManagementBundle
        })
        .state('walletMgmt.bankAccountSettings', {
            url: '/bank-account-settings',
            parentView: 'walletMgmt.bankAccountSettings',
            views: {
                '': {
                    templateUrl: '/app/walletMgmt/bank-account-settings/bank-account-settings.template.html',
                    controller: 'BankAccountSettingsCtrl'
                }
            },
            resolve: lazyLoadWalletManagementBundle
        })
        .state('walletMgmt.moncashDeposits', {
            url: '/Moncash-Mobile-Payment/deposits',
            parentView: 'walletMgmt.walletPlugins',
            params: {
                pluginName: 'Moncash-Mobile-Payment'
            },
            views: {
                '': {
                    template:
                        '<react-grid data-view-name="{{viewName}}"></react-grid>' +
                        '<info-message></info-message>',
                    controller: 'APPHDepositsController',
                }
            },
            data: {
                tabTranslationKey: 'wallet.moncash_deposits',
                viewName: 'MonCashDepositsGrid',
                tabs: [
                    {
                        translationKey: 'wallet.moncash_deposits',
                        state: 'walletMgmt.moncashDeposits'
                    },
                    {
                        translationKey: 'wallet.moncash_withdrawals',
                        state: 'walletMgmt.moncashWithdrawals'
                    }
                ]
            },
            resolve: lazyLoadWalletManagementBundle
        })
        .state('walletMgmt.moncashWithdrawals', {
            url: '/Moncash-Mobile-Payment/withdrawals',
            parentView: 'walletMgmt.walletPlugins',
            params: {
                pluginName: 'Moncash-Mobile-Payment'
            },
            views: {
                '': {
                    template:
                        '<react-grid data-view-name="{{viewName}}"></react-grid>' +
                        '<info-message></info-message>',
                    controller: 'APPHWithdrawalsController',
                }
            },
            data: {
                tabTranslationKey: 'wallet.moncash_withdrawals',
                viewName: 'MoncashWithdrawalsGrid',
                tabs: [
                     {
                        translationKey: 'wallet.moncash_deposits',
                        state: 'walletMgmt.moncashDeposits'
                    },
                    {
                        translationKey: 'wallet.moncash_withdrawals',
                        state: 'walletMgmt.moncashWithdrawals'
                    }
                ]
            },
            resolve: lazyLoadWalletManagementBundle
        })
        .state('walletMgmt.moncash-mobile-paymentConfiguration', {
            url: '/Moncash-Mobile-Payment/configuration/:pluginIdentifier',
            parentView: 'walletMgmt.walletPlugins',
            params: {
                pluginName: "Moncash-Mobile-Payment"
            },
            views: {
                '': {
                    templateUrl: 'app/walletMgmt/apph/apph-plugin-configuration.template.html',
                    controller: 'APPHPluginConfigurationController',
                    controllerAs: 'vm'
                }
            },
            /** @type APPHPluginConfigurationStateData */
            data: {
                tabTranslationKey: 'walletMgmt.moncash_configuration',
                tabs: [
                    {
                        translationKey: 'walletMgmt.moncash_configuration',
                        state: 'walletMgmt.moncash-mobile-paymentConfiguration'
                    }
                ],
                fields: [
                    {
                        label: 'general.enabled',
                        id: 'enabled',
                        type: 'checkbox',
                        model: 'enabled',
                        name: 'enabled',
                        paymentPluginConfigurationModel: 'enabled'
                    },
                    {
                        label: 'wallet.deposit_enabled',
                        id: 'deposit-enabled',
                        type: 'checkbox',
                        model: 'depositEnabled',
                        name: 'depositEnabled',
                        paymentPluginConfigurationModel: 'depositEnabled'
                    },
                    {
                        label: 'wallet.min_deposit',
                        id: 'min-deposit',
                        type: 'number',
                        model: 'minDeposit',
                        name: 'minDeposit',
                        paymentPluginConfigurationModel: 'minDeposit',
                        validators: {
                            required: {
                                error: 'general.required_field'
                            },
                            min: {
                                value: 1,
                                error: 'general.minimum_value_is',
                                errorInterpolationParams: {
                                    min: 1
                                }
                            },
                            pattern: {
                                value: NOT_DECIMAL_SEPARATOR_REGEX,
                                error: 'validation.decimal_numbers_not_allowed',
                            },
                            lessThan: {
                                value: 'maxDeposit',
                                error: 'validation.messages.must_be_less_than',
                                errorInterpolationParams: {
                                    field: 'wallet.min_deposit',
                                    dependency: 'wallet.max_deposit'
                                }
                            }
                        }
                    },
                    {
                        label: 'wallet.max_deposit',
                        id: 'max-deposit',
                        type: 'number',
                        model: 'maxDeposit',
                        name: 'maxDeposit',
                        paymentPluginConfigurationModel: 'maxDeposit',
                        validators: {
                            required: {
                                error: 'general.required_field'
                            },
                            pattern: {
                                value: NOT_DECIMAL_SEPARATOR_REGEX,
                                error: 'validation.decimal_numbers_not_allowed',
                            },
                            max: {
                                value: MAX_RELIABLY_PARSABLE_NUMBER,
                                error: 'general.maximum_value_is',
                                errorInterpolationParams: {
                                    max: MAX_RELIABLY_PARSABLE_NUMBER
                                }
                            },
                            greaterThan: {
                                value: 'minDeposit',
                                error: 'validation.messages.must_be_greater_than',
                                errorInterpolationParams: {
                                    field: 'wallet.max_deposit',
                                    dependency: 'wallet.min_deposit'
                                }
                            }
                        }
                    },
                    {
                        label: 'wallet.client_id',
                        id: 'client-id',
                        type: 'text',
                        model: 'clientId',
                        name: 'clientId',
                        paymentPluginConfigurationModel: 'details.credentials.clientId',
                        validators: {
                            required: {
                                error: 'general.required_field'
                            }
                        }
                    },
                    {
                        label: 'wallet.moncash_client_secret',
                        id: 'client-secret',
                        type: 'text',
                        model: 'clientSecret',
                        name: 'clientSecret',
                        paymentPluginConfigurationModel: 'details.credentials.clientSecret',
                        validators: {
                            required: {
                                error: 'general.required_field'
                            }
                        }
                    },
                    {
                        label: 'wallet.withdraw_enabled',
                        id: 'withdraw-enabled',
                        type: 'checkbox',
                        model: 'withdrawEnabled',
                        name: 'withdrawEnabled',
                        paymentPluginConfigurationModel: 'withdrawEnabled'
                    },
                    {
                        label: 'wallet.min_withdraw',
                        id: 'min-withdraw',
                        type: 'number',
                        model: 'minWithdraw',
                        name: 'minWithdraw',
                        paymentPluginConfigurationModel: 'minWithdraw',
                        validators: {
                            required: {
                                error: 'general.required_field',
                                dependencyModel: 'withdrawEnabled'
                            },
                            min: {
                                value: 1,
                                error: 'general.minimum_value_is',
                                errorInterpolationParams: {
                                    min: 1
                                }
                            },
                            pattern: {
                                value: NOT_DECIMAL_SEPARATOR_REGEX,
                                error: 'validation.decimal_numbers_not_allowed',
                            },
                            lessThan: {
                                value: 'maxWithdraw',
                                error: 'validation.messages.must_be_less_than',
                                errorInterpolationParams: {
                                    field: 'wallet.min_withdraw',
                                    dependency: 'wallet.max_withdraw'
                                }
                            }
                        }
                    },
                    {
                        label: 'wallet.max_withdraw',
                        id: 'max-withdraw',
                        type: 'number',
                        model: 'maxWithdraw',
                        name: 'maxWithdraw',
                        paymentPluginConfigurationModel: 'maxWithdraw',
                        validators: {
                            required: {
                                error: 'general.required_field',
                                dependencyModel: 'withdrawEnabled'
                            },
                            pattern: {
                                value: NOT_DECIMAL_SEPARATOR_REGEX,
                                error: 'validation.decimal_numbers_not_allowed',
                            },
                            max: {
                                value: MAX_RELIABLY_PARSABLE_NUMBER,
                                error: 'general.maximum_value_is',
                                errorInterpolationParams: {
                                    max: MAX_RELIABLY_PARSABLE_NUMBER
                                }
                            },
                            greaterThan: {
                                value: 'minWithdraw',
                                error: 'validation.messages.must_be_greater_than',
                                errorInterpolationParams: {
                                    field: 'wallet.max_withdraw',
                                    dependency: 'wallet.min_withdraw'
                                }
                            }
                        }
                    },
                    {
                        label: 'wallet.withdrawal_approve_limit',
                        id: 'withdrawal-approve-limit',
                        type: 'number',
                        model: 'withdrawApproveLimit',
                        name: 'withdrawApproveLimit',
                        paymentPluginConfigurationModel: 'withdrawApproveLimit',
                        validators: {
                            required: {
                                error: 'general.required_field',
                                dependencyModel: 'withdrawEnabled'
                            },
                            lessThan: {
                                value: 'maxWithdraw',
                                error: 'validation.messages.must_be_less_than',
                                errorInterpolationParams: {
                                    field: 'wallet.withdrawal_approve_limit',
                                    dependency: 'wallet.max_withdrawal'
                                }
                            },
                            greaterThan: {
                                value: 'minWithdraw',
                                error: 'validation.messages.must_be_greater_than',
                                errorInterpolationParams: {
                                    field: 'wallet.withdrawal_approve_limit',
                                    dependency: 'wallet.min_withdrawal'
                                }
                            }
                        }
                    },
                    {
                        label: 'wallet.withdraw_description',
                        id: 'withdrawal-description',
                        type: 'text',
                        model: 'withdrawalDescription',
                        name: 'withdrawalDescription',
                        paymentPluginConfigurationModel: 'details.withdrawalDescription',
                        validators: {
                            required: {
                                error: 'general.required_field',
                                dependencyModel: 'withdrawEnabled'
                            },
                        }
                    }
                ]
            },
            resolve: lazyLoadWalletManagementBundle
        })
        .state('walletMgmt.payspotWithdrawals', {
            url: '/Payspot/withdrawals',
            parentView: 'walletMgmt.walletPlugins',
            params: {
                pluginName: 'Payspot'
            },
            views: {
                '': {
                    template:
                        '<react-grid data-view-name="{{viewName}}"></react-grid>' +
                        '<info-message></info-message>',
                    controller: 'APPHWithdrawalsController',
                }
            },
            data: {
                tabTranslationKey: 'wallet.payspot_withdrawals',
                viewName: 'PayspotWithdrawalsGrid',
                tabs: [
                    {
                        translationKey: 'wallet.payspot_withdrawals',
                        state: 'walletMgmt.payspotWithdrawals'
                    }
                ]
            },
            resolve: lazyLoadWalletManagementBundle
        })
        .state('walletMgmt.payspotConfiguration', {
            url: '/payspot-configuration/:pluginIdentifier',
            parentView: 'walletMgmt.walletPlugins',
            params: {
                pluginName: "Payspot"
            },
            views: {
                '': {
                    templateUrl: 'app/walletMgmt/apph/apph-plugin-configuration.template.html',
                    controller: 'APPHPluginConfigurationController',
                    controllerAs: 'vm'
                }
            },
            /** @type APPHPluginConfigurationStateData */
            data: {
                tabTranslationKey: 'wallet.payspot_configuration',
                tabs: [
                    {
                        translationKey: 'wallet.payspot_configuration',
                        state: 'walletMgmt.payspotConfiguration'
                    }
                ],
                fields: [
                    {
                        label: 'general.enabled',
                        id: 'enabled',
                        type: 'checkbox',
                        model: 'enabled',
                        name: 'enabled',
                        paymentPluginConfigurationModel: 'enabled'
                    },
                    {
                        label: 'wallet.withdraw_enabled',
                        id: 'withdraw-enabled',
                        type: 'checkbox',
                        model: 'withdrawEnabled',
                        name: 'withdrawEnabled',
                        paymentPluginConfigurationModel: 'withdrawEnabled'
                    },
                    {
                        label: 'wallet.min_withdraw',
                        id: 'min-withdraw',
                        type: 'number',
                        model: 'minWithdraw',
                        name: 'minWithdraw',
                        paymentPluginConfigurationModel: 'minWithdraw',
                        validators: {
                            required: {
                                error: 'general.required_field',
                                dependencyModel: 'withdrawEnabled'
                            },
                            min: {
                                value: 1,
                                error: 'general.minimum_value_is',
                                errorInterpolationParams: {
                                    min: 1
                                }
                            },
                            pattern: {
                                value: NOT_DECIMAL_SEPARATOR_REGEX,
                                error: 'validation.decimal_numbers_not_allowed',
                            },
                            lessThan: {
                                value: 'maxWithdraw',
                                error: 'validation.messages.must_be_less_than',
                                errorInterpolationParams: {
                                    field: 'wallet.min_withdraw',
                                    dependency: 'wallet.max_withdraw'
                                }
                            }
                        }
                    },
                    {
                        label: 'wallet.max_withdraw',
                        id: 'max-withdraw',
                        type: 'number',
                        model: 'maxWithdraw',
                        name: 'maxWithdraw',
                        paymentPluginConfigurationModel: 'maxWithdraw',
                        validators: {
                            required: {
                                error: 'general.required_field',
                                dependencyModel: 'withdrawEnabled'
                            },
                            pattern: {
                                value: NOT_DECIMAL_SEPARATOR_REGEX,
                                error: 'validation.decimal_numbers_not_allowed',
                            },
                            max: {
                                value: MAX_RELIABLY_PARSABLE_NUMBER,
                                error: 'general.maximum_value_is',
                                errorInterpolationParams: {
                                    max: MAX_RELIABLY_PARSABLE_NUMBER
                                }
                            },
                            greaterThan: {
                                value: 'minWithdraw',
                                error: 'validation.messages.must_be_greater_than',
                                errorInterpolationParams: {
                                    field: 'wallet.max_withdraw',
                                    dependency: 'wallet.min_withdraw'
                                }
                            }
                        }
                    },
                    {
                        label: 'wallet.withdrawal_approve_limit',
                        id: 'withdrawal-approve-limit',
                        type: 'number',
                        model: 'withdrawApproveLimit',
                        name: 'withdrawApproveLimit',
                        paymentPluginConfigurationModel: 'withdrawApproveLimit',
                        validators: {
                            required: {
                                error: 'general.required_field',
                                dependencyModel: 'withdrawEnabled'
                            },
                            lessThan: {
                                value: 'maxWithdraw',
                                error: 'validation.messages.must_be_less_than',
                                errorInterpolationParams: {
                                    field: 'wallet.withdrawal_approve_limit',
                                    dependency: 'wallet.max_withdrawal'
                                }
                            },
                            equalOrGreaterThan: {
                                value: 'minWithdraw',
                                error: 'validation.messages.must_be_equal_or_greater_than',
                                errorInterpolationParams: {
                                    field: 'wallet.withdrawal_approve_limit',
                                    dependency: 'wallet.min_withdrawal'
                                }
                            }
                        }
                    },
                    {
                        label: 'wallet.payspot_withdrawals_retail_location_threshold_limit',
                        id: 'threshold-limit',
                        type: 'text',
                        model: 'thresholdLimit',
                        name: 'thresholdLimit',
                        paymentPluginConfigurationModel: 'details.retailLocationThresholdLimit',
                        validators: {
                            required: {
                                error: 'general.required_field'
                            }
                        }
                    },
                    {
                        label: 'general.company_id',
                        id: 'company-id',
                        type: 'text',
                        model: 'companyId',
                        name: 'companyId',
                        paymentPluginConfigurationModel: 'details.companyId',
                        validators: {
                            required: {
                                error: 'general.required_field'
                            }
                        }
                    },
                    {
                        label: 'wallet.payspot_secret_key',
                        id: 'secret-key',
                        type: 'text',
                        model: 'secretKey',
                        name: 'secretKey',
                        paymentPluginConfigurationModel: 'details.secretKey',
                        validators: {
                            required: {
                                error: 'general.required_field'
                            }
                        }
                    },
                    {
                        label: 'wallet.payspot_service_code',
                        id: 'service-code',
                        type: 'text',
                        model: 'serviceCode',
                        name: 'serviceCode',
                        paymentPluginConfigurationModel: 'details.serviceCode',
                        validators: {
                            required: {
                                error: 'general.required_field'
                            }
                        }
                    },
                ]
            },
            resolve: lazyLoadWalletManagementBundle
        })
        .state('walletMgmt.futureGamingCMSDeposits', {
            url: '/Future-Gaming-CM/deposits',
            parentView: 'walletMgmt.walletPlugins',
            params: {
                pluginName: 'Future-Gaming-CM'
            },
            views: {
                '': {
                    template:
                        '<react-grid data-view-name="{{viewName}}"></react-grid>' +
                        '<info-message></info-message>',
                    controller: 'APPHDepositsController',
                }
            },
            data: {
                tabTranslationKey: 'wallet.future_gaming_cms_deposits',
                viewName: 'futureGamingCMSDeposits',
                tabs: [
                    {
                        translationKey: 'wallet.future_gaming_cms_deposits',
                        state: 'walletMgmt.futureGamingCMSDeposits'
                    },
                    {
                        translationKey: 'wallet.future_gaming_cms_withdrawals',
                        state: 'walletMgmt.futureGamingCMSWithdrawals'
                    }
                ]
            },
            resolve: lazyLoadWalletManagementBundle
        })
        .state('walletMgmt.futureGamingCMSWithdrawals', {
            url: '/Future-Gaming-CM/withdrawals',
            parentView: 'walletMgmt.walletPlugins',
            params: {
                pluginName: 'Future-Gaming-CM'
            },
            views: {
                '': {
                    template:
                        '<react-grid data-view-name="{{viewName}}"></react-grid>' +
                        '<info-message></info-message>',
                    controller: 'APPHWithdrawalsController',
                }
            },
            data: {
                tabTranslationKey: 'wallet.future_gaming_cms_withdrawals',
                viewName: 'futureGamingCMSWithdrawalsGrid',
                tabs: [
                     {
                        translationKey: 'wallet.future_gaming_cms_deposits',
                        state: 'walletMgmt.futureGamingCMSDeposits'
                    },
                    {
                        translationKey: 'wallet.future_gaming_cms_withdrawals',
                        state: 'walletMgmt.futureGamingCMSWithdrawals'
                    }
                ]
            },
            resolve: lazyLoadWalletManagementBundle
        })
        .state('walletMgmt.future-gaming-cmConfiguration', {
            url: '/Future-Gaming-CM/configuration/:pluginIdentifier',
            parentView: 'walletMgmt.walletPlugins',
            params: {
                pluginName: "Future-Gaming-CM"
            },
            views: {
                '': {
                    templateUrl: 'app/walletMgmt/apph/apph-plugin-configuration.template.html',
                    controller: 'APPHPluginConfigurationController',
                    controllerAs: 'vm'
                }
            },
            /** @type APPHPluginConfigurationStateData */
            data: {
                tabTranslationKey: 'wallet.future_gaming_cms_configuration',
                tabs: [
                    {
                        translationKey: 'wallet.future_gaming_cms_configuration',
                        state: 'walletMgmt.future-gaming-cmConfiguration'
                    }
                ],
                fields: [
                    {
                        label: 'general.enabled',
                        id: 'enabled',
                        type: 'checkbox',
                        model: 'enabled',
                        name: 'enabled',
                        paymentPluginConfigurationModel: 'enabled'
                    },
                    {
                        label: 'wallet.deposit_enabled',
                        id: 'deposit-enabled',
                        type: 'checkbox',
                        model: 'depositEnabled',
                        name: 'depositEnabled',
                        paymentPluginConfigurationModel: 'depositEnabled'
                    },
                    {
                        label: 'wallet.min_deposit',
                        id: 'min-deposit',
                        type: 'number',
                        model: 'minDeposit',
                        name: 'minDeposit',
                        paymentPluginConfigurationModel: 'minDeposit',
                        validators: {
                            required: {
                                error: 'general.required_field'
                            },
                            min: {
                                value: 1,
                                error: 'general.minimum_value_is',
                                errorInterpolationParams: {
                                    min: 1
                                }
                            },
                            pattern: {
                                value: NOT_DECIMAL_SEPARATOR_REGEX,
                                error: 'validation.decimal_numbers_not_allowed',
                            },
                            lessThan: {
                                value: 'maxDeposit',
                                error: 'validation.messages.must_be_less_than',
                                errorInterpolationParams: {
                                    field: 'wallet.min_deposit',
                                    dependency: 'wallet.max_deposit'
                                }
                            }
                        }
                    },
                    {
                        label: 'wallet.max_deposit',
                        id: 'max-deposit',
                        type: 'number',
                        model: 'maxDeposit',
                        name: 'maxDeposit',
                        paymentPluginConfigurationModel: 'maxDeposit',
                        validators: {
                            required: {
                                error: 'general.required_field'
                            },
                            pattern: {
                                value: NOT_DECIMAL_SEPARATOR_REGEX,
                                error: 'validation.decimal_numbers_not_allowed',
                            },
                            max: {
                                value: MAX_RELIABLY_PARSABLE_NUMBER,
                                error: 'general.maximum_value_is',
                                errorInterpolationParams: {
                                    max: MAX_RELIABLY_PARSABLE_NUMBER
                                }
                            },
                            greaterThan: {
                                value: 'minDeposit',
                                error: 'validation.messages.must_be_greater_than',
                                errorInterpolationParams: {
                                    field: 'wallet.max_deposit',
                                    dependency: 'wallet.min_deposit'
                                }
                            }
                        }
                    },
                    {
                        label: 'wallet.withdraw_enabled',
                        id: 'withdraw-enabled',
                        type: 'checkbox',
                        model: 'withdrawEnabled',
                        name: 'withdrawEnabled',
                        paymentPluginConfigurationModel: 'withdrawEnabled'
                    },
                    {
                        label: 'wallet.min_withdraw',
                        id: 'min-withdraw',
                        type: 'number',
                        model: 'minWithdraw',
                        name: 'minWithdraw',
                        paymentPluginConfigurationModel: 'minWithdraw',
                        validators: {
                            required: {
                                error: 'general.required_field',
                                dependencyModel: 'withdrawEnabled'
                            },
                            min: {
                                value: 1,
                                error: 'general.minimum_value_is',
                                errorInterpolationParams: {
                                    min: 1
                                }
                            },
                            pattern: {
                                value: NOT_DECIMAL_SEPARATOR_REGEX,
                                error: 'validation.decimal_numbers_not_allowed',
                            },
                            lessThan: {
                                value: 'maxWithdraw',
                                error: 'validation.messages.must_be_less_than',
                                errorInterpolationParams: {
                                    field: 'wallet.min_withdraw',
                                    dependency: 'wallet.max_withdraw'
                                }
                            }
                        }
                    },
                    {
                        label: 'wallet.max_withdraw',
                        id: 'max-withdraw',
                        type: 'number',
                        model: 'maxWithdraw',
                        name: 'maxWithdraw',
                        paymentPluginConfigurationModel: 'maxWithdraw',
                        validators: {
                            required: {
                                error: 'general.required_field',
                                dependencyModel: 'withdrawEnabled'
                            },
                            pattern: {
                                value: NOT_DECIMAL_SEPARATOR_REGEX,
                                error: 'validation.decimal_numbers_not_allowed',
                            },
                            max: {
                                value: MAX_RELIABLY_PARSABLE_NUMBER,
                                error: 'general.maximum_value_is',
                                errorInterpolationParams: {
                                    max: MAX_RELIABLY_PARSABLE_NUMBER
                                }
                            },
                            greaterThan: {
                                value: 'minWithdraw',
                                error: 'validation.messages.must_be_greater_than',
                                errorInterpolationParams: {
                                    field: 'wallet.max_withdraw',
                                    dependency: 'wallet.min_withdraw'
                                }
                            }
                        }
                    },
                    {
                        label: 'wallet.withdrawal_approve_limit',
                        id: 'withdrawal-approve-limit',
                        type: 'number',
                        model: 'withdrawApproveLimit',
                        name: 'withdrawApproveLimit',
                        paymentPluginConfigurationModel: 'withdrawApproveLimit',
                        validators: {
                            required: {
                                error: 'general.required_field',
                                dependencyModel: 'withdrawEnabled'
                            },
                            lessThan: {
                                value: 'maxWithdraw',
                                error: 'validation.messages.must_be_less_than',
                                errorInterpolationParams: {
                                    field: 'wallet.withdrawal_approve_limit',
                                    dependency: 'wallet.max_withdrawal'
                                }
                            },
                            greaterThan: {
                                value: 'minWithdraw',
                                error: 'validation.messages.must_be_greater_than',
                                errorInterpolationParams: {
                                    field: 'wallet.withdrawal_approve_limit',
                                    dependency: 'wallet.min_withdrawal'
                                }
                            }
                        }
                    },
                    {
                        label: 'wallet.client_key',
                        id: 'client-key',
                        type: 'text',
                        model: 'clientKey',
                        name: 'clientKey',
                        paymentPluginConfigurationModel: 'details.clientKey',
                        validators: {
                            required: {
                                error: 'general.required_field'
                            }
                        }
                    },
                    {
                        label: 'wallet.moncash_client_secret',
                        id: 'client-secret',
                        type: 'text',
                        model: 'clientSecret',
                        name: 'clientSecret',
                        paymentPluginConfigurationModel: 'details.clientSecret',
                        validators: {
                            required: {
                                error: 'general.required_field'
                            }
                        }
                    }
                ]
            },
            resolve: lazyLoadWalletManagementBundle
        })
        .state('walletMgmt.oktopayDeposits', {
            url: '/Oktopay/deposits',
            parentView: 'walletMgmt.walletPlugins',
            params: {
                pluginName: 'oktopay'
            },
            views: {
                '': {
                    template:
                        '<react-grid data-view-name="{{viewName}}"></react-grid>' +
                        '<info-message></info-message>',
                    controller: 'APPHDepositsController',
                }
            },
            data: {
                tabTranslationKey: 'wallet.oktopay_withdrawals_tab',
                viewName: 'OktopayDepositsGrid',
                tabs: [
                    {
                        translationKey: 'wallet.oktopay_deposits_tab',
                        state: 'walletMgmt.oktopayDeposits'
                    },
                    {
                        translationKey: 'wallet.oktopay_withdrawals_tab',
                        state: 'walletMgmt.oktopayWithdrawals'
                    }
                ]
            },
            resolve: lazyLoadWalletManagementBundle
        })
        .state('walletMgmt.oktopayWithdrawals', {
            url: '/Oktopay/withdrawals',
            parentView: 'walletMgmt.walletPlugins',
            params: {
                pluginName: 'oktopay'
            },
            views: {
                '': {
                    template:
                        '<react-grid data-view-name="{{viewName}}"></react-grid>' +
                        '<info-message></info-message>',
                    controller: 'APPHWithdrawalsController',
                }
            },
            data: {
                tabTranslationKey: 'walletMgmt.oktopayWithdrawals',
                viewName: 'OktopayWithdrawalsGrid',
                tabs: [
                    {
                        translationKey: 'wallet.oktopay_deposits_tab',
                        state: 'walletMgmt.oktopayDeposits'
                    },
                    {
                        translationKey: 'wallet.oktopay_withdrawals_tab',
                        state: 'walletMgmt.oktopayWithdrawals'
                    }
                ]
            },
            resolve: lazyLoadWalletManagementBundle
        })
        .state('walletMgmt.oktopayConfiguration', {
            url: '/Oktopay/configuration/:pluginIdentifier',
            parentView: 'walletMgmt.walletPlugins',
            params: {
                pluginName: 'oktopay'
            },
            views: {
                '': {
                    templateUrl: 'app/walletMgmt/apph/apph-plugin-configuration.template.html',
                    controller: 'APPHPluginConfigurationController',
                    controllerAs: 'vm'
                }
            },
            /** @type APPHPluginConfigurationStateData */
            data: {
                tabTranslationKey: 'walletMgmt.oktopay',
                tabs: [
                    {
                        translationKey: 'walletMgmt.oktopay_configuration',
                        state: 'walletMgmt.oktopayConfiguration'
                    }
                ],
                fields: [
                    {
                        label: 'general.enabled',
                        id: 'enabled',
                        type: 'checkbox',
                        model: 'enabled',
                        name: 'enabled',
                        paymentPluginConfigurationModel: 'enabled'
                    },
                    {
                        label: 'wallet.deposit_enabled',
                        id: 'deposit-enabled',
                        type: 'checkbox',
                        model: 'depositEnabled',
                        name: 'depositEnabled',
                        paymentPluginConfigurationModel: 'depositEnabled'
                    },
                    {
                        label: 'wallet.min_deposit',
                        id: 'min-deposit',
                        type: 'number',
                        model: 'minDeposit',
                        name: 'minDeposit',
                        paymentPluginConfigurationModel: 'minDeposit',
                        validators: {
                            required: {
                                error: 'general.required_field',
                                dependencyModel: 'depositEnabled'
                            },
                            min: {
                                value: 1,
                                error: 'general.minimum_value_is',
                                errorInterpolationParams: {
                                    min: 1
                                }
                            },
                            pattern: {
                                value: NOT_DECIMAL_SEPARATOR_REGEX,
                                error: 'validation.decimal_numbers_not_allowed',
                            },
                            pattern: {
                                value: NOT_DECIMAL_SEPARATOR_REGEX,
                                error: 'validation.decimal_numbers_not_allowed',
                            },
                            lessThan: {
                                value: 'maxDeposit',
                                error: 'validation.messages.must_be_less_than',
                                errorInterpolationParams: {
                                    field: 'wallet.min_deposit',
                                    dependency: 'wallet.max_deposit'
                                }
                            }
                        }
                    },
                    {
                        label: 'wallet.max_deposit',
                        id: 'max-deposit',
                        type: 'number',
                        model: 'maxDeposit',
                        name: 'maxDeposit',
                        paymentPluginConfigurationModel: 'maxDeposit',
                        validators: {
                            required: {
                                error: 'general.required_field',
                                dependencyModel: 'depositEnabled'
                            },
                            pattern: {
                                value: NOT_DECIMAL_SEPARATOR_REGEX,
                                error: 'validation.decimal_numbers_not_allowed',
                            },
                            max: {
                                value: MAX_RELIABLY_PARSABLE_NUMBER,
                                error: 'general.maximum_value_is',
                                errorInterpolationParams: {
                                    max: MAX_RELIABLY_PARSABLE_NUMBER
                                }
                            },
                            greaterThan: {
                                value: 'minDeposit',
                                error: 'validation.messages.must_be_greater_than',
                                errorInterpolationParams: {
                                    field: 'wallet.max_deposit',
                                    dependency: 'wallet.min_deposit'
                                }
                            }
                        }
                    },
                    {
                        label: 'wallet.withdraw_enabled',
                        id: 'withdraw-enabled',
                        type: 'checkbox',
                        model: 'withdrawEnabled',
                        name: 'withdrawEnabled',
                        paymentPluginConfigurationModel: 'withdrawEnabled'
                    },
                    {
                        label: 'wallet.min_withdraw',
                        id: 'min-withdraw',
                        type: 'number',
                        model: 'minWithdraw',
                        name: 'minWithdraw',
                        paymentPluginConfigurationModel: 'minWithdraw',
                        validators: {
                            required: {
                                error: 'general.required_field',
                                dependencyModel: 'withdrawEnabled'
                            },
                            min: {
                                value: 1,
                                error: 'general.minimum_value_is',
                                errorInterpolationParams: {
                                    min: 1
                                }
                            },
                            pattern: {
                                value: NOT_DECIMAL_SEPARATOR_REGEX,
                                error: 'validation.decimal_numbers_not_allowed',
                            },
                            lessThan: {
                                value: 'maxWithdraw',
                                error: 'validation.messages.must_be_less_than',
                                errorInterpolationParams: {
                                    field: 'wallet.min_withdraw',
                                    dependency: 'wallet.max_withdraw'
                                }
                            }
                        }
                    },
                    {
                        label: 'wallet.max_withdraw',
                        id: 'max-withdraw',
                        type: 'number',
                        model: 'maxWithdraw',
                        name: 'maxWithdraw',
                        paymentPluginConfigurationModel: 'maxWithdraw',
                        validators: {
                            required: {
                                error: 'general.required_field',
                                dependencyModel: 'withdrawEnabled'
                            },
                            pattern: {
                                value: NOT_DECIMAL_SEPARATOR_REGEX,
                                error: 'validation.decimal_numbers_not_allowed',
                            },
                            max: {
                                value: MAX_RELIABLY_PARSABLE_NUMBER,
                                error: 'general.maximum_value_is',
                                errorInterpolationParams: {
                                    max: MAX_RELIABLY_PARSABLE_NUMBER
                                }
                            },
                            greaterThan: {
                                value: 'minWithdraw',
                                error: 'validation.messages.must_be_greater_than',
                                errorInterpolationParams: {
                                    field: 'wallet.max_withdraw',
                                    dependency: 'wallet.min_withdraw'
                                }
                            }
                        }
                    },
                    {
                        label: 'wallet.expiration_period',
                        id: 'deposit-transaction-timeout',
                        type: 'text',
                        model: 'expirationPeriod',
                        name: 'expirationPeriod',
                        paymentPluginConfigurationModel: 'details.expirationPeriod',
                        validators: {
                            required: {
                                error: 'general.required_field'
                            }
                        }
                    },
                    {
                        label: 'wallet.authorization_token',
                        id: 'authorization-token',
                        type: 'text',
                        model: 'authorizationToken',
                        name: 'authorizationToken',
                        paymentPluginConfigurationModel: 'details.authorizationToken',
                        validators: {
                            required: {
                                error: 'general.required_field'
                            }
                        }
                    },
                    {
                        label: 'wallet.merchant_id',
                        id: 'merchant_id',
                        type: 'text',
                        model: 'merchantId',
                        name: 'merchantId',
                        paymentPluginConfigurationModel: 'details.merchantId',
                        validators: {
                            required: {
                                error: 'general.required_field'
                            }
                        }
                    },
                    {
                        label: 'wallet.merchant_info',
                        id: 'merchant_info',
                        type: 'text',
                        model: 'merchantInfo',
                        name: 'merchantInfo',
                        paymentPluginConfigurationModel: 'details.merchantInfo',
                        validators: {
                            required: {
                                error: 'general.required_field'
                            }
                        }
                    },
                    {
                        label: 'wallet.api_url',
                        id: 'api_url',
                        type: 'text',
                        model: 'apiUrl',
                        name: 'apiUrl',
                        paymentPluginConfigurationModel: 'details.apiUrl',
                        validators: {
                            required: {
                                error: 'general.required_field'
                            }
                        }
                    }
                ]
            },
            resolve: lazyLoadWalletManagementBundle
        })
        .state('walletMgmt.superbet-web-terminal-paymentConfiguration', {
            url: '/SuperbetWebTerminalPayment/configuration/:pluginIdentifier',
            parentView: 'walletMgmt.walletPlugins',
            params: {
                pluginName: 'Superbet-Web-Terminal-Payment'
            },
            views: {
                '': {
                    templateUrl: 'app/walletMgmt/apph/apph-plugin-configuration.template.html',
                    controller: 'APPHPluginConfigurationController',
                    controllerAs: 'vm'
                }
            },
            /** @type APPHPluginConfigurationStateData */
            data: {
                tabTranslationKey: 'walletMgmt.superbet_web_terminal',
                tabs: [
                    {
                        translationKey: 'walletMgmt.superbet_web_terminal_configuration',
                        state: 'walletMgmt.superbet-web-terminal-paymentConfiguration'
                    }
                ],
                fields: [
                    {
                        label: 'general.enabled',
                        id: 'enabled',
                        type: 'checkbox',
                        model: 'enabled',
                        name: 'enabled',
                        paymentPluginConfigurationModel: 'enabled'
                    },
                    {
                        label: 'wallet.withdraw_enabled',
                        id: 'withdraw-enabled',
                        type: 'checkbox',
                        model: 'withdrawEnabled',
                        name: 'withdrawEnabled',
                        paymentPluginConfigurationModel: 'withdrawEnabled'
                    },
                    {
                        label: 'wallet.min_withdraw',
                        id: 'min-withdraw',
                        type: 'number',
                        model: 'minWithdraw',
                        name: 'minWithdraw',
                        paymentPluginConfigurationModel: 'minWithdraw',
                        validators: {
                            required: {
                                error: 'general.required_field',
                                dependencyModel: 'withdrawEnabled'
                            },
                            min: {
                                value: 1,
                                error: 'general.minimum_value_is',
                                errorInterpolationParams: {
                                    min: 1
                                }
                            },
                            pattern: {
                                value: NOT_DECIMAL_SEPARATOR_REGEX,
                                error: 'validation.decimal_numbers_not_allowed',
                            },
                            lessThan: {
                                value: 'maxWithdraw',
                                error: 'validation.messages.must_be_less_than',
                                errorInterpolationParams: {
                                    field: 'wallet.min_withdraw',
                                    dependency: 'wallet.max_withdraw'
                                }
                            }
                        }
                    },
                    {
                        label: 'wallet.max_withdraw',
                        id: 'max-withdraw',
                        type: 'number',
                        model: 'maxWithdraw',
                        name: 'maxWithdraw',
                        paymentPluginConfigurationModel: 'maxWithdraw',
                        validators: {
                            required: {
                                error: 'general.required_field',
                                dependencyModel: 'withdrawEnabled'
                            },
                            pattern: {
                                value: NOT_DECIMAL_SEPARATOR_REGEX,
                                error: 'validation.decimal_numbers_not_allowed',
                            },
                            max: {
                                value: MAX_RELIABLY_PARSABLE_NUMBER,
                                error: 'general.maximum_value_is',
                                errorInterpolationParams: {
                                    max: MAX_RELIABLY_PARSABLE_NUMBER
                                }
                            },
                            greaterThan: {
                                value: 'minWithdraw',
                                error: 'validation.messages.must_be_greater_than',
                                errorInterpolationParams: {
                                    field: 'wallet.max_withdraw',
                                    dependency: 'wallet.min_withdraw'
                                }
                            }
                        }
                    },
                    {
                        label: 'wallet.tax_rate',
                        id: 'tax-rate',
                        type: 'text',
                        model: 'taxRate',
                        name: 'taxRate',
                        paymentPluginConfigurationModel: 'details.taxRate',
                        validators: {
                            required: {
                                error: 'general.required_field'
                            }
                        }
                    },
                    {
                        label: 'wallet.api_url',
                        id: 'api_url',
                        type: 'text',
                        model: 'apiUrl',
                        name: 'apiUrl',
                        paymentPluginConfigurationModel: 'details.apiUrl',
                        validators: {
                            required: {
                                error: 'general.required_field'
                            }
                        }
                    },
                    {
                        label: 'general.uuid',
                        id: 'api-uuid',
                        type: 'text',
                        model: 'apiId',
                        name: 'apiId',
                        paymentPluginConfigurationModel: 'details.apiId',
                        validators: {
                            required: {
                                error: 'general.required_field'
                            }
                        }
                    },
                    {
                        label: 'wallet.api_secret',
                        id: 'api-secret',
                        type: 'text',
                        model: 'apiSecret',
                        name: 'apiSecret',
                        paymentPluginConfigurationModel: 'details.apiSecret',
                        validators: {
                            required: {
                                error: 'general.required_field'
                            }
                        }
                    },
                    {

                        label: 'wallet.predefined_amount',
                        labelInterpolationParams: {
                            predefinedAmountNumber : 1
                        },
                        id: 'predefined_amount-1',
                        type: 'number',
                        model: 'predefinedAmounts1',
                        name: 'predefinedAmounts1',
                        paymentPluginConfigurationModel: 'details.predefinedAmounts[0]',
                        validators: {
                            min: {
                                value: 1,
                                error: 'general.minimum_value_is',
                                errorInterpolationParams: {
                                    min: 1
                                }
                            },
                            equalOrGreaterThan: {
                                value: 'minWithdraw',
                                error: 'validation.messages.must_be_equal_or_greater_than',
                                errorInterpolationParams: {
                                    field: 'wallet.predefined_amount',
                                    dependency: 'wallet.min_withdraw'
                                }
                            },
                            equalOrLessThan: {
                                value: 'maxWithdraw',
                                error: 'validation.messages.must_be_equal_or_less_than',
                                errorInterpolationParams: {
                                    field: 'wallet.predefined_amount',
                                    dependency: 'wallet.max_withdraw'
                                }
                            },
                            distinctFrom: {
                                value: [
                                    'vm.fieldValues.predefinedAmounts2',
                                    'vm.fieldValues.predefinedAmounts3',
                                    'vm.fieldValues.predefinedAmounts4'
                                ],
                                error: 'walletMgmt.predefined_amounts_unique'
                            }
                        }
                    },
                    {

                        label: 'wallet.predefined_amount',
                        labelInterpolationParams: {
                            predefinedAmountNumber: 2
                        },
                        id: 'predefined_amount-2',
                        type: 'number',
                        model: 'predefinedAmounts2',
                        name: 'predefinedAmounts2',
                        paymentPluginConfigurationModel: 'details.predefinedAmounts[1]',
                        validators: {
                            min: {
                                value: 1,
                                error: 'general.minimum_value_is',
                                errorInterpolationParams: {
                                    min: 1
                                }
                            },
                            equalOrGreaterThan: {
                                value: 'minWithdraw',
                                error: 'validation.messages.must_be_equal_or_greater_than',
                                errorInterpolationParams: {
                                    field: 'wallet.predefined_amount',
                                    dependency: 'wallet.min_withdraw'
                                }
                            },
                            equalOrLessThan: {
                                value: 'maxWithdraw',
                                error: 'validation.messages.must_be_equal_or_less_than',
                                errorInterpolationParams: {
                                    field: 'wallet.predefined_amount',
                                    dependency: 'wallet.max_withdraw'
                                }
                            },
                            distinctFrom: {
                                value: [
                                    'vm.fieldValues.predefinedAmounts1',
                                    'vm.fieldValues.predefinedAmounts3',
                                    'vm.fieldValues.predefinedAmounts4'
                                ],
                                error: 'walletMgmt.predefined_amounts_unique'
                            }
                        }
                    },
                    {

                        label: 'wallet.predefined_amount',
                        labelInterpolationParams: {
                            predefinedAmountNumber: 3
                        },
                        id: 'predefined_amount-3',
                        type: 'number',
                        model: 'predefinedAmounts3',
                        name: 'predefinedAmounts3',
                        paymentPluginConfigurationModel: 'details.predefinedAmounts[2]',
                        validators: {
                            min: {
                                value: 1,
                                error: 'general.minimum_value_is',
                                errorInterpolationParams: {
                                    min: 1
                                }
                            },
                            equalOrGreaterThan: {
                                value: 'minWithdraw',
                                error: 'validation.messages.must_be_equal_or_greater_than',
                                errorInterpolationParams: {
                                    field: 'wallet.predefined_amount',
                                    dependency: 'wallet.min_withdraw'
                                }
                            },
                            equalOrLessThan: {
                                value: 'maxWithdraw',
                                error: 'validation.messages.must_be_equal_or_less_than',
                                errorInterpolationParams: {
                                    field: 'wallet.predefined_amount',
                                    dependency: 'wallet.max_withdraw'
                                }
                            },
                            distinctFrom: {
                                value: [
                                    'vm.fieldValues.predefinedAmounts1',
                                    'vm.fieldValues.predefinedAmounts2',
                                    'vm.fieldValues.predefinedAmounts4'
                                ],
                                error: 'walletMgmt.predefined_amounts_unique'
                            }
                        }
                    },
                    {

                        label: 'wallet.predefined_amount',
                        labelInterpolationParams: {
                            predefinedAmountNumber: 4
                        },
                        id: 'predefined_amount-4',
                        type: 'number',
                        model: 'predefinedAmounts4',
                        name: 'predefinedAmounts4',
                        paymentPluginConfigurationModel: 'details.predefinedAmounts[3]',
                        validators: {
                            min: {
                                value: 1,
                                error: 'general.minimum_value_is',
                                errorInterpolationParams: {
                                    min: 1
                                }
                            },
                            equalOrGreaterThan: {
                                value: 'minWithdraw',
                                error: 'validation.messages.must_be_equal_or_greater_than',
                                errorInterpolationParams: {
                                    field: 'wallet.predefined_amount',
                                    dependency: 'wallet.min_withdraw'
                                }
                            },
                            equalOrLessThan: {
                                value: 'maxWithdraw',
                                error: 'validation.messages.must_be_equal_or_less_than',
                                errorInterpolationParams: {
                                    field: 'wallet.predefined_amount',
                                    dependency: 'wallet.max_withdraw'
                                }
                            },
                            distinctFrom: {
                                value: [
                                    'vm.fieldValues.predefinedAmounts1',
                                    'vm.fieldValues.predefinedAmounts2',
                                    'vm.fieldValues.predefinedAmounts3'
                                ],
                                error: 'walletMgmt.predefined_amounts_unique'
                            }
                        }
                    }
                ]
            },
            resolve: lazyLoadWalletManagementBundle
        })
        .state('walletMgmt.superbet-web-terminal-paymentWithdrawals', {
            url: '/SuperbetWebTerminalPayment/withdrawals',
            parentView: 'walletMgmt.walletPlugins',
            params: {
                pluginName: 'Superbet-Web-Terminal-Payment'
            },
            views: {
                '': {
                    template:
                        '<react-grid data-view-name="{{viewName}}"></react-grid>' +
                        '<info-message></info-message>',
                    controller: 'APPHWithdrawalsController',
                }
            },
            data: {
                tabTranslationKey: 'wallet.superbet_web_terminal_withdrawals',
                viewName: 'SuperbetWebTerminalPaymentWithdrawalsGrid',
                tabs: [
                    {
                        translationKey: 'wallet.superbet_web_terminal_withdrawals',
                        state: 'walletMgmt.superbet-web-terminal-paymentWithdrawals'
                    }
                ]
            },
            resolve: lazyLoadWalletManagementBundle
        })
        .state('walletMgmt.ips-paymentTransactions', {
            url: '/IPS-payment/transactions',
            parentView: 'walletMgmt.walletPlugins',
            params: {
                pluginName: 'IPS-payment'
            },
            views: {
                '': {
                    template:
                        '<react-grid data-view-name="{{viewName}}"></react-grid>' +
                        '<info-message></info-message>',
                    controller: 'APPHDepositsController',
                }
            },
            data: {
                tabTranslationKey: 'wallet.ips_payment_transactions',
                viewName: 'IPS-paymentTransactionsGrid',
                tabs: [
                    {
                        translationKey: 'wallet.ips_payment_transactions',
                        state: 'walletMgmt.ips_paymentTransactions'
                    }
                ]
            },
            resolve: lazyLoadWalletManagementBundle
        })
        .state('walletMgmt.ips-paymentConfiguration', {
            url: '/IPS-payment/configuration/:pluginIdentifier',
            parentView: 'walletMgmt.walletPlugins',
            params: {
                pluginName: "IPS-payment"
            },
            views: {
                '': {
                    templateUrl: 'app/walletMgmt/apph/apph-plugin-configuration.template.html',
                    controller: 'APPHPluginConfigurationController',
                    controllerAs: 'vm'
                }
            },
            /** @type APPHPluginConfigurationStateData */
            data: {
                tabTranslationKey: 'walletMgmt.ips_payment_configuration',
                tabs: [
                    {
                        translationKey: 'walletMgmt.ips_payment_configuration',
                        state: 'walletMgmt.ips_paymentConfiguration'
                    }
                ],
                fields: [
                    {
                        label: 'general.enabled',
                        id: 'enabled',
                        type: 'checkbox',
                        model: 'enabled',
                        name: 'enabled',
                        paymentPluginConfigurationModel: 'enabled'
                    },
                    {
                        label: 'wallet.deposit_enabled',
                        id: 'deposit-enabled',
                        type: 'checkbox',
                        model: 'depositEnabled',
                        name: 'depositEnabled',
                        paymentPluginConfigurationModel: 'depositEnabled'
                    },
                    {
                        label: 'wallet.min_deposit',
                        id: 'min-deposit',
                        type: 'number',
                        model: 'minDeposit',
                        name: 'minDeposit',
                        paymentPluginConfigurationModel: 'minDeposit',
                        validators: {
                            required: {
                                error: 'general.required_field'
                            },
                            min: {
                                value: 1,
                                error: 'general.minimum_value_is',
                                errorInterpolationParams: {
                                    min: 1
                                }
                            },
                            pattern: {
                                value: NOT_DECIMAL_SEPARATOR_REGEX,
                                error: 'validation.decimal_numbers_not_allowed',
                            },
                            lessThan: {
                                value: 'maxDeposit',
                                error: 'validation.messages.must_be_less_than',
                                errorInterpolationParams: {
                                    field: 'wallet.min_deposit',
                                    dependency: 'wallet.max_deposit'
                                }
                            }
                        }
                    },
                    {
                        label: 'wallet.max_deposit',
                        id: 'max-deposit',
                        type: 'number',
                        model: 'maxDeposit',
                        name: 'maxDeposit',
                        paymentPluginConfigurationModel: 'maxDeposit',
                        validators: {
                            required: {
                                error: 'general.required_field'
                            },
                            pattern: {
                                value: NOT_DECIMAL_SEPARATOR_REGEX,
                                error: 'validation.decimal_numbers_not_allowed',
                            },
                            max: {
                                value: MAX_RELIABLY_PARSABLE_NUMBER,
                                error: 'general.maximum_value_is',
                                errorInterpolationParams: {
                                    max: MAX_RELIABLY_PARSABLE_NUMBER
                                }
                            },
                            greaterThan: {
                                value: 'minDeposit',
                                error: 'validation.messages.must_be_greater_than',
                                errorInterpolationParams: {
                                    field: 'wallet.max_deposit',
                                    dependency: 'wallet.min_deposit'
                                }
                            }
                        }
                    },
                    {
                        label: 'general.host',
                        id: 'host',
                        type: 'text',
                        model: 'host',
                        name: 'host',
                        paymentPluginConfigurationModel: 'details.host',
                        validators: {
                            required: {
                                error: 'general.required_field'
                            }
                        }
                    },
                    {
                        label: 'terminal.id',
                        id: 'terminalId',
                        type: 'text',
                        model: 'terminalId',
                        name: 'terminalId',
                        paymentPluginConfigurationModel: 'details.terminalId',
                        validators: {
                            required: {
                                error: 'general.required_field'
                            }
                        }
                    },
                    {
                        label: 'wallet.user_identifier',
                        id: 'userId',
                        type: 'text',
                        model: 'userId',
                        name: 'userId',
                        paymentPluginConfigurationModel: 'details.userId',
                        validators: {
                            required: {
                                error: 'general.required_field'
                            }
                        }
                    },
                    {
                        label: 'bankAccounts.bankAccount',
                        id: 'bankAccountNumber',
                        type: 'text',
                        model: 'bankAccountNumber',
                        name: 'bankAccountNumber',
                        paymentPluginConfigurationModel: 'details.bankAccountNumber',
                        validators: {
                            required: {
                                error: 'general.required_field'
                            }
                        }
                    },
                    {
                        label: 'wallet.merchant',
                        id: 'merchantName',
                        type: 'text',
                        model: 'merchantName',
                        name: 'merchantName',
                        paymentPluginConfigurationModel: 'details.merchantName',
                        validators: {
                            required: {
                                error: 'general.required_field'
                            }
                        }
                    },
                    {
                        label: 'general.payment_code',
                        id: 'sf',
                        type: 'text',
                        model: 'sf',
                        name: 'sf',
                        paymentPluginConfigurationModel: 'details.sf',
                        validators: {
                            required: {
                                error: 'general.required_field'
                            }
                        }
                    },
                    {
                        label: 'wallet.merchant_category_code',
                        id: 'm',
                        type: 'text',
                        model: 'm',
                        name: 'm',
                        paymentPluginConfigurationModel: 'details.m',
                        validators: {
                            required: {
                                error: 'general.required_field'
                            }
                        }
                    }
                ]
            },
            resolve: lazyLoadWalletManagementBundle
        })
        .state('walletMgmt.sevenIPayTransactions', {
            url: '/i-pay-transactions',
            parentView: 'walletMgmt.sevenIPayTransactions',
            views: {
                '': {
                    template:
                        '<react-grid data-view-name="{{vm.viewName}}"></react-grid>' +
                        '<info-message></info-message>',
                    controller: 'SevenIPayController',
                    controllerAs: 'vm'
                }
            },
            resolve: lazyLoadWalletManagementBundle
        })
        .state('walletMgmt.ipayMastercardTransactions', {
            url: '/iPay-Mastercard-Payment/transactions',
            parentView: 'walletMgmt.walletPlugins',
            params: {
                pluginName: 'iPay-Mastercard-Payment'
            },
            views: {
                '': {
                    template:
                        '<react-grid data-view-name="{{viewName}}"></react-grid>' +
                        '<info-message></info-message>',
                    controller: 'APPHWithdrawalsController',
                }
            },
            data: {
                tabTranslationKey: 'walletMgmt.ipay_mastercard_transactions',
                viewName: 'iPayMastercardTransactionsGrid',
                tabs: [
                    {
                        translationKey: 'walletMgmt.ipay_mastercard_transactions',
                        state: 'walletMgmt.ipayMastercardTransactions'
                    }
                ]
            },
            resolve: lazyLoadWalletManagementBundle
        })
        .state('walletMgmt.ipay-mastercard-paymentConfiguration', {
            url: '/iPay-Mastercard-Payment/configuration/:pluginIdentifier',
            parentView: 'walletMgmt.walletPlugins',
            params: {
                pluginName: 'iPay-Mastercard-Payment'
            },
            views: {
                '': {
                    templateUrl: 'app/walletMgmt/apph/apph-plugin-configuration.template.html',
                    controller: 'APPHPluginConfigurationController',
                    controllerAs: 'vm'
                }
            },
            /** @type APPHPluginConfigurationStateData */
            data: {
                tabTranslationKey: 'walletMgmt.ipay_mastercard_configuration',
                tabs: [
                    {
                        translationKey: 'walletMgmt.ipay_mastercard_configuration',
                        state: 'walletMgmt.ipay-mastercard-paymentConfiguration'
                    }
                ],
                fields: [
                    {
                        label: 'general.enabled',
                        id: 'enabled',
                        type: 'checkbox',
                        model: 'enabled',
                        name: 'enabled',
                        paymentPluginConfigurationModel: 'enabled'
                    },
                    {
                        label: 'wallet.withdrawal_enabled',
                        id: 'withdrawal-enabled',
                        type: 'checkbox',
                        model: 'withdrawEnabled',
                        name: 'withdrawEnabled',
                        paymentPluginConfigurationModel: 'withdrawEnabled'
                    },
                    {
                        label: 'wallet.min_withdrawal',
                        id: 'min-withdrawal',
                        type: 'number',
                        model: 'minWithdraw',
                        name: 'minWithdraw',
                        paymentPluginConfigurationModel: 'minWithdraw',
                        validators: {
                            required: {
                                error: 'general.required_field'
                            },
                            min: {
                                value: 1,
                                error: 'general.minimum_value_is',
                                errorInterpolationParams: {
                                    min: 1
                                }
                            },
                            pattern: {
                                value: NOT_DECIMAL_SEPARATOR_REGEX,
                                error: 'validation.decimal_numbers_not_allowed',
                            },
                            lessThan: {
                                value: 'maxWithdraw',
                                error: 'validation.messages.must_be_less_than',
                                errorInterpolationParams: {
                                    field: 'wallet.min_withdrawal',
                                    dependency: 'wallet.max_withdrawal'
                                }
                            }
                        }
                    },
                    {
                        label: 'wallet.max_withdrawal',
                        id: 'max-withdrawal',
                        type: 'number',
                        model: 'maxWithdraw',
                        name: 'maxWithdraw',
                        paymentPluginConfigurationModel: 'maxWithdraw',
                        validators: {
                            required: {
                                error: 'general.required_field'
                            },
                            pattern: {
                                value: NOT_DECIMAL_SEPARATOR_REGEX,
                                error: 'validation.decimal_numbers_not_allowed',
                            },
                            max: {
                                value: MAX_RELIABLY_PARSABLE_NUMBER,
                                error: 'general.maximum_value_is',
                                errorInterpolationParams: {
                                    max: MAX_RELIABLY_PARSABLE_NUMBER
                                }
                            },
                            greaterThan: {
                                value: 'minWithdraw',
                                error: 'validation.messages.must_be_greater_than',
                                errorInterpolationParams: {
                                    field: 'wallet.max_withdrawal',
                                    dependency: 'wallet.min_withdrawal'
                                }
                            }
                        }
                    },
                    {
                        label: 'wallet.withdrawal_approve_limit',
                        id: 'withdrawal-approve-limit',
                        type: 'number',
                        model: 'withdrawApproveLimit',
                        name: 'withdrawApproveLimit',
                        paymentPluginConfigurationModel: 'withdrawApproveLimit',
                        validators: {
                            required: {
                                error: 'general.required_field'
                            },
                            lessThan: {
                                value: 'maxWithdraw',
                                error: 'validation.messages.must_be_less_than',
                                errorInterpolationParams: {
                                    field: 'wallet.min_withdrawal',
                                    dependency: 'wallet.max_withdrawal'
                                }
                            },
                            greaterThan: {
                                value: 'minWithdraw',
                                error: 'validation.messages.must_be_greater_than',
                                errorInterpolationParams: {
                                    field: 'wallet.max_withdrawal',
                                    dependency: 'wallet.min_withdrawal'
                                }
                            }
                        }
                    },
                    {
                        label: 'wallet.api_url',
                        id: 'api-url',
                        type: 'text',
                        model: 'apiUrl',
                        name: 'apiUrl',
                        paymentPluginConfigurationModel: 'details.apiUrl',
                        validators: {
                            required: {
                                error: 'general.required_field'
                            }
                        }
                    },
                    {
                        label: 'wallet.api_secret',
                        id: 'api-secret',
                        type: 'text',
                        model: 'apiSecret',
                        name: 'apiSecret',
                        paymentPluginConfigurationModel: 'details.apiSecret',
                        validators: {
                            required: {
                                error: 'general.required_field'
                            }
                        }
                    }
                ]
            },
            resolve: lazyLoadWalletManagementBundle
        })
        .state('walletMgmt.orange-money-webpayConfiguration', {
            url: '/orange-money-webpay/configuration/:pluginIdentifier',
            parentView: 'walletMgmt.walletPlugins',
            params: {
                pluginName: 'Orange-Money-Webpay'
            },
            views: {
                '': {
                    templateUrl: 'app/walletMgmt/apph/apph-plugin-configuration.template.html',
                    controller: 'APPHPluginConfigurationController',
                    controllerAs: 'vm'
                }
            },
            /** @type APPHPluginConfigurationStateData */
            data: {
                tabTranslationKey: 'wallet.orange_money_webpay_configuration',
                tabs: [
                    {
                        translationKey: 'wallet.orange_money_webpay_configuration',
                        state: 'walletMgmt.orange-money-webpayConfiguration'
                    }
                ],
                fields: [
                    {
                        label: 'general.enabled',
                        id: 'enabled',
                        type: 'checkbox',
                        model: 'enabled',
                        name: 'enabled',
                        paymentPluginConfigurationModel: 'enabled'
                    },
                    {
                        label: 'wallet.deposit_enabled',
                        id: 'deposit-enabled',
                        type: 'checkbox',
                        model: 'depositEnabled',
                        name: 'depositEnabled',
                        paymentPluginConfigurationModel: 'depositEnabled'
                    },
                    {
                        label: 'wallet.min_deposit',
                        id: 'min-deposit',
                        type: 'number',
                        model: 'minDeposit',
                        name: 'minDeposit',
                        paymentPluginConfigurationModel: 'minDeposit',
                        validators: {
                            required: {
                                error: 'general.required_field'
                            },
                            min: {
                                value: 1,
                                error: 'general.minimum_value_is',
                                errorInterpolationParams: {
                                    min: 1
                                }
                            },
                            pattern: {
                                value: NOT_DECIMAL_SEPARATOR_REGEX,
                                error: 'validation.decimal_numbers_not_allowed',
                            },
                            max: {
                                value: MAX_RELIABLY_PARSABLE_NUMBER,
                                error: 'general.maximum_value_is',
                                errorInterpolationParams: {
                                    max: MAX_RELIABLY_PARSABLE_NUMBER
                                }
                            },
                            lessThan: {
                                value: 'maxDeposit',
                                error: 'validation.messages.must_be_less_than',
                                errorInterpolationParams: {
                                    field: 'wallet.min_deposit',
                                    dependency: 'wallet.max_deposit'
                                }
                            }
                        }
                    },
                    {
                        label: 'wallet.max_deposit',
                        id: 'max-deposit',
                        type: 'number',
                        model: 'maxDeposit',
                        name: 'maxDeposit',
                        paymentPluginConfigurationModel: 'maxDeposit',
                        validators: {
                            required: {
                                error: 'general.required_field'
                            },
                            pattern: {
                                value: NOT_DECIMAL_SEPARATOR_REGEX,
                                error: 'validation.decimal_numbers_not_allowed',
                            },
                            greaterThan: {
                                value: 'minDeposit',
                                error: 'validation.messages.must_be_greater_than',
                                errorInterpolationParams: {
                                    field: 'wallet.max_deposit',
                                    dependency: 'wallet.min_deposit'
                                }
                            }
                        }
                    },
                    {
                        label: 'wallet.merchant_key',
                        id: 'metchant-key',
                        type: 'text',
                        model: 'merchantKey',
                        name: 'merchantKey',
                        paymentPluginConfigurationModel: 'details.merchantKey',
                        validators: {
                            required: {
                                error: 'general.required_field'
                            }
                        }
                    },
                    {
                        label: 'wallet.merchant',
                        id: 'metchant-name',
                        type: 'text',
                        model: 'merchantName',
                        name: 'merchantName',
                        paymentPluginConfigurationModel: 'details.merchantName',
                        validators: {
                            required: {
                                error: 'general.required_field'
                            }
                        }
                    },
                    {
                        label: 'general.authorization_header',
                        id: 'authorization-header',
                        type: 'text',
                        model: 'authorizationHeader',
                        name: 'authorizationHeader',
                        paymentPluginConfigurationModel: 'details.authorizationHeader',
                        validators: {
                            required: {
                                error: 'general.required_field'
                            }
                        }
                    }
                ]
            },
            resolve: lazyLoadWalletManagementBundle
        })
        .state('walletMgmt.orangeMoneyWebpayTransactions', {
            url: '/Orange-Money-Webpay/transactions',
            parentView: 'walletMgmt.walletPlugins',
            params: {
                pluginName: 'Orange-Money-Webpay'
            },
            views: {
                '': {
                    template:
                        '<react-grid data-view-name="{{viewName}}"></react-grid>' +
                        '<info-message></info-message>',
                    controller: 'APPHDepositsController',
                }
            },
            data: {
                tabTranslationKey: 'wallet.orange_money_webpay_transactions',
                viewName: 'orangeMoneyWebpayTransactionsGrid',
                tabs: [
                    {
                        translationKey: 'wallet.orange_money_webpay_transactions',
                        state: 'walletMgmt.orangeMoneyWebpayTransactions'
                    }
                ]
            },
            resolve: lazyLoadWalletManagementBundle
        })
        .state('walletMgmt.adumo-paymentConfiguration', {
            url: '/adumo/configuration/:pluginIdentifier',
            parentView: 'walletMgmt.walletPlugins',
            params: {
                pluginName: 'Adumo-Payment'
            },
            views: {
                '': {
                    templateUrl: 'app/walletMgmt/apph/apph-plugin-configuration.template.html',
                    controller: 'APPHPluginConfigurationController',
                    controllerAs: 'vm'
                }
            },
            /** @type APPHPluginConfigurationStateData */
            data: {
                tabTranslationKey: 'wallet.adumo_configuration',
                tabs: [
                    {
                        translationKey: 'wallet.adumo_configuration',
                        state: 'walletMgmt.adumo-paymentConfiguration'
                    }
                ],
                fields: [
                    {
                        label: 'general.enabled',
                        id: 'enabled',
                        type: 'checkbox',
                        model: 'enabled',
                        name: 'enabled',
                        paymentPluginConfigurationModel: 'enabled'
                    },
                    {
                        label: 'wallet.deposit_enabled',
                        id: 'deposit-enabled',
                        type: 'checkbox',
                        model: 'depositEnabled',
                        name: 'depositEnabled',
                        paymentPluginConfigurationModel: 'depositEnabled'
                    },
                    {
                        label: 'wallet.min_deposit',
                        id: 'min-deposit',
                        type: 'number',
                        model: 'minDeposit',
                        name: 'minDeposit',
                        paymentPluginConfigurationModel: 'minDeposit',
                        validators: {
                            required: {
                                error: 'general.required_field'
                            },
                            min: {
                                value: 1,
                                error: 'general.minimum_value_is',
                                errorInterpolationParams: {
                                    min: 1
                                }
                            },
                            pattern: {
                                value: NOT_DECIMAL_SEPARATOR_REGEX,
                                error: 'validation.decimal_numbers_not_allowed',
                            },
                            max: {
                                value: MAX_RELIABLY_PARSABLE_NUMBER,
                                error: 'general.maximum_value_is',
                                errorInterpolationParams: {
                                    max: MAX_RELIABLY_PARSABLE_NUMBER
                                }
                            },
                            lessThan: {
                                value: 'maxDeposit',
                                error: 'validation.messages.must_be_less_than',
                                errorInterpolationParams: {
                                    field: 'wallet.min_deposit',
                                    dependency: 'wallet.max_deposit'
                                }
                            }
                        }
                    },
                    {
                        label: 'wallet.max_deposit',
                        id: 'max-deposit',
                        type: 'number',
                        model: 'maxDeposit',
                        name: 'maxDeposit',
                        paymentPluginConfigurationModel: 'maxDeposit',
                        validators: {
                            required: {
                                error: 'general.required_field'
                            },
                            pattern: {
                                value: NOT_DECIMAL_SEPARATOR_REGEX,
                                error: 'validation.decimal_numbers_not_allowed',
                            },
                            greaterThan: {
                                value: 'minDeposit',
                                error: 'validation.messages.must_be_greater_than',
                                errorInterpolationParams: {
                                    field: 'wallet.max_deposit',
                                    dependency: 'wallet.min_deposit'
                                }
                            }
                        }
                    },
                    {
                        label: 'wallet.merchant_id',
                        id: 'merchant-id',
                        type: 'text',
                        model: 'merchantId',
                        name: 'merchantId',
                        paymentPluginConfigurationModel: 'details.merchantId',
                        validators: {
                            required: {
                                error: 'general.required_field'
                            }
                        }
                    },
                    {
                        label: 'general.application_id',
                        id: 'application-id',
                        type: 'text',
                        model: 'applicationId',
                        name: 'applicationId',
                        paymentPluginConfigurationModel: 'details.applicationId',
                        validators: {
                            required: {
                                error: 'general.required_field'
                            }
                        }
                    },
                    {
                        label: 'general.jwt_secret',
                        id: 'jwt-secret',
                        type: 'text',
                        model: 'jwtSecret',
                        name: 'jwtSecret',
                        paymentPluginConfigurationModel: 'details.jwtSecret',
                        validators: {
                            required: {
                                error: 'general.required_field'
                            }
                        }
                    },
                    {
                        label: 'wallet.quickteller_redirect_url',
                        id: 'redirect-url',
                        type: 'text',
                        model: 'redirectUrl',
                        name: 'redirectUrl',
                        paymentPluginConfigurationModel: 'details.redirectUrl',
                        validators: {
                            required: {
                                error: 'general.required_field'
                            }
                        }
                    }
                ]
            },
            resolve: lazyLoadWalletManagementBundle
        })
        .state('walletMgmt.adumoTransactions', {
            url: '/Adumo/transactions',
            parentView: 'walletMgmt.walletPlugins',
            params: {
                pluginName: 'Adumo-Payment'
            },
            views: {
                '': {
                    template:
                        '<react-grid data-view-name="{{viewName}}"></react-grid>' +
                        '<info-message></info-message>',
                    controller: 'APPHDepositsController',
                }
            },
            data: {
                tabTranslationKey: 'wallet.adumo_transactions',
                viewName: 'adumoTransactionsGrid',
                tabs: [
                    {
                        translationKey: 'wallet.adumo_transactions',
                        state: 'walletMgmt.adumoTransactions'
                    }
                ]
            },
            resolve: lazyLoadWalletManagementBundle
        })
        .state('walletMgmt.payten cseConfiguration', {
            url: '/payten-cse/configuration/:pluginIdentifier',
            parentView: 'walletMgmt.walletPlugins',
            params: {
                pluginName: 'Payten CSE'
            },
            views: {
                '': {
                    templateUrl: 'app/walletMgmt/apph/apph-plugin-configuration.template.html',
                    controller: 'APPHPluginConfigurationController',
                    controllerAs: 'vm'
                }
            },
            /** @type APPHPluginConfigurationStateData */
            data: {
                tabTranslationKey: 'wallet.payten_cse_configuration',
                tabs: [
                    {
                        translationKey: 'wallet.payten_cse_configuration',
                        state: 'walletMgmt.payten cseConfiguration'
                    }
                ],
                fields: [
                    {
                        label: 'general.enabled',
                        id: 'enabled',
                        type: 'checkbox',
                        model: 'enabled',
                        name: 'enabled',
                        paymentPluginConfigurationModel: 'enabled'
                    },
                    {
                        label: 'wallet.deposit_enabled',
                        id: 'deposit-enabled',
                        type: 'checkbox',
                        model: 'depositEnabled',
                        name: 'depositEnabled',
                        paymentPluginConfigurationModel: 'depositEnabled'
                    },
                    {
                        label: 'wallet.min_deposit',
                        id: 'min-deposit',
                        type: 'number',
                        model: 'minDeposit',
                        name: 'minDeposit',
                        paymentPluginConfigurationModel: 'minDeposit',
                        validators: {
                            required: {
                                error: 'general.required_field'
                            },
                            min: {
                                value: 1,
                                error: 'general.minimum_value_is',
                                errorInterpolationParams: {
                                    min: 1
                                }
                            },
                            pattern: {
                                value: NOT_DECIMAL_SEPARATOR_REGEX,
                                error: 'validation.decimal_numbers_not_allowed',
                            },
                            max: {
                                value: MAX_RELIABLY_PARSABLE_NUMBER,
                                error: 'general.maximum_value_is',
                                errorInterpolationParams: {
                                    max: MAX_RELIABLY_PARSABLE_NUMBER
                                }
                            },
                            lessThan: {
                                value: 'maxDeposit',
                                error: 'validation.messages.must_be_less_than',
                                errorInterpolationParams: {
                                    field: 'wallet.min_deposit',
                                    dependency: 'wallet.max_deposit'
                                }
                            }
                        }
                    },
                    {
                        label: 'wallet.max_deposit',
                        id: 'max-deposit',
                        type: 'number',
                        model: 'maxDeposit',
                        name: 'maxDeposit',
                        paymentPluginConfigurationModel: 'maxDeposit',
                        validators: {
                            required: {
                                error: 'general.required_field'
                            },
                            pattern: {
                                value: NOT_DECIMAL_SEPARATOR_REGEX,
                                error: 'validation.decimal_numbers_not_allowed',
                            },
                            greaterThan: {
                                value: 'minDeposit',
                                error: 'validation.messages.must_be_greater_than',
                                errorInterpolationParams: {
                                    field: 'wallet.max_deposit',
                                    dependency: 'wallet.min_deposit'
                                }
                            }
                        }
                    },
                    {
                        label: 'wallet.api_url',
                        id: 'api-url',
                        type: 'text',
                        model: 'apiUrl',
                        name: 'apiUrl',
                        paymentPluginConfigurationModel: 'details.apiUrl',
                        validators: {
                            required: {
                                error: 'general.required_field'
                            }
                        }
                    },
                    {
                        label: 'wallet.merchant',
                        id: 'merchant',
                        type: 'text',
                        model: 'merchant',
                        name: 'merchant',
                        paymentPluginConfigurationModel: 'details.merchant',
                        validators: {
                            required: {
                                error: 'general.required_field'
                            }
                        }
                    },
                    {
                        label: 'wallet.merchantUser',
                        id: 'merchant-user',
                        type: 'text',
                        model: 'merchantUser',
                        name: 'merchantUser',
                        paymentPluginConfigurationModel: 'details.merchantUser',
                        validators: {
                            required: {
                                error: 'general.required_field'
                            }
                        }
                    },
                    {
                        label: 'wallet.merchantPassword',
                        id: 'merchant-password',
                        type: 'text',
                        model: 'merchantPassword',
                        name: 'merchantPassword',
                        paymentPluginConfigurationModel: 'details.merchantPassword',
                        validators: {
                            required: {
                                error: 'general.required_field'
                            }
                        }
                    },
                    {
                        label: 'wallet.payten_3d_dealer_payment_name',
                        id: '3d-dealer-payment-name',
                        type: 'text',
                        model: '3dDealerPaymentName',
                        name: '3dDealerPaymentName',
                        paymentPluginConfigurationModel: 'details.3dDealerPaymentName',
                        validators: {
                            required: {
                                error: 'general.required_field'
                            }
                        }
                    },
                    {
                        label: 'wallet.payten_3d_payment_system',
                        id: '3d-payment-system',
                        type: 'text',
                        model: '3dPaymentSystem',
                        name: '3dPaymentSystem',
                        paymentPluginConfigurationModel: 'details.3dPaymentSystem',
                        validators: {
                            required: {
                                error: 'general.required_field'
                            }
                        }
                    },
                    {
                        label: 'wallet.payten_moto_dealer_payment_name',
                        id: 'moto-dealer-payment-name',
                        type: 'text',
                        model: 'motoDealerPaymentName',
                        name: 'motoDealerPaymentName',
                        paymentPluginConfigurationModel: 'details.motoDealerPaymentName',
                        validators: {
                            required: {
                                error: 'general.required_field'
                            }
                        }
                    },
                    {
                        label: 'wallet.payten_moto_payment_system',
                        id: 'moto-payment-system',
                        type: 'text',
                        model: 'motoPaymentSystem',
                        name: 'motoPaymentSystem',
                        paymentPluginConfigurationModel: 'details.motoPaymentSystem',
                        validators: {
                            required: {
                                error: 'general.required_field'
                            }
                        }
                    },
                    {
                        label: 'wallet.returnUrl',
                        id: 'return-url',
                        type: 'text',
                        model: 'returnUrl',
                        name: 'returnUrl',
                        paymentPluginConfigurationModel: 'details.returnUrl',
                        validators: {
                            required: {
                                error: 'general.required_field'
                            }
                        }
                    },
                    {
                        label: 'wallet.payten_merchant_name',
                        id: 'merchant-name',
                        type: 'text',
                        model: 'merchantName',
                        name: 'merchantName',
                        paymentPluginConfigurationModel: 'details.merchantName',
                        validators: {
                            required: {
                                error: 'general.required_field'
                            }
                        }
                    },
                    {
                        label: 'wallet.payten_merchant_pib',
                        id: 'merchant-pib',
                        type: 'text',
                        model: 'merchantPib',
                        name: 'merchantPib',
                        paymentPluginConfigurationModel: 'details.merchantPib',
                        validators: {
                            required: {
                                error: 'general.required_field'
                            }
                        }
                    },
                    {
                        label: 'wallet.payten_merchant_address',
                        id: 'merchant-address',
                        type: 'text',
                        model: 'merchantAddress',
                        name: 'merchantAddress',
                        paymentPluginConfigurationModel: 'details.merchantAddress',
                        validators: {
                            required: {
                                error: 'general.required_field'
                            }
                        }
                    },
                    {
                        label: 'wallet.predefined_amount',
                        labelInterpolationParams: {
                            predefinedAmountNumber : 1
                        },
                        id: 'predefined-amount-1',
                        type: 'number',
                        model: 'predefinedAmount1',
                        name: 'predefinedAmount1',
                        paymentPluginConfigurationModel: 'details.fastDepositAmount[0]',
                        validators: {
                            required: {
                                error: 'general.required_field'
                            }
                        }
                    },
                    {
                        label: 'wallet.predefined_amount',
                        labelInterpolationParams: {
                            predefinedAmountNumber : 2
                        },
                        id: 'predefined-amount-2',
                        type: 'number',
                        model: 'predefinedAmount2',
                        name: 'predefinedAmount2',
                        paymentPluginConfigurationModel: 'details.fastDepositAmount[1]',
                        validators: {
                            required: {
                                error: 'general.required_field'
                            }
                        }
                    },
                    {
                        label: 'wallet.predefined_amount',
                        labelInterpolationParams: {
                            predefinedAmountNumber : 3
                        },
                        id: 'predefined-amount-3',
                        type: 'number',
                        model: 'predefinedAmount3',
                        name: 'predefinedAmount3',
                        paymentPluginConfigurationModel: 'details.fastDepositAmount[2]',
                        validators: {
                            required: {
                                error: 'general.required_field'
                            }
                        }
                    }
                ]
            },
            resolve: lazyLoadWalletManagementBundle
        })
        .state('walletMgmt.payten cseTransactions', {
            url: '/payten-cse/transactions',
            parentView: 'walletMgmt.walletPlugins',
            params: {
                pluginName: 'Payten CSE'
            },
            views: {
                '': {
                    template:
                        '<react-grid data-view-name="{{viewName}}"></react-grid>' +
                        '<info-message></info-message>',
                    controller: 'APPHDepositsController',
                }
            },
            data: {
                tabTranslationKey: 'wallet.payten_transactions',
                viewName: 'paytenCseTransactionsGrid',
                tabs: [
                    {
                        translationKey: 'wallet.payten_transactions',
                        state: 'walletMgmt.payten cseTransactions'
                    }
                ]
            },
            resolve: lazyLoadWalletManagementBundle
        })
        .state('walletMgmt.monriConfiguration', {
            url: '/monri/configuration/:pluginIdentifier',
            parentView: 'walletMgmt.walletPlugins',
            params: {
                pluginName: 'Monri'
            },
            views: {
                '': {
                    templateUrl: 'app/walletMgmt/apph/apph-plugin-configuration.template.html',
                    controller: 'APPHPluginConfigurationController',
                    controllerAs: 'vm'
                }
            },
            /** @type APPHPluginConfigurationStateData */
            data: {
                tabTranslationKey: 'wallet.monri_configuration',
                tabs: [
                    {
                        translationKey: 'wallet.monri_configuration',
                        state: 'walletMgmt.adumo-paymentConfiguration'
                    }
                ],
                fields: [
                    {
                        label: 'general.enabled',
                        id: 'enabled',
                        type: 'checkbox',
                        model: 'enabled',
                        name: 'enabled',
                        paymentPluginConfigurationModel: 'enabled'
                    },
                    {
                        label: 'wallet.deposit_enabled',
                        id: 'deposit-enabled',
                        type: 'checkbox',
                        model: 'depositEnabled',
                        name: 'depositEnabled',
                        paymentPluginConfigurationModel: 'depositEnabled'
                    },
                    {
                        label: 'wallet.min_deposit',
                        id: 'min-deposit',
                        type: 'number',
                        model: 'minDeposit',
                        name: 'minDeposit',
                        paymentPluginConfigurationModel: 'minDeposit',
                        validators: {
                            required: {
                                error: 'general.required_field'
                            },
                            min: {
                                value: 1,
                                error: 'general.minimum_value_is',
                                errorInterpolationParams: {
                                    min: 1
                                }
                            },
                            max: {
                                value: MAX_RELIABLY_PARSABLE_NUMBER,
                                error: 'general.maximum_value_is',
                                errorInterpolationParams: {
                                    max: MAX_RELIABLY_PARSABLE_NUMBER
                                }
                            },
                            lessThan: {
                                value: 'maxDeposit',
                                error: 'validation.messages.must_be_less_than',
                                errorInterpolationParams: {
                                    field: 'wallet.min_deposit',
                                    dependency: 'wallet.max_deposit'
                                }
                            }
                        }
                    },
                    {
                        label: 'wallet.max_deposit',
                        id: 'max-deposit',
                        type: 'number',
                        model: 'maxDeposit',
                        name: 'maxDeposit',
                        paymentPluginConfigurationModel: 'maxDeposit',
                        validators: {
                            required: {
                                error: 'general.required_field'
                            },
                            max: {
                                value: MAX_RELIABLY_PARSABLE_NUMBER,
                                error: 'general.maximum_value_is',
                                errorInterpolationParams: {
                                    max: MAX_RELIABLY_PARSABLE_NUMBER
                                }
                            },
                            greaterThan: {
                                value: 'minDeposit',
                                error: 'validation.messages.must_be_greater_than',
                                errorInterpolationParams: {
                                    field: 'wallet.max_deposit',
                                    dependency: 'wallet.min_deposit'
                                }
                            }
                        }
                    },
                    {
                        label: 'wallet.secret_key',
                        id: 'secret-key',
                        type: 'text',
                        model: 'secretKey',
                        name: 'secretKey',
                        paymentPluginConfigurationModel: 'details.secretKey',
                        validators: {
                            required: {
                                error: 'general.required_field'
                            }
                        }
                    },
                    {
                        label: 'wallet.auth_token',
                        id: 'auth-token',
                        type: 'text',
                        model: 'authToken',
                        name: 'authToken',
                        paymentPluginConfigurationModel: 'details.authToken',
                        validators: {
                            required: {
                                error: 'general.required_field'
                            }
                        }
                    }
                ]
            },
            resolve: lazyLoadWalletManagementBundle
        })
        .state('walletMgmt.monriTransactions', {
            url: '/monri/transactions',
            parentView: 'walletMgmt.walletPlugins',
            params: {
                pluginName: 'Monri'
            },
            views: {
                '': {
                    template:
                        '<react-grid data-view-name="{{viewName}}"></react-grid>' +
                        '<info-message></info-message>',
                    controller: 'APPHDepositsController',
                }
            },
            data: {
                tabTranslationKey: 'wallet.monri_transactions',
                viewName: 'monriTransactionsGrid',
                tabs: [
                    {
                        translationKey: 'wallet.monri_transactions',
                        state: 'walletMgmt.monriTransactions'
                    }
                ]
            },
            resolve: lazyLoadWalletManagementBundle
        })
	    .state('walletMgmt.xbonTransactions', {
		    url: '/xBon-payment/transactions',
		    parentView: 'walletMgmt.walletPlugins',
		    params: {
			    pluginName: 'xBon'
		    },
		    views: {
			    '': {
				    template:
					    '<react-grid data-view-name="{{viewName}}"></react-grid>' +
					    '<info-message></info-message>',
				    controller: 'APPHDepositsController',
			    }
		    },
		    data: {
			    tabTranslationKey: 'wallet.xbon_transactions',
			    viewName: 'xBon-paymentTransactionsGrid',
			    tabs: [
				    {
					    translationKey: 'wallet.xbon_transactions',
					    state: 'walletMgmt.xbonTransactions'
				    }
			    ]
		    },
		    resolve: lazyLoadWalletManagementBundle
	    })
	    .state('walletMgmt.xbonConfiguration', {
		    url: '/xBon/configuration/:pluginIdentifier',
		    parentView: 'walletMgmt.walletPlugins',
		    params: {
			    pluginName: "xBon"
		    },
		    views: {
			    '': {
				    templateUrl: 'app/walletMgmt/apph/apph-plugin-configuration.template.html',
				    controller: 'APPHPluginConfigurationController',
				    controllerAs: 'vm'
			    }
		    },
		    /** @type APPHPluginConfigurationStateData */
		    data: {
			    tabTranslationKey: 'wallet.xbon_configuration',
			    tabs: [
				    {
					    translationKey: 'wallet.xbon_configuration',
					    state: 'walletMgmt.xbonConfiguration'
				    }
			    ],
			    fields: [
				    {
					    label: 'general.enabled',
					    id: 'enabled',
					    type: 'checkbox',
					    model: 'enabled',
					    name: 'enabled',
					    paymentPluginConfigurationModel: 'enabled'
				    },
				    {
					    label: 'wallet.deposit_enabled',
					    id: 'deposit-enabled',
					    type: 'checkbox',
					    model: 'depositEnabled',
					    name: 'depositEnabled',
					    paymentPluginConfigurationModel: 'depositEnabled'
				    },
				    {
					    label: 'wallet.min_deposit',
					    id: 'min-deposit',
					    type: 'number',
					    model: 'minDeposit',
					    name: 'minDeposit',
					    paymentPluginConfigurationModel: 'minDeposit',
					    validators: {
						    required: {
							    error: 'general.required_field'
						    },
						    min: {
							    value: 1,
							    error: 'general.minimum_value_is',
							    errorInterpolationParams: {
								    min: 1
							    }
						    },
						    pattern: {
							    value: NOT_DECIMAL_SEPARATOR_REGEX,
							    error: 'validation.decimal_numbers_not_allowed',
						    },
						    lessThan: {
							    value: 'maxDeposit',
							    error: 'validation.messages.must_be_less_than',
							    errorInterpolationParams: {
								    field: 'wallet.min_deposit',
								    dependency: 'wallet.max_deposit'
							    }
						    }
					    }
				    },
				    {
					    label: 'wallet.max_deposit',
					    id: 'max-deposit',
					    type: 'number',
					    model: 'maxDeposit',
					    name: 'maxDeposit',
					    paymentPluginConfigurationModel: 'maxDeposit',
					    validators: {
						    required: {
							    error: 'general.required_field'
						    },
						    pattern: {
							    value: NOT_DECIMAL_SEPARATOR_REGEX,
							    error: 'validation.decimal_numbers_not_allowed',
						    },
						    max: {
							    value: MAX_RELIABLY_PARSABLE_NUMBER,
							    error: 'general.maximum_value_is',
							    errorInterpolationParams: {
								    max: MAX_RELIABLY_PARSABLE_NUMBER
							    }
						    },
						    greaterThan: {
							    value: 'minDeposit',
							    error: 'validation.messages.must_be_greater_than',
							    errorInterpolationParams: {
								    field: 'wallet.max_deposit',
								    dependency: 'wallet.min_deposit'
							    }
						    }
					    }
				    },
				    {
					    label: 'general_host',
					    id: 'host',
					    type: 'text',
					    model: 'host',
					    name: 'host',
					    paymentPluginConfigurationModel: 'details.host',
					    validators: {
						    required: {
							    error: 'general.required_field'
						    }
					    }
				    },
				    {
					    label: 'general.port',
					    id: 'port',
					    type: 'text',
					    model: 'port',
					    name: 'port',
					    paymentPluginConfigurationModel: 'details.port',
					    validators: {
						    required: {
							    error: 'general.required_field'
						    }
					    }
				    },
				    {
					    label: 'wallet.user_identifier',
					    id: 'userId',
					    type: 'text',
					    model: 'userId',
					    name: 'userId',
					    paymentPluginConfigurationModel: 'details.userId',
					    validators: {
						    required: {
							    error: 'general.required_field'
						    }
					    }
				    },
				    {
					    label: 'general.token',
					    id: 'token',
					    type: 'text',
					    model: 'token',
					    name: 'token',
					    paymentPluginConfigurationModel: 'details.token',
					    validators: {
						    required: {
							    error: 'general.required_field'
						    }
					    }
                    },
                    {
					    label: 'wallet.commission',
					    id: 'commission',
					    type: 'number',
					    model: 'commission',
					    name: 'commission',
					    paymentPluginConfigurationModel: 'details.commission',
					    validators: {
                            pattern: {
							    value: TWO_DECIMAL_PLACES_REGEX,
							    error: 'validation.two_decimal_limit',    
						    },
					    }
				    }
			    ]
		    },
		    resolve: lazyLoadWalletManagementBundle
	    })
	    .state('walletMgmt.klikerTransactions', {
		    url: '/kliker-payment/transactions',
		    parentView: 'walletMgmt.walletPlugins',
		    params: {
			    pluginName: 'Kliker'
		    },
		    views: {
			    '': {
				    template:
					    '<react-grid data-view-name="{{viewName}}"></react-grid>' +
					    '<info-message></info-message>',
				    controller: 'APPHDepositsController',
			    }
		    },
		    data: {
			    tabTranslationKey: 'wallet.kliker_transactions',
			    viewName: 'kliker-paymentTransactionsGrid',
			    tabs: [
				    {
					    translationKey: 'wallet.kliker_transactions',
					    state: 'walletMgmt.klikerTransactions'
				    }
			    ]
		    },
		    resolve: lazyLoadWalletManagementBundle
	    })
	    .state('walletMgmt.klikerConfiguration', {
		    url: '/kliker/configuration/:pluginIdentifier',
		    parentView: 'walletMgmt.walletPlugins',
		    params: {
			    pluginName: "Kliker"
		    },
		    views: {
			    '': {
				    templateUrl: 'app/walletMgmt/apph/apph-plugin-configuration.template.html',
				    controller: 'APPHPluginConfigurationController',
				    controllerAs: 'vm'
			    }
		    },
		    /** @type APPHPluginConfigurationStateData */
		    data: {
			    tabTranslationKey: 'wallet.kliker_configuration',
			    tabs: [
				    {
					    translationKey: 'wallet.kliker_configuration',
					    state: 'walletMgmt.klikerConfiguration'
				    }
			    ],
			    fields: [
				    {
					    label: 'general.enabled',
					    id: 'enabled',
					    type: 'checkbox',
					    model: 'enabled',
					    name: 'enabled',
					    paymentPluginConfigurationModel: 'enabled'
				    },
				    {
					    label: 'wallet.deposit_enabled',
					    id: 'deposit-enabled',
					    type: 'checkbox',
					    model: 'depositEnabled',
					    name: 'depositEnabled',
					    paymentPluginConfigurationModel: 'depositEnabled'
				    },
				    {
					    label: 'wallet.min_deposit',
					    id: 'min-deposit',
					    type: 'number',
					    model: 'minDeposit',
					    name: 'minDeposit',
					    paymentPluginConfigurationModel: 'minDeposit',
					    validators: {
						    required: {
							    error: 'general.required_field'
						    },
						    min: {
							    value: 1,
							    error: 'general.minimum_value_is',
							    errorInterpolationParams: {
								    min: 1
							    }
						    },
						    pattern: {
							    value: NOT_DECIMAL_SEPARATOR_REGEX,
							    error: 'validation.decimal_numbers_not_allowed',
						    },
						    lessThan: {
							    value: 'maxDeposit',
							    error: 'validation.messages.must_be_less_than',
							    errorInterpolationParams: {
								    field: 'wallet.min_deposit',
								    dependency: 'wallet.max_deposit'
							    }
						    }
					    }
				    },
				    {
					    label: 'wallet.max_deposit',
					    id: 'max-deposit',
					    type: 'number',
					    model: 'maxDeposit',
					    name: 'maxDeposit',
					    paymentPluginConfigurationModel: 'maxDeposit',
					    validators: {
						    required: {
							    error: 'general.required_field'
						    },
						    pattern: {
							    value: NOT_DECIMAL_SEPARATOR_REGEX,
							    error: 'validation.decimal_numbers_not_allowed',
						    },
						    max: {
							    value: MAX_RELIABLY_PARSABLE_NUMBER,
							    error: 'general.maximum_value_is',
							    errorInterpolationParams: {
								    max: MAX_RELIABLY_PARSABLE_NUMBER
							    }
						    },
						    greaterThan: {
							    value: 'minDeposit',
							    error: 'validation.messages.must_be_greater_than',
							    errorInterpolationParams: {
								    field: 'wallet.max_deposit',
								    dependency: 'wallet.min_deposit'
							    }
						    }
					    }
				    },
				    {
					    label: 'general_host',
					    id: 'host',
					    type: 'text',
					    model: 'host',
					    name: 'host',
					    paymentPluginConfigurationModel: 'details.host',
					    validators: {
						    required: {
							    error: 'general.required_field'
						    }
					    }
				    },
				    {
					    label: 'general.port',
					    id: 'port',
					    type: 'text',
					    model: 'port',
					    name: 'port',
					    paymentPluginConfigurationModel: 'details.port',
					    validators: {
						    required: {
							    error: 'general.required_field'
						    }
					    }
				    },
				    {
					    label: 'wallet.user_identifier',
					    id: 'userId',
					    type: 'text',
					    model: 'userId',
					    name: 'userId',
					    paymentPluginConfigurationModel: 'details.userId',
					    validators: {
						    required: {
							    error: 'general.required_field'
						    }
					    }
				    },
				    {
					    label: 'general.token',
					    id: 'token',
					    type: 'text',
					    model: 'token',
					    name: 'token',
					    paymentPluginConfigurationModel: 'details.token',
					    validators: {
						    required: {
							    error: 'general.required_field'
						    }
					    }
                    },
                    {
					    label: 'wallet.commission',
					    id: 'commission',
					    type: 'number',
					    model: 'commission',
					    name: 'commission',
					    paymentPluginConfigurationModel: 'details.commission',
					    validators: {
                            pattern: {
							    value: TWO_DECIMAL_PLACES_REGEX,
							    error: 'validation.two_decimal_limit',    
						    },
					    }
				    }
			    ]
		    },
		    resolve: lazyLoadWalletManagementBundle
	    })
        .state('walletMgmt.vcashConfiguration', {
            url: '/vcash/configuration/:pluginIdentifier',
            parentView: 'walletMgmt.walletPlugins',
            params: {
                pluginName: 'VCash'
            },
            views: {
                '': {
                    templateUrl: 'app/walletMgmt/apph/apph-plugin-configuration.template.html',
                    controller: 'APPHPluginConfigurationController',
                    controllerAs: 'vm'
                }
            },
            /** @type APPHPluginConfigurationStateData */
            data: {
                tabTranslationKey: 'wallet.vcash_configuration',
                tabs: [
                    {
                        translationKey: 'wallet.vcash_configuration',
                        state: 'walletMgmt.vcash-paymentConfiguration'
                    }
                ],
                fields: [
                    {
                        label: 'general.enabled',
                        id: 'enabled',
                        type: 'checkbox',
                        model: 'enabled',
                        name: 'enabled',
                        paymentPluginConfigurationModel: 'enabled'
                    },
                    {
                        label: 'wallet.deposit_enabled',
                        id: 'deposit-enabled',
                        type: 'checkbox',
                        model: 'depositEnabled',
                        name: 'depositEnabled',
                        paymentPluginConfigurationModel: 'depositEnabled'
                    },
                    {
                        label: 'wallet.min_deposit',
                        id: 'min-deposit',
                        type: 'number',
                        model: 'minDeposit',
                        name: 'minDeposit',
                        paymentPluginConfigurationModel: 'minDeposit',
                        validators: {
                            required: {
                                error: 'general.required_field'
                            },
                            min: {
                                value: 1,
                                error: 'general.minimum_value_is',
                                errorInterpolationParams: {
                                    min: 1
                                }
                            },
                            max: {
                                value: MAX_RELIABLY_PARSABLE_NUMBER,
                                error: 'general.maximum_value_is',
                                errorInterpolationParams: {
                                    max: MAX_RELIABLY_PARSABLE_NUMBER
                                }
                            },
                            lessThan: {
                                value: 'maxDeposit',
                                error: 'validation.messages.must_be_less_than',
                                errorInterpolationParams: {
                                    field: 'wallet.min_deposit',
                                    dependency: 'wallet.max_deposit'
                                }
                            }
                        }
                    },
                    {
                        label: 'wallet.max_deposit',
                        id: 'max-deposit',
                        type: 'number',
                        model: 'maxDeposit',
                        name: 'maxDeposit',
                        paymentPluginConfigurationModel: 'maxDeposit',
                        validators: {
                            required: {
                                error: 'general.required_field'
                            },
                            max: {
                                value: MAX_RELIABLY_PARSABLE_NUMBER,
                                error: 'general.maximum_value_is',
                                errorInterpolationParams: {
                                    max: MAX_RELIABLY_PARSABLE_NUMBER
                                }
                            },
                            greaterThan: {
                                value: 'minDeposit',
                                error: 'validation.messages.must_be_greater_than',
                                errorInterpolationParams: {
                                    field: 'wallet.max_deposit',
                                    dependency: 'wallet.min_deposit'
                                }
                            }
                        }
                    },
                    {
                        label: 'wallet.api_secret',
                        id: 'api-secret',
                        type: 'text',
                        model: 'apiSecret',
                        name: 'apiSecret',
                        paymentPluginConfigurationModel: 'details.apiSecret',
                        validators: {
                            required: {
                                error: 'general.required_field'
                            }
                        }
                    },
                    {
                        label: 'wallet.vendor_id',
                        id: 'vendor-id',
                        type: 'text',
                        model: 'vendorId',
                        name: 'vendorId',
                        paymentPluginConfigurationModel: 'details.vendorId',
                        validators: {
                            required: {
                                error: 'general.required_field'
                            }
                        }
                    }
                ]
            },
            resolve: lazyLoadWalletManagementBundle
        })
        .state('walletMgmt.vcashTransactions', {
            url: '/vcash/transactions',
            parentView: 'walletMgmt.walletPlugins',
            params: {
                pluginName: 'VCash'
            },
            views: {
                '': {
                    template:
                        '<react-grid data-view-name="{{viewName}}"></react-grid>' +
                        '<info-message></info-message>',
                    controller: 'APPHDepositsController',
                }
            },
            data: {
                tabTranslationKey: 'wallet.vcash_transactions',
                viewName: 'vcashTransactionsGrid',
                tabs: [
                    {
                        translationKey: 'wallet.vcash_transactions',
                        state: 'walletMgmt.vcashTransactions'
                    }
                ]
            },
            resolve: lazyLoadWalletManagementBundle
        })
        .state('walletMgmt.avoucherConfiguration', {
            url: '/avoucher/configuration/:pluginIdentifier',
            parentView: 'walletMgmt.walletPlugins',
            params: {
                pluginName: 'Avoucher'
            },
            views: {
                '': {
                    templateUrl: 'app/walletMgmt/apph/apph-plugin-configuration.template.html',
                    controller: 'APPHPluginConfigurationController',
                    controllerAs: 'vm'
                }
            },
            /** @type APPHPluginConfigurationStateData */
            data: {
                tabTranslationKey: 'wallet.avoucher_configuration',
                tabs: [
                    {
                        translationKey: 'wallet.avoucher_configuration',
                        state: 'walletMgmt.avoucher-paymentConfiguration'
                    }
                ],
                fields: [
                    {
                        label: 'general.enabled',
                        id: 'enabled',
                        type: 'checkbox',
                        model: 'enabled',
                        name: 'enabled',
                        paymentPluginConfigurationModel: 'enabled'
                    },
                    {
                        label: 'wallet.deposit_enabled',
                        id: 'deposit-enabled',
                        type: 'checkbox',
                        model: 'depositEnabled',
                        name: 'depositEnabled',
                        paymentPluginConfigurationModel: 'depositEnabled'
                    },
                    {
                        label: 'wallet.min_deposit',
                        id: 'min-deposit',
                        type: 'number',
                        model: 'minDeposit',
                        name: 'minDeposit',
                        paymentPluginConfigurationModel: 'minDeposit',
                        validators: {
                            required: {
                                error: 'general.required_field'
                            },
                            min: {
                                value: 1,
                                error: 'general.minimum_value_is',
                                errorInterpolationParams: {
                                    min: 1
                                }
                            },
                            max: {
                                value: MAX_RELIABLY_PARSABLE_NUMBER,
                                error: 'general.maximum_value_is',
                                errorInterpolationParams: {
                                    max: MAX_RELIABLY_PARSABLE_NUMBER
                                }
                            },
                            lessThan: {
                                value: 'maxDeposit',
                                error: 'validation.messages.must_be_less_than',
                                errorInterpolationParams: {
                                    field: 'wallet.min_deposit',
                                    dependency: 'wallet.max_deposit'
                                }
                            }
                        }
                    },
                    {
                        label: 'wallet.max_deposit',
                        id: 'max-deposit',
                        type: 'number',
                        model: 'maxDeposit',
                        name: 'maxDeposit',
                        paymentPluginConfigurationModel: 'maxDeposit',
                        validators: {
                            required: {
                                error: 'general.required_field'
                            },
                            max: {
                                value: MAX_RELIABLY_PARSABLE_NUMBER,
                                error: 'general.maximum_value_is',
                                errorInterpolationParams: {
                                    max: MAX_RELIABLY_PARSABLE_NUMBER
                                }
                            },
                            greaterThan: {
                                value: 'minDeposit',
                                error: 'validation.messages.must_be_greater_than',
                                errorInterpolationParams: {
                                    field: 'wallet.max_deposit',
                                    dependency: 'wallet.min_deposit'
                                }
                            }
                        }
                    },
                    {
                        label: 'wallet.api_url',
                        id: 'url',
                        type: 'text',
                        model: 'url',
                        name: 'url',
                        paymentPluginConfigurationModel: 'details.url',
                        validators: {
                            required: {
                                error: 'general.required_field'
                            }
                        }
                    },
                    {
                        label: 'wallet.api_username',
                        id: 'username',
                        type: 'text',
                        model: 'username',
                        name: 'username',
                        paymentPluginConfigurationModel: 'details.username',
                        validators: {
                            required: {
                                error: 'general.required_field'
                            }
                        }
                    },
                    {
                        label: 'wallet.api_password',
                        id: 'password',
                        type: 'text',
                        model: 'password',
                        name: 'password',
                        paymentPluginConfigurationModel: 'details.password',
                        validators: {
                            required: {
                                error: 'general.required_field'
                            }
                        }
                    }
                ]
            },
            resolve: lazyLoadWalletManagementBundle
        })
        .state('walletMgmt.avoucherTransactions', {
            url: '/avoucher/transactions',
            parentView: 'walletMgmt.walletPlugins',
            params: {
                pluginName: 'Avoucher'
            },
            views: {
                '': {
                    template:
                        '<react-grid data-view-name="{{viewName}}"></react-grid>' +
                        '<info-message></info-message>',
                    controller: 'APPHDepositsController',
                }
            },
            data: {
                tabTranslationKey: 'wallet.avoucher_transactions',
                viewName: 'vcashTransactionsGrid',
                tabs: [
                    {
                        translationKey: 'wallet.avoucher_transactions',
                        state: 'walletMgmt.avoucherTransactions'
                    }
                ]
            },
            resolve: lazyLoadWalletManagementBundle
        })
        .state('walletMgmt.yougandaConfiguration', {
            url: '/yo-uganda-configuration/:pluginIdentifier',
            parentView: 'walletMgmt.walletPlugins',
            params: {
                pluginName: 'YoUganda'
            },
            views: {
                '': {
                    templateUrl: 'app/walletMgmt/apph/apph-plugin-configuration.template.html',
                    controller: 'APPHPluginConfigurationController',
                    controllerAs: 'vm'
                }
            },
            data: {
                tabTranslationKey: 'wallet.yo_uganda_configuration',
                tabs: [
                    {
                        translationKey: 'wallet.yo_uganda_configuration',
                        state: 'walletMgmt.yougandaConfiguration'
                    }
                ],
                fields: [
                    {
                        label: 'general.enabled',
                        id: 'enabled',
                        type: 'checkbox',
                        model: 'enabled',
                        name: 'enabled',
                        paymentPluginConfigurationModel: 'enabled'
                    },
                    {
                        label: 'wallet.deposit_enabled',
                        id: 'deposit-enabled',
                        type: 'checkbox',
                        model: 'depositEnabled',
                        name: 'depositEnabled',
                        paymentPluginConfigurationModel: 'depositEnabled'
                    },
                    {
                        label: 'wallet.min_deposit',
                        id: 'min-deposit',
                        type: 'number',
                        model: 'minDeposit',
                        name: 'minDeposit',
                        paymentPluginConfigurationModel: 'minDeposit',
                        validators: {
                            required: {
                                error: 'general.required_field'
                            },
                            min: {
                                value: 1,
                                error: 'general.minimum_value_is',
                                errorInterpolationParams: {
                                    min: 1
                                }
                            },
                            pattern: {
                                value: NOT_DECIMAL_SEPARATOR_REGEX,
                                error: 'validation.decimal_numbers_not_allowed',
                            },
                            max: {
                                value: MAX_RELIABLY_PARSABLE_NUMBER,
                                error: 'general.maximum_value_is',
                                errorInterpolationParams: {
                                    max: MAX_RELIABLY_PARSABLE_NUMBER
                                }
                            },
                            lessThan: {
                                value: 'maxDeposit',
                                error: 'validation.messages.must_be_less_than',
                                errorInterpolationParams: {
                                    field: 'wallet.min_deposit',
                                    dependency: 'wallet.max_deposit'
                                }
                            }
                        }
                    },
                    {
                        label: 'wallet.max_deposit',
                        id: 'max-deposit',
                        type: 'number',
                        model: 'maxDeposit',
                        name: 'maxDeposit',
                        paymentPluginConfigurationModel: 'maxDeposit',
                        validators: {
                            required: {
                                error: 'general.required_field'
                            },
                            pattern: {
                                value: NOT_DECIMAL_SEPARATOR_REGEX,
                                error: 'validation.decimal_numbers_not_allowed',
                            },
                            greaterThan: {
                                value: 'minDeposit',
                                error: 'validation.messages.must_be_greater_than',
                                errorInterpolationParams: {
                                    field: 'wallet.max_deposit',
                                    dependency: 'wallet.min_deposit'
                                }
                            }
                        }
                    },
                    {
                        label: 'wallet.withdrawal_enabled',
                        id: 'withdraw-enabled',
                        type: 'checkbox',
                        model: 'withdrawEnabled',
                        name: 'withdrawEnabled',
                        paymentPluginConfigurationModel: 'withdrawEnabled'
                    },
                    {
                        label: 'wallet.min_withdrawal',
                        id: 'min-withdraw',
                        type: 'number',
                        model: 'minWithdraw',
                        name: 'minWithdraw',
                        paymentPluginConfigurationModel: 'minWithdraw',
                        validators: {
                            required: {
                                error: 'general.required_field'
                            },
                            min: {
                                value: 1,
                                error: 'general.minimum_value_is',
                                errorInterpolationParams: {
                                    min: 1
                                }
                            },
                            pattern: {
                                value: NOT_DECIMAL_SEPARATOR_REGEX,
                                error: 'validation.decimal_numbers_not_allowed',
                            },
                            max: {
                                value: MAX_RELIABLY_PARSABLE_NUMBER,
                                error: 'general.maximum_value_is',
                                errorInterpolationParams: {
                                    max: MAX_RELIABLY_PARSABLE_NUMBER
                                }
                            },
                            lessThan: {
                                value: 'maxWithdraw',
                                error: 'validation.messages.must_be_less_than',
                                errorInterpolationParams: {
                                    field: 'wallet.min_withdraw',
                                    dependency: 'wallet.max_withdraw'
                                }
                            }
                        }
                    },
                    {
                        label: 'wallet.max_withdrawal',
                        id: 'max-withdraw',
                        type: 'number',
                        model: 'maxWithdraw',
                        name: 'maxWithdraw',
                        paymentPluginConfigurationModel: 'maxWithdraw',
                        validators: {
                            required: {
                                error: 'general.required_field'
                            },
                            pattern: {
                                value: NOT_DECIMAL_SEPARATOR_REGEX,
                                error: 'validation.decimal_numbers_not_allowed',
                            },
                            greaterThan: {
                                value: 'minWithdraw',
                                error: 'validation.messages.must_be_greater_than',
                                errorInterpolationParams: {
                                    field: 'wallet.max_withdraw',
                                    dependency: 'wallet.min_withdraw'
                                }
                            }
                        }
                    },
                    {
                        label: 'wallet.withdrawal_approve_limit',
                        id: 'withdraw-approve-limit',
                        type: 'number',
                        model: 'withdrawApproveLimit',
                        name: 'withdrawApproveLimit',
                        paymentPluginConfigurationModel: 'withdrawApproveLimit',
                        validators: {
                            required: {
                                error: 'general.required_field',
                                dependencyModel: 'withdrawEnabled'
                            },
                            lessThan: {
                                value: 'maxWithdraw',
                                error: 'validation.messages.must_be_less_than',
                                errorInterpolationParams: {
                                    field: 'wallet.withdrawal_approve_limit',
                                    dependency: 'wallet.max_withdraw'
                                }
                            },
                            greaterThan: {
                                value: 'minWithdraw',
                                error: 'validation.messages.must_be_greater_than',
                                errorInterpolationParams: {
                                    field: 'wallet.withdrawal_approve_limit',
                                    dependency: 'wallet.min_withdraw'
                                }
                            }
                        }
                    },
                    {
                        label: 'wallet.deposit_narrative',
                        id: 'deposit-narrative',
                        type: 'text',
                        model: 'depositNarrative',
                        name: 'depositNarrative',
                        paymentPluginConfigurationModel: 'details.depositNarrative',
                        validators: {
                            required: {
                                error: 'general.required_field'
                            }
                        }
                    },
                    {
                        label: 'wallet.withdrawal_narrative',
                        id: 'withdrawal-narrative',
                        type: 'text',
                        model: 'withdrawalNarrative',
                        name: 'withdrawalNarrative',
                        paymentPluginConfigurationModel: 'details.withdrawalNarrative',
                        validators: {
                            required: {
                                error: 'general.required_field'
                            }
                        }
                    },
                    {
                        label: 'wallet.api_username',
                        id: 'api-username',
                        type: 'text',
                        model: 'apiUsername',
                        name: 'apiUsername',
                        paymentPluginConfigurationModel: 'details.apiUsername',
                        validators: {
                            required: {
                                error: 'general.required_field'
                            }
                        }
                    },
                    {
                        label: 'wallet.api_password',
                        id: 'api-password',
                        type: 'text',
                        model: 'apiPassword',
                        name: 'apiPassword',
                        paymentPluginConfigurationModel: 'details.apiPassword',
                        validators: {
                            required: {
                                error: 'general.required_field'
                            }
                        }
                    },
                    {
                        label: 'wallet.public_key',
                        id: 'public-key',
                        type: 'text',
                        model: 'publicKey',
                        name: 'publicKey',
                        paymentPluginConfigurationModel: 'details.publicKey',
                        validators: {
                            required: {
                                error: 'general.required_field'
                            }
                        }
                    },
                ]
            },
            resolve: lazyLoadWalletManagementBundle
        })
        .state('walletMgmt.yougandaDeposits', {
            url: '/yo-uganda/deposits',
            parentView: 'walletMgmt.walletPlugins',
            params: {
                pluginName: 'YoUganda'
            },
            views: {
                '': {
                    template:
                        '<react-grid data-view-name="{{viewName}}"></react-grid>' +
                        '<info-message></info-message>',
                    controller: 'APPHDepositsController',
                }
            },
            data: {
                tabTranslationKey: 'wallet.yo_uganda_deposits',
                viewName: 'YoUgandaDepositsGrid',
                tabs: [
                    {
                        translationKey: 'wallet.yo_uganda_deposits',
                        state: 'walletMgmt.yougandaDeposits'
                    },
                    {
                        translationKey: 'wallet.yo_uganda_withdrawals',
                        state: 'walletMgmt.yougandaWithdrawals'
                    }
                ]
            },
            resolve: lazyLoadWalletManagementBundle
        })
        .state('walletMgmt.yougandaWithdrawals', {
            url: '/yo-uganda/withdrawals',
            parentView: 'walletMgmt.walletPlugins',
            params: {
                pluginName: 'YoUganda'
            },
            views: {
                '': {
                    template:
                        '<react-grid data-view-name="{{viewName}}"></react-grid>' +
                        '<info-message></info-message>',
                    controller: 'APPHWithdrawalsController',
                }
            },
            data: {
                tabTranslationKey: 'wallet.yo_uganda_withdrawals',
                viewName: 'YoUgandaWithdrawalsGrid',
                tabs: [
                     {
                        translationKey: 'wallet.yo_uganda_deposits',
                        state: 'walletMgmt.yougandaDeposits'
                    },
                    {
                        translationKey: 'wallet.yo_uganda_withdrawals',
                        state: 'walletMgmt.yougandaWithdrawals'
                    }
                ]
            },
            resolve: lazyLoadWalletManagementBundle
        })
        .state('walletMgmt.player-transferConfiguration', {
            url: '/player-transfer-configuration/:pluginIdentifier',
            parentView: 'walletMgmt.walletPlugins',
            params: {
                pluginName: 'Player-Transfer'
            },
            views: {
                '': {
                    templateUrl: 'app/walletMgmt/apph/apph-plugin-configuration.template.html',
                    controller: 'APPHPluginConfigurationController',
                    controllerAs: 'vm'
                }
            },
            data: {
                tabTranslationKey: 'wallet.player_transfer_configuration',
                tabs: [
                    {
                        translationKey: 'wallet.player_transfer_configuration',
                        state: 'walletMgmt.player-transferConfiguration'
                    }
                ],
                fields: [
                    {
                        label: 'general.enabled',
                        id: 'enabled',
                        type: 'checkbox',
                        model: 'enabled',
                        name: 'enabled',
                        paymentPluginConfigurationModel: 'enabled'
                    },
                    {
                        label: 'wallet.withdrawal_enabled',
                        id: 'withdraw-enabled',
                        type: 'checkbox',
                        model: 'withdrawEnabled',
                        name: 'withdrawEnabled',
                        paymentPluginConfigurationModel: 'withdrawEnabled'
                    },
                    {
                        label: 'wallet.min_withdrawal',
                        id: 'min-withdraw',
                        type: 'number',
                        model: 'minWithdraw',
                        name: 'minWithdraw',
                        paymentPluginConfigurationModel: 'minWithdraw',
                        validators: {
                            required: {
                                error: 'general.required_field'
                            },
                            min: {
                                value: 1,
                                error: 'general.minimum_value_is',
                                errorInterpolationParams: {
                                    min: 1
                                }
                            },
                            pattern: {
                                value: NOT_DECIMAL_SEPARATOR_REGEX,
                                error: 'validation.decimal_numbers_not_allowed',
                            },
                            max: {
                                value: MAX_RELIABLY_PARSABLE_NUMBER,
                                error: 'general.maximum_value_is',
                                errorInterpolationParams: {
                                    max: MAX_RELIABLY_PARSABLE_NUMBER
                                }
                            },
                            lessThan: {
                                value: 'maxWithdraw',
                                error: 'validation.messages.must_be_less_than',
                                errorInterpolationParams: {
                                    field: 'wallet.min_withdraw',
                                    dependency: 'wallet.max_withdraw'
                                }
                            }
                        }
                    },
                    {
                        label: 'wallet.max_withdrawal',
                        id: 'max-withdraw',
                        type: 'number',
                        model: 'maxWithdraw',
                        name: 'maxWithdraw',
                        paymentPluginConfigurationModel: 'maxWithdraw',
                        validators: {
                            required: {
                                error: 'general.required_field'
                            },
                            pattern: {
                                value: NOT_DECIMAL_SEPARATOR_REGEX,
                                error: 'validation.decimal_numbers_not_allowed',
                            },
                            greaterThan: {
                                value: 'minWithdraw',
                                error: 'validation.messages.must_be_greater_than',
                                errorInterpolationParams: {
                                    field: 'wallet.max_withdraw',
                                    dependency: 'wallet.min_withdraw'
                                }
                            }
                        }
                    },
                    {
                        label: 'wallet.withdrawal_approve_limit',
                        id: 'withdraw-approve-limit',
                        type: 'number',
                        model: 'withdrawApproveLimit',
                        name: 'withdrawApproveLimit',
                        paymentPluginConfigurationModel: 'withdrawApproveLimit',
                        validators: {
                            required: {
                                error: 'general.required_field',
                                dependencyModel: 'withdrawEnabled'
                            },
                            lessThan: {
                                value: 'maxWithdraw',
                                error: 'validation.messages.must_be_less_than',
                                errorInterpolationParams: {
                                    field: 'wallet.withdrawal_approve_limit',
                                    dependency: 'wallet.max_withdraw'
                                }
                            },
                            greaterThan: {
                                value: 'minWithdraw',
                                error: 'validation.messages.must_be_greater_than',
                                errorInterpolationParams: {
                                    field: 'wallet.withdrawal_approve_limit',
                                    dependency: 'wallet.min_withdraw'
                                }
                            }
                        }
                    },
                    {
                        label: 'wallet.player_transfer_destination_company_uuid',
                        id: 'destination_tenant',
                        type: 'text',
                        model: 'destinationTenant',
                        name: 'destinationTenant',
                        paymentPluginConfigurationModel: 'details.destinationTenantId',
                        validators: {
                            required: {
                                error: 'general.required_field'
                            }
                        }
                    },
                    {
                        label: 'wallet.deposit_enabled',
                        id: 'deposit-enabled',
                        type: 'checkbox',
                        model: 'depositEnabled',
                        name: 'depositEnabled',
                        paymentPluginConfigurationModel: 'depositEnabled'
                    },
                    {
                        label: 'wallet.min_deposit',
                        id: 'min-deposit',
                        type: 'number',
                        model: 'minDeposit',
                        name: 'minDeposit',
                        paymentPluginConfigurationModel: 'minDeposit',
                        validators: {
                            required: {
                                error: 'general.required_field'
                            },
                            min: {
                                value: 1,
                                error: 'general.minimum_value_is',
                                errorInterpolationParams: {
                                    min: 1
                                }
                            },
                            pattern: {
                                value: NOT_DECIMAL_SEPARATOR_REGEX,
                                error: 'validation.decimal_numbers_not_allowed',
                            },
                            max: {
                                value: MAX_RELIABLY_PARSABLE_NUMBER,
                                error: 'general.maximum_value_is',
                                errorInterpolationParams: {
                                    max: MAX_RELIABLY_PARSABLE_NUMBER
                                }
                            },
                            lessThan: {
                                value: 'maxDeposit',
                                error: 'validation.messages.must_be_less_than',
                                errorInterpolationParams: {
                                    field: 'wallet.min_deposit',
                                    dependency: 'wallet.max_deposit'
                                }
                            }
                        }
                    },
                    {
                        label: 'wallet.max_deposit',
                        id: 'max-deposit',
                        type: 'number',
                        model: 'maxDeposit',
                        name: 'maxDeposit',
                        paymentPluginConfigurationModel: 'maxDeposit',
                        validators: {
                            required: {
                                error: 'general.required_field'
                            },
                            pattern: {
                                value: NOT_DECIMAL_SEPARATOR_REGEX,
                                error: 'validation.decimal_numbers_not_allowed',
                            },
                            greaterThan: {
                                value: 'minDeposit',
                                error: 'validation.messages.must_be_greater_than',
                                errorInterpolationParams: {
                                    field: 'wallet.max_deposit',
                                    dependency: 'wallet.min_deposit'
                                }
                            }
                        }
                    }
                ]
            },
            resolve: lazyLoadWalletManagementBundle
          })
          .state('walletMgmt.playerTransferDeposits', {
              url: '/player-transfer/deposits',
              parentView: 'walletMgmt.walletPlugins',
              params: {
                  pluginName: 'Player-Transfer'
              },
              views: {
                  '': {
                      template:
                          '<react-grid data-view-name="{{viewName}}"></react-grid>' +
                          '<info-message></info-message>',
                      controller: 'APPHDepositsController',
                  }
              },
              data: {
                  tabTranslationKey: 'wallet.player_transfer_deposits',
                  viewName: 'PlayerTransferDepositsGrid',
                  tabs: [
                      {
                          translationKey: 'wallet.player_transfer_deposits',
                          state: 'walletMgmt.playerTransferDeposits'
                      },
                      {
                          translationKey: 'wallet.player_transfer_withdrawals',
                          state: 'walletMgmt.playerTransferWithdrawals'
                      }
                  ]
              },
              resolve: lazyLoadWalletManagementBundle
          })
          .state('walletMgmt.playerTransferWithdrawals', {
              url: '/player-transfer/withdrawals',
              parentView: 'walletMgmt.walletPlugins',
              params: {
                  pluginName: 'Player-Transfer'
              },
              views: {
                  '': {
                      template:
                          '<react-grid data-view-name="{{viewName}}"></react-grid>' +
                          '<info-message></info-message>',
                      controller: 'APPHWithdrawalsController',
                  }
              },
              data: {
                  tabTranslationKey: 'wallet.player_transfer_withdrawals',
                  viewName: 'PlayerTransferWithdrawalsGrid',
                  tabs: [
                       {
                          translationKey: 'wallet.player_transfer_deposits',
                          state: 'walletMgmt.playerTransferDeposits'
                      },
                      {
                          translationKey: 'wallet.player_transfer_withdrawals',
                          state: 'walletMgmt.playerTransferWithdrawals'
                      }
                  ]
              },
              resolve: lazyLoadWalletManagementBundle
          })
          .state('walletMgmt.c-payConfiguration', {
            url: '/c-pay-configuration/:pluginIdentifier',
            parentView: 'walletMgmt.walletPlugins',
            params: {
                pluginName: 'C-Pay'
            },
            views: {
                '': {
                    templateUrl: 'app/walletMgmt/apph/apph-plugin-configuration.template.html',
                    controller: 'APPHPluginConfigurationController',
                    controllerAs: 'vm'
                }
            },
            data: {
                tabTranslationKey: 'wallet.c_pay_configuration',
                tabs: [
                    {
                        translationKey: 'wallet.c_pay_configuration',
                        state: 'walletMgmt.c-payConfiguration'
                    }
                ],
                fields: [
                    {
                        label: 'general.enabled',
                        id: 'enabled',
                        type: 'checkbox',
                        model: 'enabled',
                        name: 'enabled',
                        paymentPluginConfigurationModel: 'enabled'
                    },
                    {
                        label: 'wallet.deposit_enabled',
                        id: 'deposit-enabled',
                        type: 'checkbox',
                        model: 'depositEnabled',
                        name: 'depositEnabled',
                        paymentPluginConfigurationModel: 'depositEnabled'
                    },
                    {
                        label: 'wallet.min_deposit',
                        id: 'min-deposit',
                        type: 'number',
                        model: 'minDeposit',
                        name: 'minDeposit',
                        paymentPluginConfigurationModel: 'minDeposit',
                        validators: {
                            required: {
                                error: 'general.required_field'
                            },
                            min: {
                                value: 1,
                                error: 'general.minimum_value_is',
                                errorInterpolationParams: {
                                    min: 1
                                }
                            },
                            pattern: {
                                value: NOT_DECIMAL_SEPARATOR_REGEX,
                                error: 'validation.decimal_numbers_not_allowed',
                            },
                            max: {
                                value: MAX_RELIABLY_PARSABLE_NUMBER,
                                error: 'general.maximum_value_is',
                                errorInterpolationParams: {
                                    max: MAX_RELIABLY_PARSABLE_NUMBER
                                }
                            },
                            lessThan: {
                                value: 'maxDeposit',
                                error: 'validation.messages.must_be_less_than',
                                errorInterpolationParams: {
                                    field: 'wallet.min_deposit',
                                    dependency: 'wallet.max_deposit'
                                }
                            }
                        }
                    },
                    {
                        label: 'wallet.max_deposit',
                        id: 'max-deposit',
                        type: 'number',
                        model: 'maxDeposit',
                        name: 'maxDeposit',
                        paymentPluginConfigurationModel: 'maxDeposit',
                        validators: {
                            required: {
                                error: 'general.required_field'
                            },
                            pattern: {
                                value: NOT_DECIMAL_SEPARATOR_REGEX,
                                error: 'validation.decimal_numbers_not_allowed',
                            },
                            greaterThan: {
                                value: 'minDeposit',
                                error: 'validation.messages.must_be_greater_than',
                                errorInterpolationParams: {
                                    field: 'wallet.max_deposit',
                                    dependency: 'wallet.min_deposit'
                                }
                            }
                        }
                    },
                    {
                        label: 'wallet.api_key',
                        id: 'api_key',
                        type: 'text',
                        model: 'apiKey',
                        name: 'apiKey',
                        paymentPluginConfigurationModel: 'details.apiKey',
                        validators: {
                            required: {
                                error: 'general.required_field'
                            }
                        }
                    },
                    {
                        label: 'wallet.c_pay_client_secret',
                        id: 'client_secret',
                        type: 'text',
                        model: 'clientSecret',
                        name: 'clientSecret',
                        paymentPluginConfigurationModel: 'details.clientSecret',
                        validators: {
                            required: {
                                error: 'general.required_field'
                            }
                        }
                    },
                    {
                        label: 'wallet.c_pay_client_code',
                        id: 'client_code',
                        type: 'text',
                        model: 'clientCode',
                        name: 'clientCode',
                        paymentPluginConfigurationModel: 'details.clientCode',
                        validators: {
                            required: {
                                error: 'general.required_field'
                            }
                        }
                    },
                    {
                        label: 'wallet.c_pay_client_otp_medium',
                        id: 'otp_medium',
                        type: 'text',
                        model: 'otpMedium',
                        name: 'otpMedium',
                        paymentPluginConfigurationModel: 'details.otpMedium',
                        validators: {
                            required: {
                                error: 'general.required_field'
                            }
                        }
                    },
                ]
            },
            resolve: lazyLoadWalletManagementBundle
          })
          .state('walletMgmt.cPayDeposits', {
              url: '/c-pay/deposits',
              parentView: 'walletMgmt.walletPlugins',
              params: {
                  pluginName: 'C-Pay'
              },
              views: {
                  '': {
                      template:
                          '<react-grid data-view-name="{{viewName}}"></react-grid>' +
                          '<info-message></info-message>',
                      controller: 'APPHDepositsController',
                  }
              },
              data: {
                  tabTranslationKey: 'wallet.c_pay_deposits',
                  viewName: 'CPayDepositsGrid',
                  tabs: [
                      {
                          translationKey: 'wallet.c_pay_deposits',
                          state: 'walletMgmt.cPayDeposits'
                      }
                  ]
              },
              resolve: lazyLoadWalletManagementBundle
          })
        .state('walletMgmt.merkur-casino-ssbtConfiguration', {
            url: '/merkur-casino-ssbt/configuration/:pluginIdentifier',
            parentView: 'walletMgmt.walletPlugins',
            params: {
                pluginName: 'Merkur-Casino-SSBT'
            },
            views: {
                '': {
                    templateUrl: 'app/walletMgmt/apph/apph-plugin-configuration.template.html',
                    controller: 'APPHPluginConfigurationController',
                    controllerAs: 'vm'
                }
            },
            data: {
                tabTranslationKey: 'wallet.merkurssbt_configuration',
                tabs: [
                    {
                        translationKey: 'wallet.merkurssbt_configuration',
                        state: 'walletMgmt.merkurSsbt-paymentConfiguration'
                    }
                ],
                fields: [
                    {
                        label: 'wallet.deposit_enabled',
                        id: 'deposit-enabled',
                        type: 'checkbox',
                        model: 'depositEnabled',
                        name: 'depositEnabled',
                        paymentPluginConfigurationModel: 'depositEnabled'
                    },
                    {
                        label: 'wallet.min_deposit',
                        id: 'min-deposit',
                        type: 'number',
                        model: 'minDeposit',
                        name: 'minDeposit',
                        paymentPluginConfigurationModel: 'minDeposit',
                        validators: {
                            required: {
                                error: 'general.required_field'
                            },
                            min: {
                                value: 1,
                                error: 'general.minimum_value_is',
                                errorInterpolationParams: {
                                    min: 1
                                }
                            },
                            max: {
                                value: MAX_RELIABLY_PARSABLE_NUMBER,
                                error: 'general.maximum_value_is',
                                errorInterpolationParams: {
                                    max: MAX_RELIABLY_PARSABLE_NUMBER
                                }
                            },
                            lessThan: {
                                value: 'maxDeposit',
                                error: 'validation.messages.must_be_less_than',
                                errorInterpolationParams: {
                                    field: 'wallet.min_deposit',
                                    dependency: 'wallet.max_deposit'
                                }
                            }
                        }
                    },
                    {
                        label: 'wallet.max_deposit',
                        id: 'max-deposit',
                        type: 'number',
                        model: 'maxDeposit',
                        name: 'maxDeposit',
                        paymentPluginConfigurationModel: 'maxDeposit',
                        validators: {
                            required: {
                                error: 'general.required_field'
                            },
                            max: {
                                value: MAX_RELIABLY_PARSABLE_NUMBER,
                                error: 'general.maximum_value_is',
                                errorInterpolationParams: {
                                    max: MAX_RELIABLY_PARSABLE_NUMBER
                                }
                            },
                            greaterThan: {
                                value: 'minDeposit',
                                error: 'validation.messages.must_be_greater_than',
                                errorInterpolationParams: {
                                    field: 'wallet.max_deposit',
                                    dependency: 'wallet.min_deposit'
                                }
                            }
                        }
                    }
                ]
            },
            resolve: lazyLoadWalletManagementBundle
        })
        .state('walletMgmt.merkurCasinoSsbtTransactions', {
            url: '/merkur-casino-ssbt/transactions',
            parentView: 'walletMgmt.walletPlugins',
            params: {
                pluginName: 'Merkur-Casino-SSBT'
            },
            views: {
                '': {
                    template:
                        '<react-grid data-view-name="{{viewName}}"></react-grid>' +
                        '<info-message></info-message>',
                    controller: 'APPHDepositsController',
                }
            },
            data: {
                tabTranslationKey: 'wallet.merkurssbt_transactions',
                viewName: 'merkurSsbtTransactionsGrid',
                tabs: [
                    {
                        translationKey: 'wallet.merkurssbt_transactions',
                        state: 'walletMgmt.merkurSsbtTransactions'
                    }
                ]
            },
            resolve: lazyLoadWalletManagementBundle
        });


    /**
     * @typedef {'checkbox'|'number'|'url'|'text'|'textarea'} FieldType
     */

    /**
     * @typedef BaseField
     * @property {string} label - label for field
     * @property {string} id - input element id
     * @property {string} model - model key
     * @property {string} name - name, used in form for field validation
     * @property {string} paymentPluginConfigurationModel - key of configuration model to which field coresponds
     */

    /**
     * @typedef BaseValidator
     * @property {string} error - translation key for error
     */

    /**
     * @typedef {BaseValidator} RequiredValidator
     * @property {string} dependencyModel - the field on which for the current field depends whether it will be required or not
     */

    /**
     * @typedef MinValidator
     * @property {number} value - minimal value for model to be valid
     * @property {string} error - translation key for error
     * @property {Object} errorInterpolationParams - interpolation object for error translation
     * @property {string} errorInterpolationParams.min - Value for `min` in translation
     */

    /**
     * @typedef MaxValidator
     * @property {number} value - maximal value for model to be valid
     * @property {string} error - translation key for error
     * @property {Object} errorInterpolationParams - interpolation object for error translation
     * @property {string} errorInterpolationParams.max - Value for `max` in translation
     */

    /**
     * @typedef LessThanValidator
     * @property {string} value - key of model value from which this value must be smaller
     * @property {string} error - translation key for error
     * @property {Object} errorInterpolationParams - interpolation object for error translation
     * @property {string} errorInterpolationParams.field - interpolation translation key of this field
     * @property {string} errorInterpolationParams.dependency - interpolation translation key of field from which validated field must be smaller
     */

    /**
     * @typedef EqualOrLessThanValidator
     * @property {string} value - key of model value from which this value must be smaller or equal
     * @property {string} error - translation key for error
     * @property {Object} errorInterpolationParams - interpolation object for error translation
     * @property {string} errorInterpolationParams.field - interpolation translation key of this field
     * @property {string} errorInterpolationParams.dependency - interpolation translation key of field from which validated field must be smaller
     */

    /**
     * @typedef GreaterThanValidator
     * @property {string} value - key of model value from which this value must be larger
     * @property {string} error - translation key for error
     * @property {Object} errorInterpolationParams - interpolation object for error translation
     * @property {string} errorInterpolationParams.field - interpolation translation key of this field
     * @property {string} errorInterpolationParams.dependency - interpolation translation key of field from which validated field must be larger
     */

    /**
     * @typedef EqualOrGreaterThanValidator
     * @property {string} value - key of model value from which this value must be larger or equal
     * @property {string} error - translation key for error
     * @property {Object} errorInterpolationParams - interpolation object for error translation
     * @property {string} errorInterpolationParams.field - interpolation translation key of this field
     * @property {string} errorInterpolationParams.dependency - interpolation translation key of field from which validated field must be larger
     */

    /**
     * @typedef PatternValidator
     * @type {string|RegExp} value - regex pattern to validate against - RegExp literal, RegExp constructor or string are supported
     * @property {string} error - translation key for error
     */

    /**
     * Validates uniqueness of field against others
     * @typedef DistinctFromValidator
     * @property {Array.<string>} value - Array of field models to validate against, values use lodash `get` property syntax
     * @property {string} error - translation key for error
     */

    /**
     * @typedef UrlFieldValidators
     * @property {RequiredValidator} [required]
     */

    /**
     * @typedef NumberFieldValidators
     * @property {RequiredValidator} [required]
     * @property {MinValidator} [min]
     * @property {MaxValidator} [max]
     * @property {LessThanValidator} [lessThan]
     * @property {EqualOrLessThanValidator} [equalOrLessThanValidator]
     * @property {GreaterThanValidator} [greaterThan]
     * @property {EqualOrGreaterThanValidator} [equalOrGreaterThan]
     * @property {DistinctFromValidator} [distinctFrom]
     * @property {PatternValidator} [pattern]
     */

    /**
     * @typedef TextFieldValidators
     * @property {RequiredValidator} [required]
     */

    /**
     * @typedef TextareaFieldValidators
     * @property {RequiredValidator} [required]
     */

    /**
     * @typedef CheckboxFieldBase
     * @property {'checkbox'} type
     */

    /**
     * @typedef UrlFieldBase
     * @property {'url'} type
     * @property {string} [placeholder] - input placeholder translation key
     * @property {UrlFieldValidators} [validators]
     */

    /**
     * @typedef NumberFieldBase
     * @property {'number'} type
     * @property {string} [placeholder] - input placeholder translation key
     * @property {NumberFieldValidators} [validators]
     */

    /**
     * @typedef TextFieldBase
     * @property {'text'} type
     * @property {string} [placeholder] - input placeholder translation key
     * @property {string} [labelInterpolationParams] - Parameters to interpolate into label
     * @property {TextFieldValidators} [validators]
     */

    /**
     * @typedef TextareaFieldBase
     * @property {'textarea'} type
     * @property {string} [placeholder] - input placeholder translation key
     * @property {TextareaFieldValidators} [validators]
     */

    /**
     * @typedef {BaseField & CheckboxFieldBase} CheckboxField
     */

    /**
     * @typedef {BaseField & UrlFieldBase} UrlField
     */

    /**
     * @typedef {BaseField & NumberFieldBase} NumberField
     */

    /**
     * @typedef {BaseField & TextFieldBase} TextField
     */

    /**
     * @typedef {BaseField & TextareaFieldBase} TextareaField
     */

    /**
     * @typedef {CheckboxField|UrlField|NumberField|TextField|TextareaField} Fields
     */

    /**
     * @typedef {Array.<Fields>} FieldsArray
     */

    /**
     * @typedef APPHPluginConfigurationTab
     * @property {string} translationKey - translation key for tab
     * @property {string} state - ui-router state for tab
     */

    /**
     * @typedef {Array.<APPHPluginConfigurationTab>} APPHPluginConfigurationTabs
     */

    /**
     * @typedef {Object} APPHPluginConfigurationStateData
     * @property {string} tabTranslationKey - translation key for subnavigation
     * @property {FieldsArray} fields - form fields
     * @property {APPHPluginConfigurationTabs} tabs - second level navigation/tabs
     */

}]);
;
var sevenAdminPromotions = angular.module('seven-admin.promotions', [
]);

sevenAdminPromotions.config([ '$stateProvider', function ($stateProvider) {

    $stateProvider
        .state('promotions', {
            url: '/promotions',
            templateUrl: '/app/promotions/promotions.html',
            parent: 'main',
            controller: 'PromotionsController',
            data: {
                module: 'promotions'
            },
            resolve: {
                loadController: ['$ocLazyLoad', function($ocLazyLoad) {
                    return $ocLazyLoad.load('[DIST_PATH]js/seven-admin.promotions.js')
                }]
            }
        })
        .state('promotions.bonus', {
            url: '/bonus',
            parentView: 'promotions.bonus',
            views: {
                '': {
                    templateUrl: '/app/promotions/bonuses/bonus-list.html',
                    controller: 'BonusListController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                loadController: ['$ocLazyLoad', function($ocLazyLoad) {
                    return $ocLazyLoad.load('[DIST_PATH]js/seven-admin.promotions.js')
                }]
            }
        })
        .state('promotions.bonusCreator', {
            url: '/bonus-creator',
            parentView: 'promotions.bonus',
            views: {
                '': {
                    templateUrl: '/app/promotions/bonuses/bonus-creator.template.html',
                    controller: 'BonusCreatorController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                loadController: ['$ocLazyLoad', function($ocLazyLoad) {
                    return $ocLazyLoad.load('[DIST_PATH]js/seven-admin.promotions.js')
                }]
            }
        })
        .state('promotions.bonusDetails', {
            url: '/bonus/bonus-details/:bonusUuid',
            parentView: 'promotions.bonus',
            views: {
                '': {
                    templateUrl: '/app/promotions/bonuses/details/bonus-details.html',
                    controller: 'BonusDetailsController'
                }
            },
            resolve: {
                loadController: ['$ocLazyLoad', function($ocLazyLoad) {
                    return $ocLazyLoad.load('[DIST_PATH]js/seven-admin.promotions.js')
                }]
            },
            params: {
                columnSaveStrategy: 'strip'
            }
        })
        .state('promotions.bonusEdit', {
            url: '/bonus/edit/:bonusUuid',
            parentView: 'promotions.bonus',
            views: {
                '': {
                    templateUrl: 'app/promotions/bonuses/edit/bonus-edit.html',
                    controller: 'BonusEditController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                loadController: ['$ocLazyLoad', function($ocLazyLoad) {
                    return $ocLazyLoad.load('[DIST_PATH]js/seven-admin.promotions.js')
                }]
            }
        })
        .state('promotions.bonusConfiguration', {
            url: '/bonus/edit/:bonusUuid/configuration',
            parentView: 'promotions.bonus',
            views: {
                '': {
                    templateUrl: 'app/promotions/bonuses/edit/bonus-configuration.html',
                    controller: 'BonusConfigurationController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                loadController: ['$ocLazyLoad', function($ocLazyLoad) {
                    return $ocLazyLoad.load('[DIST_PATH]js/seven-admin.promotions.js')
                }]
            }
        })
        .state('promotions.loyalty', {
            url: '/loyalty',
            parentView: 'promotions.loyalty',
            views: {
                '': {
                    templateUrl: '/app/promotions/loyalty/loyalty.template.html',
                    controller: 'LoyaltyController',
                    controllerAs: 'model'
                }
            },
            resolve: {
                loadController: ['$ocLazyLoad', function($ocLazyLoad) {
                    return $ocLazyLoad.load('[DIST_PATH]js/seven-admin.promotions.js')
                }]
            }
        })
        .state('promotions.newCompetition', {
            url: '/new-competition',
            parentView: 'promotions.loyalty',
            views: {
                '': {
                    templateUrl: '/app/promotions/loyalty/competition/new-loyalty-competition.template.html',
                    controller: 'NewLoyaltyCompetitionController',
                    controllerAs: 'model'
                }
            },
            resolve: {
                loadController: ['$ocLazyLoad', function($ocLazyLoad) {
                    return $ocLazyLoad.load([
                        '[DIST_PATH]js/seven-admin.promotions.js',
                        '[DIST_PATH]js/seven-admin-productmgmt.js'
                    ])
                }]
            }
        })
        .state('promotions.rounds', {
            url: 'loyalty/competitions/:competitionId?roundId',
            parentView: 'promotions.loyalty',
            views: {
                '': {
                    templateUrl: '/app/promotions/loyalty/competition/loyalty-competition.template.html',
                    controller: 'LoyaltyCompetitionController',
                    controllerAs: 'model'
                }
            },
            resolve: {
                loadController: ['$ocLazyLoad', function($ocLazyLoad) {
                    return $ocLazyLoad.load('[DIST_PATH]js/seven-admin.promotions.js')
                }]
            }
        })
}]);
;
var sevenAdminShared = angular.module('seven-admin.shared', []);;
var sevenAdminComponents = angular.module('seven-admin.components', []);
;
(function() {
    angular
        .module('seven-admin.auth', []);
}());
;
(function(){
    angular
        .module('seven-admin.auth')
        .config(config);

    config.$inject = ['$stateProvider'];

    function config ($stateProvider) {
        $stateProvider
            .state('main', {
                templateUrl: '/app/shared/templates/main.html',
                abstract: true
            })
            /** LOGIN page */
            .state('login', {
                url: '/login?user',
                templateUrl: '/app/auth/user-login/login-page.html',
                controller: 'LoginController',
                resolve: {
                    loadController: ['$ocLazyLoad', function($ocLazyLoad) {
                        return $ocLazyLoad.load('[DIST_PATH]js/seven-admin.auth.js')
                    }]
                },
                data: {
                    module: 'PUBLIC'
                }
            })
            /** FORGOT PASS page */
            .state('forgot', {
                url: '/forgot',
                templateUrl: '/app/auth/user-login/login-page.html',
                controller: 'ForgotPassController',
                resolve: {
                    loadController: ['$ocLazyLoad', function($ocLazyLoad) {
                        return $ocLazyLoad.load('[DIST_PATH]js/seven-admin.auth.js')
                    }]
                },
                data: {
                    module: 'PUBLIC'
                }
            })
            /** RESETTING PASS page */
            /** TODO: investigate this duplication **/
            .state('resetting', {
                url: '/resetting/:token',
                templateUrl: '/app/auth/user-login/login-page.html',
                controller: 'ForgotPassController',
                resolve: {
                    loadController: ['$ocLazyLoad', function($ocLazyLoad) {
                        return $ocLazyLoad.load('[DIST_PATH]js/seven-admin.auth.js')
                    }]
                },
                data: {
                    module: 'PUBLIC'
                }
            })
            /** RESETTING PASS page */
            .state('reset', {
                url: '/reset/:type',
                templateUrl: '/app/auth/general-template.html',
                controller: 'ResetPassController',
                resolve: {
                    loadController: ['$ocLazyLoad', function($ocLazyLoad) {
                        return $ocLazyLoad.load('[DIST_PATH]js/seven-admin.auth.js')
                    }]
                },
                data: {
                    module: 'PUBLIC'
                }
            })

            /** LOGOUT (not a page, just logout call)*/
            .state('logout', {
                url: '/logout',
                template: '',
                controller: 'LogoutController',
                resolve: {
                    loadController: ['$ocLazyLoad', function($ocLazyLoad) {
                        return $ocLazyLoad.load('[DIST_PATH]js/seven-admin.auth.js')
                    }]
                },
                data: {
                    module: 'PUBLIC'
                }
            })

            /** VERIFY EMAIL ACCOUNT - just return token to server */
            .state('verifyAccount', {
                url: '/verify-account/:token?usr',
                templateUrl: '/app/auth/user-login/login-page.html',
                controller: 'VerifyAccountController',
                resolve: {
                    loadController: ['$ocLazyLoad', function($ocLazyLoad) {
                        return $ocLazyLoad.load('[DIST_PATH]js/seven-admin.auth.js')
                    }]
                },
                data: {
                    module: 'PUBLIC'
                }
            })

            /** VERIFY EMAIL - change first password received by email */
            .state('verifyEmail2', {
                url: '/verify-email',
                templateUrl: '/app//auth/verify-email.html',
                controller: 'VerifyEmailController',
                resolve: {
                    loadController: ['$ocLazyLoad', function($ocLazyLoad) {
                        return $ocLazyLoad.load('[DIST_PATH]js/seven-admin.auth.js')
                    }]
                },
                data: {
                    module: 'PUBLIC'
                }
            })

            /** FORBIDDEN - redirect to this for a disallowed user action */
            .state('forbidden', {
                url: '/forbidden',
                templateUrl: '/app/auth/forbidden-page/forbidden-page.html',
                controller: 'ForbiddenPageController',
                resolve: {
                    loadController: ['$ocLazyLoad', function($ocLazyLoad) {
                        return $ocLazyLoad.load('[DIST_PATH]js/seven-admin.auth.js')
                    }]
                },
                data: {
                    module: 'PUBLIC'
                }
            })

            .state('loginCompanySwitch', {
                url: '/forbidden-login',
                templateUrl: '/app/auth/forbidden-page/login-company-switch.html',
                controller: 'LoginSwitchController',
                resolve: {
                    loadController: ['$ocLazyLoad', function($ocLazyLoad) {
                        return $ocLazyLoad.load('[DIST_PATH]js/seven-admin.auth.js')
                    }]
                },
                data: {
                    module: 'PUBLIC'
                },
                params: {
                    username: undefined,
                    password: undefined,
                    companies: undefined
                }
            })

            .state('deviceInstall', {
                url: '/device-install',
                templateUrl: '/app/auth/login-template.html',
                controller: 'DeviceInstallController',
                resolve: {
                    loadController: ['$ocLazyLoad', function($ocLazyLoad) {
                        return $ocLazyLoad.load([
                            '[DIST_PATH]js/seven-admin.auth.js',
                            '[DIST_PATH]js/seven-admin-shopmgmt.js'
                        ])
                    }]
                },
                data: {
                    module: 'PUBLIC'
                }
            });
    }

}());
;
var sevenAdminSettings = angular.module('seven-admin-settings', [
]);

sevenAdminSettings.config([ '$stateProvider', function ($stateProvider) {

    $stateProvider
        .state('settingsMgmt', {
            url: '/settings',
            templateUrl: '/app/settings/settings.index.html',
            parent: 'main',
            controller: 'settingsController',
            data: {
                module: 'settingsMgmt'
            },
            resolve: {
                loadController: ['$ocLazyLoad', function($ocLazyLoad) {
                    return $ocLazyLoad.load('[DIST_PATH]js/seven-admin-settings.js')
                }]
            }
        })
        .state('settingsMgmt.applicationSettings', {
            url: '/application-settings',
            parentView: 'settingsMgmt.applicationSettings',
            views: {
                '': {
                    templateUrl: '/app/settings/application-settings/application-settings.template.html',
                    controller: 'ApplicationSettingsController'
                }
            },
            resolve: {
                loadController: ['$ocLazyLoad', function($ocLazyLoad) {
                    return $ocLazyLoad.load('[DIST_PATH]js/seven-admin-settings.js')
                }]
            }
        })
        .state('settingsMgmt.peripheralSettings', {
            url: '/peripheral-settings',
            parentView: 'settingsMgmt.peripheralSettings',
            views: {
                '': {
                    templateUrl: '/app/settings/peripheralSettings/peripheralSettings.index.html',
                    controller: 'peripheralSettingsCtrl'
                }
            },
            resolve: {
                loadController: ['$ocLazyLoad', function($ocLazyLoad) {
                    return $ocLazyLoad.load('[DIST_PATH]js/seven-admin-settings.js')
                }]
            }
        })
        .state('settingsMgmt.platformSettings', {
            url: '/platform-settings',
            parentView: 'settingsMgmt.platformSettings',
            redirectTo: 'settingsMgmt.platformSettings.general',
            views: {
                '': {
                    template: '<div ui-view></div>',
                    controller: function () {}
                }
            },
            resolve: {
                loadController: ['$ocLazyLoad', function($ocLazyLoad) {
                    return $ocLazyLoad.load('[DIST_PATH]js/seven-admin-settings.js')
                }]
            }
        })
        .state('settingsMgmt.platformSettings.general', {
            url: '/general',
            parentView: 'settingsMgmt.platformSettings',
            views: {
                '': {
                    templateUrl: '/app/settings/platformSettings/generalPlatformSettings/generalPlatformSettings.index.html',
                    controller: 'generalPlatformSettingsCtrl'
                }
            },
            resolve: {
                loadController: ['$ocLazyLoad', function($ocLazyLoad) {
                    return $ocLazyLoad.load('[DIST_PATH]js/seven-admin-settings.js')
                }]
            }
        })
        .state('settingsMgmt.platformSettings.ticketPin', {
            url: '/ticket-pin',
            parentView: 'settingsMgmt.platformSettings',
            views: {
                '': {
                    templateUrl: '/app/settings/platformSettings/ticket-pin-settings/ticket-pin-settings.index.html',
                    controller: 'ticketPinSettingsCtrl'
                }
            },
            resolve: {
                loadController: ['$ocLazyLoad', function($ocLazyLoad) {
                    return $ocLazyLoad.load('[DIST_PATH]js/seven-admin-settings.js')
                }]
            }
        })
        .state('settingsMgmt.platformSettings.workingTime', {
            url: '/working-time',
            parentView: 'settingsMgmt.platformSettings',
            views: {
                '': {
                    templateUrl: '/app/settings/platformSettings/workingTimeSettings/platform-working-time-settings.index.html',
                    controller: 'platformWorkingTimeSettingsCtrl as vm',
                }
            },
            resolve: {
                loadController: ['$ocLazyLoad', function($ocLazyLoad) {
                    return $ocLazyLoad.load('[DIST_PATH]js/seven-admin-settings.js')
                }]
            }
        })
        .state('settingsMgmt.accessControlSettings', {
            url: '/access-control-settings',
            parentView: 'settingsMgmt.accessControlSettings',
            views: {
                '': {
                    templateUrl: '/app/settings/accessControlSettings/accessControlSettings.index.html',
                    controller: 'accessControlSettingsCtrl'
                }
            },
            resolve: {
                loadController: ['$ocLazyLoad', function($ocLazyLoad) {
                    return $ocLazyLoad.load('[DIST_PATH]js/seven-admin-settings.js')
                }]
            }
        });
}]);
;
(function() {
    angular
        .module('seven-admin.operations', []);
}());;
app.factory('applicationListsService', ['$http', 'appSettingsSvc', 'userInitData', function ($http, appSettingsSvc, userInitData) {
  var apiBaseUrl = appSettingsSvc.urls.gravityApi;

  var formatCompanyName = function (companyName) {
    var result = companyName.toLowerCase().match(/[A-Za-z0-9]+/g);
    return result.join('_');
  };

  return {
      getCompanyLists: function (companyName, availableLists, type) {
        var hasListsOfType = _.some(availableLists, function (item) {
          return item.includes(type);
        });

        // Don't try to load the list of requested type if it isn't available at all
        if (!hasListsOfType) return Promise.resolve({});

        var url = _.template('${apiBaseUrl}/admin/lists/${listName}')({
            apiBaseUrl: apiBaseUrl,
            listName: type + '_' + formatCompanyName(companyName)
        });

        return $http.get(
          url,
          {
            headers: {
              'X-Nsft-SCD-App-Name': 'seven_admin'
            }
          }).then(function (response) {
            return response.data.list;
        }).catch(function () {
          return {};
        });
      },
      getListArticle: function (articleName) {
        var url = _.template('${apiBaseUrl}/admin/articles/${articleName}')({
          apiBaseUrl: apiBaseUrl,
          articleName: articleName
        });

        return $http.get(
          url,
          {
            headers: {
              'X-Nsft-SCD-company-uuid': userInitData.currentCompany.uuid
            }
          }).then(function (response) {
            return response.data.article;
        });
      }
  }
}]);
;
app.factory('applicationSettingsService', ['$http', 'appSettingsSvc', function ($http, appSettingsSvc) {
    var apiBaseUrl = appSettingsSvc.urls.gravityApi,
        appTemplate = 'seven_admin';

    return {
        getApplicationVersions: function () {
            return this.getGlobalSettingByKey('versions').then(function(data) {
                return data.versions;
            });
        },
        getGlobalSettingByKey: function (key) {
            var url = _.template('${apiBaseUrl}/app-templates/${appTemplate}/settings/${key}')({
                apiBaseUrl: apiBaseUrl,
                appTemplate: appTemplate,
                key: key
            });

            return $http.get(url).then(function (response) {
                return response.data.appTemplateSetting;
            });
        }
    }
}]);
;
app.factory('appSettingsSvc', [
'$state', '$translate', '$filter', 'userInitData', 'ENV_CFG',
function ($state, $translate, $filter, userInitData, ENV_CFG) {

    var allModules = {};

    /**
     * Sort sub-modules by it's priority and get first id value
     * @param {Object} data
     * @returns {*}
     */
    function getFirstState(data) {
        if (data.submodules.length) {
            return $filter('orderBy')(data.submodules, 'priority')[0].id;
        }
    }

    allModules = appendAppDefinedModules(getStates(userInitData.clientAppModules), userInitData);

    /**
     * Generate Object that contains info about every module and it's sub-modules
     * @param {Array} modules - Raw list of backend response available modules
     * @param {String} [state] - Parent state of sub-module. If it's not provided use child state
     * @returns {{Object}} obj
     */
    function getStates(modules, state) {

        var obj = {},
            fullState = '';


        angular.forEach(modules, function(module) {
            if (!state) {
                fullState = module.id + '.' + getFirstState(module);
            } else {
                fullState += state + '.' + module.id;
            }


            obj[module.id] = {
                id: module.id,
                name: module.translation,
                state: fullState,
                iconClass: 'n-i n-i-' + module.id,
                visible: module.visible,
                priority: module.priority,
                actions: module.actions || [],
                submodules: module.submodules && module.submodules.length ? getStates(module.submodules, state ? fullState : module.id) : null,
                bootstrapUrl: module.onDemandBoot ? module.onDemandBoot : ''
            };
            fullState = '';
        });

        return obj;
    }

    /** Adds modules that can't be added to bootstrap
     * @function
     * @name appendAppDefinedModules
     * @param modules - modules object
     * @param userData - userInitData
     * @returns {*}
     */
    function appendAppDefinedModules(modules, userData) {
        if (modules) {
            // Until this type of modules are added to bootstrap via gravity api this is the way to add to menu
            var toolsModule = _.get(modules, 'tools');
            var zodiacEnabled = _.get(userData, 'settings.company.zodiacEnabled');

            modules.certifications = {
                id: 'certifications',
                name: $translate.instant('certifications.title'),
                actions: {},
                bootstrapUrl: "",
                iconClass: "n-i n-i-details",
                state: 'certifications.list',
                submodules: {
                    list:  {
                        id: 'list',
                        name: $translate.instant('general.list'),
                        actions: {},
                        bootstrapUrl: "",
                        iconClass: "n-i n-i-details",
                        state: 'certifications.list',
                        visible: true,
                    }
                },
                visible: false
            };

            if (zodiacEnabled && toolsModule) {
                var chatSupport = {
                    actions: {},
                    bootstrapUrl: "",
                    iconClass: "n-i n-i-maintenance",
                    id: "support",
                    name: $translate.instant('chat.support'),
                    priority: 9,
                    state: "tools.support",
                    submodules: null,
                    visible: true
                };

                toolsModule.submodules.support = chatSupport;

                $translate.onReady(function() {
                    // Translations are loaded after appSettingsService initialization so this is required for chat tab
                    // translation
                    chatSupport.name = $translate.instant('chat.support');
                });
            }
        }

        return modules;
    }

    var tenantId = userInitData.currentCompany && userInitData.currentCompany.uuid;

    var settings = {
        urls: {
            host: ENV_CFG.api.backend,
            api: ENV_CFG.api.backend,
            apph: ENV_CFG.api.apph,
            cmsAssets: ENV_CFG.api.cmsAssets,
            gravityApi: ENV_CFG.api.gravity,
            socketApi: ENV_CFG.api.socket,
            staticApi: ENV_CFG.api.static,
            assets: ENV_CFG.api.assets,
            bonusApi: ENV_CFG.api.bonus,
            sevenMule: ENV_CFG.api.sevenMule,
            ngsApi: ENV_CFG.api.ngs,
            ngsOpen: ENV_CFG.api.ngsOpen,
            rmSocketApi: ENV_CFG.api.rmSocket[tenantId] || ENV_CFG.api.rmSocket.default,
            sevenIPay: ENV_CFG.api.sevenIPay,
            smTicketSocket: ENV_CFG.api.smTicketSocket[tenantId] || ENV_CFG.api.smTicketSocket.default,
            smTicketCalculator: ENV_CFG.api.smTicketCalculator[tenantId] || ENV_CFG.api.smTicketCalculator.default,
            sbGatewayApi: ENV_CFG.api.sbGateway,
            smGatewayApi: ENV_CFG.api.smGateway[tenantId] || ENV_CFG.api.smGateway.default,
            taxAuthorityApi: ENV_CFG.api.taxAuthority,
            poolbetApi: ENV_CFG.api.poolbet,
            quickbetApi: ENV_CFG.api.quickbet,
            sportsbookApi: ENV_CFG.api.sportsbook[tenantId] || ENV_CFG.api.sportsbook.default,
            sbVisualization: ENV_CFG.api.sbVisualization,
            sbVisualizationLegacy: ENV_CFG.api.sbVisualizationLegacy,
            reporting: ENV_CFG.api.reporting,
            tags: ENV_CFG.api.tags,
            cms: ENV_CFG.client.cms,
            iam: ENV_CFG.api.iam,
            inspiredApi: ENV_CFG.api.inspired,
            loyalty: ENV_CFG.api.loyalty,
            zodiac: ENV_CFG.api.zodiac,
            futureGaming: ENV_CFG.api.futureGaming,
            plaCompliance: ENV_CFG.api.plaCompliance,
            blinkingVerification: ENV_CFG.api.blinkingVerification,
            merkurSSBTIntegration: ENV_CFG.api.merkurSSBTIntegration,
        },

        params: {
            page: 1,
            count: 25
        },

        modules: allModules,
        firstModule: $filter('orderObjectBy')(allModules, 'priority'),
        allModules: allModules
    };

    settings.loginApi = {
        normal: settings.urls.api + 'admin/jwt/login_check',
        oauth: settings.urls.api + 'admin/secure_area/connect'
    };

    return settings;
}]);
;
sevenAdminShared.factory('browserService', [function () {

    /**
     * Checks if browser type/version are IE/<=9
     * @returns {boolean} -
     */

    function browserIE9OrLess() {
        var ieVersionRegex = null,
            ieVersion = null,
            isItIe = false;

        if (navigator.userAgent.indexOf('MSIE ') !== -1) {
            ieVersionRegex = /MSIE (\d+\.\d+)/;

            if (ieVersionRegex.test(navigator.userAgent)) {
                ieVersion = Number(RegExp.$1);

                if (ieVersion <= 9) {
                    isItIe = true;
                }
            }
        }

        return isItIe;
    }

    return {
        IE9OrLess: browserIE9OrLess()
    };
}]);;
(function () {
    angular
        .module("seven-admin.shared")
        .factory("ChangelogService", ChangelogService);

    ChangelogService.$inject = [
        "$http",
        "$q",
        "appSettingsSvc",
        "userInitData"
    ];

    function ChangelogService(
        $http,
        $q,
        appSettingsSvc,
        userInitData
    ) {
        var applicationName = 'seven_admin';
        var baseGravityUrl = appSettingsSvc.urls.gravityApi;
        var changelogs;
        var changelogReads = [];
        var hasUnreadChangelogs = false;

        var init = function() {
            loadChangelogs();
        };

        function getChangelogs() {
            var changelogsCategory = "changelogs";
            var url = baseGravityUrl + "/admin/articles/category/" + changelogsCategory;

            return $http.get(url, {
                cache: true,
                headers: {
                    "X-Nsft-SCD-App-Name": applicationName
                },
                ignoreLoader: "yes",
                params: {
                    pageSize: 1000
                }
            }).then(function(response) {
                return response.data.articles;
            });
        }

        function getChangelogReads() {
            var key = 'changelogsReads';
            var url = _.template('${apiBaseUrl}/settings/users/${key}')({
                apiBaseUrl: baseGravityUrl,
                uuid: userInitData.user.uuid,
                key: key
            });

            return $http.get(url, {
                cache: true,
                ignoreLoader: "yes"
            }).then(function(response) {
                if (response.data[key]) {
                  changelogReads = response.data[key];
                }
                return response.data[key];
            });
        }

        function loadChangelogs() {
            return $q.all({
                changelogs: getChangelogs(),
                changelogReads: getChangelogReads()
            }).then(function (response) {
                changelogs = attachReadData(response.changelogs, response.changelogReads);
                setUnreadChangelogs(response.changelogs);
                return changelogs;
            })
        }

        function setUnreadChangelogs(changelogs) {
            if (_.isArray(changelogs)) {
                hasUnreadChangelogs = changelogs.some(function(changelog) {
                    return changelog.unread === true;
                })
            }
        }

        function attachReadData(changelogs, changelogReads) {
            return changelogs.map(function(changelog) {
                return _.assign(changelog, {
                    unread: changelogReads
                        ? changelogReads.indexOf && changelogReads.indexOf(changelog.id) === -1
                        : true
                });
            });
        }


        function markChangelogAsRead(changelog) {
            setChangelogAsRead(changelog);
            setUnreadChangelogs(changelogs);
            saveChangelogReads()
        }

        function markAllChangelogsAsRead() {
            _.each(changelogs, function(changelog) {
                setChangelogAsRead(changelog);
            });
            setUnreadChangelogs(changelogs);
            saveChangelogReads();
        }

        function setChangelogAsRead(changelog) {
            var foundChangelog = _.find(changelogs, {'id': changelog.id});

            foundChangelog.unread = false;
            changelogReads.push(changelog.id);
        }


        function saveChangelogReads() {
            var url = baseGravityUrl + '/settings/users';

            return $http.put(url, {
                key: 'changelogsReads',
                type: 'object',
                value: changelogReads
            })
        }

        function getChangelog(changelogName) {
            var url = baseGravityUrl + "/web/articles/" + changelogName;

            return $http.get(url, {
                cache: true,
                headers: {
                    "X-Nsft-SCD-App-Name": applicationName
                },
                ignoreLoader: "yes"
            })
            .then(function(response) {
                return response.data.article;
            });
        }

        init();

        return {
            getChangelog: getChangelog,
            loadChangelogs: loadChangelogs,
            markChangelogAsRead: markChangelogAsRead,
            markAllChangelogsAsRead: markAllChangelogsAsRead,
            get changelogs() {
                return changelogs;
            },
            get hasUnreadChangelogs() {
                return hasUnreadChangelogs;
            }
        };
    }
})();
;
sevenAdminShared.factory('dataSvc', [
    '$http', 'appSettingsSvc', '$rootScope', '$filter', '$location', '$stateParams', '$state',
    function ($http, appSettingsSvc, $rootScope, $filter, $location, $stateParams, $state) {


    /**
    * Generate object containing roles info that can be used in permissions view
    * @param {Array} infoArray - Array containing raw info about roles
    * @returns {Object} roles - Formatted roles object
     **/
    function generateValidRoles (infoArray) {

        var roles = {};
        angular.forEach(infoArray, function (val, key) {
            roles[val.id] = {};
            roles[val.id].roles = val.roles;
            roles[val.id].name = val.translation;
        });
        return roles;

    }


    /**;
    * Generate filtered date string by provided arguments
    * @param {number} hour
    * @param {number} minute
    * @param {number} second
    * @param {number} year
    * @param {number} month
    * @param {number} day
    * @param {number} type
    * @returns {String} date
    **/
    function generateDate (hour, minute, second, year, month, day, type) {
        var today = new Date();

        year = year || 0;
        month = month || 0;
        day = day || 0;

        if (type === 'forward') {
            year = parseInt(year) * (-1);
            month = parseInt(month) * (-1);
            day = parseInt(day) * (-1);
        }

        var date = new Date( today.getFullYear() - year, today.getMonth() - month, today.getDate() - day, hour, minute, second );

        return $filter('date')(date, 'yyyy-MM-dd*HH:mm:ss');
    }


    function loadColumns (columns, linkKey) {
        var localColumns = JSON.parse(localStorage.getItem(linkKey)),
            columnsArr = Object.keys(columns),
            columnsChanged = false;

        // Reset columns if object length is different
        if (columns && localColumns && Object.keys(localColumns).length !== Object.keys(columns).length || !localColumns) {
            return columns;
        }

        angular.forEach( localColumns, function (val, key){
            // Reset columns if column key is changed
            if(columnsArr.indexOf(key) === -1) {
                columnsChanged = true;
            }
            // Reset columns if column type is changed
            if (columns[key] && val.type !== columns[key].type) {
                columnsChanged = true;
            }
        });

        if (localColumns !== null) {
            return columnsChanged ? columns : localColumns;
        }
    }
    /**
     * Generates key name for saving columns to local storage
     * Strategies: expandwihtab - add tab name to key
     *             strip        - strip last path part after slash
     * @return {String}
     */
    function getLinkKeys(expandParameterName) {
        var linkKeys = $location.$$path;
        var pathArray = [];

        switch ($stateParams.columnSaveStrategy) {
            case 'expandwithtab':
                linkKeys += '-' + $location.search()['tab'];
                break;
            case 'expandWithUrlParameter':
                linkKeys += '-' + $location.search()[expandParameterName];
                break;
            case 'strip':
                pathArray = linkKeys.split('/');
                pathArray.pop();
                linkKeys = pathArray.join('/');
                break;
        }

        return linkKeys;
    }

	return {
        getLinkKeys: getLinkKeys,


        /**
         * Get list of company administrators
         * @returns {HttpPromise}
        **/
        getCompanyAdministrators: function () {
            return $http.get(appSettingsSvc.urls.api + '/admin/users/company_admins.json')
        },

        /**
        * Get list of all countries
        * @returns {HttpPromise}  data
        **/
        getCountries: function () {
            return $http.get(appSettingsSvc.urls.api + '/common/countries.json');
        },


        /**
        * Get list of all currencies supported in platform
        * @returns {HttpPromise} data
        */
        getCurrencies: function () {
            return $http.get(appSettingsSvc.urls.api + '/common/currencies.json');
        },



        /**
         * Get list of genders
         * @returns {HttpPromise} data
         */
        getGenders: function () {
            return $http.get(appSettingsSvc.urls.api + '/common/genders.json');
        },



        /**
        * Get list of all available languages supported in platform
        * @returns {HttpPromise} data
        */
        getLocales: function () {
            return $http.get(appSettingsSvc.urls.api + '/common/locales.json');
        },

        getTaxPoliciesForCountry: function (params) {
          return $http.get(appSettingsSvc.urls.api + '/common/tax-authority.json', {params: params}).then(function (response) {
              return response;
          })
        },


        /**
         * Get list of all company betshops
         * @returns {Array}
         */
        getBetshops: function() {
            var url = appSettingsSvc.urls.api + '/admin/betshops/type/frontedparsed.json';

            return $http({
                url: url,
                method: 'GET'
            }).then(function (response) {
                return response;
            }, function (error) {
                return error;
            });

        },


        /**
        * Get list of all time-zones
        * @returns {Object} backend response
        */
        getTimezones: function () {
            var url = appSettingsSvc.urls.api + '/common/timezones.json';

            return $http.get(url)
                .then(function (response) {
                    return response;
                }, function (response) {
                    return response;
                });
        },


        /**
        * Get list of all supported date formats that can be displayed in admin
        * @returns {Object} backend response
        */
        getDateFormats: function () {
            var url = appSettingsSvc.urls.api + '/common/dateformats.json';

            return $http.get(url)
                .then(function (response) {
                    return response;
                }, function (response) {
                    return response;
                });
        },

        /**
        * Get instances of products to set configuration for it.
        * Used in operator configuration, betshop configuration and betshop group configuration
        * @returns {HttpPromise} backend response
        */
        getCompanyProducts: function() {
            var url = appSettingsSvc.urls.api + "/admin/company-product-versions.json";

            return $http.get(url);
        },


        /**
        * Check for differences in local storage columns and backend response columns for main grid
        * @param {number} columns
        */
        checkLocalStorage: function (columns) {
            var linkKey = getLinkKeys();

            return loadColumns(columns, linkKey);
        },


        /**
        * Generate date by year, month and day and set time to 00:00:00
        * @param {number} year
        * @param {number} month
        * @param {number} day
        * @param {'forward'} [type] - Generate date in the future, by default numbers for date
        */
        getStartDate: function (year, month, day, type) {
            return generateDate(0, 0, 0, year, month, day, type);
        },


       /**
       * Generate date by year, month and day and set time to 23:59:59
       * @param {number} year
       * @param {number} month
       * @param {number} day
       */
        getEndDate: function (year, month, day, type) {
            return generateDate(23, 59, 59, year, month, day, type);
        },


        /**
        * Get specific info about single product by cpvUuid
        * @param {string} cpvUUid
        * @returns {Object} response
        * @returns {Object} error
        */
        getProductInfo: function (cpvUUid) {
            var url = appSettingsSvc.urls.api + '/admin/productaccounts/' + cpvUUid + '.json';

            return $http.get(url)
                .then(function (response) {
                    return response;
                }, function (error) {
                    return error;
                });

        },


        /**
        * Get backend defined date and time values
        * @returns {Object} response
        * @returns {Object} error
        */
        getDateTimeInfo: function () {
            var url = appSettingsSvc.urls.api + '/common/datetime/info.json';

            return $http.get(url)
                .then(function (response) {
                    return response;
                }, function (error) {
                    return error;
            });
        },


        /**
        * Show or hide action bar in grid according to provided visibility
        * @param {boolean} visibility
        * @returns {}
        */
        setActionBarVisibility: function (visibility) {
            var element = angular.element(document.getElementById('grid-action-bar'));
            element.removeClass(visibility ? 'hidden' : 'visible').addClass(visibility ? 'visible' : 'hidden');
        },


        /**
         * Check grid items for last selected row id. If id is found, return row $index key, otherwise set it to 0
         * @param {Array} data - Array of grid data
         * @param {Number|String} $key - Key for object property. Will be different in some controllers, so must be provided
         * @param {*} id - Last selected row id
         * @returns {number}
         */
        checkSelectedKey: function (data, $key, id) {
            var key = 0;

            for (var i = 0; data && i < data.length; i++) {
                if (data[i][$key] === id) {
                    return i;
                }
            }

            return key;
        },

        /**
         * Check grid row details object for last selected row id. If id is found, return row index, otherwise set it to 0
         * @param {Array} data - Array of grid data
         * @param {Number|String} $key - Key for object property. Will be different in some controllers, so must be provided
         * @param {*} id - Last selected row id
         * @returns {number}
         */
        checkSelectedDetailsKey: function (data, $key, id) {
            var key = 0;

            for (var i = 0; i < data.length; i++) {
                // search inside row.details
                if (data[i].details[$key] === id) {
                    return i;
                }
                //key = data[i][$key] === id;
            }

            return key;
        },

        /**
        * Highlight main table row by it's row key
        * @param {String} rowKey
        */
        successRowHighlight: function (rowKey) {
            var elem = document.getElementById('main-table-row-' + rowKey);

            elem.classList.add('row-highlighted');
            setTimeout(function() {
                elem.classList.remove('row-highlighted');
            }, 700);
        },

        /**
         * Highlight main table row by it's row key
         * @param {String} rowKey
         */
        errorRowHighlight: function (rowKey) {
            var elem = document.getElementById('main-table-row-' + rowKey);

            elem.classList.add('error-row-highlighted');
            setTimeout(function() {
                elem.classList.remove('error-row-highlighted');
            }, 700);
        },

        changeTableWidth: function (mainTableId, sideTableId, mainClass, sideClass) {
            var mainTable = document.getElementById(mainTableId),
                sideTable = document.getElementById(sideTableId),
                classVal;

            if (!mainTable || !sideTable) return;

            for (var i = 0; i < mainTable.classList.length; i++) {
                classVal = mainTable.classList[i];
                if (classVal.indexOf('col-') !== -1){
                    mainTable.classList.remove(classVal);
                }
            }

            for (var j = 0; j < sideTable.classList.length; j++) {
                classVal = sideTable.classList[j];
                if (classVal.indexOf('col-') !== -1){
                    sideTable.classList.remove(classVal);
                }
            }

            mainTable.classList.add(mainClass);
            sideTable.classList.add(sideClass);
        },

        /**
         * Generate RFC4122 version 4 compliant uuid
         * @returns {string}
         */
        uuidv4: function() {
            return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function(c) {
                var r = Math.random() * 16 | 0, v = c == 'x' ? r : (r & 0x3 | 0x8);
                return v.toString(16);
            });
        }
    };

}]);
;
(function () {
    angular
        .module('seven-admin.shared')
        .service('FavoritesService', FavoritesService);

    FavoritesService.$inject = ['$http', 'appSettingsSvc', 'userInitData'];

    function FavoritesService($http, appSettingsSvc, userInitData) {
        var _favorites = [];
        var companyId = userInitData.currentCompany && userInitData.currentCompany.id;
        var favoritesKey = companyId ?
            _.template('admin.cID${companyId}_menu_favorites')({companyId: companyId}):
            _.template('admin.menu-favorites')();

        var getFavorites = function () {
            var url = _.template('${apiBaseUrl}/settings/users/${key}')({
                apiBaseUrl: appSettingsSvc.urls.gravityApi,
                key: favoritesKey
            });

            return $http.get(url).then(function (response) {
                return response.data;
            });
        };

        var init = function () {
            getFavorites().then(function (data) {
                if (!_.isEmpty(data)) {
                    _.each(_favorites, function () {
                        _favorites.pop()
                    });

                    _.each(data[favoritesKey], function (favorite) {
                        _favorites.push(favorite);
                    })
                }
            })
        };

        init();

        return {
            toggleFavorite: function (item) {
                var index = _.findIndex(_favorites, function (favorite) {
                    return _.isEqual(_.omit(favorite, '$$hashKey'), item);
                });
                if (index !== -1) {
                    _favorites.splice(index, 1);
                } else {
                    _favorites.push(item);
                }

                this.saveFavorites();
            },

            removeFavorite: function(item) {
                var index = _.findIndex(_favorites, item);

                if (index !== -1) {
                    _favorites.splice(index, 1)
                }

                this.saveFavorites();
            },

            saveFavorites: function () {
                var url = _.template('${apiBaseUrl}/settings/users')({apiBaseUrl: appSettingsSvc.urls.gravityApi});

                return $http.put(url, {
                    key: favoritesKey,
                    value: _favorites,
                    type: 'object'
                })

            },

           favorites: _favorites
       }
    }
}());
;
/**
 * Get current url value
 * Get columns stored in local storage by current url value
 * @type {{getCurrentLocation: LocationMixin.getCurrentLocation, getLocalColumns: LocationMixin.getLocalColumns}}
 */
var LocationMixin = {
    getCurrentLocation: function () {
        var a = window.location.hash,
            subVal = a.indexOf('?') !== -1 ? a.indexOf('?') : a.length;
        return a.substring(1, subVal);
    },

    getLocalColumns: function (storageKey) {
        var a = storageKey || this.getCurrentLocation();
        return JSON.parse(localStorage.getItem(a));
    }
};


/**
 * Set all translations
 * Get translation by key
 * @type {{}}
 */
var translations = {};
var TranslateMixin = {

    setTranslation: function (values) {
        translations = values;
    },

    // Global translate method
    translate: function (key, value) {
        // Return provided key if there is not translation
        if (typeof translations[key] === 'undefined') return key;

        // Dynamic values in translations
        // Replace {{ }} brackets with provided value
        if (typeof value !== 'undefined') {
            var tr = angular.copy(translations[key]),
                fIndex = tr.indexOf('{'),
                lIndex = tr.lastIndexOf('}');

            if (fIndex !== -1 && lIndex !== -1) {
                return tr.replace(tr.substring(fIndex, lIndex + 1), value);
            }
        }

        return translations[key];
    }
};

/**
 * Methods for expandable table in Prematch offer selection and Prematch outrights selection
 * @type {{unsavedSelectionChanges: {}, showExpandTable: ExpendableTable.showExpandTable, hideExpandTable: ExpendableTable.hideExpandTable, processSelectionChange: ExpendableTable.processSelectionChange, checkSelectionChanges: ExpendableTable.checkSelectionChanges, saveMatchSettings: ExpendableTable.saveMatchSettings, saveTournamentSettings: ExpendableTable.saveTournamentSettings, updateExpandTableMatches: ExpendableTable.updateExpandTableMatches}}
 */
var ExpendableTable = {

    unsavedSelectionChanges: {},

    // Display expandable table
    showExpandTable: function () {
        var expandTable = document.getElementById('prematch-offer-expand-table');
        if (!expandTable) return;
        expandTable.classList.remove('hidden');
    },

    // Hide expandable table
    hideExpandTable: function () {
        var expandTable = document.getElementById('prematch-offer-expand-table');
        if (!expandTable) return;
        expandTable.classList.add('hidden');
    },


    /**
     * @param selections <- current selections state
     * @param selectedIndex <- indexOf change ('selection_' + selectedIndex)
     * @param tournamentId <- used when saving selections <- passed as param to saveProcessedChanges
     * @param typeOfSettings == 'matchSettings' || 'tournamentSettings'
     * @param matchId <- this param is only passed when changing match settings (undefined on 'tournamentSettings')
     */
    processSelectionChange: function(selections, selectedIndex, tournamentId, typeOfSettings, matchId) {
        var processedChanges = {
            selections: selections,
            changes: []
        };

        if (matchId !== undefined && typeOfSettings == 'matchSettings') {
            processedChanges['match_id'] = matchId;
        }
        processedChanges['changes'] = selectedIndex === 0 ? Object.keys(selections) : [Object.keys(selections)[selectedIndex-1]];
        typeOfSettings === 'matchSettings' ? this.saveMatchSettings(processedChanges, tournamentId) : this.saveTournamentSettings(processedChanges, tournamentId);
    },

    /**
     * Check if there is any unsaved data
     * If not, create new object for unsaved data
     * @param id
     */
    checkSelectionChanges: function (id) {
        if (!this.unsavedSelectionChanges[id]) {
            this.unsavedSelectionChanges[id] = {
                'tournamentSettings': {
                    'changes': []
                },
                'matchSettings': {}
            };
        }
    },

    /**
     * Check changes in selection
     * Set params
     * @param data
     * @param tournamentId
     */
    saveMatchSettings: function (data, tournamentId) {

        this.checkSelectionChanges(tournamentId);

        var matchId = data.match_id;
        delete data.match_id;
        this.unsavedSelectionChanges[tournamentId]['matchSettings'][matchId] = data;
    },


    saveTournamentSettings: function (data, tournamentId) {

        this.checkSelectionChanges(tournamentId);

        var matchSettings = this.unsavedSelectionChanges[tournamentId]['matchSettings'],
            tournamentSettings = this.unsavedSelectionChanges[tournamentId]['tournamentSettings'];

        if (Object.keys(matchSettings).length > 0) {
            Object.keys(matchSettings).map(function(match) {
                if (data.changes.length === 4) {
                    matchSettings[match]['selections'] = data['selections'];
                } else {
                    matchSettings[match]['selections'][ data.changes[0] ] = data['selections'][ data.changes[0] ];
                }
            });
        }
        if (data['changes'].length === 4) {
            tournamentSettings['changes'] = data.changes;
        } else if (tournamentSettings['changes'].indexOf( data.changes[0] ) === -1) {
            tournamentSettings['changes'].push(data['changes'][0]);
        }
        tournamentSettings['selections'] = data['selections'];
    },


    /**
     *
     * @param expandData <= data(matches) loaded to expand table
     * @param tournamentId
     * @returns { returns updated 'expandData' object with current(unsaved) changes}
     */
    updateExpandTableMatches: function(expandData, tournamentId) {
        if (!this.unsavedSelectionChanges[tournamentId]) return expandData;

        var updatedExpandData = _.clone(expandData),
            matchSettings = this.unsavedSelectionChanges[tournamentId]['matchSettings'],
            tournamentSettings = this.unsavedSelectionChanges[tournamentId]['tournamentSettings'];

        updatedExpandData.data.map(function(match) {
            if (matchSettings[match.id]) {
                match['selections'] = matchSettings[match.id]['selections'];
            } else if (tournamentSettings['changes'].length > 0) {
                tournamentSettings['changes'].map(function(selection) {
                    match['selections'][selection] = tournamentSettings['selections'][selection];
                })
            }
        });
        return updatedExpandData;
    }
};


var CustomSelectionMixin = {
    /**
     * Filter provided array with provided value
     * @param data - Array to filter
     * @param value - Value to filter
     * @param key - Key in array object to filter
     */
    filterContentByInputValue: function (data, value, key) {
        var val = null,
            searchValues = [];

        for (var i = 0; i < data.length; i++) {
            val = data[i][key].toLowerCase();
            if (val.indexOf(value) !== -1) {
                searchValues.push(data[i]);
            }
        }
        return searchValues;
    },

    getRowIndexById: function (data, id) {
        var tmpRow = 0;

        for (var i = 0; data && i < data.length; i++) {
            if (data[i].id === id) {
                tmpRow = i;
            }
        }
        return tmpRow;
    }
};
;
sevenAdminShared.service('taxAuthority', [
    '$http',
    '$q',
    'Blob',
    'ENV_CFG',
    'FileSaver',
    'tokenAuthService',
    'userInitData',
    'appSettingsSvc',
function (
    $http,
    $q,
    Blob,
    ENV_CFG,
    FileSaver,
    tokenAuthService,
    userInitData,
    appSettingsSvc,
) {
    var companyUuid = (userInitData.currentCompany && userInitData.currentCompany.uuid);
    var basePolishTaxAuthorityUrl = _.get(ENV_CFG, 'api.taxAuthority.tax_authority_pol');
    // LutrijaBiH has different tax authority service endpoint
    var baseFbihTaxAuthorityUrl = [
        '978e4128-f042-496e-8f61-2b166793a8a5',
        'd4ccd338-5093-4c6e-9a42-a769b13f7c2d'
    ].includes(companyUuid) ?
        'https://tax-authority-lutrijabih.ba.nsoftcdn.com:8443' :
        _.get(ENV_CFG, 'api.taxAuthority.tax_authority_bih');
    var baseMontenegrinTaxAuthorityUrl = _.get(ENV_CFG, 'api.taxAuthority.tax_authority_mne');
    var baseRomanianTaxAuthorityUrl = _.get(ENV_CFG, 'api.taxAuthority.tax_authority_rom');
    var baseSerbianTaxAuthorityUrl = _.get(ENV_CFG, 'api.taxAuthority.tax_authority_srb');
    var baseBiHRSTaxAuthorityUrl = _.get(ENV_CFG, 'api.taxAuthority.tax_authority_bih_rs')
    var baseMneV2TaxAuthorityUrl = _.get(ENV_CFG, 'api.taxAuthority.tax_authority_mne_v2')
    var mandatoryPolishTaxAuthorityHeaders = {
        'X-NSFT-SEVEN-COMPANY-UUID': companyUuid
    };
    var mandatoryBiHRSTTaxAuthorityHeaders = {
        'X-NSFT-SEVEN-TENANT-ID': companyUuid
    };

    var mapResponseData = function (response) {
        return response.data;
    }

    return  {
        /** Get Romanian tax authority company settings
         *
         * @param {String} uuid - Company uuid
         * @returns {HttpPromise}
         */
        getRomanianCompanyTaxSettings: function (uuid) {
            return $http.get(baseRomanianTaxAuthorityUrl + '/api/v1/companies/' + uuid)
        },

        /** Save Romanian tax authority company settings
         *
         * @param {Object} data
         * @returns {HttpPromise}
         */
        saveRomanianCompanyTaxSettings: function (data) {
            return $http.put(baseRomanianTaxAuthorityUrl + '/api/v1/company_settings', data)
        },

        /** Save sensitive Romanian tax authority company settings
         * @function
         * @name saveRomanianCompanySensitiveTaxSettings
         * @memberOf taxAuthority
         * @param {Object} data
         * @param {string} data.companyUuid - Company uuid
         * @param {boolean} [data.cnpEnabled] - Is CNP turned on
         * @param {number} [data.cnpLimit] - Amount after which CNP needs to be used
         * @returns {HttpPromise}
         */
        saveRomanianCompanySensitiveTaxSettings: function(data) {
            const url = baseRomanianTaxAuthorityUrl + '/api/v1/cnp_settings';
            const settings = Object.assign({}, data, {companyUuid: companyUuid});

            return $http.put(url, settings);
        },

        /** Get payouts waiting to be approved/declined
         *
         * @param uuid - Company uuid
         * @return {HttpPromise}
         */
        getPendingPayouts: function (uuid) {
            return $http.get(baseRomanianTaxAuthorityUrl + '/api/v1/foreign_transaction/pending_payouts', {
                params: {
                    uuid: uuid
                }
            })
        },

        /**
         *
         * @param companyUuid
         * @param referenceNumber -
         * @return {HttpPromise}
         */
        approvePendingPayout: function (companyUuid, referenceNumber) {
            return $http.put(baseRomanianTaxAuthorityUrl + '/api/v1/foreign_transaction/approve', {
                companyUuid: companyUuid,
                referenceNumber: referenceNumber
            })
        },

        /**
         *
         * @param companyUuid
         * @param referenceNumber
         * @return {HttpPromise}
         */
        declinePendingPayout: function (companyUuid, referenceNumber) {
            return $http.put(baseRomanianTaxAuthorityUrl + '/api/v1/foreign_transaction/decline', {
                companyUuid: companyUuid,
                referenceNumber: referenceNumber})
        },

        /**
         *
         * @param count
         * @param page
         * @param [search]
         * @returns {HttpPromise}
         */
        getPlayers: function (count, page, search) {
            return $http.get(baseRomanianTaxAuthorityUrl + '/api/v1/players', {
                params: {
                    uuid: companyUuid,
                    count: count,
                    page: page,
                    search: search
                }
            })
        },

        savePlayerData: function (data) {
            return $http.post(baseRomanianTaxAuthorityUrl + '/api/v1/players', data);
        },

        bih: {
            getLocations: function () {
                return $http.get(baseFbihTaxAuthorityUrl + '/api/v1/location/locations', {params: {uuid: companyUuid}})
                    .then(function (response) {
                        return response.data;
                    })
            },
            editLocationJIB: function (location) {
                var url = baseFbihTaxAuthorityUrl + '/api/v1/location/location';

                return $http({
                    url: url,
                    method: 'PATCH',
                    data: {
                        jib: location.jib,
                        companyUuid: companyUuid,
                        uuid: location.uuid,
                        externalCausationId: null
                    }
                })
            },

            getSupportedProducts: function () {
                var url = baseFbihTaxAuthorityUrl + '/api/v1/company/supported-products';

                return $http.get(url).then(function (response) {
                    return response.data;
                });
            },

            generateMonthlyReportUrl: function (exportParams) {
                var urlTemplate = _.template('${baseFbihTaxAuthorityUrl}/api/v1/report/monthly/${companyUuid}?gameType=${gameType}&reportMonth=${reportMonth}&dateOfSubmission=${dateOfSubmission}&unmc=${unmc}&subjectName=${subjectName}&subjectLocation=${subjectLocation}');

                return urlTemplate({
                    baseFbihTaxAuthorityUrl: baseFbihTaxAuthorityUrl,
                    companyUuid: companyUuid,
                    gameType: exportParams.reportType,
                    reportMonth: exportParams.reportMonth,
                    dateOfSubmission: moment(exportParams.dateOfSubmission).format('YYYY-MM-DD'),
                    unmc: exportParams.unmc,
                    subjectLocation: exportParams.subjectLocation,
                    subjectName: exportParams.subjectName
                });
            },

            downloadMonthlyReport: function (exportUrl) {
                return $http.get(exportUrl).then(function (response) {
                    var contentType = response.headers('Content-Type');
                    var fileName = response.headers('Content-Disposition').replace('attachment;filename=','');
                    var data = new Blob([response.data], {type: contentType});

                    FileSaver.saveAs(data, fileName);
                })
            },

            getReportSummary: function (gameType) {
                var url = baseFbihTaxAuthorityUrl + '/api/v1/report/monthly/summary/' + companyUuid;

                return $http({
                    url: url,
                    method: 'GET',
                    params: {
                        gameType: gameType
                    }
                }).then(function (response) {
                    return response.data;
                });
            }
        },
        bih_rs: {
            getLocations: function (queryParams) {
                const url = `${baseBiHRSTaxAuthorityUrl}/tenants/${companyUuid}/locations`;
                const params = _.assign({}, queryParams, {
                    size: queryParams.size || queryParams.count,
                    count: null,
                    direction: null,
                    sort: (queryParams.direction && queryParams.sort && `${queryParams.direction}|${queryParams.sort}`) || null,
                });

                return $http({
                    method: 'GET',
                    url: url,
                    params: params,
                    headers: mandatoryBiHRSTTaxAuthorityHeaders,
                }).then(response => response.data)
            },
            getLocation: function (uuid) {
                return this.getLocations({
                    ids: uuid,
                    page: 1,
                    size: 1,
                }).then((response) => _.get(response, 'data[0]'));
            },
            getLocationDevices: function (uuid) {
                const ARBITRARY_LARGE_PAGE_SIZE = 1000;

                return this.getDevices({
                    locationIds: uuid,
                    page: 1,
                    size: ARBITRARY_LARGE_PAGE_SIZE,
                }).then(({data, pagination: {page, pages}}) => {
                    if (page === pages) {
                        return data;
                    }

                    const start = page + 1;
                    const stop = pages;
                    const deviceRequestsPromises = Array
                        .from(
                            {length: (stop - start) + 1},
                            (_, i) => start + i)
                        .map((page) =>
                            this.getDevices({
                                locationIds: uuid,
                                page: page,
                                size: ARBITRARY_LARGE_PAGE_SIZE,
                            }));

                    return $q.all(deviceRequestsPromises)
                        .then(responses => data.concat(...responses.map(r => r.data)))
                })
            },
            getDevices: function (queryParams) {
                const url = `${baseBiHRSTaxAuthorityUrl}/tenants/${companyUuid}/devices`;
                const params = _.assign({}, queryParams, {
                    size: queryParams.size || queryParams.count,
                    count: null
                });

                return $http({
                    method: 'GET',
                    url: url,
                    params: params,
                    headers: mandatoryBiHRSTTaxAuthorityHeaders,
                }).then(response => response.data);
            },
            updateLocation: function (locationData, locationUUID) {
                const url = `${baseBiHRSTaxAuthorityUrl}/tenants/${companyUuid}/locations/${locationUUID}`;

                return $http({
                    method: 'PATCH',
                    url: url,
                    data: locationData,
                    headers: mandatoryBiHRSTTaxAuthorityHeaders,
                });
            },
            /**
             * @name updateDevices
             * @param {Array<{id: string, deviceCode: string}>} devices
             * @returns {Promise}
             */
            updateDevices: function (devices) {
               const url = `${baseBiHRSTaxAuthorityUrl}/tenants/${companyUuid}/bulk/devices`;

               return $http({
                   method: 'POST',
                   url: url,
                   data: {
                       devices,
                   },
                   headers: mandatoryBiHRSTTaxAuthorityHeaders,
               });
            },
        },
        pol: {
            getTransactions: function (params) {
                var url = basePolishTaxAuthorityUrl + '/api/v1/transaction';
                return $http({
                    url: url,
                    method: 'GET',
                    params: params,
                    headers: mandatoryPolishTaxAuthorityHeaders
                }).then(function (response) {
                    return response.data;
                });
            },
            getExportLinks: function (params, formats) {
                if (_.isEmpty(params)) return null;

                var url = basePolishTaxAuthorityUrl + '/api/v1/transaction/export?';
                var exportLinks = {};
                var additionalParams = {
                    token: tokenAuthService.getAccessToken(true),
                    companyUuid: companyUuid
                };

                _.each(formats, function (format) {
                    var link = url;

                    _.each(_.assign({type: format}, params, additionalParams), function (value, key) {
                        link+= key + '=' + value + '&'
                    });

                    exportLinks[format] = link;
                });

                return exportLinks;
            }
        },

        rom: {
            getPayoutTransactions: function (params) {
                var url = baseRomanianTaxAuthorityUrl + '/api/v1/payouts.json';
                return $http({
                    url: url,
                    method: 'GET',
                    params: params
                }).then(function (response) {
                    return response;
                });
            },

            getHighPayoutWinnings: function (params) {
                var url = baseRomanianTaxAuthorityUrl + '/api/v1/high-payouts.json'

                return $http({
                    url: url,
                    method: 'GET',
                    params: params
                }).then(function (response) {
                    return response;
                });
            }
        },

        mne: {
            getTerminals: function(params) {
                var url = baseMontenegrinTaxAuthorityUrl + '/terminals';
                var queryParams = _.assign({ uuid: companyUuid }, params);

                return $http.get(url, {
                    params: queryParams
                }).then(function(response) {
                    return response.data;
                });
            },
            setTerminalCode: function(data) {
                var url = baseMontenegrinTaxAuthorityUrl + '/terminal.json';

                return $http.patch(url, data);
            },
            setTerminalSerialNumber: function(data) {
                var url = baseMontenegrinTaxAuthorityUrl + '/terminal/serial-number.json';

                return $http.patch(url, data);
            }
        },

        cuw: {
            getTaxAuthorityDetails: function(companyId) {
                var url = appSettingsSvc.urls.api + '/curacao-tax/tenants/' + companyId + '/configs';

                return $http.get(url)
                    .then(function (response){
                        return response;
                    });
            },

            saveTaxAuthorityDetails: function(data, companyId) {
                var url = appSettingsSvc.urls.api + '/curacao-tax/tenants/' + companyId + '/configs';

                return $http({
                    url: url,
                    method: 'PUT',
                    data: data
                }).then(function (response){
                    return response;
                });
            }
        },

        srb: {
            _mapDeviceReportParams: function (queryParams) {
                var GRID_FILTER_DATE_FORMAT = "YYYY-MM-DD*HH:mm:ss";
                var DEVICE_REPORT_DATE_FORMAT = 'YYYY-MM-DD';

                return  _.assign({}, queryParams, {
                    size: queryParams.count,
                    count: null,
                    startDate: moment(queryParams.startDate, GRID_FILTER_DATE_FORMAT).format(DEVICE_REPORT_DATE_FORMAT),
                    endDate: moment(queryParams.endDate, GRID_FILTER_DATE_FORMAT).format(DEVICE_REPORT_DATE_FORMAT),
                });
            },
            getLocations: function (filters) {
                var params = {
                    page: filters.page,
                    size: filters.count
                };

                if (filters.search) params.search = filters.search;

                return $http.get(
                    baseSerbianTaxAuthorityUrl + '/api/admin/v1/betshops',
                    {
                        params: params
                    })
                    .then(function (response) {
                        return response.data;
                    });
            },
            getLocationDetails: function (locationId) {
                return $http.get(
                    baseSerbianTaxAuthorityUrl + '/api/admin/v1/betshops/' + locationId
                ).then(function (response) {
                    return response.data;
                });
            },
            updateLocationDetails: function (payload) {
                return $http.put(
                    baseSerbianTaxAuthorityUrl + '/api/admin/v1/betshops/' + payload.id,
                    payload
                ).then(function (response) {
                    return response.data;
                });
            },
            getDeviceReportData: function (queryParams) {
                var url = `${baseSerbianTaxAuthorityUrl}/api/admin/v1/reports`;
                var params = this._mapDeviceReportParams(queryParams);

                return $http({
                    url: url,
                    method: 'GET',
                    params: params,
                    headers: {
                        'X-NSFT-ACCOUNT-ID': companyUuid
                    },
                    canceler: 'getDeviceReportData'
                }).then(
                    mapResponseData
                );
            },
            getDeviceReportFilters: function () {
                var url = `${baseSerbianTaxAuthorityUrl}/api/admin/v1/report-filters`;

                return $http({
                    url: url,
                    method: 'GET',
                    headers: {
                        'X-NSFT-ACCOUNT-ID': companyUuid
                    }
                }).then(
                    mapResponseData
                )
            },
            getDeviceReport: function (filters) {
                return $q.all({
                    report: this.getDeviceReportData(filters),
                    filters: this.getDeviceReportFilters()
                })
            },
            exportDeviceReport: function (exportParams) {
                var url = `${baseSerbianTaxAuthorityUrl}/api/admin/v1/reports/${exportParams.format}`;
                var queryParams = Object.fromEntries(new URLSearchParams(exportParams.filtersUrlFragment));
                var params = this._mapDeviceReportParams(queryParams);

                return $http({
                    url: url,
                    method: 'GET',
                    params: params,
                    responseType: 'blob',
                    headers: {
                        'X-NSFT-ACCOUNT-ID': companyUuid
                    }
                }).then(function (response) {
                    var contentType = response.headers('Content-Type');
                    var contentDisposition = response.headers('Content-Disposition');
                    var fileNameRegex = /filename="(.*)"/;
                    var fileName = (contentDisposition && contentDisposition.match(fileNameRegex)[1]);
                    var data = new Blob([response.data], { type: contentType });

                    FileSaver.saveAs(data, fileName);
                })
            }
        },
        mne_v2: {
            getLocations: function (filters) {
                var url = `${baseMneV2TaxAuthorityUrl}/api/admin/v1/betshops`;

                var params = {
                    page: filters.page,
                    size: filters.count
                };

                if (filters.search) params.search = filters.search;

                return $http
                .get(url, {
                  params: params,
                })
                .then(function (response) {
                  return response.data;
                });
            },
            getLocationDetails: function (locationId) {
                var url = `${baseMneV2TaxAuthorityUrl}/api/admin/v1/betshops/${locationId}`;

                return $http.get(url).then(function (response) {
                    return response.data;
                  });
            },
            updateLocationDetails: function (payload) {
                var url = `${baseMneV2TaxAuthorityUrl}/api/admin/v1/betshops/${payload.id}`;

                return $http.put(url, payload).then(function (response) {
                    return response.data;
                  });
            },
        }
    }
}]);
;
sevenAdminShared.factory('userSvc', ['$rootScope', '$http', 'appSettingsSvc', 'userInitData', function ($rootScope, $http, appSettingsSvc, userInitData) {
	function getModules() {

		var modules = userInitData.clientAppModules,
		modulesList = ['DASHBOARD'];

		angular.forEach(modules, function (module) {
			modulesList.push(module.id);
		});

		return modulesList;
	}

	function getSubModules() {
		var modules = userInitData.clientAppModules,
			subModulesList = [];

		angular.forEach(modules, function (module) {
			angular.forEach(module.submodules, function (submodule) {
				subModulesList.push(submodule.id);
			})
		});

		return subModulesList;
	}

	function getSubModulesForModule(moduleName) {
		var modules = userInitData.clientAppModules,
			subModulesList = [];

		angular.forEach(modules, function (module) {
			if (module.id == moduleName) {
				angular.forEach(module.submodules, function (submodule) {
					subModulesList.push(submodule.id);
				});
			}
		});

		return subModulesList;
	}

	/**
	 * @function
	 * @memberOf userSvc
	 * @name hasRoles
	 * @param {Array.<string>} roles
	 * @return {boolean}
	 */
	function hasRoles(roles) {
		return _.every(roles, function (role) {
			return userInitData.roles.includes(role);
		})
	}

	/**
	 * @function
	 * @memberOf userSvc
	 * @name  hasAnyRole
	 * @param {Array.<string>} roles
	 * @return {boolean}
	 */
	function hasAnyRole(roles) {
		return _.some(roles, function (role) {
			return userInitData.roles.includes(role);
		})
	}

	return {
		userDetails: userInitData.user,
		userModules: getModules(), // list of modules
		userModulesData: userInitData.modules,
		userSubModules: getSubModules(), // list of submodules
		userSubModulesForModule: function (module) {
			return getSubModulesForModule(module); // list of submodules
		},
		userSubModulesData: userInitData.modules,
		hasRoles: hasRoles,
		hasAnyRole: hasAnyRole,
	}
}]);
;
/**
 * @ngdoc directive
 * @name enterKey
 *
 * @description
 * The enterKey directive allows you to specify custom behavior when
 * an element is enter key is pressed on focused element
 *
 * @element ANY
 * @param {expression}  to evaluate upon pressing enter key on focused element
 *
 */
sevenAdminShared.directive('enterKey', [function () {
    return function (scope, element, attrs) {
        element.bind("keydown keypress", function (event) {
            if (event.which === 13) {
                scope.$apply(function () {
                    scope.$eval(attrs.enterKey);
                });

                event.preventDefault();
            }
        });
    };
}]);;
app.service('gatewayService', [
    '$location',
    '$stateParams',
    'ENV_CFG', 
    'userInitData', 
    'tokenAuthService', 
    function (
        $location,
        $stateParams,
        ENV_CFG, 
        userInitData, 
        tokenAuthService
    ) {
        var gateway = window.gravity.gateway.master,
            prefix = '/product-mgmt',
            getCurrentRoute = function () {
                return $location.path().replace(prefix, '');
            },
            getCurrentRouteV2 = function () {
                var stateHasPath = $stateParams.hasOwnProperty('integratedPath');
                var locationPath = $location.path();

                if (stateHasPath) {
                    return $stateParams.integratedPath;
                } else {
                    return locationPath.slice(locationPath.indexOf('/', 1));
                }
            };

        return {
            /**
             * @name getLoadPayload
             * @param {Object} [additionalData] - Append or override load data
             * @returns {Object}
             */
            getLoadPayload: function(additionalData) {
                var user = userInitData.user;
                var tenant = userInitData.currentCompany;
                var loadData =  {
                    config: { // deprecated
                        cpvUuid: $stateParams.productId, // use account.linkId
                        company: {
                            timezoneOffset: _.get(userInitData, 'currentCompany.timezone.tzOffset')
                        }
                    },
                    companyUuid: this.getAccount().id, // deprecated
                    currency: {
                        symbol: tenant.currency
                    },
                    dataCenter: ENV_CFG.dc, // deprecated
                    env: ENV_CFG.env, // deprecated
                    environment: this.getEnvironmentData(), // deprecated
                    language: userInitData.user.language, // deprecated, use locale
                    locale: {
                        iso1: user.language
                    },
                    route: getCurrentRoute(),
                    settings: {},
                    tenant: {
                        name: tenant.name,
                        uuid: tenant.uuid
                    },
                    user: {
                        uuid: user.uuid,
                        username: user.username,
                        firstName: user.firstname,
                        email: user.email,
                        id: user.id,
                        lastName: user.lastname,
                        language: user.language, // deprecated
                        logged: true, // we are always logged in
                        auth: tokenAuthService.getTokens(),
                        timezone: user.timezone,
                        token: tokenAuthService.getAccessToken(), // deprecated
                        company: tenant, // deprecated,
                        momentDateFormat: user.momentDateFormat, // deprecated
                        dateFormat: user.dateFormat, // deprecated
                    },
                    account: {
                        linkId: $stateParams.productId,
                    },
                };
                return angular.extend(loadData, additionalData);
            },

            /**
             * @name getLoadPayloadV2
             * @returns {Object}
             */
             getLoadPayloadV2: function() {
                var user = userInitData.user;
                var tenant = userInitData.currentCompany;
                var loadData =  {
                    account: {
                        linkId: $stateParams.productId
                    },
                    currency: {
                        symbol: tenant.currency
                    },
                    locale: {
                        iso1: user.language
                    },
                    route: getCurrentRouteV2(),
                    settings: {
                        timezoneOffset: _.get(userInitData, 'currentCompany.timezone.tzOffset'),
                        dateFormat: user.dateFormat
                    },
                    tenant: {
                        name: tenant.name,
                        uuid: tenant.uuid
                    },
                    user: {
                        uuid: user.uuid,
                        username: user.username,
                        firstName: user.firstname,
                        email: user.email,
                        id: user.id,
                        lastName: user.lastname,
                        logged: true, // we are always logged in
                        auth: {
                            token: tokenAuthService.getTokens().accessToken
                        }
                    }
                }
                return loadData;
            },

            /**
             *
             * @returns {{dataCenter: string | undefined, env: string | undefined}}
             */
            getEnvironmentData: function() {
                return {
                    dataCenter: userInitData.dataCenter,
                    env: ENV_CFG.env
                }
            },
            getAccount: function () {
                return {
                    id: userInitData.currentCompany ? userInitData.currentCompany.uuid : null
                }
            },
            init: function () {
                this.gateway = new gateway({});
            },
            addSlave: function (config) {
                this.gateway.addSlave(config)
            },
            removeSlave: function (slaveId) {
                this.gateway.removeSlave(slaveId)
            }
        };
    }
]);
;
'use strict';

/* Common controllers */
angular.module('app.controllers', [])
    .controller('AppCtrl', ['$scope', '$ocLazyLoad', 'userInitData', 'GravitySettingsService', function ($scope, $ocLazyLoad, userInitData, GravitySettingsService) {
        var storedSettings = JSON.parse(localStorage.getItem('settings'));
        $scope.app = {
            selectCount: '100',
            pageCount: '1',
            settings: {
                storedUser: '' // if user want to save username on login form
            }
        };

        $ocLazyLoad.load('[DIST_PATH]js/login.controller.js');

        if (storedSettings) {
            $scope.app.settings = storedSettings;
        } else {
            localStorage.setItem('settings', JSON.stringify($scope.app.settings));
        }

        $scope.$watch('app.settings', function () {
            localStorage.setItem('settings', JSON.stringify($scope.app.settings));
        }, true);

        const partialInit = function () {
            setBannerMessageBar();
        }

        const setBannerMessageBar = function () {
            const currentCompanyUUID = _.get(userInitData, 'currentCompany.uuid')
            const bannerMessageBarSettings = GravitySettingsService.getSettingByKey('widget.headerBannerMessageBar');
            const companyBannerMessageBarMessage = _.get(bannerMessageBarSettings,  `[${currentCompanyUUID}]`);
            const generalBannerMessageBarMessage = _.get(bannerMessageBarSettings, "*");
            const message = companyBannerMessageBarMessage || generalBannerMessageBarMessage;

            if (message) {
                $scope.bannerMessageBar = {
                    message: message
                }
            }
        }

        partialInit();
    }]);
;
'use strict';

/* Common directives */
app.directive('focus', function ($timeout) {
    return {
        scope: {
            trigger: '@focus'
        },
        link: function (scope, element) {
            scope.$watch('trigger', function (value) {
                if (value == "true") {
                    $timeout(function () {
                        element[0].focus();
                    });
                }
            });
        }
    };
});

/**
 * @ngdoc directive
 * @name clickOutside
 * @function
 * @restrict 'A'
 * @element ANY
 * @param {expression} clickOutside {@link guide/expression Expression} to evaluate upon click outside of element
 * @param {expression=} clickOutsideAttachIf {@link guide/expression Expression} that determines will
 * @param {string=} clickOutsideExclude {@link guide/expression Expression} comma separated list of selectors that will
 * be excluded from execution of clickOutside expression
 * @param {expression=} clickOutsideNoPropagationStop don't stop propagation of click, use it with clickOutsideAttachIf
 */
app.directive('clickOutside', function ($document) {
    return {
        restrict: 'A',
        link: function (scope, elem, attr) {
            var init = function() {
                initListeners();
                initWatchers();
            };

            var shouldExclude = function(target) {
                var excluded = getExcludedElements();

                for (var i = 0; i < excluded.length; i++) {
                    if (excluded[i].contains(target)) {
                        return true;
                    }
                }

                return false;
            };

            var getExcludedElements = function() {
                var result = [];

                if (attr.clickOutsideExclude) {
                    _.each(attr.clickOutsideExclude.split(','), function(selector) {
                        if (selector) {
                            try {
                                var node = document.querySelector(selector.trim());
                                if (node) {
                                    result.push(node);
                                }
                            } catch (err) {
                                if (window.console) {
                                    window.console.error('click-outside directive:clickOutsideExclude: Check your exclude selector syntax.', err);
                                }
                            }
                        }
                    });
                }

                return result;
            };

            var stopPropagation = function (e) {
                // this part keeps it from firing the click on the document.
                e.stopPropagation();
            };

            var listener = function (e) {
                // magic here.
                if (!elem[0].contains(e.target) && !shouldExclude(e.target)) {
                    scope.$apply(attr.clickOutside);
                }
            };

            var attachDocumentClickListener = function() {
                $document.on('click', listener);
            };

            var detachDocumentClickListener = function() {
                angular.element($document).off('click', listener);
            };

            var attachStopPropagationListener = function() {
                elem.on('click', stopPropagation);
            };

            var detachStopPropagationListener = function() {
                elem.off('click', stopPropagation);
            };

            var initWatchers = function() {
                scope.$watch(attr.clickOutsideAttachIf, function (newValue) {
                    if (newValue === true) {
                        attachDocumentClickListener()
                    } else if (newValue === false){
                        detachDocumentClickListener();
                    }
                });

                scope.$watch(attr.clickOutsideNoPropagationStop, function (newValue) {
                    if (newValue === true) {
                        detachStopPropagationListener();
                    } else if (newValue === false) {
                        attachStopPropagationListener();
                    }
                });
            };

            var initListeners = function() {
                attachStopPropagationListener();
                attachDocumentClickListener();
            };

            var destroyListeners = function () {
                detachDocumentClickListener();
                detachStopPropagationListener();
            };

            scope.$on("$destroy", destroyListeners);

            init();
        }
    }
});

app.directive('checkLength', function () {
    return {
        restrict: 'A',
        scope: true,
        link: function ($scope, elem, attr) {
            $scope.$watch('fieldValues', function (value) {
                // first load will be undefined
                if (value[attr.ngValue] && $scope[attr.name]) {
                    var valid = value[attr.ngValue].length < attr.checkLength;
                    $scope[attr.name].$setValidity('minlength', !valid);
                }
            }, true );

        }
    }
});


app.directive('stringToNumber', function() {
    return {
        require: 'ngModel',
        link: function(scope, element, attrs, ngModel) {
            if (attrs.stringToNumber !== 'false') {
                ngModel.$parsers.push(function(value){
                    return '' + value;
                });
                ngModel.$formatters.push(function(value) {
                    return parseFloat(value, 10);
                });
            }
        }
    }
});

app.directive('rightClick', function($parse) {
    return function(scope, element, attrs) {
        var fn = $parse(attrs.rightClick);
        element.bind('contextmenu', function(event) {
            scope.$apply(function() {
                event.preventDefault();
                fn(scope, {$event:event});
            });
        });
    };
});

// Rendered directive
// NOTE: Use to check when repeater is finished
app.directive('sevenRendered', function () {
    var emit = function (scope, delay) {
        setTimeout(function () {
            scope.$emit('SEVEN.Rendered');
        }, angular.isUndefined(delay) ? 100 : delay);
    };

    return {
        restrict: 'A',
        link: function (scope, elem, attrs) {
            // Attached above repeater: watch length
            scope.$watch(function () {
                return attrs.sevenRendered;
            }, function (current, previous) {
                if (current && current !== previous) {
                    emit(scope);
                }
            });

            // Attached to repeater
            if (scope.$last === true) {
                emit(scope);
            }
        }
    };
});

app.directive("sevenDisableAnimate", function ($animate) {
    return function (scope, element) {
        $animate.enabled(false, element);
    };
});

/**
 * @ngdoc directive
 * @name sevenRemoveStepValidator
 * @description
 * The 'sevenRemoveStepValidator' removes step validator from numeric input
 * fields as suggested in
 * https://docs.angularjs.org/guide/migration#-input-type-number-
 */
app.directive('sevenRemoveStepValidator', function() {
    return {
        restrict: 'A',
        require: '?ngModel',
        link: function (scope, elem, attrs, ngModelCtrl) {
            // ...that are of type "number" and have `ngModel`...
            if (attrs.type === 'number' && ngModelCtrl) {
                // ...remove the `step` validator.
                delete ngModelCtrl.$validators.step;
            }
        }
    };
});

/**
 * @ngdoc directive
 * @name sevenStopClick
 * @function
 * @description Stops propagation of click event
 * @restrict 'A'
 * @element ANY
 */
angular
    .module('npAdmin')
    .directive('sevenStopClick', function() {
       return {
           restrict: 'A',
           link: function(scope, $element) {
               $element[0].addEventListener('click', function(event) {
                   event.stopPropagation();
               })
           }
       }
    });

angular
    .module('npAdmin')
    .directive('emptyStringModelToNull', function () {
        return {
            require: 'ngModel',
            link: function (scope, element, attrs, ngModel) {
                ngModel.$parsers.push(function (viewValue) {
                    return viewValue === '' ? null : viewValue;
                })
            }
        }
    })
;
'use strict';

/* Common filters */


/**
 *  Returning parts of URI
 */
app.filter('uri', function ($location) {
    return {
        segment: function (segment) {
            var query = $location.path(); // Get URI

            var data = query.slice(1).split("/"); // To obj

            // Return segment (segments are 1,2,3 keys are 0,1,2)
            if (data[segment - 1]) {
                return data[segment - 1];
            }

            return false;
        }
    }
});

/**
 * Angular orderBy works for arrays by default
 * but need filter for objects/associative arrays
 */
app.filter('orderObjectBy', function () {
    return function (input, attribute) {
        if (!angular.isObject(input)) return input;

        var array = [];
        for (var objectKey in input) {
            array.push(input[objectKey]);
        }

        array.sort(function (a, b) {
            a = parseInt(a[attribute]);
            b = parseInt(b[attribute]);
            return a - b;
        });

        return array;
    };
});

/**
 * Returns difference between two arrays
 * e.g. differ between a=[1,2,3,4] & b=[1,3] is c=[2,4]
 */
app.filter('arrayDiffer', function () {
    return function (arr1, arr2) {
        if (angular.isUndefined(arr1) || angular.isUndefined(arr2)) return;
        return arr1.filter(function (n) {
            return arr2.indexOf(n) == -1;
        });
    };
});

/**
 * Returns non duplicate items
 */
app.filter('unique', function () {
    return function (collection, keyname) {
        var output = [],
            keys = [];

        angular.forEach(collection, function (item) {
            var key = item[keyname];

            if (!inArray(key, keys)) {
                keys.push(key);
                output.push(item);
            }
        });

        return output;
    };
});

/**
 * Returns utc date
 */

app.filter('utcDate', function ($filter, userInitData) {
    return function (evt, timeStamp, list) {
        var timeFormat = userInitData.user.timeFormat24 ? 'HH:mm:ss' : 'hh:mm a',
            dateFormat = userInitData.user.dateFormat,
            a = new Date(timeStamp*1000),
            b = new Date(a.getUTCFullYear(), a.getUTCMonth(), a.getUTCDate(), a.getUTCHours(), a.getUTCMinutes(), a.getUTCSeconds());
        return $filter('date')(b,dateFormat + ' ' + (list.showTimeInGrid !== 'no' ? timeFormat : ''));
    };
});

app.filter('customUtcDate', function ($filter) {
    return function (evt, timeStamp, format) {
            var a = new Date(timeStamp*1000),
                b = new Date(a.getUTCFullYear(), a.getUTCMonth(), a.getUTCDate(), a.getUTCHours(), a.getUTCMinutes(), a.getUTCSeconds());

        return $filter('date')(b, format || 'yyyy-MM-dd HH:mm');
    };
});

app.filter('classGenerator', function() {
    return function (string) {
        return string.toLowerCase().replace(/[ ]/g, '-');
    }
});


app.filter('stringify', function() {
    return function(input) {
        return angular.isString(input) ? input : JSON.stringify(input);
    };
});

app.filter('join', function() {
    return function(input, separator) {
        return input.join(separator).trim();
    };
});

app.filter('moment', function() {
    return function(input, format, utcOffset) {
        return utcOffset ? moment.utc(input).utcOffset(utcOffset).format(format) : moment(input).format(format);
    };
});

app.filter('deviceStatusFilter', function () {
    return function (devices, deviceFilters) {
        if (!angular.isArray(devices)) return devices;

        var expresionEmpty = true;

        for (var key in deviceFilters) {
            if (deviceFilters.hasOwnProperty(key) && deviceFilters[key]) {
                expresionEmpty = false;
            }
        }

        if (expresionEmpty)
            return devices;

        var filtered = [];

        angular.forEach(devices, function (device) {
            for (var key in deviceFilters) {
                if (device.hasOwnProperty(key) && deviceFilters[key] && device[key] === deviceFilters[key]) {
                    if (key === 'isUninstalled' && device.isReadyToInstall) continue;

                    filtered.push(device);
                    break;
                }
            }
        });


        return filtered;
    }
});

app.filter('keylength', function(){
    return function(input){
        return Object.keys(input).length;
    }
});

// https://github.com/microsoft/uuid-validate
app.filter('isValidUUID', function() {
  var UUIDPattern = /^[\da-f]{8}-[\da-f]{4}-[1-5][\da-f]{3}-[\da-f]{4}-[\da-f]{12}$/i;

  var UUIDVersion = function (uuid) {
      return uuid.charAt(14) | 0;
  }

  return function (uuid) {
      if (typeof uuid !== "string" || !UUIDPattern.test(uuid)) return false;

      var version = UUIDVersion(uuid);

      switch (version) {
          case 1:
          case 2:
              return true;
          case 3:
          case 4:
          case 5:
              return ['8', '9', 'a', 'b'].includes(uuid.charAt(19).toLowerCase());
          default:
              return false;
      }
  }
})
;
function inArray(needle, haystack, argStrict) {
    //  discuss at: http://phpjs.org/functions/inArray/
    // original by: Kevin van Zonneveld (http://kevin.vanzonneveld.net)
    // improved by: vlado houba
    // improved by: Jonas Sciangula Street (Joni2Back)
    //    input by: Billy
    // bugfixed by: Brett Zamir (http://brett-zamir.me)
    //   example 1: inArray('van', ['Kevin', 'van', 'Zonneveld']);
    //   returns 1: true
    //   example 2: inArray('vlado', {0: 'Kevin', vlado: 'van', 1: 'Zonneveld'});
    //   returns 2: false
    //   example 3: inArray(1, ['1', '2', '3']);
    //   example 3: inArray(1, ['1', '2', '3'], false);
    //   returns 3: true
    //   returns 3: true
    //   example 4: inArray(1, ['1', '2', '3'], true);
    //   returns 4: false

    var key = '',
        strict = !! argStrict;

    //we prevent the double check (strict && arr[key] === ndl) || (!strict && arr[key] == ndl)
    //in just one for, in order to improve the performance 
    //deciding wich type of comparation will do before walk array
    if (strict) {
        for (key in haystack) {
            if (haystack[key] === needle) {
                return true;
            }
        }
    } else {
        for (key in haystack) {
            if (haystack[key] == needle) {
                return true;
            }
        }
    }

    return false;
}

/**
 * When need just one item per object
 * @param  {Array/Object} container
 * @param  {string} item
 * @return {Array}
 */
function getSelectedObjectItems(container, item) {
    var items = [];
    
    angular.forEach(container, function(value, key) {
        items.push(value[item]);
    });

    return items;
}

function containsObject(obj, list) {

    for (var i = 0; i < list.length; i++) {
        // objects wrapped by JSON.stringify 'cause normal comparing is never true
        if (JSON.stringify(list[i]) === JSON.stringify(obj)) {
            return true;
        }
    }

    return false;
}

// Speed up calls to hasOwnProperty
var hasOwnProperty = Object.prototype.hasOwnProperty;

function isEmpty(obj) {

    // null and undefined are "empty"
    if (obj == null) return true;

    // Assume if it has a length property with a non-zero value
    // that that property is correct.
    if (obj.length > 0)    return false;
    if (obj.length === 0)  return true;

    // Otherwise, does it have any properties of its own?
    // Note that this doesn't handle
    // toString and valueOf enumeration bugs in IE < 9
    for (var key in obj) {
        if (hasOwnProperty.call(obj, key)) return false;
    }

    return true;
}

function getRandomInt(min, max) {
    return Math.floor(Math.random() * (max - min + 1)) + min;
}

function getMultiArrayIntersection(multiArray) {
    return multiArray.shift().filter(function (v) {
        return multiArray.every(function (a) {
            return a.indexOf(v) !== -1;
        });
    });
}

String.prototype.capitalize = function() {
    return this.charAt(0).toUpperCase() + this.slice(1);
};


// Time picker input validation
function checkIfNumericalValue (event) {
    var charCode = (event.which) ? event.which : event.keyCode;

    // end if not numerical value is entered
    return (charCode >= 48 && charCode <= 57);

}























;
app.factory('commonSvc', ['$http', 'appSettingsSvc', function ($http, $state, appSettingsSvc) {

	return {
		resendVerificationKey: function (params) {

			var data = {
			   action: params.action,
			   verificationCodeHash: params.verificationCodeHash
			};

			return $http.post(params.resendVerificationCodeLink, data)
			.then(function(response) {
                return response;
            }, function (response) {
                return response;
            });
		},

		getCurrentSubmodule: function() {
            var moduleName = $state.current.name.split('.')[0];
            var submoduleName = $state.current.name.split('.')[1];

            return appSettingsSvc.modules[moduleName].submodules[submoduleName];
        },

        getTabActionsId: function () {

            var listOfIds = [];

            var currentModule = $state.current.parentView.split('.')[0];
            var currentSubmodule = $state.current.parentView.split('.')[1];

            var currentActions = appSettingsSvc.modules[currentModule].submodules[currentSubmodule].actions;

            angular.forEach(currentActions.tabs, function(val){
                listOfIds.push(val.id);
            });

            return listOfIds;
        },

        checkProductById: function (id) {
            var product = '';

            switch (parseInt(id)) {
                case 2:
                case 7:
                    product = 'LiveBetting';
                    break;
                case 3:
                case 4:
                    product = 'PreMatchBetting';
                    break;
            }

            return product;
        }
	}
}]);

;
(function($) {

	$.fn.tableHeadFixer = function(param) {
		var defaults = {
			head: true,
			foot: false,
			left: 0,
			right: 0,
			'z-index': 0
		};

		var settings = $.extend({}, defaults, param);

		return this.each(function() {
			settings.table = this;
			settings.parent = $(settings.table).parent();
			setParent();

			if(settings.head == true)
				fixHead();

			if(settings.foot == true)
				fixFoot();

			if(settings.left > 0)
				fixLeft();

			if(settings.right > 0)
				fixRight();

			setCorner();

			$(settings.parent).trigger("scroll");

			$(window).resize(function() {
				$(settings.parent).trigger("scroll");
			});
		});

		/*
		 This function solver z-index problem in corner cell where fix row and column at the same time,
		 set corner cells z-index 1 more then other fixed cells
		 */
		function setCorner() {
			var table = $(settings.table);

			if(settings.head) {
				if(settings.left > 0) {
					var tr = table.find("thead tr");

					tr.each(function(k, row) {
						solverLeftColspan(row, function(cell) {
							$(cell).css("z-index", settings['z-index'] + 1);
						});
					});
				}

				if(settings.right > 0) {
					var tr = table.find("thead tr");

					tr.each(function(k, row) {
						solveRightColspan(row, function(cell) {
							$(cell).css("z-index", settings['z-index'] + 1);
						});
					});
				}
			}

			if(settings.foot) {
				if(settings.left > 0) {
					var tr = table.find("tfoot tr");

					tr.each(function(k, row) {
						solverLeftColspan(row, function(cell) {
							$(cell).css("z-index", settings['z-index']);
						});
					});
				}

				if(settings.right > 0) {
					var tr = table.find("tfoot tr");

					tr.each(function(k, row) {
						solveRightColspan(row, function(cell) {
							$(cell).css("z-index", settings['z-index']);
						});
					});
				}
			}
		}

		// Set style of table parent
		function setParent() {
			var parent = $(settings.parent);
			var table = $(settings.table);

			parent.append(table);
			parent
				.css({
					'overflow-x' : 'auto',
					'overflow-y' : 'auto'
				});

			parent.scroll(function() {
				var scrollWidth = parent[0].scrollWidth;
				var clientWidth = parent[0].clientWidth;
				var scrollHeight = parent[0].scrollHeight;
				var clientHeight = parent[0].clientHeight;
				var top = parent.scrollTop();
				var left = parent.scrollLeft();

				if(settings.head)
					this.find("thead tr > *").css("top", top);

				if(settings.foot)
					this.find("tfoot tr > *").css("bottom", scrollHeight - clientHeight - top);

				if(settings.left > 0)
					settings.leftColumns.css("left", left);

				if(settings.right > 0)
					settings.rightColumns.css("right", scrollWidth - clientWidth - left);
			}.bind(table));
		}

		// Set table head fixed
		function fixHead () {
			var thead = $(settings.table).find("thead");
			var tr = thead.find("tr");
			var cells = thead.find("tr > *");

			setBackground(cells);
			cells.css({
				'position' : 'relative'
			});
		}

		// Set table foot fixed
		function fixFoot () {
			var tfoot = $(settings.table).find("tfoot");
			var tr = tfoot.find("tr");
			var cells = tfoot.find("tr > *");

			setBackground(cells);
			cells.css({
				'position' : 'relative'
			});
		}

		// Set table left column fixed
		function fixLeft () {
			var table = $(settings.table);

			// var fixColumn = settings.left;

			settings.leftColumns = $();

			var tr = table.find("tr");
			tr.each(function(k, row) {

				solverLeftColspan(row, function(cell) {
					settings.leftColumns = settings.leftColumns.add(cell);
				});
				// var inc = 1;

				// for(var i = 1; i <= fixColumn; i = i + inc) {
				// 	var nth = inc > 1 ? i - 1 : i;

				// 	var cell = $(row).find("*:nth-child(" + nth + ")");
				// 	var colspan = cell.prop("colspan");

				// 	settings.leftColumns = settings.leftColumns.add(cell);

				// 	inc = colspan;
				// }
			});

			var column = settings.leftColumns;

			column.each(function(k, cell) {
				var cell = $(cell);

				setBackground(cell);
				cell.css({
					'position' : 'relative'
				});
			});
		}

		// Set table right column fixed
		function fixRight () {
			var table = $(settings.table);

			var fixColumn = settings.right;

			settings.rightColumns = $();

			var tr = table.find("tr");
			tr.each(function(k, row) {
				solveRightColspan(row, function(cell) {
					settings.rightColumns = settings.rightColumns.add(cell);
				});
			});

			var column = settings.rightColumns;

			column.each(function(k, cell) {
				var cell = $(cell);

				setBackground(cell);
				cell.css({
					'position' : 'relative'
				});
			});

		}

		// Set fixed cells backgrounds
		function setBackground(elements) {
			elements.each(function(k, element) {
				var element = $(element);
				var parent = $(element).parent();

				var elementBackground = element.css("background-color");
				elementBackground = (elementBackground == "transparent" || elementBackground == "rgba(0, 0, 0, 0)") ? null : elementBackground;

				var parentBackground = parent.css("background-color");
				parentBackground = (parentBackground == "transparent" || parentBackground == "rgba(0, 0, 0, 0)") ? null : parentBackground;

				var background = parentBackground ? parentBackground : "white";
				background = elementBackground ? elementBackground : background;

				element.css("background-color", background);
			});
		}

		function solverLeftColspan(row, action) {
			var fixColumn = settings.left;
			var inc = 1;

			for(var i = 1; i <= fixColumn; i = i + inc) {
				var nth = inc > 1 ? i - 1 : i;

				var cell = $(row).find("> *:nth-child(" + nth + ")");
				var colspan = cell.prop("colspan");

				if (cell.cellPos().left < fixColumn) {
					action(cell);
				}

				inc = colspan;
			}
		}

		function solveRightColspan(row, action) {
			var fixColumn = settings.right;
			var inc = 1;

			for(var i = 1; i <= fixColumn; i = i + inc) {
				var nth = inc > 1 ? i - 1 : i;

				var cell = $(row).find("> *:nth-last-child(" + nth + ")");
				var colspan = cell.prop("colspan");

				action(cell);

				inc = colspan;
			}
		}
	};

})(jQuery);

/*  cellPos jQuery plugin
    ---------------------
    Get visual position of cell in HTML table (or its block like thead).
    Return value is object with "top" and "left" properties set to row and column index of top-left cell corner.
    Example of use:
        $("#myTable tbody td").each(function(){
            $(this).text( $(this).cellPos().top +", "+ $(this).cellPos().left );
        });
*/
(function($){
    /* scan individual table and set "cellPos" data in the form { left: x-coord, top: y-coord } */
    function scanTable( $table ) {
        var m = [];
        $table.children( "tr" ).each( function( y, row ) {
            $( row ).children( "td, th" ).each( function( x, cell ) {
                var $cell = $( cell ),
                    cspan = $cell.attr( "colspan" ) | 0,
                    rspan = $cell.attr( "rowspan" ) | 0,
                    tx, ty;
                cspan = cspan ? cspan : 1;
                rspan = rspan ? rspan : 1;
                for( ; m[y] && m[y][x]; ++x );  //skip already occupied cells in current row
                for( tx = x; tx < x + cspan; ++tx ) {  //mark matrix elements occupied by current cell with true
                    for( ty = y; ty < y + rspan; ++ty ) {
                        if( !m[ty] ) {  //fill missing rows
                            m[ty] = [];
                        }
                        m[ty][tx] = true;
                    }
                }
                var pos = { top: y, left: x };
                $cell.data( "cellPos", pos );
            } );
        } );
    };

    /* plugin */
    $.fn.cellPos = function( rescan ) {
        var $cell = this.first(),
            pos = $cell.data( "cellPos" );
        if( !pos || rescan ) {
            var $table = $cell.closest( "table, thead, tbody, tfoot" );
            scanTable( $table );
        }
        pos = $cell.data( "cellPos" );
        return pos;
    }
})(jQuery);;
(function() {
  angular
    .module('seven-admin.shared')
    .controller('IntegrationController', IntegrationController);

  IntegrationController.$inject = [
    '$rootScope',
    '$scope',
    '$state',
    '$stateParams',
    '$translate',
    'gatewayService',
    'widgetService',
    'userInitData',
    'tokenAuthService',
    'Titles'
  ];

  function IntegrationController(
    $rootScope,
    $scope,
    $state,
    $stateParams,
    $translate,
    gatewayService,
    widgetService,
    userInitData,
    tokenAuthService,
    Titles
  ) {
    var vm = this;
    var currentStateData = $state.current.data;

    var init = function () {
      vm.widgetLoading = true;
      vm.widgetKey = currentStateData.widgetKey;
      vm.widgetSettings = widgetService.getWidgetByKey(vm.widgetKey);
      vm.isTypeProduct = vm.widgetSettings.type === 'PRODUCT';
      vm.isV2Integration = !vm.isTypeProduct;
      vm.data = vm.isV2Integration ? gatewayService.getLoadPayloadV2() : gatewayService.getLoadPayload();
      // Backward compatibility, only used for Numbers Betting until product migrate to using route data from gateway payload instead of frame URL
      vm.urlPath = getFramePath();
      vm.onFinally = onFinally;

      setGlobalSettings();

      if(vm.isTypeProduct) {
        setProductSpecifics();
      }
      setBreadcrumbsAndTitles();
    };

    var setProductSpecifics = function () {
      $rootScope.productClass = 'a-module-gateway-product hide-main-content-tabs';
    };

    var setListeners = function () {
      $scope.$on('User.AuthorizationChanged', function () {
        var userData = userInitData.user;
        var tokens = tokenAuthService.getTokens();

        gatewayService.gateway.sendMessage(vm.frameId, {
          action: 'User.AuthorizationChanged',
          slaveId: vm.slaveId,
          data: {
            auth: {
              id: userData.uuid,
              token: tokens && tokens.accessToken
            }
          }
        })
      });
  };

    var onFinally = function () {
      $rootScope.$evalAsync(function(){
        setListeners();
        vm.widgetLoading = false;
      });
    };

    var setBreadcrumbsAndTitles = function () {
      if (!currentStateData.breadcrumbs) return;

      const translatedBreadcrumbs = currentStateData.breadcrumbs.map((breadcrumb) => {
        return _.merge({}, breadcrumb, {name: $translate.instant(breadcrumb.name)});
      })
      Titles.manualSet(translatedBreadcrumbs);
    }

    var getFramePath = function () {
     if (!currentStateData.addPathToFrameURL) return null;

      return $stateParams.path.split('/')[0];
    }

    var setGlobalSettings = function () {
      $rootScope.productClass = 'a-module-gateway-product';
    }

    init();
  }
})();
;
/*! nanoScrollerJS - v0.8.7 - 2015
 * http://jamesflorentino.github.com/nanoScrollerJS/
 * Copyright (c) 2015 James Florentino; Licensed MIT */
(function(factory) {
    if (typeof define === 'function' && define.amd) {
        return define(['jquery'], function($) {
            return factory($, window, document);
        });
    } else if (typeof exports === 'object') {
        return module.exports = factory(require('jquery'), window, document);
    } else {
        return factory(jQuery, window, document);
    }
})(function($, window, document) {
    "use strict";
    var BROWSER_IS_IE7, BROWSER_SCROLLBAR_WIDTH, DOMSCROLL, DOWN, DRAG, ENTER, KEYDOWN, KEYUP, MOUSEDOWN, MOUSEENTER, MOUSEMOVE, MOUSEUP, MOUSEWHEEL, NanoScroll, PANEDOWN, RESIZE, SCROLL, SCROLLBAR, TOUCHMOVE, UP, WHEEL, cAF, defaults, getBrowserScrollbarWidth, hasTransform, isFFWithBuggyScrollbar, rAF, transform, _elementStyle, _prefixStyle, _vendor;
    defaults = {

        /**
         a classname for the pane element.
         @property paneClass
         @type String
         @default 'nano-pane'
         */
        paneClass: 'nano-pane',

        /**
         a classname for the slider element.
         @property sliderClass
         @type String
         @default 'nano-slider'
         */
        sliderClass: 'nano-slider',

        /**
         a classname for the content element.
         @property contentClass
         @type String
         @default 'nano-content'
         */
        contentClass: 'nano-content',

        /**
         a setting to enable native scrolling in iOS devices.
         @property iOSNativeScrolling
         @type Boolean
         @default false
         */
        iOSNativeScrolling: false,

        /**
         a setting to prevent the rest of the page being
         scrolled when user scrolls the `.content` element.
         @property preventPageScrolling
         @type Boolean
         @default false
         */
        preventPageScrolling: false,

        /**
         a setting to disable binding to the resize event.
         @property disableResize
         @type Boolean
         @default false
         */
        disableResize: false,

        /**
         a setting to make the scrollbar always visible.
         @property alwaysVisible
         @type Boolean
         @default false
         */
        alwaysVisible: false,

        /**
         a default timeout for the `flash()` method.
         @property flashDelay
         @type Number
         @default 1500
         */
        flashDelay: 1500,

        /**
         a minimum height for the `.slider` element.
         @property sliderMinHeight
         @type Number
         @default 20
         */
        sliderMinHeight: 20,

        /**
         a maximum height for the `.slider` element.
         @property sliderMaxHeight
         @type Number
         @default null
         */
        sliderMaxHeight: null,

        /**
         an alternate document context.
         @property documentContext
         @type Document
         @default null
         */
        documentContext: null,

        /**
         an alternate window context.
         @property windowContext
         @type Window
         @default null
         */
        windowContext: null
    };

    /**
     @property SCROLLBAR
     @type String
     @static
     @final
     @private
     */
    SCROLLBAR = 'scrollbar';

    /**
     @property SCROLL
     @type String
     @static
     @final
     @private
     */
    SCROLL = 'scroll';

    /**
     @property MOUSEDOWN
     @type String
     @final
     @private
     */
    MOUSEDOWN = 'mousedown';

    /**
     @property MOUSEENTER
     @type String
     @final
     @private
     */
    MOUSEENTER = 'mouseenter';

    /**
     @property MOUSEMOVE
     @type String
     @static
     @final
     @private
     */
    MOUSEMOVE = 'mousemove';

    /**
     @property MOUSEWHEEL
     @type String
     @final
     @private
     */
    MOUSEWHEEL = 'mousewheel';

    /**
     @property MOUSEUP
     @type String
     @static
     @final
     @private
     */
    MOUSEUP = 'mouseup';

    /**
     @property RESIZE
     @type String
     @final
     @private
     */
    RESIZE = 'resize';

    /**
     @property DRAG
     @type String
     @static
     @final
     @private
     */
    DRAG = 'drag';

    /**
     @property ENTER
     @type String
     @static
     @final
     @private
     */
    ENTER = 'enter';

    /**
     @property UP
     @type String
     @static
     @final
     @private
     */
    UP = 'up';

    /**
     @property PANEDOWN
     @type String
     @static
     @final
     @private
     */
    PANEDOWN = 'panedown';

    /**
     @property DOMSCROLL
     @type String
     @static
     @final
     @private
     */
    DOMSCROLL = 'DOMMouseScroll';

    /**
     @property DOWN
     @type String
     @static
     @final
     @private
     */
    DOWN = 'down';

    /**
     @property WHEEL
     @type String
     @static
     @final
     @private
     */
    WHEEL = 'wheel';

    /**
     @property KEYDOWN
     @type String
     @static
     @final
     @private
     */
    KEYDOWN = 'keydown';

    /**
     @property KEYUP
     @type String
     @static
     @final
     @private
     */
    KEYUP = 'keyup';

    /**
     @property TOUCHMOVE
     @type String
     @static
     @final
     @private
     */
    TOUCHMOVE = 'touchmove';

    /**
     @property BROWSER_IS_IE7
     @type Boolean
     @static
     @final
     @private
     */
    BROWSER_IS_IE7 = window.navigator.appName === 'Microsoft Internet Explorer' && /msie 7./i.test(window.navigator.appVersion) && window.ActiveXObject;

    /**
     @property BROWSER_SCROLLBAR_WIDTH
     @type Number
     @static
     @default null
     @private
     */
    BROWSER_SCROLLBAR_WIDTH = null;
    rAF = window.requestAnimationFrame;
    cAF = window.cancelAnimationFrame;
    _elementStyle = document.createElement('div').style;
    _vendor = (function() {
        var i, transform, vendor, vendors, _i, _len;
        vendors = ['t', 'webkitT', 'MozT', 'msT', 'OT'];
        for (i = _i = 0, _len = vendors.length; _i < _len; i = ++_i) {
            vendor = vendors[i];
            transform = vendors[i] + 'ransform';
            if (transform in _elementStyle) {
                return vendors[i].substr(0, vendors[i].length - 1);
            }
        }
        return false;
    })();
    _prefixStyle = function(style) {
        if (_vendor === false) {
            return false;
        }
        if (_vendor === '') {
            return style;
        }
        return _vendor + style.charAt(0).toUpperCase() + style.substr(1);
    };
    transform = _prefixStyle('transform');
    hasTransform = transform !== false;

    /**
     Returns browser's native scrollbar width
     @method getBrowserScrollbarWidth
     @return {Number} the scrollbar width in pixels
     @static
     @private
     */
    getBrowserScrollbarWidth = function() {
        var outer, outerStyle, scrollbarWidth;
        outer = document.createElement('div');
        outerStyle = outer.style;
        outerStyle.position = 'absolute';
        outerStyle.width = '100px';
        outerStyle.height = '100px';
        outerStyle.overflow = SCROLL;
        outerStyle.top = '-9999px';
        document.body.appendChild(outer);
        scrollbarWidth = outer.offsetWidth - outer.clientWidth;
        document.body.removeChild(outer);
        return scrollbarWidth;
    };
    isFFWithBuggyScrollbar = function() {
        var isOSXFF, ua, version;
        ua = window.navigator.userAgent;
        isOSXFF = /(?=.+Mac OS X)(?=.+Firefox)/.test(ua);
        if (!isOSXFF) {
            return false;
        }
        version = /Firefox\/\d{2}\./.exec(ua);
        if (version) {
            version = version[0].replace(/\D+/g, '');
        }
        return isOSXFF && +version > 23;
    };

    /**
     @class NanoScroll
     @param element {HTMLElement|Node} the main element
     @param options {Object} nanoScroller's options
     @constructor
     */
    NanoScroll = (function() {
        function NanoScroll(el, options) {
            this.el = el;
            this.options = options;
            BROWSER_SCROLLBAR_WIDTH || (BROWSER_SCROLLBAR_WIDTH = getBrowserScrollbarWidth());
            this.$el = $(this.el);
            this.doc = $(this.options.documentContext || document);
            this.win = $(this.options.windowContext || window);
            this.body = this.doc.find('body');
            this.$content = this.$el.children("." + this.options.contentClass);
            this.$content.attr('tabindex', this.options.tabIndex || 0);
            this.content = this.$content[0];
            this.previousPosition = 0;
            if (this.options.iOSNativeScrolling && (this.el.style.WebkitOverflowScrolling != null)) {
                this.nativeScrolling();
            } else {
                this.generate();
            }
            this.createEvents();
            this.addEvents();
            this.reset();
        }


        /**
         Prevents the rest of the page being scrolled
         when user scrolls the `.nano-content` element.
         @method preventScrolling
         @param event {Event}
         @param direction {String} Scroll direction (up or down)
         @private
         */

        NanoScroll.prototype.preventScrolling = function(e, direction) {
            if (!this.isActive) {
                return;
            }
            if (e.type === DOMSCROLL) {
                if (direction === DOWN && e.originalEvent.detail > 0 || direction === UP && e.originalEvent.detail < 0) {
                    e.preventDefault();
                }
            } else if (e.type === MOUSEWHEEL) {
                if (!e.originalEvent || !e.originalEvent.wheelDelta) {
                    return;
                }
                if (direction === DOWN && e.originalEvent.wheelDelta < 0 || direction === UP && e.originalEvent.wheelDelta > 0) {
                    e.preventDefault();
                }
            }
        };


        /**
         Enable iOS native scrolling
         @method nativeScrolling
         @private
         */

        NanoScroll.prototype.nativeScrolling = function() {
            this.$content.css({
                WebkitOverflowScrolling: 'touch'
            });
            this.iOSNativeScrolling = true;
            this.isActive = true;
        };


        /**
         Updates those nanoScroller properties that
         are related to current scrollbar position.
         @method updateScrollValues
         @private
         */

        NanoScroll.prototype.updateScrollValues = function() {
            var content, direction;
            content = this.content;
            this.maxScrollTop = content.scrollHeight - content.clientHeight;
            this.prevScrollTop = this.contentScrollTop || 0;
            this.contentScrollTop = content.scrollTop;
            direction = this.contentScrollTop > this.previousPosition ? "down" : this.contentScrollTop < this.previousPosition ? "up" : "same";
            this.previousPosition = this.contentScrollTop;
            if (direction !== "same") {
                this.$el.trigger('update', {
                    position: this.contentScrollTop,
                    maximum: this.maxScrollTop,
                    direction: direction
                });
            }
            if (!this.iOSNativeScrolling) {
                this.maxSliderTop = this.paneHeight - this.sliderHeight;
                this.sliderTop = this.maxScrollTop === 0 ? 0 : this.contentScrollTop * this.maxSliderTop / this.maxScrollTop;
            }
        };


        /**
         Updates CSS styles for current scroll position.
         Uses CSS 2d transfroms and `window.requestAnimationFrame` if available.
         @method setOnScrollStyles
         @private
         */

        NanoScroll.prototype.setOnScrollStyles = function() {
            var cssValue;
            if (hasTransform) {
                cssValue = {};
                cssValue[transform] = "translate(0, " + this.sliderTop + "px)";
            } else {
                cssValue = {
                    top: this.sliderTop
                };
            }
            if (rAF) {
                if (cAF && this.scrollRAF) {
                    cAF(this.scrollRAF);
                }
                this.scrollRAF = rAF((function(_this) {
                    return function() {
                        _this.scrollRAF = null;
                        return _this.slider.css(cssValue);
                    };
                })(this));
            } else {
                this.slider.css(cssValue);
            }
        };


        /**
         Creates event related methods
         @method createEvents
         @private
         */

        NanoScroll.prototype.createEvents = function() {
            this.events = {
                down: (function(_this) {
                    return function(e) {
                        _this.isBeingDragged = true;
                        _this.offsetY = e.pageY - _this.slider.offset().top;
                        if (!_this.slider.is(e.target)) {
                            _this.offsetY = 0;
                        }
                        _this.pane.addClass('active');
                        _this.doc.bind(MOUSEMOVE, _this.events[DRAG]).bind(MOUSEUP, _this.events[UP]);
                        _this.body.bind(MOUSEENTER, _this.events[ENTER]);
                        return false;
                    };
                })(this),
                drag: (function(_this) {
                    return function(e) {
                        _this.sliderY = e.pageY - _this.$el.offset().top - _this.paneTop - (_this.offsetY || _this.sliderHeight * 0.5);
                        _this.scroll();
                        if (_this.contentScrollTop >= _this.maxScrollTop && _this.prevScrollTop !== _this.maxScrollTop) {
                            _this.$el.trigger('scrollend');
                        } else if (_this.contentScrollTop === 0 && _this.prevScrollTop !== 0) {
                            _this.$el.trigger('scrolltop');
                        }
                        return false;
                    };
                })(this),
                up: (function(_this) {
                    return function(e) {
                        _this.isBeingDragged = false;
                        _this.pane.removeClass('active');
                        _this.doc.unbind(MOUSEMOVE, _this.events[DRAG]).unbind(MOUSEUP, _this.events[UP]);
                        _this.body.unbind(MOUSEENTER, _this.events[ENTER]);
                        return false;
                    };
                })(this),
                resize: (function(_this) {
                    return function(e) {
                        _this.reset();
                    };
                })(this),
                panedown: (function(_this) {
                    return function(e) {
                        _this.sliderY = (e.offsetY || e.originalEvent.layerY) - (_this.sliderHeight * 0.5);
                        _this.scroll();
                        _this.events.down(e);
                        return false;
                    };
                })(this),
                scroll: (function(_this) {
                    return function(e) {
                        _this.updateScrollValues();
                        if (_this.isBeingDragged) {
                            return;
                        }
                        if (!_this.iOSNativeScrolling) {
                            _this.sliderY = _this.sliderTop;
                            _this.setOnScrollStyles();
                        }
                        if (e == null) {
                            return;
                        }
                        if (_this.contentScrollTop >= _this.maxScrollTop) {
                            if (_this.options.preventPageScrolling) {
                                _this.preventScrolling(e, DOWN);
                            }
                            if (_this.prevScrollTop !== _this.maxScrollTop) {
                                _this.$el.trigger('scrollend');
                            }
                        } else if (_this.contentScrollTop === 0) {
                            if (_this.options.preventPageScrolling) {
                                _this.preventScrolling(e, UP);
                            }
                            if (_this.prevScrollTop !== 0) {
                                _this.$el.trigger('scrolltop');
                            }
                        }
                    };
                })(this),
                wheel: (function(_this) {
                    return function(e) {
                        var delta;
                        if (e == null) {
                            return;
                        }
                        delta = e.delta || e.wheelDelta || (e.originalEvent && e.originalEvent.wheelDelta) || -e.detail || (e.originalEvent && -e.originalEvent.detail);
                        if (delta) {
                            _this.sliderY += -delta / 3;
                        }
                        _this.scroll();
                        return false;
                    };
                })(this),
                enter: (function(_this) {
                    return function(e) {
                        var _ref;
                        if (!_this.isBeingDragged) {
                            return;
                        }
                        if ((e.buttons || e.which) !== 1) {
                            return (_ref = _this.events)[UP].apply(_ref, arguments);
                        }
                    };
                })(this)
            };
        };


        /**
         Adds event listeners with jQuery.
         @method addEvents
         @private
         */

        NanoScroll.prototype.addEvents = function() {
            var events;
            this.removeEvents();
            events = this.events;
            if (!this.options.disableResize) {
                this.win.bind(RESIZE, events[RESIZE]);
            }
            if (!this.iOSNativeScrolling) {
                this.slider.bind(MOUSEDOWN, events[DOWN]);
                this.pane.bind(MOUSEDOWN, events[PANEDOWN]).bind("" + MOUSEWHEEL + " " + DOMSCROLL, events[WHEEL]);
            }
            this.$content.bind("" + SCROLL + " " + MOUSEWHEEL + " " + DOMSCROLL + " " + TOUCHMOVE, events[SCROLL]);
        };


        /**
         Removes event listeners with jQuery.
         @method removeEvents
         @private
         */

        NanoScroll.prototype.removeEvents = function() {
            var events;
            events = this.events;
            this.win.unbind(RESIZE, events[RESIZE]);
            if (!this.iOSNativeScrolling) {
                this.slider.unbind();
                this.pane.unbind();
            }
            this.$content.unbind("" + SCROLL + " " + MOUSEWHEEL + " " + DOMSCROLL + " " + TOUCHMOVE, events[SCROLL]);
        };


        /**
         Generates nanoScroller's scrollbar and elements for it.
         @method generate
         @chainable
         @private
         */

        NanoScroll.prototype.generate = function() {
            var contentClass, cssRule, currentPadding, options, pane, paneClass, sliderClass;
            options = this.options;
            paneClass = options.paneClass, sliderClass = options.sliderClass, contentClass = options.contentClass;
            if (!(pane = this.$el.children("." + paneClass)).length && !pane.children("." + sliderClass).length) {
                this.$el.append("<div class=\"" + paneClass + "\"><div class=\"" + sliderClass + "\" /></div>");
            }
            this.pane = this.$el.children("." + paneClass);
            this.slider = this.pane.find("." + sliderClass);
            if (BROWSER_SCROLLBAR_WIDTH === 0 && isFFWithBuggyScrollbar()) {
                currentPadding = window.getComputedStyle(this.content, null).getPropertyValue('padding-right').replace(/[^0-9.]+/g, '');
                cssRule = {
                    right: -14,
                    paddingRight: +currentPadding + 14
                };
            } else if (BROWSER_SCROLLBAR_WIDTH) {
                cssRule = {
                    right: -BROWSER_SCROLLBAR_WIDTH
                };
                this.$el.addClass('has-scrollbar');
            }
            if (cssRule != null) {
                this.$content.css(cssRule);
            }
            return this;
        };


        /**
         @method restore
         @private
         */

        NanoScroll.prototype.restore = function() {
            this.stopped = false;
            if (!this.iOSNativeScrolling) {
                this.pane.show();
            }
            this.addEvents();
        };


        /**
         Resets nanoScroller's scrollbar.
         @method reset
         @chainable
         @example
         $(".nano").nanoScroller();
         */

        NanoScroll.prototype.reset = function() {
            var content, contentHeight, contentPosition, contentStyle, contentStyleOverflowY, paneBottom, paneHeight, paneOuterHeight, paneTop, parentMaxHeight, right, sliderHeight;
            if (this.iOSNativeScrolling) {
                this.contentHeight = this.content.scrollHeight;
                return;
            }
            if (!this.$el.find("." + this.options.paneClass).length) {
                this.generate().stop();
            }
            if (this.stopped) {
                this.restore();
            }
            content = this.content;
            contentStyle = content.style;
            contentStyleOverflowY = contentStyle.overflowY;
            if (BROWSER_IS_IE7) {
                this.$content.css({
                    height: this.$content.height()
                });
            }
            contentHeight = content.scrollHeight + BROWSER_SCROLLBAR_WIDTH;
            parentMaxHeight = parseInt(this.$el.css("max-height"), 10);
            if (parentMaxHeight > 0) {
                this.$el.height("");
                this.$el.height(content.scrollHeight > parentMaxHeight ? parentMaxHeight : content.scrollHeight);
            }
            paneHeight = this.pane.outerHeight(false);
            paneTop = parseInt(this.pane.css('top'), 10);
            paneBottom = parseInt(this.pane.css('bottom'), 10);
            paneOuterHeight = paneHeight + paneTop + paneBottom;
            sliderHeight = Math.round(paneOuterHeight / contentHeight * paneHeight);
            if (sliderHeight < this.options.sliderMinHeight) {
                sliderHeight = this.options.sliderMinHeight;
            } else if ((this.options.sliderMaxHeight != null) && sliderHeight > this.options.sliderMaxHeight) {
                sliderHeight = this.options.sliderMaxHeight;
            }
            if (contentStyleOverflowY === SCROLL && contentStyle.overflowX !== SCROLL) {
                sliderHeight += BROWSER_SCROLLBAR_WIDTH;
            }
            this.maxSliderTop = paneOuterHeight - sliderHeight;
            this.contentHeight = contentHeight;
            this.paneHeight = paneHeight;
            this.paneOuterHeight = paneOuterHeight;
            this.sliderHeight = sliderHeight;
            this.paneTop = paneTop;
            this.slider.height(sliderHeight);
            this.events.scroll();
            this.pane.show();
            this.isActive = true;
            if ((content.scrollHeight === content.clientHeight) || (this.pane.outerHeight(true) >= content.scrollHeight && contentStyleOverflowY !== SCROLL)) {
                this.pane.hide();
                this.isActive = false;
            } else if (this.el.clientHeight === content.scrollHeight && contentStyleOverflowY === SCROLL) {
                this.slider.hide();
            } else {
                this.slider.show();
            }
            this.pane.css({
                opacity: (this.options.alwaysVisible ? 1 : ''),
                visibility: (this.options.alwaysVisible ? 'visible' : '')
            });
            contentPosition = this.$content.css('position');
            if (contentPosition === 'static' || contentPosition === 'relative') {
                right = parseInt(this.$content.css('right'), 10);
                if (right) {
                    this.$content.css({
                        right: '',
                        marginRight: right
                    });
                }
            }
            return this;
        };


        /**
         @method scroll
         @private
         @example
         $(".nano").nanoScroller({ scroll: 'top' });
         */

        NanoScroll.prototype.scroll = function() {
            if (!this.isActive) {
                return;
            }
            this.sliderY = Math.max(0, this.sliderY);
            this.sliderY = Math.min(this.maxSliderTop, this.sliderY);
            this.$content.scrollTop(this.maxScrollTop * this.sliderY / this.maxSliderTop);
            if (!this.iOSNativeScrolling) {
                this.updateScrollValues();
                this.setOnScrollStyles();
            }
            return this;
        };


        /**
         Scroll at the bottom with an offset value
         @method scrollBottom
         @param offsetY {Number}
         @chainable
         @example
         $(".nano").nanoScroller({ scrollBottom: value });
         */

        NanoScroll.prototype.scrollBottom = function(offsetY) {
            if (!this.isActive) {
                return;
            }
            this.$content.scrollTop(this.contentHeight - this.$content.height() - offsetY).trigger(MOUSEWHEEL);
            this.stop().restore();
            return this;
        };


        /**
         Scroll at the top with an offset value
         @method scrollTop
         @param offsetY {Number}
         @chainable
         @example
         $(".nano").nanoScroller({ scrollTop: value });
         */

        NanoScroll.prototype.scrollTop = function(offsetY) {
            if (!this.isActive) {
                return;
            }
            this.$content.scrollTop(+offsetY).trigger(MOUSEWHEEL);
            this.stop().restore();
            return this;
        };


        /**
         Scroll to an element
         @method scrollTo
         @param node {Node} A node to scroll to.
         @chainable
         @example
         $(".nano").nanoScroller({ scrollTo: $('#a_node') });
         */

        NanoScroll.prototype.scrollTo = function(node) {
            if (!this.isActive) {
                return;
            }
            this.scrollTop(this.$el.find(node).get(0).offsetTop);
            return this;
        };


        /**
         To stop the operation.
         This option will tell the plugin to disable all event bindings and hide the gadget scrollbar from the UI.
         @method stop
         @chainable
         @example
         $(".nano").nanoScroller({ stop: true });
         */

        NanoScroll.prototype.stop = function() {
            if (cAF && this.scrollRAF) {
                cAF(this.scrollRAF);
                this.scrollRAF = null;
            }
            this.stopped = true;
            this.removeEvents();
            if (!this.iOSNativeScrolling) {
                this.pane.hide();
            }
            return this;
        };


        /**
         Destroys nanoScroller and restores browser's native scrollbar.
         @method destroy
         @chainable
         @example
         $(".nano").nanoScroller({ destroy: true });
         */

        NanoScroll.prototype.destroy = function() {
            if (!this.stopped) {
                this.stop();
            }
            if (!this.iOSNativeScrolling && this.pane.length) {
                this.pane.remove();
            }
            if (BROWSER_IS_IE7) {
                this.$content.height('');
            }
            this.$content.removeAttr('tabindex');
            if (this.$el.hasClass('has-scrollbar')) {
                this.$el.removeClass('has-scrollbar');
                this.$content.css({
                    right: ''
                });
            }
            return this;
        };


        /**
         To flash the scrollbar gadget for an amount of time defined in plugin settings (defaults to 1,5s).
         Useful if you want to show the user (e.g. on pageload) that there is more content waiting for him.
         @method flash
         @chainable
         @example
         $(".nano").nanoScroller({ flash: true });
         */

        NanoScroll.prototype.flash = function() {
            if (this.iOSNativeScrolling) {
                return;
            }
            if (!this.isActive) {
                return;
            }
            this.reset();
            this.pane.addClass('flashed');
            setTimeout((function(_this) {
                return function() {
                    _this.pane.removeClass('flashed');
                };
            })(this), this.options.flashDelay);
            return this;
        };

        return NanoScroll;

    })();
    $.fn.nanoScroller = function(settings) {
        return this.each(function() {
            var options, scrollbar;
            if (!(scrollbar = this.nanoscroller)) {
                options = $.extend({}, defaults, settings);
                this.nanoscroller = scrollbar = new NanoScroll(this, options);
            }
            if (settings && typeof settings === "object") {
                $.extend(scrollbar.options, settings);
                if (settings.scrollBottom != null) {
                    return scrollbar.scrollBottom(settings.scrollBottom);
                }
                if (settings.scrollTop != null) {
                    return scrollbar.scrollTop(settings.scrollTop);
                }
                if (settings.scrollTo) {
                    return scrollbar.scrollTo(settings.scrollTo);
                }
                if (settings.scroll === 'bottom') {
                    return scrollbar.scrollBottom(0);
                }
                if (settings.scroll === 'top') {
                    return scrollbar.scrollTop(0);
                }
                if (settings.scroll && settings.scroll instanceof $) {
                    return scrollbar.scrollTo(settings.scroll);
                }
                if (settings.stop) {
                    return scrollbar.stop();
                }
                if (settings.destroy) {
                    return scrollbar.destroy();
                }
                if (settings.flash) {
                    return scrollbar.flash();
                }
            }
            return scrollbar.reset();
        });
    };
    $.fn.nanoScroller.Constructor = NanoScroll;
});;
;
(function (angular, $, undefined) {
  'use strict';
  if ($.fn['nanoScroller'] === undefined) {
    throw new Error("nanoScrollerJS is not defined in jQuery");
  }
  //jQuery must be used, cause angular method 'find' has different behavior
  if (angular.element !== $) {
    throw new Error("Angular must use jQuery not jqLite");
  }

  var AS_ELEMENT = 1, AS_ATTRIBUTE = 0;
  /**
   * Wrapper of nanoScrollerJS
   * @name sun.scrollable
   */
  var module = angular.module('sun.scrollable', ['ng']);

  /**
   * Configuration for the directive
   * @name scrollableConfig
   * @param scrollableConfig.template Template of the scroller
   * @param scrollableConfig.bottomMargin Available number of pixels from the bottom,
   *        in which it is considered that scroller is in bottom
   */
  module.constant("scrollableConfig", {
    template    : '<div class="{nanoClass}"><div class="{contentClass}" ng-transclude></div></div>',
    bottomMargin: 40
  });

  /**
   * Default configuration of the nanoScroller
   * @name nanoScrollerDefaults
   */
  module.constant("nanoScrollerDefaults", {
    nanoClass   : 'nano',
    contentClass: 'nano-content'
  });
  module.directive("scrollable", createScrollableDirective(AS_ELEMENT));
  module.directive("scrollable", createScrollableDirective(AS_ATTRIBUTE));

  /**
   * Create directive 'scrollable' specified by variable `type`.
   * If type equals to `AS_ELEMENT` directive will replace element, otherwise template will be appended.
   * @param type Type of the directive: `AS_ELEMENT` or `AS_ATTRIBUTE`
   * @returns {function} Directive creation function
   */
  function createScrollableDirective(type) {
    var directive = function ($timeout, scrollableConfig, nanoScrollerDefaults) {
      return {
        transclude: true,
        replace   : type === AS_ELEMENT,
        restrict  : type === AS_ELEMENT ? 'E' : 'A',
        priority  : 1000,
        template  : format(scrollableConfig.template, nanoScrollerDefaults),
        link      : function (scope, element, attr) {
          var oldHeight,
            contentClass = nanoScrollerDefaults.contentClass,
            nanoClass = nanoScrollerDefaults.nanoClass,
            contentElement = element.find('.' + contentClass)[0],
            parentElement = contentElement.parentElement,
            $nanoElement = element.hasClass(nanoClass) ? element : element.find('.' + nanoClass),
            options = angular.extend({}, nanoScrollerDefaults, convertStringToValue(attr), scope.$eval(attr['scrollable']));

          function listener(newHeight, oldHeight) {
            // If this is first run, create nanoScroller
            if (newHeight === oldHeight) {
              // First run must be async
              scope.$evalAsync(function () {
                $nanoElement.nanoScroller(options);
                $nanoElement.nanoScroller();
              });
            }
            //If scroller was on the bottom, scroll to bottom
            else if (newHeight !== oldHeight && contentElement.scrollTop &&
              (oldHeight - contentElement.scrollTop - parentElement.clientHeight) < scrollableConfig.bottomMargin) {
              scope.$evalAsync(function () {
                // To make right calculation scroller must be reseted
                // See https://github.com/maxaon/angular-nanoscroller/issues/4
                $nanoElement.nanoScroller();
                $nanoElement.nanoScroller({scroll: 'bottom'});
              });

            }
            // Otherwise just update the pane
            else {
              $nanoElement.nanoScroller();
            }
          }

          function collectionListener() {
            var newHeight = contentElement.scrollHeight;
            if (oldHeight === undefined) {
              oldHeight = newHeight;
            }
            listener(newHeight, oldHeight);
          }

          if (attr['static']) {
            // Call scroller after transclusion
            listener();
          }
          else if (typeof attr['watch'] === 'string' || attr['watchCollection']) {
            angular.forEach(splitter(attr['watch']), function (name) {
              scope.$watch(name, collectionListener);
            });
            angular.forEach(splitter(attr['watchCollection']), function (name) {
              scope.$watchCollection(name, collectionListener);
            });
          }
          // If no watchers are supplied fall back to content element height check
          else {
            // http://jsperf.com/angular-watch-collection-vs-element-scroll-height
            // Call nanoScroller, when height of content is changed
            scope.$watch(function () {
                return contentElement.scrollHeight;
              },
              listener);
          }
          scope.$on("$destroy", function () {
            $nanoElement.nanoScroller({ destroy: true });
            $nanoElement = contentElement = parentElement = null;
          });
        }
      };
    };
    directive.$inject = ['$timeout', 'scrollableConfig', 'nanoScrollerDefaults'];
    return directive;
  }

  /**
   * Convert element attributes from stings to objects.
   * Also filter attribute (starting from '$' and class)
   * @param attr Attribute array
   * @returns {{}} Filtered object of converted attributes
   */
  function convertStringToValue(attr) {
    var result = {};
    angular.forEach(attr, function (value, key) {
      if (key.indexOf("$") === 0) {
        return;
      }
      switch (key) {
        case "true":
          value = true;
          break;
        case "false":
          value = false;
          break;
        case "null":
          value = null;
          break;
        case "class":
          return;
      }
      result[key] = value;
    });
    return result;
  }

  /**
   * Split text in attribute by `,` or `;`
   * @param val Attribute value
   * @returns {Array} Array of name
   */
  function splitter(val) {
    if (!val) {
      return [];
    }
    return val.replace(",", ";").split(";");
  }

  /**
   * Format `str` in python way (only dictionary)
   * @param str Input string
   * @param params Replacing variables
   * @returns {String}
   */
  function format(str, params) {
    return str.replace(new RegExp("{.*?}", "g"), function (variable) {
      return params[variable.slice(1, -1)] || "";
    });
  }

}(angular, jQuery));
;
(function() {
    /**
     * @ngdoc directive
     * @name sevenResizable
     * @function
     * @restrict 'A'
     * @element ANY
     * @param {expression=} onResizeMove {@link guide/expression Expression}
     * @param {expression=} onResizeStart {@link guide/expression Expression}
     * @param {expression=} onResizeEnd {@link guide/expression Expression}
     * @param {expression=} resizableOptions  {@link guide/expression Expression}
     */
    angular
        .module('seven-admin.shared')
        .directive('sevenResizable', sevenResizable);

    function sevenResizable() {
        return {
            restrict: 'A',
            scope: {
                onResizeMove: '&',
                onResizeStart: '&',
                onResizeEnd: '&',
                resizableOptions: '<'
            },
            link: function (scope, element) {
                var intractableElement = interact(element[0]);
                var options = true;

                if (scope.resizableOptions) {
                    options = scope.resizableOptions;
                }

                intractableElement
                    .resizable(options)
                    .on('resizemove', function(event) {
                        scope.$apply(scope.onResizeMove({event: event}));
                    })
                    .on('resizestart', function(event) {
                        scope.$apply(scope.onResizeStart({event: event}));
                    }).on('resizeend', function(event) {
                        scope.$apply(scope.onResizeEnd({event: event}));
                    });

                var cleanUpListeners = function() {
                    intractableElement.unset();
                };

                scope.$on("$destroy", cleanUpListeners);
            }
        }
    }
}());
;
sevenAdminShared.factory('auditSvc', ['userInitData', 'ENV_CFG', 'tokenAuthService', function (userInitData, ENV_CFG, tokenAuthService) {
	return {
		isAuditActive: false,
		init: function() {
			this.isAuditActive = _.get(userInitData, 'settings.application.auditLogs.active');

			if (!this.isAuditActive) return;

			SevenClientSDK.Audit.init({
				environment: ENV_CFG.env,
				tenant: userInitData.mode === "COMPANY" ? userInitData.currentCompany.uuid : userInitData.mode,
				source: "7Admin"
			});

			this.sendPostInitAuditRecords();
		},
		recordInterceptor: function(response) {
			if (!this.isAuditActive) return;

			var config = angular.copy(response.config);
			var extractResponseData = _.get(config, 'auditData.extractResponseData');
			var extractedData = {};

			if (_.isObject(extractResponseData)) {
				_.forEach(extractResponseData, function (responseDataKey, auditRecordKey) {
					var responseDataValue = _.get(response, responseDataKey)

					if (responseDataValue) {
						extractedData[auditRecordKey] = responseDataValue;
					}
				})
			}

			angular.merge(
				config,
				config.auditData,
				extractedData,
				{
					status: response.statusText || response.status
				}
			);

			SevenClientSDK.Audit.recordInterceptor(config);
		},
		record: function (data) {
			if (!this.isAuditActive) return;

			data.authorization = 'Bearer ' +tokenAuthService.getAccessToken();
			data.status = data.status || 'OK';

			SevenClientSDK.Audit.record(data);
		},
		/**
		 * @ngdoc function
		 * @function
		 * @memberOf auditSvc
		 * @name createAuditData
		 * @param {BaseAuditData} baseAuditData
		 * @param {ChangingAuditData} additionalAuditData
		 * @returns {AuditData}
		 */
		createAuditData: function (baseAuditData, additionalAuditData) {
			return _.assign({}, baseAuditData, additionalAuditData)
		},
		/**
		 * @ngdoc function
		 * @function
		 * @memberOf auditSvc
		 * @name createAuditRecordData
		 * @param {BaseAuditData} baseAuditData
		 * @param {ChangingAuditData} additionalAuditData
		 * @param response
		 * @returns {AuditRecordData}
		 */
		createAuditRecordData: function (baseAuditData, additionalAuditData, response) {
			var requestData = {
				url: response.config.url,
				method: response.config.method
			}
			return _.assign({}, baseAuditData, requestData, additionalAuditData);
		},
		preparePostInitAuditRecordPayload: function (payload) {
			const existingPayloads = JSON.parse(localStorage.getItem('postInitRecordPayloads')) || [];
            existingPayloads.push(payload);
			localStorage.setItem('postInitRecordPayloads', JSON.stringify(existingPayloads));
        },
		sendPostInitAuditRecords: function () {
			const postInitRecordPayloads = JSON.parse(localStorage.getItem('postInitRecordPayloads')) || [];
			postInitRecordPayloads.forEach((payload) => {
				this.record(payload);
			});
			localStorage.removeItem('postInitRecordPayloads');
        }
	}

	/**
	 * @typedef BaseAuditData
	 * @property {Boolean} audit - Enable or disable audit
	 * @property {String} domain - Audit domain
	 */

	/**
	 * @typedef ChangingAuditData
	 * @property {Boolean} [audit] - Enable or disable audit
	 * @property {String} resourceType - Audit resource type identifier
	 * @property {String} [resourceId] - Audit resource identifier (most often UUID or id)
	 * @property {String} [resourceDisplayId] - Audit resource display id
	 * @property {*} [context] - Audit context
	 */

	/**
	 * @typedef {BaseAuditData & ChangingAuditData} AuditData
	 */

	/**
	 * @typedef AuditRecordRequestData
	 * @property {String} url - HTTP request URL
	 * @property {String} method - HTTP request method
	 */

	/**
	 * @typedef {BaseAuditData & ChangingAuditData & AuditRecordRequestData} AuditRecordData
	 */
}]);
;
(function() {
    /**
     * @ngdoc service
     * @name GravityMenusService
     */
    angular
        .module('seven-admin.shared')
        .service('GravityMenusService', GravityMenusService);

    GravityMenusService.$inject = [
        '$log',
        '$translate',
        'userInitData'
    ]

    function GravityMenusService(
        $log,
        $translate,
        userInitData
    ) {
        var self = this;

        /**
         * @typedef MenuItemCustomData
         * @property {String} [when] - optional condition for displaying menu items
         * @property {Object} route - Route object
         * @property {String} route.name - Route name - must match part of state name after .
         *
         * @typedef MenuItem
         * @property {String} url
         * @property {String} title
         * @property {String} [subtitle]
         * @property {number} priority
         * @property {String} menuTitle
         * @property {string} menuName
         * @property {String} [icon]
         * @property {Boolean} disabled
         * @property {String} [description]
         * @property {MenuItemCustomData} customData
         *
         * @typedef {MenuItem[]} Menu
         *
         * @typedef {Object.<string, Menu>} Menus
         */

        /**
         * @name _menus
         * @propertyOf GravityMenusService
         * @type {{}|Menus}
         * @private
         */
        this._menus = {};

        /**
         * @ngdoc method
         * @function
         * @name setMenus
         * @memberOf GravityMenusService
         * @param {Menus} menus
         */
        this.setMenus = function(menus) {
            this._menus = filterMenus(angular.copy(menus));
        };

        /**
         * @ngdoc function
         * @function
         * @name getMenus
         * @memberOf GravityMenusService
         * @return {Menus}
         */
        this.getMenus = function() {
            return this._menus;
        }

        /**
         * @ngdoc function
         * @function
         * @name getMenu
         * @memberOf GravityMenusService
         * @param {String} name - Menu name
         * @return {Menu}
         */
        this.getMenu = function(name) {
            return this._menus[name] || [];
        }

        /**
         * @ngdoc function
         * @function
         * @name getMenuAsSubNavigation
         * @memberOf GravityMenusService
         * @param {String} name - Menu name
         * @return Object
         * @description Create object required for subnavigation directive menu from menus,
         * Roles are not yet supported so all menu items will be shown
         */
        this.getMenuAsSubNavigation = function(name) {
            return _
                .chain(this._menus[name])
                .keyBy('customData.route.name')
                .mapValues(function(menu, key) {
                    return {
                        id: key,
                        name: $translate.instant(menu.customData.translationKey),
                        priority: self._menus[name].length - menu.priority,
                        state: menu.menuName + '.' + key,
                        iconClass: 'n-i n-i-' + key,
                        visible: true,
                    }
                })
                .value();
        }

        /**
         * @name filterMenus
         * @param {Menus} menus
         * @return Menus
         */
        function filterMenus(menus) {
            const filteredMenus = _.reduce(menus, function(currentFilteredMenus, menu, menuKey) {
                var filteredMenuItems = _.filter(menu, function(menuItem) {
                    var menuItemCondition = _.get(menuItem, 'customData.when');

                    if (menuItemCondition) {
                        const conditionTokens = menuItemCondition.split(" ");

                        return evaluateTokens(conditionTokens);
                    }

                    return true;
                })

                if (filteredMenuItems.length) {
                    currentFilteredMenus[menuKey] = filteredMenuItems;
                }

                return currentFilteredMenus;
            }, {})

            /**
             * @name evaluateContext
             * @param {String} context
             * @param {String} value
             * @return {boolean}
             */
            function evaluateContext (context, value) {
                let contextValue;

                if (context === 'taxAuthority') {
                    contextValue = userInitData.taxAuthority && userInitData.taxAuthority.key;
                } else if ( context === 'tenant') {
                    contextValue = userInitData.currentCompany && userInitData.currentCompany.uuid
                } else {
                    $log.debug('Unsupported context', context);

                    return false;
                }

                if (value) {
                    return contextValue === value;
                } else {
                    return contextValue;
                }
            }

            /**
             * @name evaluateTokens
             * @param {Array<String>} tokens
             * @return {boolean}
             */
            function evaluateTokens(tokens) {
                if (tokens.length === 1 || tokens.length === 3) {
                    return evaluateContext(tokens[0], tokens[2])
                } else {
                    $log.debug('Unsupported condition format, supported formats are:');
                    $log.debug('{$context} == {$value}');
                    $log.debug('${context}')

                    return false;
                }
            }

            return filteredMenus;
        }
    }
}());
;
(function() {
    /**
     * @ngdoc service
     * @name GravitySettingsService
     */
    angular
        .module('seven-admin.shared')
        .service('GravitySettingsService', GravitySettingsService)

    function GravitySettingsService() {
        /**
         * @typedef {Object.<string, GravityApplicationSetting>|{}} GravityApplicationSettings
         * @typedef {Number|String|Object|undefined} GravityApplicationSetting
         */

        /**
         * @name _settings
         * @propertyOf GravitySettingsService
         * @type GravityApplicationSettings
         * @private
         */
        this._settings = {};

        /**
         * Set value of settings
         * @param settings
         */
        this.setSettings = function(settings) {
            this._settings = angular.copy(settings);
        }

        /**
         * Get all application settings
         * @returns GravityApplicationSettings
         */
        this.getSettings = function() {
            return this._settings;
        }

        /**
         *
         * @param key
         * @return GravityApplicationSetting
         */
        this.getSettingByKey = function(key) {
            return _.get(this._settings, key);
        }

        /**
         * Get application setting for module by name, optionally specific property by key (property key can use lodash.get syntax for deep selection)
         * @param {String} moduleName - Name of module
         * @param {String} [key] - Optional specific property by key (property key can use lodash.get syntax for deep selection)
         * @return GravityApplicationSetting
         */
        this.getModuleSettings = function(moduleName, key) {
            var moduleKeyPath = '["module.' + moduleName + '"]';
            var path = key ?
                moduleKeyPath + '.' + key :
                moduleKeyPath;

            return this.getSettingByKey(path);
        }
    }
}());
;
var socket;

sevenAdminShared.factory('socketSvc', [
    '$rootScope', '$cookies', 'userInitData', 'appSettingsSvc', 'tokenAuthService',
    function ($rootScope, $cookies, userInitData, appSettingsSvc, tokenAuthService) {
    var socketApi = appSettingsSvc.urls.socketApi;



    return {
        namespace: function (namespace){
            if (socket) {
                return socket;
            }
            var token = tokenAuthService.getAccessToken();

            socket = io.connect( socketApi + namespace, {
                query: 'token=' + token + '&clientType=user&clientSubType=Global',
                forceNew: true,
                transports: ['websocket']
            });
            return socket;
        },
        on: function (eventName, callback) {
            socket.emit('subscribe', eventName);
            
            socket.on(eventName, function () {
                var args = arguments;
                $rootScope.$apply(function () {
                    callback.apply(socket, args);
                });
            });
        },
        off: function (eventName) {
            // Some socket instances don't implement this event so they'll keep sending updates, nevertheless try sending it
            socket.emit('unsubscribe', eventName);
            socket.off(eventName);
        },
        emit: function (eventName, data, callback) {
            socket.emit(eventName, data, function () {
                var args = arguments;
                $rootScope.$apply(function () {
                    if (callback) {
                        callback.apply(socket, args);
                    }
                });
            })
        },
        disconnect: function(){
            return socket.disconnect();
        }
    };
}]);

;
/**
 * @ngdoc directive
 * @name spaceKey
 *
 * @description
 * The spaceKey directive allows you to specify custom behavior when
 * an element is enter key is pressed on focused element
 *
 * @element ANY
 * @param {expression} ngClick {@link guide/expression Expression} to evaluate upon
 * click. ({@link guide/expression#-event- Event object is available as `$event`})
 *
 */
sevenAdminShared.directive('spaceKey', [function () {
    return function (scope, element, attrs) {
        element.bind("keypress", function (event) {
            var keyCode = event.which || event.keyCode;
            if (keyCode === 32) {
                event.preventDefault();

                scope.$apply(function () {
                    scope.$eval(attrs.spaceKey);
                });

            }
        });
    };
}]);
;
(function() {
    angular
        .module('seven-admin.shared')
        .factory('tokenAuthService', ['$http', '$rootScope', 'appSettingsSvc', function ($http, $rootScope, appSettingsSvc) {
            var TOKEN_REFRESH_OFFSET_MS = 18000;

            // TODO 1: Replace every localStorage.getItem('token') with tokenAuthService.getAccessToken()
            // TODO 2: ACCESS_TOKEN_KEY value should be changed to 'SevenAccessToken' once first TODO is done
            var ACCESS_TOKEN_KEY = 'SevenAccessToken';
            var REFRESH_TOKEN_KEY = 'SevenRefreshToken';
            var SM_TOKEN_KEY = 'smToken';

            var accessToken = null;
            var refreshToken = null;
            var tokenRefreshCheck = null;

            function setTokens(at, rt) {
                if (at) {
                    accessToken = at;
                    localStorage.setItem(ACCESS_TOKEN_KEY, at);
                }

                if (rt) {
                    refreshToken = rt;
                    localStorage.setItem(REFRESH_TOKEN_KEY, rt);
                }
            }

            function setTokenRefreshCheck() {
                if (!accessToken || !refreshToken) return;

                var tokenRefreshInterval = _getTokenRefreshInterval();

                tokenRefreshCheck = setTimeout(function () {
                    _refreshAccessToken();
                }, tokenRefreshInterval);
            }


            function removeTokens() {
                localStorage.removeItem(ACCESS_TOKEN_KEY);
                localStorage.removeItem(REFRESH_TOKEN_KEY);
                localStorage.removeItem(SM_TOKEN_KEY);

                clearTimeout(tokenRefreshCheck);
            }

            function getAccessToken(addPrefix) {
                if (!accessToken) accessToken = localStorage.getItem(ACCESS_TOKEN_KEY);

                if (addPrefix) {
                    return 'Bearer ' + accessToken;
                } else {
                    return accessToken;
                }
            }

            function getRefreshToken(addPrefix) {
                if (!refreshToken) refreshToken = localStorage.getItem(REFRESH_TOKEN_KEY);

                if (addPrefix) {
                    return 'Bearer ' + refreshToken;
                } else {
                    return refreshToken;
                }
            }

            function getTokens(addPrefix) {
                return {
                    accessToken: getAccessToken(addPrefix),
                    refreshToken: getRefreshToken(addPrefix)
                }
            }

            function _refreshAccessToken() {
                $http({
                    url: appSettingsSvc.urls.api + '/iam/api/v1/authentication/regenerate',
                    method: 'POST',
                    data: {
                        refreshToken: refreshToken
                    }
                }).then(function (response) {
                    var data = response.data;
                    setTokens(data.accessToken, data.refreshToken);
                    setTokenRefreshCheck();
                    $rootScope.$broadcast('User.AuthorizationChanged', {});
                });
            }

            function _getTokenRefreshInterval() {
                var tokenExpiryTime = jwt_decode(accessToken).exp;
                var currentTime = moment().unix();

                return (tokenExpiryTime - currentTime) * 1000 - TOKEN_REFRESH_OFFSET_MS;
            }

            return {
                setTokenRefreshCheck: setTokenRefreshCheck,
                setTokens: setTokens,
                removeTokens: removeTokens,
                getAccessToken: getAccessToken,
                getTokens: getTokens
            };
        }]);
}());
;
sevenAdminShared.factory('translationSvc', ['$q', 'userInitData', 'ENV_CFG', '$http', '$window', function ($q, userInitData, ENV_CFG, $http, $window) {
    return function (options) {
        var deferred = $q.defer(),
            data = {};

        var getPublicTranslations = function (language) {
            return $http({
                url: ENV_CFG.api.gravity + '/admin/translations',
                method: 'GET',
                params: {public: 1},
                headers: {'X-Nsft-SCD-Locale': language}
            }).then(function (response) {
                if (response.data) {
                    return response.data;
                } else if (language !== 'en') {
                    return getPublicTranslations('en')
                } else {
                    return null;
                }
            })
        };

        if (!userInitData && ENV_CFG.api.gravity) {
            return getPublicTranslations($window.navigator.language.split("-")[0].toLowerCase());
        }

        if (userInitData) {
            data = userInitData.translations;
            deferred.resolve(data);
        } else {
            deferred.reject(options.key);
        }

        return deferred.promise;
    };
}]);
;
(function() {
    angular
        .module('seven-admin.shared')
        .directive('sevenDistinctFromValidator', distinctFromValidator)

    distinctFromValidator.$inject = [
        '$parse'
    ]

    function distinctFromValidator(
        $parse
    ) {
        return {
            link: link,
            require: 'ngModel',
            bindToController: true
        };

        function link (scope, element, attr, ngModelController) {
            var comparisonModels = $parse(attr.sevenDistinctFromValidator)(scope);

            if (_.isArray(comparisonModels) && comparisonModels.length) {
                ngModelController.$validators.distinctFrom = function(modelValue, viewValue) {
                    var modelEmpty = ngModelController.$isEmpty(viewValue);

                    return modelEmpty || _.every(comparisonModels, function(modelKey) {
                        var comparisonModelValue = _.get(scope, modelKey);

                        return ngModelController.$isEmpty(comparisonModelValue) || comparisonModelValue !== modelValue;
                    });
                }

                comparisonModels.forEach(function(modelKey) {
                    scope.$watch(modelKey, function() {
                        ngModelController.$validate();
                    });
                })
            }
        }
    }
}());
;
sevenAdminShared.directive('equalOrGreaterThan', function () {
    return {
        restrict: 'A',
        require: 'ngModel',
        bindToController: true,
        link: function (scope, element, attr, ngModelController) {
            var fieldValues;
            // Run validator when attribute changes
            attr.$observe('equalOrGreaterThan', function () {
                ngModelController.$validate();
            });

            // Run validator when compared field value changes
            scope.$watch(function () {
                return fieldValues && fieldValues[attr.equalOrGreaterThan];
            }, function () {
                ngModelController.$validate();
            });

            ngModelController.$validators.equalOrGreaterThan = function (modelValue, viewValue) {
                fieldValues = attr.equalOrGreaterThanControllerAs ? scope[attr.equalOrGreaterThanControllerAs].fieldValues : scope.fieldValues;
                return fieldValues && (
                    ngModelController.$isEmpty(viewValue) ||
                    isNaN(Number(fieldValues[attr.equalOrGreaterThan])) ||
                    isNaN(Number(viewValue)) ||
                    (Number(viewValue) >= Number(fieldValues[attr.equalOrGreaterThan]))
                );
            };
        }
    }
});;
sevenAdminShared.directive('equalOrLessThan', function () {
    return {
        restrict: 'A',
        require: 'ngModel',
        bindToController: true,
        link: function (scope, element, attr, ngModelController) {
            var fieldValues;
            // Run validator when attribute changes
            attr.$observe('equalOrLessThan', function () {
                ngModelController.$validate();
            });

            // Run validator when compared field value changes
            scope.$watch(function () {
                return fieldValues && fieldValues[attr.equalOrLessThan]
            }, function () {
                ngModelController.$validate();
            });

            ngModelController.$validators.equalOrLessThan = function (modelValue, viewValue) {
                fieldValues = attr.equalOrLessThanControllerAs ? scope[attr.equalOrLessThanControllerAs].fieldValues : scope.fieldValues;
                return fieldValues && (
                    ngModelController.$isEmpty(viewValue) ||
                    isNaN(Number(fieldValues[attr.equalOrLessThan])) ||
                    isNaN(Number(viewValue)) ||
                    (Number(viewValue) <= Number(fieldValues[attr.equalOrLessThan]))
                );
            };
        }
    }
});;
sevenAdminShared.directive('greaterThan', function () {
    return {
        restrict: 'A',
        require: 'ngModel',
        bindToController: true,
        link: function (scope, element, attr, ngModelController) {
            var fieldValues;
            // Run validator when attribute changes
            attr.$observe('greaterThan', function () {
                ngModelController.$validate();
            });

            // Run validator when compared field value changes
            scope.$watch(function () {
                return fieldValues && fieldValues[attr.greaterThan];
            }, function () {
                ngModelController.$validate();
            });

            ngModelController.$validators.greaterThan = function (modelValue, viewValue) {
                fieldValues = attr.greaterThanControllerAs ? scope[attr.greaterThanControllerAs].fieldValues : scope.fieldValues;
                return (
                    ngModelController.$isEmpty(viewValue) ||
                    isNaN(Number(fieldValues[attr.greaterThan])) ||
                    isNaN(Number(viewValue)) ||
                    (Number(viewValue) > Number(fieldValues[attr.greaterThan]))
                );
            };
        }
    }
});;
(function () {
    sevenAdminShared.directive('sevenLength', sevenLength);

    sevenLength.$inject = ['$parse'];

    function sevenLength($parse) {
        return {
            restrict: 'A',
            require: '?ngModel',
            link: function (scope, elm, attr, ctrl) {
                if(!ctrl) return;

                var requiredLength;
                var requiredLengthGetter = $parse(attr.sevenLength);
                var multiple;

                // Validates length, can use single value, or array of values (valid if is matches any of values)
                ctrl.$validators.sevenLength = function (modelValue, viewValue) {
                    if (!viewValue || !requiredLength) return true;
                    if (multiple) return requiredLength.indexOf(viewValue.length) !== -1;
                    else return requiredLength === viewValue.length;
                };

                attr.$observe('sevenLength', function () {
                    requiredLength = requiredLengthGetter(scope);
                    multiple = _.isArray(requiredLength);

                    ctrl.$validate();
                });
            }
        }
    }
}());;
sevenAdminShared.directive('lessThan', function () {
    return {
        restrict: 'A',
        require: 'ngModel',
        bindToController: true,
        link: function (scope, element, attr, ngModelController) {
            var fieldValues;
            // Run validator when attribute changes
            attr.$observe('lessThan', function () {
                ngModelController.$validate();
            });

            // Run validator when compared field value changes
            scope.$watch(function () {
                return fieldValues && fieldValues[attr.lessThan];
            }, function () {
                ngModelController.$validate();
            });

            ngModelController.$validators.lessThan = function (modelValue, viewValue) {
                fieldValues = attr.lessThanControllerAs ? scope[attr.lessThanControllerAs].fieldValues : scope.fieldValues;
                return fieldValues && (
                    ngModelController.$isEmpty(viewValue) ||
                    isNaN(Number(fieldValues[attr.lessThan])) ||
                    isNaN(Number(viewValue)) ||
                    (Number(viewValue) < Number(fieldValues[attr.lessThan]))
                );
            };
        }
    }
});;
(function () {
    /**
     * @ngdoc directive
     * @name sevenMaxDate
     * @restrict A
     *
     * @param {expression} sevenMaxDate - expression of type Date
     */
    angular
        .module('seven-admin.shared')
        .directive('sevenMaxDate', sevenMaxDateDirective);

    sevenMaxDateDirective.$inject = ['$parse'];

    function sevenMaxDateDirective($parse) {
        return {
            restrict: 'A',
            require: '?ngModel',
            link: function (scope, element, attrs, ngModelController) {
                var maxDate;
                var maxDateGetter = $parse(attrs.sevenMaxDate);

                attrs.$observe('sevenMaxDate', function () {
                    maxDate = maxDateGetter(scope);
                    ngModelController.$validate();
                });

                scope.$watch(function () {
                    return maxDateGetter(scope)
                }, function (newValue) {
                    maxDate = newValue;
                    ngModelController.$validate();
                });

                ngModelController.$validators.sevenMaxDate = function (modelValue) {
                    return !isValidDate(modelValue) || isUndefined(maxDate) || modelValue < maxDate;
                };

                function isValidDate(value) {
                    // picked from angular source,
                    // Invalid Date: getTime() returns NaN
                    return value && !(value.getTime && value.getTime() !== value.getTime());
                }

                function isUndefined(value) {return typeof value === 'undefined';}
            }
        }
    }
}());
;
(function () {
    /**
     * @ngdoc directive
     * @name sevenMinDate
     * @restrict A
     *
     * @param {expression} sevenMinDate - expression of type Date
     */
    angular
        .module('seven-admin.shared')
        .directive('sevenMinDate', sevenMinDateDirective);

    sevenMinDateDirective.$inject = ['$parse'];

    function sevenMinDateDirective($parse) {
        return {
            restrict: 'A',
            require: '?ngModel',
            link: function (scope, element, attrs, ngModelController) {
                var minDate;
                var minDateGetter = $parse(attrs.sevenMinDate);

                attrs.$observe('sevenMinDate', function () {
                    minDate = minDateGetter(scope);
                    ngModelController.$validate();
                });

                scope.$watch(function () {
                    return minDateGetter(scope)
                }, function (newValue) {
                    minDate = newValue;
                    ngModelController.$validate();
                });

                ngModelController.$validators.sevenMinDate = function (modelValue) {
                    return !isValidDate(modelValue) || isUndefined(minDate) || modelValue > minDate;
                };

                function isValidDate(value) {
                    // picked from angular source,
                    // Invalid Date: getTime() returns NaN
                    return value && !(value.getTime && value.getTime() !== value.getTime());
                }

                function isUndefined(value) {return typeof value === 'undefined';}
            }
        }
    }
}());
;
(function () {
    sevenAdminShared.directive('sevenUiSelectRequired', sevenUiSelectRequiredDirective);

    // Used just as attribute, if needed add support for requiredness expression evaluation
    function sevenUiSelectRequiredDirective() {
        return {
            restrict: 'A',
            require: '?ngModel',
            link: function (scope, elm, attr, ctrl) {
                if (!ctrl) return;

                ctrl.$validators.sevenUiSelectRequired = function (modelValue, viewValue) {
                    if (attr.hasOwnProperty('multiple'))
                        return !!(modelValue && modelValue.length) || !!(viewValue && viewValue.length);
                    else
                        return !ctrl.$isEmpty(modelValue) || !!ctrl.$isEmpty(viewValue);
                };

                attr.$observe('sevenUiSelectRequired', function () {
                    ctrl.$validate();
                });
            }
        }
    }
}());;
(function() {
  angular
    .module('seven-admin.shared')
    .service('widgetService', WidgetService);

    function WidgetService() {
      var self = this,
          _widgets = {};

      this.registerWidget = function (key, widget) {
        var localWidget = JSON.parse(window.localStorage.getItem('widget.' + key));
        _widgets[key] = localWidget || widget;
      };

      this.registerWidgetsFromAppSettings = function (applicationSettings) {
        _.forEach(applicationSettings, function(value, key) {
          if (!key.startsWith('widget.')) return;

          var widget = _.cloneDeep(value),
              widgetKey = key.replace('widget.', '');

          self.registerWidget(widgetKey, widget);
        });
      };
      
      this.getWidgetByKey = function (key) {
        return _widgets[key];
      };
    }
})();
;
(function() {
    angular
        .module('seven-admin.zodiac', []);
}());
;
sevenAdminComponents.directive('viewAccordion', ['browserService', '$timeout', function (browserService, $timeout) {

    var templateUrl = '/app/components/accordion/accordion.html';

    return {
        restrict: 'E',
        templateUrl: browserService.IE9OrLess ? templateUrl.split('#')[0] : templateUrl,
        scope: true,
        controller: function ($scope) {

            $scope.semiSelectedRoles = {};
            /**
             * Watch for changes in roles
             * Highlight select all btn after roles are initialized
             */
            $scope.$watch('fieldValues.roles', function (roles) {

                if (!roles || !roles.length) return;

                highlightSelectAllBtn();
            });


            /**
             * Set semi selected module containers to add class to select all btn
             */
            function highlightSelectAllBtn () {
                angular.forEach($scope.view.viewContent.fields, function (module, name) {
                    $scope.semiSelectedRoles[name] = checkRolesInArray(module.roles, $scope.fieldValues.roles);
                });
            }


            /**
             * Check if there are selected roles in separate module permission container
             * @param moduleRoles
             * @param fieldValuesRoles
             * @returns {boolean}
             */
            function checkRolesInArray (moduleRoles, fieldValuesRoles) {
                var hasRoles = false;

                angular.forEach(moduleRoles, function (role) {
                    if (fieldValuesRoles.indexOf(role.id) !== -1) {
                        hasRoles = true;
                    }
                });

                return hasRoles;
            }

            /**
             * Set action bar state
             * Save btn will be enabled or disabled depending on equality of old and new data
             */
            var checkActionBarState = function () {

                var name = $scope.view.viewContent.name;
                $scope.saveStates[name] = !(angular.equals($scope.fieldValues, $scope.oldFieldData));

            };

            /**
             * Triggered directly from view
             */
            $scope.checkActionBarState = function () {
                checkActionBarState();
            };

            $scope.setAccordionFormActionBarState = function () {
                $timeout(function () {
                    var name = $scope.view.viewContent.name,
                        currentForm = $scope[name],
                        changedForm = !angular.equals($scope.fieldValues, $scope.oldFieldData);

                    $scope.saveStates[name] = (currentForm.$valid && changedForm);
                });
            };


            /**
             * Checkbox value changed in accordion permissions
             * @param role
             * @param key
             */
            $scope.checkboxChange = function (role, key) {

                if (!$scope.fieldValues.roles) {
                    $scope.fieldValues.roles = [];
                }

                var index = $scope.fieldValues.roles.indexOf(role);

                if (index === -1) {
                    $scope.fieldValues.roles.push(role);
                    $scope.selectedRoles[role] = role;
                } else {
                    $scope.fieldValues.roles.splice(index,1);
                    delete $scope.selectedRoles[role];
                }

                highlightSelectAllBtn();
                checkActionBarState();
            };


            /**
             * Add all roles to field values from single module
             * @param data
             */
            function selectAllCheckboxes(data) {
                angular.forEach(data.roles, function (val) {
                    var roleInGroup = $scope.groupRoles && $scope.groupRoles.indexOf(val.id) !== -1;

                    if(!roleInGroup) {
                        if($scope.fieldValues.roles.indexOf(val.id) === -1) {
                            $scope.fieldValues.roles.push(val.id);
                        }
                        $scope.selectedRoles[val.id] = val.id;
                    }
                });

                checkActionBarState();
            }


            /**
             * Remove all roles form field values for single module
             * @param data
             */
            function unSelectAllCheckboxes(data) {
                var index;
                angular.forEach(data.roles, function (val) {
                    var roleInGroup = $scope.groupRoles && $scope.groupRoles.indexOf(val.id) !== -1;

                    index = $scope.fieldValues.roles.indexOf(val.id);
                    if(!roleInGroup) {
                        if (index !== -1) {
                            $scope.fieldValues.roles.splice(index, 1);
                        }
                        delete $scope.selectedRoles[val.id];
                    }
                });

                checkActionBarState();
            }


            /**
             * Watch for select all trigger in accordion permissions
             * @param trigger
             * @param key
             */
            $scope.triggerAll = function (trigger, key) {
                if (!$scope.fieldValues.roles) {
                    $scope.fieldValues.roles = [];
                }

                var allCheckboxes = $scope.view.viewContent.fields[key];
                trigger ? selectAllCheckboxes(allCheckboxes) : unSelectAllCheckboxes(allCheckboxes);


                highlightSelectAllBtn();
                checkActionBarState();
            };

            $scope.accordionSelectAll = {};


            /**
             * Highlight select all button if all roles are selected
             */
            $scope.$watch('selectedRoles', function(newValue){

                if (newValue) {
                    angular.forEach($scope.view.viewContent.fields, function (val,key){
                        $scope.accordionSelectAll[key] = true;

                        angular.forEach(val.roles, function(v){
                            if(v.id !== newValue[v.id]) {
                                $scope.accordionSelectAll[key] = false;
                            }
                        });
                    });
                }
            }, true);

        }
    }
}]);
;
(function () {
  angular
      .module('seven-admin.components')
      .directive('alert', function(){
        return {
          restrict: 'E',
          transclude: true,
          scope: { type:'@' },
          templateUrl: '/app/components/alert/alert.html'
        };
    })
}());
;
(function () {
    angular.module('seven-admin.components').component('bannerMessageBar', {
        templateUrl: '/app/components/banner-message-bar/banner-message-bar.template.html',
        bindings: {
            message: '<',
        },
        controllerAs: 'vm'
    });
}());
;
(function () {
    angular
        .module('seven-admin.components')
        .component('breadcrumbs', {
            templateUrl: '/app/components/breadcrumbs/breadcrumbs.html',
            controller: BreadcrumbsController
        });

    BreadcrumbsController.inject = [
        '$scope',
        '$rootScope',
        'Titles',
        '$state',
        'FavoritesService'
    ];

    function BreadcrumbsController(
        $scope,
        $rootScope,
        Titles,
        $state,
        FavoritesService
    ) {
        var init = function() {
            $scope.breadcrumbs = Titles.content;
            $scope.toggleFavorite = toggleFavorite;

            setWatchers();
        };

        var checkIsBreadcrumbFavorite = function () {
            $scope.isFavorite = false;

            if (FavoritesService.favorites && FavoritesService.favorites.length && $scope.breadcrumbs.length) {
                var breadcrumbState = $scope.breadcrumbs[$scope.breadcrumbs.length -1].link;

                FavoritesService.favorites.forEach(function (favorite) {
                    var paramsMatch = !_.isEmpty(favorite.params) ? _.isMatch($state.params, favorite.params) : true;

                    if (favorite.state === breadcrumbState && paramsMatch) {
                        $scope.isFavorite = true;
                    }
                });
            }
        };

        var setWatchers = function() {
            $scope.$watch('breadcrumbs', function (breadcrumbs) {
                $scope.breadcrumbs = breadcrumbs;
                checkIsBreadcrumbFavorite();
            }, true);

            $scope.$watch(function () {
                return FavoritesService.favorites
            }, function () {
                checkIsBreadcrumbFavorite();
            }, true);
        };

        var toggleFavorite = function (breadcrumbs) {
            var state = $state.current.name;
            var uiSref = _.isEmpty($state.params) ? state : _.template('${state}(${params})')({
                state: state,
                params: JSON.stringify($state.params)
            });

            FavoritesService.toggleFavorite({
                uiSref: uiSref,
                state: state,
                params: $state.params,
                title: breadcrumbs[breadcrumbs.length - 1].name
            })
        };

        init();
    }
}());
;
/**
 * @ngdoc service
 * @name Titles
 * @requires $rootScope
 * @requires $state
 * @requires appSettingsSvc
 *
 **/
sevenAdminComponents.factory('Titles', ['$rootScope', '$state', 'appSettingsSvc', 'GravitySettingsService', 'GravityMenusService', function ($rootScope, $state, appSettingsSvc, GravitySettingsService, GravityMenusService) {
    this.content = [];
    $rootScope.pageTitle = '7Admin';
    
    this.resetBreadcrumbs = function () {
        this.content.splice(0, this.content.length); // keep the reference for listener
    };

    this.setPageTitle = function () {
        $rootScope.pageTitle = '';
        var name;

        for (var i = 0; i < this.content.length; i++) {
            name = this.content[i] ? this.content[i].name : '';
            $rootScope.pageTitle += name;

            if (i < this.content.length - 1) {
                $rootScope.pageTitle += ' > ';
            }
        }

        $rootScope.pageTitle += ' - 7Admin';
    };

    this.setBreadcrumbs = function () {
        var module = $state.current.data.module,
            mainState = '',
            min;

        this.resetBreadcrumbs();

        if (!appSettingsSvc.modules[module]) return;

        var useMenus = GravitySettingsService.getModuleSettings(module, 'useMenus');
        var subnavigation = useMenus ?
            GravityMenusService.getMenuAsSubNavigation(module) :
            appSettingsSvc.modules[module].submodules;
        var currentViewSubmoduleName = $state.current.parentView.split('.')[1];
        var currentStateName = _.get(subnavigation, `${currentViewSubmoduleName}.name`);

        angular.forEach(subnavigation, function (v) {
            if ((min && v.priority < min) || !min) {
                mainState = v.state;
                min = v.priority;
            }
        });

        this.content.push({
            name: appSettingsSvc.modules[module].name,
            link: mainState
        });

        if (!isEmpty(subnavigation) && currentStateName) {
            this.content.push({
                name: currentStateName,
                link: $state.current.parentView
            });
        }
    };

    /**
     * @memberOf Titles
     * Sets breadcrumbs and page title from current state module structure,
     * if name parameter is provided appends that to breadcrumbs and title
     *
     * @param {string} [name] - Title of state that will be appended to automatically set breadcrumbs
     */
    this.autoSet = function (name) {
        this.setBreadcrumbs();
        
        if (name) {
            this.content.push({
                name: name,
                link: $state.current.name
            });
        }
        
        this.setPageTitle();
    };

    this.manualSet = function (content) {
        this.resetBreadcrumbs();

        for (var i = 0; i < content.length; i++) {
            this.content.push(content[i]);
        }

        this.setPageTitle();
    };

    this.manualSetByIndex = function (content, index) {
        this.content[index] = content;
        this.setPageTitle();
    };

    return this;
}]);
;
sevenAdminComponents.directive('deviceList', ['browserService', function (browserService) {

    var templateUrl = '/app/components/cards/device-list/device-list.html';

    return {
        restrict: 'E',
        templateUrl: browserService.IE9OrLess ? templateUrl.split('#')[0] : templateUrl,
        scope: true,
        controller: function ($scope) {
            var init = function () {
                $scope.filters = creteFilters();

                $scope.toggleAll = toggleAll;
                $scope.filterDeviceType = filterDeviceType;
                $scope.toggleActive = toggleActive;
            };

            var creteFilters = function () {
                return {
                    status: {
                        opened: false,
                        active: true,
                        values: {
                            isInstalled: true,
                            isReadyToInstall: true,
                            isUninstalled: false
                        }
                    },
                    type: {
                        opened: false,
                        active: false,
                        values: {
                            shop: false,
                            terminal: false,
                            visualization: false,
                            undefined: false
                        }
                    }
                }
            };

            var toggleAll = function (filter, toggleState) {
                for (var key in filter.values) {filter.values[key] = toggleState}
                filter.active = toggleState;
            };

            var filterDeviceType = function (device) {
                // For devices without type value is "" so it's remapped to undefined so it can be matched with filter key
                var deviceType = device.type || 'undefined';
                // If all device types are deselected display all of them, don't show empty device list
                var allDeselected = _.reduce($scope.filters.type.values, function (result, item) {
                    return !item && result;
                }, true);

                if (allDeselected) return true;

                return $scope.filters.type.values[deviceType];
            };

            var toggleActive = function (filter) {
                filter.active = _.reduce(filter.values, function(result, filterItem){
                    return result || filterItem;
                }, false)
            };

            init();
        }
    }
}]);
;
sevenAdminComponents.directive('viewProducts', [
    'appSettingsSvc', 'browserService', function (appSettingsSvc, browserService) {

        var templateUrl = '/app/components/cards/product-list-general/product-list-general.html';

    return {
        restrict: 'E',
        templateUrl: browserService.IE9OrLess ? templateUrl.split('#')[0] : templateUrl,
        scope: true,
        controller: function ($scope) {
            $scope.baseImageUrl = appSettingsSvc.urls.cmsAssets + '/public_general/product_';
            $scope.placeholderUrl = appSettingsSvc.urls.cmsAssets + '/public_general/product_products_placeholder_242x136.jpg';

            $scope.noLowLevelProductConfig = [
                'PreMatchBetting',
                'LiveBetting',
                'SportradarVTO',
                'SportradarVFL',
                'SportradarVBL',
                'SportsbookSM',
                'WorldNumbers',
                'PoolBet'
            ]
        }
    }
}]);
;
sevenAdminComponents.directive('productsList', ['appSettingsSvc', 'browserService', function (appSettingsSvc, browserService) {

    var templateUrl = '/app/components/cards/product-list/product-list.html';

    return {
        restrict: 'E',
        templateUrl: browserService.IE9OrLess ? templateUrl.split('#')[0] : templateUrl,
        scope: true,
        controller: function ($scope) {
            $scope.baseImageUrl = appSettingsSvc.urls.cmsAssets + '/public_general/product_';
            $scope.placeholderUrl = appSettingsSvc.urls.cmsAssets + '/public_general/product_products_placeholder_242x136.jpg'
        }
    }
}]);
;
sevenAdminComponents.directive('walletPluginList', ['browserService', function (browserService) {

    var templateUrl = '/app/components/cards/wallet-plugin-list/wallet-plugin-list.html';

    return {
        restrict: 'E',
        templateUrl: browserService.IE9OrLess ? templateUrl.split('#')[0] : templateUrl,
        scope: true,
        controller: function () {}
    }
}]);
;
(function () {
    angular
        .module('seven-admin.components')
        .component('changelogs', {
            templateUrl: '/app/components/changelog/changelogs.template.html',
            controller: Changelogs,
            controllerAs: 'changelogsVm',
            bindings: {
                changelogs: '<'
            }
        });

    Changelogs.$inject = [
        '$scope',
        '$timeout',
        'ChangelogService'
    ];

    function Changelogs(
        $scope,
        $timeout,
        ChangelogService
    ) {
        var changelogsVm = this;

        Object.defineProperty(changelogsVm, "hasUnreadChangelogs", {
            get: function() {
                return ChangelogService.hasUnreadChangelogs;
            }
        });

        changelogsVm.getChangelog = getChangelog;
        changelogsVm.markChangelogAsRead = markChangelogAsRead;
        changelogsVm.markAllChangelsAsRead = ChangelogService.markAllChangelogsAsRead;
        changelogsVm.backToChangelogs = backToChangelogs;

        function markChangelogAsRead(changelog) {
            if (changelog.unread !== false) {
                ChangelogService.markChangelogAsRead(changelog)
            }
        }

        function getChangelog(changelog) {
            ChangelogService.getChangelog(changelog.name).then(function(changelog) {
                changelogsVm.changelog = changelog;
                changelogsVm.changelogOpened = true;
            })
        }

        function backToChangelogs() {
            changelogsVm.changelogOpened = false;
        }
    }
}());
;
sevenAdminComponents.component('comments', {
    template: function () {
        return [
            '<iframe id="{{::commentsVm.frameId}}"',
            'ng-src="{{commentsVm.source}}"',
            'style="width:100%;"',
            'frameborder="0"',
            'scrolling="no">',
            '</iframe>'
        ].join('');
    },
    controllerAs: 'commentsVm',
    controller: ['$log', '$scope', '$sce', 'ENV_CFG', 'dataSvc', 'userInitData', 'gatewayService', function ($log, $scope, $sce, ENV_CFG, dataSvc, userInitData, gatewayService) {
        var vm = this;

        var basePluginId = 'PluginGravityComments';
        var frameId = 'plugin-gravity-comments';
        var instanceId = dataSvc.uuidv4();
        var instancedFrameIdTemplate = _.template('${frameId}.${instanceId}');
        var pluginId;
        var pluginIdTemplate = _.template('${basePluginId}.${instanceId}');
        var pluginSourceTemplate = _.template('${base}?instanceID=${instanceId}');

        var allowedNamespaces = {
            Betshop: 'Betshop',
            Player: 'Player',
            Ticket: 'Ticket',
            Display: 'Display'
        };

        var init = function () {
            var basePluginSource = ENV_CFG.frames[basePluginId];
            var pluginSource = vm.newInstance ? pluginSourceTemplate({base: basePluginSource, instanceId: instanceId}) : basePluginSource;

            pluginId = vm.newInstance ? pluginIdTemplate({basePluginId: basePluginId, instanceId: instanceId}) : basePluginId;
            vm.frameId = vm.newInstance ? instancedFrameIdTemplate({frameId: frameId, instanceId: instanceId}) : frameId;

            if (basePluginSource) {
                vm.source = $sce.trustAsResourceUrl(pluginSource);

                addSlaveGateway();
                setListeners();
            }
        };

        var changes = function (changes) {
            if (changes && changes.reference) {
                // First change will be handled in $onInit, all others here
                if (!changes.reference.isFirstChange()) {
                    changeReference(changes.reference.currentValue);
                }
            }
        };

        var addSlaveGateway = function() {
            gatewayService.addSlave({
                slaveId: pluginId,
                frameId: vm.frameId,
                loaded: function () {
                    changeReference(vm.reference);
                },
                data: gatewayService.getLoadPayload({
                    context: gatewayService.getAccount().id
                })
            })
        };

        var destroySlaveGateway = function() {
            gatewayService.removeSlave(pluginId);
        };

        var getContext = function () {
            if (userInitData.currentCompany) {
                return userInitData.currentCompany.uuid;
            }
        };

        var getNamespacedReference = function (namespace, reference) {
            return _.template('${namespace}.${reference}')({
                namespace: namespace,
                reference: reference
            });
        };

        var changeReference = function () {
            if (allowedNamespaces && vm.namespace) {
                var namespace = allowedNamespaces[vm.namespace];
                if (namespace) {
                    if (vm.reference) {
                        gatewayService.gateway.sendMessage(vm.frameId, {
                            action: 'Comments.ReferenceChanged',
                            slaveId: pluginId,
                            data: {
                                context: getContext(),
                                reference: getNamespacedReference(namespace, vm.reference),
                                language: userInitData.user.language
                            }
                        });
                    }
                } else {
                    $log.warn('[Admin] Comment namespace is not allowed =>', vm.namespace);
                }
            }
        };

        var setListeners = function () {
            $scope.$on('User.AuthorizationChanged', function (event, user) {
                gatewayService.gateway.sendMessage(vm.frameId, {
                    action: 'User.AuthorizationChanged',
                    productId: pluginId,
                    data: {
                        user: user,
                        language: userInitData.user.language
                    }
                });
            });
        };

        vm.$onInit = init;
        vm.$onChanges = changes;
        vm.$onDestroy = destroySlaveGateway;
    }],
    bindings: {
        namespace: '@',
        reference: '<',
        newInstance: '<'
    }
});
;
sevenAdminComponents.directive('viewConfiguration', [
    '$rootScope', '$location', 'appSettingsSvc', 'browserService',
    function ($rootScope, $location, appSettingsSvc, browserService) {

        var templateUrl = '/app/components/config-forms/config-forms.html';

    return {
        restrict: 'E',
        templateUrl: browserService.IE9OrLess ? templateUrl.split('#')[0] : templateUrl,
        scope: true,
        controller: function ($scope) {

            $scope.activeTabButton = 0;

            // Check for form validity on configuration form field changes.
            // And enable/disable save button if form is valid and there are changes in form
            $scope.configurationFormFieldAction = function () {

                var name = $scope.view.viewContent.name,
                    currentForm = $scope[name];

                var formValid = currentForm.$valid,
                    valuesEquals = !(angular.equals($scope.fieldValues, $scope.oldFieldData));

                $scope.saveStates[name] = (formValid && valuesEquals);
            };


            $scope.checkStep = function(val, type) {
                if (type === 'integer' || !val) {
                    return 1;
                } else {
                    return (Math.pow(10, Math.floor(val).toString().length - 2));
                }

            };

            /* This field (boolean-array) is a hack made for Dugandzic,
            since he doesn't know a thing about modern frontend techniques
            and gets angry too quickly */

            $scope.booleanArrayOptions = {};

            $scope.checkArrayValues = function(fieldKey, fieldValue) {
                return $scope.fieldValues[fieldKey].indexOf(fieldValue) !== -1;
            };

            $scope.setArrayValues = function(fieldKey, fieldValue, cbState) {
                var elemIndex = $scope.fieldValues[fieldKey].indexOf(fieldValue);

                if (cbState && elemIndex < 0) {
                    $scope.fieldValues[fieldKey].push(fieldValue);
                } else if (elemIndex >= 0) {
                    $scope.fieldValues[fieldKey].splice(elemIndex, 1);
                }
            };

            function d(elem) {
                return document.getElementById(elem);
            }

            $scope.moveWell = function (direction, id, currentVal, total, isEnum) {
                var elem = d('multi_' + id + '_' + currentVal),
                    next = '',
                    total = parseInt(total);

                if (direction === 1) { /* previous */
                    next = (currentVal > 1) ? (currentVal - 1) : total;
                } else { /* next */
                    next = (currentVal < total) ? (currentVal + 1) : 1;
                }
                if(!isEnum) {
                    elem.parentElement.parentElement.className = 'ng-hide';
                    d('multi_' + id + '_' + next).parentElement.parentElement.className = 'ng-show';
                } else {
                    elem.parentElement.parentElement.parentElement.className = 'ng-hide';
                    d('multi_' + id + '_' + next).parentElement.parentElement.parentElement.className = 'ng-show';
                }
            };

            $scope.checkEnumType = function (variable) {
                return typeof variable !== 'object';
            }
        }
    }
}]);
;
sevenAdminProductMgmt.factory('configFormService', [ '$translate', function ($translate) {


    function generateConfigurationInstances (data) {
        var configInstance = [];
        angular.forEach(data, function (val, key) {

            configInstance = [];
            configInstance.push({
                'schema': val.generalValidationSchema,
                'config': val.generalConfig,
                'oldConfig': angular.copy(val.generalConfig),
                'name': $translate.instant('general.general')
            });
            angular.forEach(val.companyProductInstances, function (v) {
                configInstance.push({
                    'schema': val.instanceValidationSchema,
                    'config': v.config ? v.config : {},
                    'oldConfig': v.config ? angular.copy(v.config) : {},
                    'name': v.deliveryPlatform,
                    'uuid': v.uuid
                });
            });
        });

        return configInstance;
    }


    return {
        /**
         * Will generate configuration instances
         * @param data
         * @returns {Array}
         */
        setConfigurationInstances: function (data) {

            var configInstance = [];
            angular.forEach(data, function (val, key) {

                configInstance = [];
                configInstance.push({
                    'schema': val.generalValidationSchema,
                    'config': val.generalConfig,
                    'oldConfig': angular.copy(val.generalConfig),
                    'name': $translate.instant('general.general')
                });

                angular.forEach(val.companyProductInstances, function (v) {
                    configInstance.push({
                        'schema': val.instanceValidationSchema,
                        'config': v.config ? v.config : {},
                        'oldConfig': v.config ? angular.copy(v.config) : {},
                        'name': v.deliveryPlatform,
                        'uuid': v.uuid
                    });
                });
            });

        return configInstance;

        },


        /**
         * Will generate views (tabs) by configuration instances
         * @param instances
         * @param {Object} config
         * @returns {Array}
         */


        generateViews: function (instances, config) {
            var views = [];

            for (var i = 0; i < instances.length; i++) {

                views.push({
                    'name': instances[i].name ? instances[i].name : instances[i].deliveryPlatform,
                    'negativeActionText': $translate.instant('general.cancel'),
                    'positiveActionText': $translate.instant('general.save'),
                    'negativeActionCallback': 'cancelChanges',
                    'positiveActionCallback': 'saveData',
                    'canProceed': 'no',
                    'formEmpty': config.formEmpty ? 'yes' : 'no',
                    'viewContent' : {
                        'type': 'configuration',
                        'buttons': 'yes',
                        'name': 'configurationForm_' + i,
                        'id': 'config-' + i,
                        'overwrittenIcon': config.overwrittenIcon ? 'yes': 'no',
                        'fields': []
                    }
                });
            }

            return views;
        },

        /**
         * Will filter out non-defined schema keys
         * @param {Object} fieldValues
         * @returns {Object}
         */

        filterConfig: function (fieldValues, provider) {
            // Allow null values only for NGS products
            var allowNullValues = provider === 'ngs';
 
            angular.forEach(fieldValues, function (val, key) {
                var isUndefined = angular.isUndefined(val);
                var isNull = val === null;
                if (isUndefined || (!allowNullValues && isNull)) {
                    delete fieldValues[key];
                }
            });

            return fieldValues;
        },

        /**
         * Will generate a response based on configuration form tabs
         * @param data
         * @param saveSchema
         * @returns {Object}
         */
        groupFormData: function (data, saveSchema) {
            var response = {};

            angular.forEach(saveSchema, function (schemaItem, schemaKey) {
                response[schemaKey] = {};
                angular.forEach(data, function (item, itemKey) {
                    if (schemaItem[itemKey]) {
                        response[schemaKey][itemKey] = item;
                    }
                });
            });

            return response;
        }
    }

}]);;
sevenAdminComponents.directive('ipWhitelistForm', ['browserService', 'ipWhitelistService', '$translate', function (browserService, ipWhitelistService, $translate) {

    var templateUrl = '/app/components/config-forms/ip-whitelist-form.html';

    return {
        restrict: 'E',
        templateUrl: browserService.IE9OrLess ? templateUrl.split('#')[0] : templateUrl,
        scope: false,
        controller: function ($scope) {
            $scope.addIPAddressField = function addIPAddressField(IPAddressType, IPAddressVersion) {
                var fieldsLength = $scope.view.viewContent.fields[IPAddressType].length,
                    field = ipWhitelistService.getIPAddresField({type: IPAddressVersion + IPAddressType}, fieldsLength);

                $scope.lastAddedFieldId = field.id;

                $scope.view.viewContent.fields[IPAddressType].push(field);
            };

            $scope.removeIPAddressField = function removeIPAddressField(id, removedIndex, type) {
                var lastIndex = $scope.view.viewContent.fields[type].length - 1;

                // Remap fields array and remove field
                $scope.view.viewContent.fields[type].map(function (fieldValue, index) {
                    var newFieldValue = {};
                    if (index >= removedIndex && index !== lastIndex) {
                        newFieldValue.name = $scope.view.viewContent.fields[type][index + 1].name;
                        newFieldValue.id = fieldValue.id;
                        newFieldValue.unique = $scope.view.viewContent.fields[type][index + 1].unique;

                        return newFieldValue;
                    } else {
                        return fieldValue;
                    }
                });

                $scope.view.viewContent.fields[type].splice(lastIndex, 1);

                $scope.removeFieldValue(id, removedIndex, type);
                $scope.setActionBarState();
            };

            $scope.setActionBarState = function setActionBarState() {

                // current view name
                var name = $scope.view.viewContent.name,
                    // active form
                    currentForm = $scope[name];

                var changedForm = !angular.equals($scope.fieldValues, $scope.oldFieldData);

                $scope.saveStates[name] = (currentForm.$valid && changedForm);
            };
        }
    }
}]);
;
sevenAdminComponents.factory('ipWhitelistService', ['$translate',function ($translate) {
        function getIPAddressType (ipAddress) {
            return ipAddress.type.slice(2).toLowerCase();
        }

        function getIPAddressVersion (ipAddress) {
            return ipAddress.type.slice(0, 2)
        }


        return {
            getFieldValue: function (ipAddress) {
                var rangeArray;

                if (ipAddress.type.slice(2).toLowerCase() === 'range') {
                    rangeArray = ipAddress.lowerBound.split('.').map(function (value, index) {
                        if (value === ipAddress.upperBound.split('.')[index]) {
                            return value;
                        } else {
                            return value + '/' + ipAddress.upperBound.split('.')[index];
                        }
                    });

                    return rangeArray.join('.');
                }

                return ipAddress.ip;
            },

            getIPAddresField: function (ipAddress, fieldsLength) {
                var field = {};

                if (getIPAddressType(ipAddress) === 'single') {
                    var IPAddressVersion = getIPAddressVersion(ipAddress, fieldsLength);

                    field.name = 'IP' + IPAddressVersion + ' ' + $translate.instant('general.address');
                    field.id = IPAddressVersion.toUpperCase() + 'Single_' + fieldsLength;
                    field.pattern = /^(?:(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.){3}(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)$/;
                } else {
                    field.name = 'IP Range';
                    field.id = 'V4Range_' + fieldsLength;
                }

                return field;
            },

            generateIPAddressData: function (fieldValues, forceChange) {
                var ipOptions = [],
                    type,
                    address,
                    lowerBound,
                    upperBound;

                angular.forEach(fieldValues, function (value, key) {
                    type = key.split('_')[0].slice(2);
                    address = {};
                    lowerBound = [];
                    upperBound = [];

                    if (type === 'Single' && value) {
                        address = {type: 'V4Single', ip: value};
                        ipOptions.push(address);
                    } else if (type === 'Range') {
                        angular.forEach(value.split('.'), function (rangePart) {
                            if (rangePart.indexOf('/') === -1) {
                                lowerBound.push(rangePart);
                                upperBound.push(rangePart)
                            } else {
                                lowerBound.push(rangePart.split('/')[0]);
                                upperBound.push(rangePart.split('/')[1]);
                            }
                        });

                        address = {
                            type: 'V4Range',
                            lowerBound: lowerBound.join('.'),
                            upperBound: upperBound.join('.')
                        };
                        ipOptions.push(address);
                    }
                });

                return {
                    ipOptions: ipOptions,
                    forceChange: forceChange,
                    verifyCode: fieldValues.verifyCode
                };
            },

            getIPAddressType: getIPAddressType
        }
}]);;
sevenAdminComponents.directive('viewInstances', ['appSettingsSvc', 'browserService', function (appSettingsSvc, browserService) {

    var templateUrl = '/app/components/config-forms/product-instances/product-instances.html';

    return {
        restrict: 'E',
        templateUrl: browserService.IE9OrLess ? templateUrl.split('#')[0] : templateUrl,
        scope: true,
        controller: function ($scope) {
            $scope.baseImageUrl = appSettingsSvc.urls.cmsAssets + '/public_general/product_';
            $scope.placeholderUrl = appSettingsSvc.urls.cmsAssets + '/public_general/product_products_placeholder_315x178.jpg';
        }
    }
}]);
;
sevenAdminComponents.directive('displayConfig', ['browserService', function (browserService) {

    var templateUrl = '/app/components/device-config/display-config.html';

    return {
        restrict: 'E',
        templateUrl: browserService.IE9OrLess ? templateUrl.split('#')[0] : templateUrl,
        scope: true,
        controller: function ($scope, $element, $attrs) {

        }
    }
}]);
;

sevenAdminComponents.directive('peripheralsForm', ['browserService', function (browserService) {

    var templateUrl = '/app/components/device-config/peripherals.html';

    return {
        restrict: 'E',
        templateUrl: browserService.IE9OrLess ? templateUrl.split('#')[0] : templateUrl,
        scope: true,
        controller: function () {
        }
    }
}]);
;
sevenAdminComponents.directive('systemInfo', ['browserService', function (browserService) {

    var templateUrl = '/app/components/device-config/system-info.html';

    return {
        restrict: 'E',
        templateUrl: browserService.IE9OrLess ? templateUrl.split('#')[0] : templateUrl,
        scope: true,
        controller: function ($scope, $element, $attrs) {

        }
    }
}]);
;
(function () {
    angular
        .module('seven-admin.components')
        .controller('AboutController', AboutController);

    AboutController.$inject = [
        '$document',
        '$scope',
        '$translate',
        'APP',
        'applicationSettingsService',
        'ChangelogService',
        'userInitData'
    ];

    function AboutController(
        $document,
        $scope,
        $translate,
        APP,
        applicationSettingsService,
        ChangelogService,
        userInitData
    ) {
        var aboutVm = this;

        var init = function () {
            aboutVm.aboutViews = creteViews();
            aboutVm.activeView = $scope.data.changelog ? 'changelog' : 'about';
            aboutVm.fullHeight = aboutVm.activeView === 'changelog';
            Object.defineProperty(aboutVm, "changelogs", {
                get: function() {
                    return ChangelogService.changelogs;
                }
            });

            aboutVm.activateView = activateView;
            aboutVm.close = closePopup;

            loadApplicationDesciption();
            registerClosePopupHandler();
            createScopeListeners();
        };

        var activateView = function (view) {
            aboutVm.activeView = view.name;
            aboutVm.fullHeight = view.name === 'changelog';
        };

        var creteViews = function() {
            return [{
                name: "about",
                title: $translate.instant("general.about_7admin")
            }, {
                name: "changelog",
                title: $translate.instant("general.changelog")
            }]
        };

        var loadApplicationDesciption = function() {
            getApplicationVersions().then(function (versions) {
                var version = versions[_.get(userInitData, 'currentCompany.uuid')] || APP.version;

                aboutVm.appDescription = {
                    name: '7Admin',
                    version: version,
                    build: APP.build,
                    releaseDate: '21.6.2017',
                    aboutApp: '7Admin is a very powerful administrative suite that enables the customer to track all \
                               business data in real time. With this application, it is possible to review daily, weekly,\
                               monthly and annual reports with desired parameters. \
                               Furthermore, it provides tracking of individual bet shops, as well as the entire \
                               business or just specific group of bet shops.',
                    copyrightMsg: 'Copyright \xA9 ' + moment().format('YYYY') + ' NSoft d.o.o. Mostar. All rights reserved.'
                }
            });
        };

        var registerClosePopupHandler = function() {
            $document.on('keyDown', closeWithKeyboardHandler)
        };


        var deregisterClosePopupHandler = function() {
            $document.off('keyDown', closeWithKeyboardHandler)
        };

        var createScopeListeners = function() {
            $scope.$on("$destroy", deregisterClosePopupHandler);
        };

        var closePopup = function () {
            $scope.close();
        };

        var closeWithKeyboardHandler = function(event) {
            var ESCAPE = 27;

            if (event.which === ESCAPE) {
                closePopup();
            }
        };

        var getApplicationVersions = function () {
            return applicationSettingsService.getApplicationVersions();
        };

        init();
    }
}());
;
sevenAdminComponents.directive('confirmPopup', [function () {

    return {
        restrict: 'E',
        scope: {
            infoText: '=',
            size: '=',
            confirm: '&',
            cancel: '&'
        },
        template: '<div class="popup-dialog-wrapper">' +
                        '<div class="confirm-popup" ng-class="size">' +
                            '<div class="popup-dialog-header">{{infoText.header}}</div>' +
                            '<div class="confirm-popup-content">{{infoText.content}}</div>' +

                            '<div class="sm-form-button-row">' +
                                '<button class="btn btn-default" ng-click="cancel()" translate>general.no</button>' +
                                '<button class="btn btn-primary" ng-click="confirm()" translate>general.yes</button>' +
                            '</div>' +
                        '</div>' +
                    '</div>'
    }
}]);
;
sevenAdminComponents.directive('dialogWindow', ['browserService', function (browserService) {

    var templateUrl = '/app/components/dialogs/dialog-window/dialog-window.html';

    return {
        restrict: 'E',
        templateUrl: browserService.IE9OrLess ? templateUrl.split('#')[0] : templateUrl,
        scope: true,
        controller: function ($scope) {

            $scope.saveStates = $scope.saveStates || {};

            $scope.submitCode = function (action, index) {
                $scope.$emit('actionBar:' + action, { index : index, viewContentName : $scope.viewContentName });
            };

            $scope.$watch('resetSelectionField', function (data) {
                angular.element(document.getElementById('users')).val('');
            }, true);
        }
    }
}]);
;
sevenAdminComponents.directive('popupDialog', ['browserService', function (browserService) {

	var templateUrl = '/app/components/dialogs/popup-dialog/popup-dialog.html';

	return {
		restrict: 'A',
		scope: {
			popupShow: '=',
			popupHeading: '@',
			popupRejectText: '@',
			popupConfirmText: '@',
			popupConfirmAction: '=',
			popupConfirmDisabled: '='
		},
		replace: true,
		transclude: true,
		templateUrl: browserService.IE9OrLess ? templateUrl.split('#')[0] : templateUrl,
		controller: function ($scope) {

			// $scope.popupShow = false;

			$scope.closePopup = function() {
				$scope.popupShow = false;
			}
		}
	}
}]);
;
sevenAdminComponents.directive('actionBar', ['browserService', function (browserService) {

    var templateUrl = '/app/components/forms/action-bar/action-bar.html';

	return {
		restrict: 'E',
		templateUrl: browserService.IE9OrLess ?  templateUrl.split('#')[0] : templateUrl,
		scope: {
            negativeActionCallback: '=',
            positiveActionCallback: '=',
            customActionCallback: '=',
            resendInviteActionCallback: '=',
            negativeActionText: '=',
            positiveActionText: '=',
            customActionText: '=',
            resendInviteActionText: '=',
            resendActivated: '=',
            canProceed: '=',
            formEmpty: '=',
            ignoreValidation: '=',
            validate: '=',
            saveStates: '=',
            customActionDisabled: '=',
            oldData: '=',
            newData: '=',
            viewName: '=',
            changeInProgress:'=',
            viewType: '=',
            index: '=',
            viewContentName: '=',
            viewContentType: '=',
            customClassName: '=',
		},
		controller: function ($scope) {

            // Enable current form Save button if form is set to empty form
            var checkFormType = function () {
                if ($scope.ignoreValidation === 'yes') return;
                $scope.saveStates[$scope.viewName] = $scope.formEmpty === 'yes';
            };

            checkFormType();


            // Watch for old field data value changes and enable/disable save button
            $scope.$watch('oldData', function (value) {
                if ($scope.ignoreValidation === 'yes') return;

                $scope.saveStates[$scope.viewName] = !(angular.equals(value, $scope.newData));

                checkFormType();
            });

            // Emit events for actions bar to controllers
            $scope.actionBarEmit = function (callback) {

                $scope.$emit('actionBar:' + $scope[callback], {
                    index : $scope.index,
                    viewContentName : $scope.viewContentName
                });
            };
		}
	};

}]);
;
sevenAdminComponents.factory('formSvc', ['$translate',function ($translate) {
    return {

        /**
         * Create form display information
         * @param {Array} fields
         * @returns {null}
         */

        createFormFields: function (fields) {
            var form = [];

            angular.forEach(fields, function (field, key) {
                var newField = {
                    'name': field.name,
                    'placeholder': field.placeholder ? field.placeholder : field.name,
                    'id': field.id,
                    'type': field.type,
                    'disabled': field.disabled || 'no',
                    'required': field.required || 'no',
                    'error': field.error || 'Empty or invalid ' + field.name
                };

                if (field.type === 'text' || field.type === 'textarea' || field.type === 'number' || field.type === 'email' ) {
                    newField.disabled = field.disabled ? 'yes' : 'no';
                    newField.classes = 'form-control input-md';
                }

                if (field.type === 'select') {
                    newField.classes = 'form-control input-md';
                    newField.disabled = field.disabled ? 'yes' : 'no';
                    newField.options = field.options;
                    newField.default = field.default || $translate.instant('general.select_value');
                }

                if (field.type === 'multi-combo') {
                    newField.allItems = field.allItems;
                    newField.selectedItems = field.selectedItems;
                }

                if (field.type === 'checkbox') {
                    newField.classes = 'checkbox-toggle-btn';
                    newField.disabled = field.disabled ? 'yes' : 'no';
                }

                if (field.pattern) {
                    newField.pattern = field.pattern;
                }

                if (field.maxlength) {
                    newField.maxlength = field.maxlength;
                }

                if (field.min) {
                    newField.min = field.min;
                }

                if (field.max) {
                    newField.max = field.max;
                }

                if (field.callback) {
                    newField.callback = field.callback;
                }

                if (field.greaterThan) {
                    newField.greaterThan = field.greaterThan;
                }

                if (field.lessThan) {
                    newField.lessThan = field.lessThan;
                }

                if (field.equalOrLessThan) {
                    newField.equalOrLessThan = field.equalOrLessThan;
                }

                if (field.equalOrGreaterThan) {
                    newField.equalOrGreaterThan = field.equalOrGreaterThan;
                }

                form.push(newField);
            });

            return form;
        },

        setAvailableFields: function (formFields, dataFields) {
            var dataFieldKeys = Object.keys(dataFields);

            for (var i = formFields.length - 1; i >= 0; i--) {
                if (dataFieldKeys.indexOf(formFields[i].id) === -1) {
                    formFields.splice(i, 1);
                }
            }

            return formFields;
        }
    };
}]);;
sevenAdminComponents.directive('viewForm', ['$rootScope', 'browserService', '$timeout', function ($rootScope, browserService, $timeout) {

    var templateUrl = '/app/components/forms/main-form/main-form.html';

    return {
        restrict: 'E',
        templateUrl: browserService.IE9OrLess ? templateUrl.split('#')[0] : templateUrl,
        scope: true,
        require : '^^?viewTemplates',
        controller: function ($scope, $element, $attrs) {

            /**
             * Form fields change trigger
             * Disable Save button if form is invalid
             * Disable Save button if first load data is equal to current
             */

            $scope.newPasswordValue = {};

            $scope.changeFormField = function () {

                    // current view name
                var name = $scope.view.viewContent.name,
                    // active form
                    currentForm = $scope[name];

                var changedForm = !angular.equals($scope.fieldValues, $scope.oldFieldData);

                $timeout(function() {
                    $scope.saveStates[name] = (currentForm.$valid && changedForm);
                }, 100);
            };

            $scope.selectSingleOption = function (item, field, allItems) {

                $scope.fieldValues[field] = [];
                $scope.selectedOptions[field] = [];

                angular.copy(allItems, $scope.fieldValues[field]);

                if (item) {
                    item = angular.fromJson(angular.toJson(item)); //remove $$hashKey field
                    swapValues($scope.fieldValues[field], $scope.selectedOptions[field], item)
                }
            };

            function swapValues(removeFrom, addTo, item) {
                var key = null;
                angular.forEach(removeFrom, function (v, k) {
                    v.id ? key = 'id' : key = 'value';
                    if (v[key] === item[key]) {
                        removeFrom.splice(k, 1);
                    }
                });

                addTo.push(item);
            }

            $scope.addMultiOption = function (item, field) {
                item = angular.fromJson(angular.toJson(item)); // remove $$hashKey field
                var fId = item.id ? 'id' : 'value';
                $scope.fieldValues[field].push(item[fId]);
            };

            $scope.removeMultiOption = function (item, field) {
                var fId = item.id ? 'id' : 'value',
                    index = $scope.fieldValues[field].indexOf(item[fId]);
                $scope.fieldValues[field].splice(index, 1);
            };

            $scope.checkSelectionParams = function (cbFields, cbFieldId) {
                $scope.maxFieldsSelected = false;
                var selectedNum = 0;

                angular.forEach(cbFields.values, function(cbField, k) {
                    if (cbField.selected) {
                        ++selectedNum;
                    }
                });

                if (selectedNum > cbFields.options.maximum && cbFields.values[cbFieldId].selected === true) {
                    cbFields.values[cbFieldId].selected = false;
                    $scope.maxFieldsSelected = true;
                } else {
                    $scope.maxFieldsSelected= false;
                }

                if (selectedNum === cbFields.options.maximum) {
                    $scope.maxFieldsSelected = true;
                }
            };

            $scope.$on('resetFormValidation', function (events, data) {
                $scope[data.formName].$setPristine();
            });

            var passwordFields = {};

            $scope.$on('setPasswordField', function (evt, field) {
                passwordFields[field.id] = field.value;
            });

            $scope.$on('fieldChanged', function () {
                $scope.changeFormField();
            });

            $scope.setPasswordDisplay = function (field, fieldValue) {
                $scope.fieldValues[field.id] = passwordFields[field.id];

                field.type === 'password' ? field.type = 'text' : field.type = 'password';
            };

            $scope.selectColor = function (field, item) {
                $scope.fieldValues[field.id] = item;
                $rootScope.userTheme = item;
            };

            // Used since angular.isFunction can't be used in template
            $scope.isFunctionA = function (value) {
                return angular.isFunction(value);
            };
        },
        link: function (scope, element, attrs, viewTemplatesController) {
            //If viewTemplates directive controller exist and if view contains steps notify viewTemplates directive about form validity
            if (viewTemplatesController && scope.viewList.type == 'steps') {
                scope.$watch(function () {
                    return scope[scope.view.viewContent.name].$invalid;
                }, function (formInvalid) {
                    viewTemplatesController.setStepChangeValidity(formInvalid)
                });
            }
        }
    }
}]);

sevenAdminComponents.directive('checkPassword', function () {
    return {
        restrict: 'A',
        require: 'ngModel',
        link: function($scope, $element, $attrs, ngModelCtrl) {
            ngModelCtrl.$parsers.splice(0,0,(function (fieldValue) {
                $scope.$emit('setPasswordField', {
                    id: $attrs.id,
                    value: fieldValue
                });

                return fieldValue;
            }));
        }
    };
});
;
sevenAdminComponents.directive('readOnlyForm', ['browserService', function (browserService) {

    var templateUrl = '/app/components/forms/read-only-form/read-only-form.html';

    return {
        restrict: 'E',
        templateUrl: browserService.IE9OrLess ? templateUrl.split('#')[0] : templateUrl,
        scope: true,
        controller: function ($scope) {

        }
    }
}]);
;
sevenAdminComponents.directive('saveMenu', ['browserService', function (browserService) {

    var templateUrl = '/app/components/forms/save-menu/save-menu.html';

	return {
		restrict: 'E',
		templateUrl: browserService.IE9OrLess ? templateUrl.split('#')[0] : templateUrl,
		scope: {
			formData: '=',
			oldData: '=',
			newData: '='
		},
		controller: function ($scope, $element, $attrs) {

			$scope.saveBtnActive = true;

            $scope.$watch('newData', function (newData) {

                // Disable save button if is not a valid form
                if ($scope.formData.$invalid) {
                    $scope.saveBtnActive = false;
                    return;
                }

                // Disable save button if newData == oldData
                if (angular.equals (newData, $scope.oldData)) {
                    $scope.saveBtnActive = false;
                    return;
                }

                // Otherwise show save button - there are some changes
                $scope.saveBtnActive = true;
            }, true);

            // oldData should equal to newData after successful save action
            $scope.$watch('oldData', function (oldData) {

                // Disable save button if oldData == newData
                if (angular.equals (oldData, $scope.newData)) {
                    $scope.saveBtnActive = false;
                    return;
                }

                $scope.saveBtnActive = true;
            }, true);

            // CANCEL action sent to controller
            $scope.cancel = function () {
                $scope.$emit('saveMenu:cancel');
            };

            // SAVE action sent to controller if is a valid form
            $scope.save = function () {
                // if ($scope.formData.$valid) {
                    $scope.saveBtnActive = false;
                    $scope.$emit('saveMenu:save');
                // }
            };
		}
	};
}]);
;
(function () {
    'use strict';

    angular
        .module('seven-admin.components')
        .component('headerServices', {
            templateUrl: '/app/components/header/header-services/header-services.template.html',
            controllerAs: 'model',
            controller: [
                '$scope',
                'userInitData',
                function ($scope, userInitData) {
                    var vm = this;
                    vm.zodiacEnabled = !!_.get(userInitData, 'settings.company.zodiacEnabled');
                }]
        });
})();
;
sevenAdminComponents.directive('companyList', ['$state', '$stateParams', '$timeout', '$window', 'appSettingsSvc', 'browserService', 'companyIdentitySvc', 'userInitData',
    function ($state, $stateParams, $timeout, $window, appSettingsSvc, browserService, companyIdentitySvc, userInitData) {

        var templateUrl = '/app/components/header/user-menu-profile/company-list/company-list.html';

        return {
            restrict: 'E',
            replace: true,
            templateUrl: browserService.IE9OrLess ? templateUrl.split('#')[0] : templateUrl,
            controller: function ($scope) {

                $scope.userCompanies = userInitData.user ? userInitData.user.companies : [];

                // Sort companies by name
                if (!isEmpty($scope.userCompanies)) {
                    $scope.userCompanies.sort(function (a, b) {
                        return a.name.toLowerCase() > b.name.toLowerCase() ? 1 : -1;
                    });
                    $scope.activeCompanies = $scope.userCompanies.filter(company => {
                        return company.isActive;
                    })
                    $scope.disabledCompanies = $scope.userCompanies.filter(company => {
                        return !company.isActive;
                    })
                }

                // Add super admin mode if user have it
                if (userInitData.hasSuperAdminMode) {
                    $scope.superAdmin = {name: 'Super Admin', id: 'super'};
                }

                $scope.switchCompany = function (companyId, currentState) {
                    companyIdentitySvc
                        .switchCompany(companyId)
                        .then(function () {
                            companyIdentitySvc.saveFutureRedirectPath(currentState);
                            $window.location.reload();
                    });
                };

                $scope.$watch('companySearch.name', function(newValue, oldValue) {
                    var regex = new RegExp($scope.companySearch.name, 'i');
                    $scope.activeCompanies = $scope.userCompanies.filter(company => {
                        return company.isActive && regex.test(company.name);
                    });
                    $scope.disabledCompanies = $scope.userCompanies.filter(company => {
                        return !company.isActive && regex.test(company.name);
                    });
                });

                // Determine current selected company or super mode, used to highlight selected company or super admin
                var setCurrentCompany = function () {

                    if (userInitData.mode === 'SUPER') {
                        setSelectedAttribute('super');
                        return;
                    }

                    for (var i = 0; i < userInitData.user.companies.length; i++) {
                        if (userInitData.user.companies[i].id === userInitData.user.lastCompany) {
                            setSelectedAttribute(userInitData.user.companies[i].id);
                        }
                    }
                };

                setCurrentCompany();

                // Set attribute 'selected' and each company and super admin mode,
                // used to highlight selected company or super admin
                function setSelectedAttribute(id) {
                    var i = 0;
                    if (id === 'super') {
                        $scope.superAdmin['selected'] = true;
                    }
                    for (i = 0; i < $scope.activeCompanies.length; i++) {
                        $scope.activeCompanies[i].selected = $scope.activeCompanies[i].id === id;
                    }
                    for (i = 0; i < $scope.disabledCompanies.length; i++) {
                        $scope.disabledCompanies[i].selected = $scope.disabledCompanies[i].id === id;
                    }
                }

                
            }
        };

    }]);

;
(function() {
    angular
        .module("seven-admin.components")
        .factory("companyIdentitySvc", companyIdentitySvc);

    companyIdentitySvc.$inject = ["$http", "$state", "appSettingsSvc"];

    function companyIdentitySvc($http, $state, appSettingsSvc) {
        var redirectPathStorageKey = "companySwitch.redirectPath";

        return {
            /**
             * Switch between companies by company id
             *
             * @param {String} companyId
             * @returns {HttpPromise}
             */
            switchCompany: function(companyId) {
                return $http
                    .post(
                        appSettingsSvc.urls.api + "/admin/companies/switches",
                        {
                            companyId: companyId
                        }
                    )
                    .then(function(response) {
                        return response;
                    });
            },

            /**
             * Saves path of current state's parentView to local storage so it can be used after reload to redirect to correct
             * path
             *
             * @function
             * @memberOf companyIdentitySvc
             * @name saveFutureRedirectPath
             * @param {string} currentState
             */
            saveFutureRedirectPath: function(currentState) {
                // If state matches products save to product list state since different companies have different products
                var companySwitchRedirectState =
                    currentState.parentView.split(".")[0] === "productMgmt"
                        ? "productMgmt.products"
                        : currentState.parentView;
                var companySwitchRedirectPath = $state
                    .href(companySwitchRedirectState)
                    .replace("#", "");

                localStorage.setItem(
                    redirectPathStorageKey,
                    companySwitchRedirectPath
                );
            },

            /**
             * Returns redirect path from local storage
             *
             * @function
             * @memberOf companyIdentitySvc
             * @name getRedirectPath
             * @returns {string}
             */
            getRedirectPath: function() {
                return localStorage.getItem(redirectPathStorageKey);
            },

            /**
             * Removes redirect path from local storage
             *
             * @function
             * @memberOf companyIdentitySvc
             * @name removeRedirectPath
             */
            removeRedirectPath: function() {
              localStorage.removeItem(redirectPathStorageKey);
            },

            /**
             * Checks does redirect path exists
             *
             * @function
             * @memberOf companyIdentitySvc
             * @name redirectPathExists
             * @returns {boolean}
             */
            redirectPathExists: function() {
                return !!this.getRedirectPath();
            }
        };
    }
})();
;
sevenAdminComponents.directive('userMenuProfile', ['$filter', '$rootScope', 'appSettingsSvc', 'browserService', 'userInitData',
	function ($filter, $rootScope, appSettingsSvc, browserService, userInitData) {

	var templateUrl = '/app/components/header/user-menu-profile/user-menu-profile.html';

	return {
		restrict: 'E',
		templateUrl: browserService.IE9OrLess ? templateUrl.split('#')[0] : templateUrl,
		scope: true,
		controller: function ($scope) {

			$scope.menuActive = false;
			$scope.user = userInitData.user;
			$scope.availableLink = [];
			$scope.superAdminMode = userInitData.mode === 'SUPER';
            $scope.companyListActive = false;
            $scope.companySearch = {name: ''};

			var companies = userInitData.user.companies;

			// Remove messages from user menu
			if (_.get(appSettingsSvc, 'modules.userSettings.submodules.messages')) {
				delete appSettingsSvc.modules.userSettings.submodules.messages;
			}

			// Condition for showing company selector
			$scope.multiCompanies = companies && (companies.length > 1 || (companies.length === 1 && userInitData.hasSuperAdminMode));

			if (appSettingsSvc.modules.userSettings) {
				$scope.availableLink = $filter('orderObjectBy')(appSettingsSvc.modules.userSettings.submodules, 'priority');
			}
			// Set user avatar url
			if (!isEmpty(userInitData)) {
				$scope.avatarUrl = userInitData.user.avatar;
			}

			function setCurrentCompany() {
				if ($scope.superAdminMode) {
					$scope.currentCompany = "Super Admin";
					return;
				}

				for (var i = 0; i < companies.length; i++) {
					if (companies[i].id === userInitData.user.lastCompany) {
						$scope.currentCompany = companies[i].name;
						return;
					}
				}
			}

			$scope.toggleCompanyList = function (state) {
				$scope.companyListActive = state;
            };

			$scope.clearCompanySearch = function () {
				$scope.companySearch.name = '';
            };

			setCurrentCompany();
		}
	}
}]);
;
sevenAdminComponents.directive('contentHeader', ['browserService', function (browserService) {

    var templateUrl = '/app/components/horizontal-strip/contentHeader.html';

    return {
        restrict:       'A',
        templateUrl:    browserService.IE9OrLess ? templateUrl.split('#')[0] : templateUrl
    };
}]);
;
sevenAdminComponents.directive('subnavigation',
    ['browserService', 'Subnavigation', '$rootScope', '$state', '$translate', function (browserService, Subnavigation, $rootScope, $state, $translate) {
        var templateUrl = '/app/components/horizontal-strip/subnavigation/subnavigation.html';

        return {
            restrict: 'E',
            replace: true,
            priority: 100,
            templateUrl: browserService.IE9OrLess ? templateUrl.split('#')[0] : templateUrl,
            controller: function ($scope) {
                $scope.additionalHeading = '';
                $scope.subNavActions = {};
                $scope.subNavs = [];

                var rootScopeListeners = {stateChangeSuccess: null};

                if ($state.current.additionalTitle) {
                    $scope.additionalHeading = $translate.instant($state.current.additionalTitle);
                }

                $scope.$watch(function () {
                    return Subnavigation.subNavs;
                }, function (newValue) {
                    $scope.subNavs = newValue;
                }, true);


                rootScopeListeners.stateChangeSuccess = $rootScope.$on('$stateChangeSuccess', function() {
                    if ($state.current.additionalTitle) {
                        $scope.additionalHeading = $translate.instant($state.current.additionalTitle);
                    }
                });

                $scope.$on('$destroy', function () {
                    angular.forEach(rootScopeListeners, function (unbind) {
                        unbind();
                    });
                });
            }
        };
    }]);
;
sevenAdminComponents.factory('Subnavigation', [ function (){
    this.subNavs = [];
    this.subNavActions = {};

    this.set = function (subnavigation) {
        var subNavs = [],
            subNavActions = {};

        angular.forEach(subnavigation, function (submodule) {
            // Subnavigation in array form is client defined and doesn't have visible property since w're
            if (angular.isArray(subnavigation) || submodule.visible) {
                subNavs.push(submodule);

                if (submodule.actions && submodule.actions.subNav) {
                    subNavActions[submodule.state] = submodule.actions.subNav;
                }
            }
        });

        this.subNavActions = subNavActions;
        this.subNavs = subNavs;
    };

    this.clear = function () {
        this.subNavs = [];
    };

    return this;
}]);
;
(function () {
    angular.module('seven-admin.components').component('jsonEditor', {
        template: '<div></div>',
        require: {
            model: 'ngModel'
        },
        controller: JsonEditorComponentController,
        controllerAs: 'jsonEditorVm'
    });

    JsonEditorComponentController.$inject = [
        '$scope',
        '$element'
    ];

    function JsonEditorComponentController(
        $scope,
        $element
    ) {
        var jsonEditorVm = this;

        var init = function () {
            $element.html('');
            jsonEditorVm.editor = new JSONEditor(
                $element[0],
                {
                    mode: 'code',
                    onChange: function () {
                        var isValid = false;

                        try {
                            jsonEditorVm.model.$setViewValue(jsonEditorVm.editor.get());
                            isValid = true;
                        } catch (e) {} finally {
                            jsonEditorVm.model.$setValidity('jsonParse', isValid);
                            jsonEditorVm.model.$setTouched();
                            $scope.$apply();
                        }

                    }
                }
            );
        };

        var destroy = function () {
            if (jsonEditorVm.editor) {
                jsonEditorVm.editor.destroy();
                jsonEditorVm.editor = null;
            }
        };

        $scope.$watch(function () {
            return jsonEditorVm.model.$modelValue;
        }, function (newValue) {
            // Write value to editor when model changes, _.isEqual is used to check the source of module change since
            // model can be changed from controller and from editor
            if (jsonEditorVm.editor && !_.isEqual(newValue, jsonEditorVm.editor.get()))
                jsonEditorVm.editor.set(newValue)
        },true);

        jsonEditorVm.$onInit = init;
        jsonEditorVm.$onDestroy = destroy;
    }
}());
;
sevenAdminComponents.directive('actionList',['browserService', function (browserService) {

    var templateUrl = '/app/components/lists/action-list/action-list.html';

    return {
        restrict: 'E',
        templateUrl: browserService.IE9OrLess ? templateUrl : templateUrl + '',
        scope: true,
        controller: function($scope){

        }
    }
}]);
;
sevenAdminComponents.directive('circleLoader', ['browserService', function (browserService) {

    var templateUrl = '/app/components/loaders/circle-loader/circle-loader.html';

    return {
        restrict: 'E',
        replace: true,
        templateUrl: browserService.IE9OrLess ? templateUrl.split('#')[0] : templateUrl,
        controller: function () {
        }
    };
}]);
;
sevenAdminComponents.directive('loaderBar', ['$http', '$filter', function ($http, $filter) {
    return {
        restrict: 'E',
        link: function (scope, elm) {
            /**
             * First load flag
             * @type {Boolean}
             */
            var firstLoad = true;

            /**
             * Check for pending requests
             * @return {Boolean}
             */
            scope.isLoading = function () {
                return $http.pendingRequests.length > 0;
            };

            /**
             * Show/hide loader depending on requests
             * @param {Boolean} newVal
             */
            scope.$watch(scope.isLoading, function (newVal) {
                /**
                 * Number of pending requests that are not ignored manually (ignoreLoader)
                 * ignoreLoader flag is used on requests that don't need to activate loader
                 * @type {Integer}
                 */
                var req = $filter('filter')($http.pendingRequests, {ignoreLoader: '!yes'});

                if(!firstLoad && req.length == 0) {
                    elm.removeClass('active');
                } else {
                    if (newVal) {
                        elm.addClass('active');
                    } else {
                        elm.removeClass('active');
                    }

                    firstLoad = false;
                }
            });
        }
    };

}]);
;
sevenAdminComponents.directive('loginForm', ['browserService', function (browserService) {

    var templateUrl = '/app/components/login/login-form.html';

    return {
        restrict: 'E',
        templateUrl: browserService.IE9OrLess ? templateUrl.split('#')[0] : templateUrl,
        controller: function () {

        }
    };
}]);
;
sevenAdminComponents.directive('loginImage', ['browserService', function (browserService) {

    var templateUrl = '/app/components/login/login-image.html';

    return {
        restrict: 'E',
        templateUrl: browserService.IE9OrLess ? templateUrl.split('#')[0] : templateUrl,
        link: function ($scope) {
            var imgPath = '/assets/img/login-images/';

            var loginImage = document.getElementById('login-image');

            $scope.showImgLoader = true;

            $scope.loginImages = [
                {
                    name: 'lucky_six',
                    text: 'Lucky Six - Our most successful game. Find out why!',
                }, {
                    name: 'lucky_x',
                    text: 'Lucky X - Next generation of betting',
                }, {
                    name: 'virtual_greyhounds',
                    text: 'Virtual Greyhound Races - Enjoy amazingly realistic virtual races',
                }, {
                    name: 'virtual_horses',
                    text: 'Virtual Horse Races - Experience the thrill',
                }, {
                    name: 'live_betting',
                    text: 'Live Betting MTS - 18.000 matches. 18 different sports. Monthly.',
                }, {
                    name: 'prematch_betting',
                    text: 'Pre-Match Betting MTS - most popular form of betting',
                }, {
                    name: 'virtual_motorcycle_speedway',
                    text: 'Virtual Motorcycle Speedway - Fast paced revenue booster',
                },
                {
                    name: 'next_six',
                    text: 'Next6',
                },
                {
                    name: 'keno',
                    text: 'Keno',
                }
            ];

            setActiveBackground(Math.floor(Math.random() * $scope.loginImages.length));

            function setActiveBackground (index) {
                var bgImage = new Image();
                bgImage.src = imgPath + $scope.loginImages[index].name + '.jpg';
                bgImage.onload = function () {
                    $scope.showImgLoader = false;
                    loginImage.style.setProperty('background', 'url(' + imgPath + $scope.loginImages[index].name + '.jpg)');
                    loginImage.style.setProperty('background-size', 'cover');
                    $scope.activeImageText = $scope.loginImages[index].text;
                    $scope.$apply();
                }
            }
        }
    };
}]);
;
sevenAdminComponents.directive('viewTemplates', [
    '$rootScope', '$location', '$window', 'appSettingsSvc', '$interval', '$timeout', '$state', 'browserService', 'dataSvc', 'Subnavigation',
    function ($rootScope, $location, $window, appSettingsSvc, $interval, $timeout, $state, browserService, dataSvc, Subnavigation) {

        var templateUrl = '/app/components/main-content/main-content.html';

        return {
            restrict: 'E',
            templateUrl: browserService.IE9OrLess ? templateUrl.split('#')[0] : templateUrl,
            scope: true,
            controller: function ($scope, $element, $attrs, commonSvc, userInitData, $window, $animate) {

                var rootScopeListeners = {
                    globalClickEvt: null
                };

                $animate.enabled($element, false);

                $scope.dateFormat = userInitData.user.dateFormat;
                $scope.saveStates = {};

                // setting tab selection in url
                if ($scope.viewList.type === 'tabs') {

                    if (!$location.search()['tab']) {
                        setSelectedTabInUrl();
                    } else {
                        getSelectedTabFromUrl();
                    }

                    activateTabUrlWatch();
                }

                function getSelectedTabFromUrl() {
                    angular.forEach($scope.viewList.views, function (view, key) {
                        if (view.id === $location.search()['tab']) {
                            $scope.index = key;
                            $scope.activeFormName = view.viewContent.name;
                            $scope.activeView = view.viewContent.name;
                        }
                    });
                }

                function setSelectedTabInUrl() {
                    angular.forEach($scope.viewList.views, function (view) {
                        if (view.viewContent && view.viewContent.name === $scope.activeFormName) {
                            $location.search('tab', view.id);
                        }
                    });
                }

                function activateTabUrlWatch() {
                    $scope.$watch(function () {
                        return $location.absUrl();
                    }, function () {
                        getSelectedTabFromUrl();
                    });
                }

                $scope.setView = function (viewContentName, viewType, index) {
                    $scope.index = index;
                    $scope.activeFormName = viewContentName;

                    // one cannot simply move through steps without validation of all previous steps
                    if (viewType === 'steps') {
                        if (!$scope.stepChangeDisabled) {
                            $scope.activeView = viewContentName;
                        }
                    } else if (viewType === 'tabs') { // tabs
                        if (angular.equals($scope.newData, $scope.oldData)) {
                            $scope.activeView = viewContentName;
                            setSelectedTabInUrl();
                        }
                        else {
                            if ($scope.infoMessages && $scope.infoMessages['redirect']) {
                                $scope.infoMessages['redirect'].positiveActionCallback = 'saveChanges';
                                $scope.infoMessages['redirect'].negativeActionCallback = 'cancelChanges';
                                $scope.infoMessages['redirect'].display = 'yes';
                            }
                        }

                    } else { // direct switching is ok
                        $scope.activeView = viewContentName;
                    }
                };

                $scope.$watch(function () {
                    return Subnavigation.subNavActions;
                }, function (newValue) {
                    $scope.subNavActions = newValue;
                });


                $scope.menuAction = function (state, type, name) {
                    $scope.bcPageAction = "/ " + name;

                    switch(type) {
                        case 'addUser':
                            $scope.$emit('inviteUser', type);
                            break;
                        case 'addLog':
                            $scope.$emit('addLog', type);
                            break;
                        // TODO FIX THIS HACK !
                        case 'settings.betGroupNew':
                            $state.go('productMgmt.sportbook.betGroupNew', {}, {reload: true});
                            break;
                        default:
                            $state.go(state.split('.')[0] + '.' + type, {}, {reload: true});
                            break;
                    }
                };

                $scope.$on('actionBar:prevStep', function (evt, data) {
                    var br = data.viewContentName.split('_'); //name_ID
                    var prev = parseInt(br[1]) - 1;
                    prev = prev > 0 ? prev : 0;
                    $scope.activeView = br[0] + '_' + prev;
                });

                $scope.$on('actionBar:nextStep', function (evt, data) {
                    var br = data.viewContentName.split('_'); //name_ID
                    var next = parseInt(br[1]) + 1;
                    $scope.activeView = br[0]  + '_' + next;
                });


                // watch for view changes if viewChange() function is defined (in appropriate ctrlr)

                if (typeof $scope.viewChange === 'function') {
                    $scope.$watch('activeView', function (newValue, oldValue) {
                        if (newValue !== oldValue) {
                            $scope.viewChange(newValue, oldValue, $scope.index);
                        }
                    });
                }

                $scope.checkTabPermissions = function (tabId) {
                    var validity = false;

                    var currentActions = {};
                    var currentSubmodules = dataSvc.getCurrentSubmodule();

                    if (currentSubmodules.actions.tabs) {

                        angular.forEach(currentSubmodules.actions.tabs, function (val, key) {
                            if(tabId === val.id) {
                                validity = true;
                            }
                        });
                    }

                    return validity;
                };

                $scope.subAction = function (callback) {
                    this[callback].apply(this, arguments);
                };

                $scope.showDetailsColumns = false;

                $scope.resendVerificationKey = function (params, key) {
                    commonSvc.resendVerificationKey(params).then(function (response) {
                        if (response.data) {
                            $scope.dialogs[key].params = response.data;
                        }
                    });
                };

                rootScopeListeners.globalClickEvt = $rootScope.$on('globalClickEvt', function () {
                    if ($scope.viewList.details) {
                        angular.forEach($scope.viewList.details.views, function (val){
                            val.colAppearance = false;
                        });
                    }
                });

                $scope.$on('$destroy',function() {
                    $scope.viewList = {};

                    angular.forEach(rootScopeListeners, function (unbind) {
                        unbind();
                    });
                });

                this.setStepChangeValidity = function(formInvalid) {
                    $scope.stepChangeDisabled = formInvalid;
                }
            }
        }
    }]);
;
(function () {
    angular
        .module('seven-admin.components')
        .component('headerMenu', {
            templateUrl: '/app/components/main-menu/main-menu.template.html',
            controllerAs: 'mainMenuVm',
            controller: MainMenuController
        });

    MainMenuController.$inject = [
        '$scope',
        '$translate',
        'appSettingsSvc',
        'ChangelogService',
        'GravityMenusService',
        'GravitySettingsService',
        'modalService',
        'tokenAuthService',
        'userInitData',
        'FavoritesService',
        'applicationListsService'
    ];

    function MainMenuController(
        $scope,
        $translate,
        appSettingsSvc,
        ChangelogService,
        GravityMenusService,
        GravitySettingsService,
        modalService,
        tokenAuthService,
        userInitData,
        FavoritesService,
        applicationListsService
    ) {
        var mainMenuVm = this;
        var hiddenItems = ['userSettings', 'productStore'];

        var init = function () {
            mainMenuVm.visible = false;
            mainMenuVm.toggle = toggle;
            mainMenuVm.hide = hide;
            mainMenuVm.showAbout = showAbout;
            mainMenuVm.showChangelog = showChangelog;
            Object.defineProperty(mainMenuVm, 'hasUnreadChangelogs', {get: function() {
                return ChangelogService.hasUnreadChangelogs
            }});

            mainMenuVm.menu = createMenu();
            mainMenuVm.cmsLink = appSettingsSvc.urls.cms && appSettingsSvc.urls.cms + '?a=' + tokenAuthService.getAccessToken();
            mainMenuVm.sevenMarket =  _.find(appSettingsSvc.modules, {id: 'productStore'});
            mainMenuVm.certifications =  _.find(appSettingsSvc.modules, {id: 'certifications'});
            mainMenuVm.favorites = FavoritesService.favorites;

            mainMenuVm.removeFavorite = removeFavorite;

            mainMenuVm.certificateList = {};
            loadCertificatesLists();

            setListeners();
        };

        var toggle = function () {
            mainMenuVm.visible = !mainMenuVm.visible;
        };

        var hide = function () {
            mainMenuVm.visible = false;
        };

        var showAbout = function () {
            modalService.showModal({
                appendElement: $('#main-app'),
                templateUrl: '/app/components/dialogs/about-popup/about-popup.template.html',
                controllerAs: 'aboutVm',
                controller: 'AboutController',
                data: {
                    about: true
                }
            })
        };

        var showChangelog = function () {
            modalService.showModal({
                appendElement: $('#main-app'),
                templateUrl: '/app/components/dialogs/about-popup/about-popup.template.html',
                controllerAs: 'aboutVm',
                controller: 'AboutController',
                data: {
                    changelog: true
                }
            })
        };

        var createMenu = function () {
            return _.chain(appSettingsSvc.modules)
                .filter(function (item) {return item.visible && hiddenItems.indexOf(item.id) === -1;})
                .sortBy('priority')
                .map(function (item) {
                    // TODO: this should be removed and refactored when all modules are ready for migrating to menus
                    if (shouldUseMenu(item.id)) {
                        return createMainMenuMenuFromMenus(item.id);
                    }

                    return _.merge({submodules: _.sortBy(item.submodules, 'priority')}, _.pick(item, ['name', 'state', 'iconClass', 'id']))
                })
                .value();
        };


        /**
         * @typedef MainMenuMenuItem
         * @proprety {String} id
         * @property {String} name - Title of menu item
         * @property {String} state - ui-router state of menu in main menu
         *
         * @typedef MainMenuMenu
         * @proprety {String} id
         * @property {String} name - Title of menu in main menu
         * @property {String} state - ui-router state of menu in main menu
         * @property {String} iconClass - Full icon class of menu (includes n-i n-i-class)
         * @property {MainMenuMenuItem[]} submodules - Items in main menu menu
         */

        /**
         *
         * @param moduleName - Name of module for which will menu be craterd
         * @return {MainMenuMenu}
         */
        var createMainMenuMenuFromMenus = function(moduleName) {
            var menu = GravityMenusService.getMenu(moduleName);
            var mainMenu = GravityMenusService.getMenu('main');
            var mainMenuItem = _.find(mainMenu, function(menuItem) {
                return menuItem.customData.route.childMenu === moduleName;
            });
            if (_.isEmpty(menu) || _.isEmpty(mainMenu) || _.isEmpty(mainMenuItem)) return [];
            
           var icon = mainMenuItem.icon || moduleName;

            return {
                id: menu[0].menuName,
                name: $translate.instant(mainMenuItem.customData.translationKey),
                state: moduleName + '.' + menu[0].customData.route.name,
                iconClass: 'n-i n-i-' + icon,
                submodules: menu.map(function(menu) {
                    return {
                        name: $translate.instant(menu.customData.translationKey),
                        id: menu.customData.route.name,
                        state: moduleName + '.' + menu.customData.route.name
                    }
                })
            }
        };

        /**
         * Determines if menu should should be used for some module instead of appSettingsSvc.modules
         * @param {String} moduleName
         * @returns {Boolean}
         */
        var shouldUseMenu = function(moduleName) {
            return !!(GravitySettingsService.getModuleSettings(moduleName, 'useMenus'))
        }

        var removeFavorite = function (favorite) {
            FavoritesService.removeFavorite(favorite)
        };

        var setListeners = function() {
            $scope.$watch(function () {
                return FavoritesService.favorites
            }, function (favorites) {
                mainMenuVm.favorites = favorites;
            })
        };

        var loadCertificatesLists = function() {
            if (!userInitData.currentCompany) return;
            applicationListsService.getCompanyLists(userInitData.currentCompany.name, userInitData.lists, 'certificates').then(function (response) {
                mainMenuVm.certificateList = response;
            });
        };

        mainMenuVm.$onInit = init;
    }
}());
;
// Common modal service
// NOTE: Keep this clean and abstract
sevenAdminComponents.service('modalService', [
    '$document',
    '$compile',
    '$controller',
    '$http',
    '$rootScope',
    '$q',
    '$templateCache',
function (
    $document,
    $compile,
    $controller,
    $http,
    $rootScope,
    $q,
    $templateCache
) {
    return {
        getTemplate: function (templateUrl) {
            // Load template from cache if available
            var cachedTemplate = $templateCache.get(templateUrl);
            if (cachedTemplate) {
                return $q(function(resolve) {
                    resolve(cachedTemplate);
                });
            } else {
                return $http({method: 'GET', url: templateUrl, cache: true}).then(function (result) {
                    $templateCache.put(templateUrl, result.data);
                    return result.data;
                });
            }
        },
        showModal: function (options) {
            // Load template
            return this.getTemplate(options.templateUrl).then(function (template) {
                // Create modal scope
                var scope = $rootScope.$new();
                var element = $compile(angular.element(template))(scope);

                // Define helper close function
                var close = function (params) {
                    // Check callback
                    if (angular.isFunction(options.callback)) {
                        options.callback(params);
                    }

                    // Cleanup
                    scope.$destroy();
                    element.remove();
                    scope = null;
                    element = null;
                    controller = null;
                    $document.off('keydown', closeKeyboardHandler);
                };

                // Support controller as name and function
                if (angular.isString(options.controller)) {
                    if (options.controllerAs) {
                        options.controller = options.controller + ' as ' + options.controllerAs;
                    }
                }

                // Bind to scope
                scope.close = close;
                scope.data = angular.merge({}, options.data);

                // Create controller
                var controller = $controller(options.controller, {
                    $element: element,
                    $scope: scope
                });

                // Define close handler
                var closeKeyboardHandler = function (event) {
                    if (event.which === 27) {
                        close();
                    }
                };

                // Set ESC close handler
                $document.on('keydown', closeKeyboardHandler);

                // Append element to passed parent or document
                if (options.appendElement) {
                    options.appendElement.append(element);
                } else {
                    angular.element($document).append(element);
                }

                // Return full modal object from promise
                return {
                    controller: controller,
                    scope: scope,
                    element: element
                };
            });
        }
    };
}]);;
sevenAdminComponents.directive('infoMessage', ['browserService', 'notificationService', function (browserService, notificationService) {

    var templateUrl = '/app/components/notifications/info-message/info-message.html';

    return {
        restrict: 'E',
        templateUrl: browserService.IE9OrLess ? templateUrl.split('#')[0] : templateUrl,
        scope: true,
        controller: function ($scope, $state) {
            $scope.notificationPosition = notificationService.getNotificationPosition();

            $scope.doCallback = function (callback) {
                if (callback) {
                    $scope.$emit('infoMessage:' + callback, {});
                }
            };

            $scope.$on('infoMessage:goToParentState', function () {
                $state.go($state.current.parentView, {}, {reload: false});
            });

            $scope.$on('infoMessage:refreshCurrentState', function () {
                $state.go($state.current.name, {}, {reload: true});
            });

            $scope.$watch(function() {
                return notificationService.getNotificationPosition()
            }, function(position) {
                $scope.notificationPosition = position;
            });
        }
    }
}]);
;
sevenAdminComponents.factory('notificationService', ['$timeout', 'userInitData', function ($timeout, userInitData) {

    return {
        /**
         * Get setting for notification portion from user settings
         * @returns {string}
         */
        getNotificationPosition: function() {
            return _.get(userInitData, 'settings.user.ui.notificationPosition')
        },

        /**
         * Set notification display and duration
         * @param {Object} notification
         * @param {Number} [duration] - send 0 if indefinite
         * @returns {null}
         */

        showInfoNotification: function (notification, duration) {
            notification.display = 'yes';

            if (duration) {
                notification.timeout = $timeout(function () {
                    notification.display = 'no';
                }, duration);
            }
        },
        hideInfoNotification: function (notification) {
            notification.display = 'no';
            if (notification.timeout) {
                $timeout.cancel(notification.timeout);
                delete notification.timeout;
            }
        },

        serverResponseSuccessful: function (status) {
            return status === 200;
        },

        serverResponseValid: function (status) {
            return [200, 201, 204].indexOf(status) !== -1;
        },

        requestCanceled: function (status) {
            return status === -1;
        }
    }
}]);
;
(function () {
    angular.module('seven-admin.components').component('sevenPagination', {
        templateUrl: '/app/components/pagination/pagination.template.html',
        controller: PaginationComponentController,
        bindings: {
            // Aliased since ui-bootstrap contains component/directive called pagination
            pagination: '<sPagination',
            paginationConfig: '<',
            paginationChanged: '&'
        },
        controllerAs: 'paginationVm'
    });

    PaginationComponentController.$inject = [
        '$location'
    ];


    function PaginationComponentController(
        $location
    ) {
        var ctrl = this;
        var defaultPaginationConfig = {
            startingPageOffset: 0,
            containsTotalPages: true,
            paginationClass: 's-pagination',
            updateLocation: true,
            locationParamNames: {
                currentPage: 'currentPage',
                pageSize: 'pageSize'
            },
            paginationObjectNames: {
                pageSize: 'pageSize',
                currentPage: 'currentPage',
                totalCount: 'totalCount',
                totalPages: 'totalPages'
            },
            pageSize: '25'
        };
        var paginationConfig = defaultPaginationConfig;
        // Done before $onInit since $onInit triggers after first $onChange
        ctrl.paginationClass = paginationConfig.paginationClass;
        ctrl.pageSize = paginationConfig.pageSize.toString();
        ctrl.startingPageOffset = paginationConfig.startingPageOffset;

        var init = function () {
            ctrl.pages = [];
            ctrl.changePage = changePage;
            ctrl.onPageSizeChange = onPageSizeChange;
        };

        var update = function (changes) {
            if (changes.paginationConfig && changes.paginationConfig.currentValue){
                paginationConfig = _.merge({}, paginationConfig, changes.paginationConfig.currentValue);

                if (changes.paginationConfig.currentValue.paginationClass && ctrl.paginationClass !== changes.paginationConfig.currentValue.paginationClass) {
                    ctrl.paginationClass = changes.paginationConfig.currentValue.paginationClass;
                }

                if (changes.paginationConfig.currentValue.startingPageOffset && ctrl.startingPageOffset !== changes.paginationConfig.currentValue.startingPageOffset) {
                    ctrl.startingPageOffset = changes.paginationConfig.currentValue.startingPageOffset;
                }
            }

            if (changes.pagination && changes.pagination.currentValue) {
                var search = {};

                if (ctrl.currentPage !== changes.pagination.currentValue[paginationConfig.paginationObjectNames.currentPage]){
                    ctrl.currentPage = changes.pagination.currentValue[paginationConfig.paginationObjectNames.currentPage];
                    search[paginationConfig.locationParamNames.currentPage] = changes.pagination.currentValue[paginationConfig.paginationObjectNames.currentPage];
                }
                if (ctrl.pageSize.toString() !== changes.pagination.currentValue[paginationConfig.paginationObjectNames.pageSize].toString()) {
                    ctrl.pageSize = changes.pagination.currentValue[paginationConfig.paginationObjectNames.pageSize].toString();
                    search[paginationConfig.locationParamNames.pageSize] = changes.pagination.currentValue[paginationConfig.paginationObjectNames.pageSize];
                }
                if (paginationConfig.updateLocation && !_.isEmpty(search)) {
                    $location.search(_.assign({},$location.search(),search));
                }
            }

            if (ctrl.pagination)
                render();
        };

        var render = function () {
            ctrl.pages = generatePagesArray();
        };

        var generatePagesArray = function generatePagesArray () {
            var currentPage     = parseInt(ctrl.pagination[paginationConfig.paginationObjectNames.currentPage]),
                totalItems      = parseInt(ctrl.pagination[paginationConfig.paginationObjectNames.totalCount]),
                pageSize        = parseInt(ctrl.pagination[paginationConfig.paginationObjectNames.pageSize]);

            var maxBlocks, minBlocks, maxPage, maxPivotPages, minPage, numPages, pages;
            maxBlocks = 11;
            minBlocks = 5;
            pages = [];
            numPages = Math.ceil(totalItems / pageSize);

            if (numPages > 1) {
                maxPivotPages = Math.round((maxBlocks - minBlocks) / 2);
                minPage = Math.max(2, currentPage - maxPivotPages);
                maxPage = Math.min(numPages - 1, currentPage + maxPivotPages * 2 - (currentPage - minPage));
                minPage = Math.max(2, minPage - (maxPivotPages * 2 - (maxPage - minPage)));

                var i = minPage;

                pages.push({
                    text: '1',
                    number: 1 + paginationConfig.startingPageOffset
                });

                while (i <= maxPage) {
                    if ((i === minPage && i !== 2) || (i === maxPage && i !== numPages - 1)) {
                        pages.push({
                            number: i  + paginationConfig.startingPageOffset,
                            text: '...'
                        });
                    } else {
                        pages.push({
                            number: i + paginationConfig.startingPageOffset,
                            text: i
                        });
                    }

                    i++;
                }

                pages.push({
                    text: numPages,
                    number: numPages + paginationConfig.startingPageOffset
                });
            }

            return pages;
        };

        var changePage = function (page) {
            if (ctrl.currentPage === page.number || page.number < 1 + paginationConfig.startingPageOffset || page.number > ctrl.pages[ctrl.pages.length - 1].number)
                return;

            var changes = {};
            changes[paginationConfig.paginationObjectNames.currentPage] = page.number;
            changes[paginationConfig.paginationObjectNames.pageSize] = ctrl.pageSize;

            if (paginationConfig.updateLocation)
                $location.search(paginationConfig.locationParamNames.currentPage, page.number);

            ctrl.currentPage = page.number;
            ctrl.paginationChanged(changes);

        };

        var onPageSizeChange = function () {
            var changes = {};
            var search = {};

            changes[paginationConfig.paginationObjectNames.currentPage] = 1 + paginationConfig.startingPageOffset;
            changes[paginationConfig.paginationObjectNames.pageSize] = ctrl.pageSize;

            if (paginationConfig.updateLocation){
                search[paginationConfig.locationParamNames.pageSize] = ctrl.pageSize;
                search[paginationConfig.locationParamNames.currentPage] = 1 + paginationConfig.startingPageOffset;

                $location.search(_.assign({},$location.search(),search));
            }

            ctrl.paginationChanged(changes);
        };

        ctrl.$onInit = init;
        ctrl.$onChanges = update;
    }
}());
;
var reactGridModule = angular.module('react.grid.module', []);

/**
 * Grid component service
 * Directive will listen for init method in service and render component
 */
reactGridModule.service('gridComponentService', ['$http', '$rootScope', '$location', 'filterService', 'appSettingsSvc', 'dataSvc', 'userInitData', 'ENV_CFG',
    function ($http,   $rootScope, $location, filterService, appSettingsSvc, dataSvc, userInitData, ENV_CFG) {
        var companyId = userInitData.currentCompany && userInitData.currentCompany.id;
        var self = this;
        var data = {},          // Table data in cells
            columns = {},       // Columns definitions (type, visibility)
            titles = {},        // Column headers
            filters = {},       // All filters info (values, types, display names, backend selected)
            sums = [],          // Backend sums if provided
            pagination = {},    // All pagination info (count, page, total)
            additionalSums = {},    // Sums used in player transactions
            config = {},        // Will keep specific info about table
            rcActions = [],     // Right click actions
            serverTime = {},
            supportedExportFormats = [], // Supported export formats
            viewName = '';

        // Get server time
        (function getServerDateAndTime(){
            var url = appSettingsSvc.urls.api + '/common/datetime/info.json';

            $http.get(url).then(function (response) {
                serverTime = {
                    currentServerDate: new Date(response.data.currentTime * 1000),
                    currentWeekStart: new Date(response.data.currentWeek * 1000),
                    previousWeekStart: new Date(response.data.previousWeek * 1000)
                };
            });
        }());

        this.triggerTable = false;

        /**
         * Reset all data method.
         * Useful when reloading table using different filters.
         * Required since using @gridComponentService service doesn't create new instance
         */
        this.resetAllData = function () {
            data = {};
            columns = {};
            titles = {};
            filters = {};
            pagination = {};
            rcActions = [];
            additionalSums = {};
            supportedExportFormats = [];
        };

        /**
         * Load backend provided active filters to url
         * Set count and page as provided from backend
         */
        var loadBackendActiveFilters = function (activeFilters, pagination, filterDelimiters) {
            angular.forEach(activeFilters, function (val, key) {
                var delimiter = config.filterDelimiter || (filterDelimiters && filterDelimiters[key]) || ',';

                if (filters[key].type === 'range') {
                    $location.search(key, (val.fromValue || '') + '~' + (val.toValue || ''));
                } else {
                    $location.search(key, val.join(delimiter));
                }

            });

            $location.search('count', pagination.count);
            $location.search('page', pagination.page);
        };

        var checkLocalColumns = function (columns) {
            var linkKey = config.columnSaveKey || dataSvc.getLinkKeys(),
                localColumns = JSON.parse(localStorage.getItem(linkKey)),
                columnsArr = Object.keys(columns),
                columnsChanged = false;

            if ((columns && localColumns && Object.keys(localColumns).length !== Object.keys(columns).length) || !localColumns) {
                if (localColumns)
                    localStorage.removeItem(linkKey);

                return columns;
            }

            angular.forEach( localColumns, function (val, key){
                // Reset columns if column key is changed
                if (columnsArr.indexOf(key) === -1)
                    columnsChanged = true;

                // Reset columns if column type or sortability is changed
                if (columns[key] && (val.type !== columns[key].type || val.sortDisabled !== columns[key].sortDisabled))
                    columnsChanged = true;

            });

            if (columnsChanged)
                localStorage.removeItem(linkKey);

            return columnsChanged ? columns : localColumns;
        };

        var parseRememberedFilterData = function (data) {
            var fs = new filterService;
            var parsedData = {};
            var date;
            var urlDate;

            _.each(data, function (value, key) {
                if (value.value) {
                    date = fs.getUrlFormatedDatesFromPredefinedValue(value.value);
                    urlDate = {};
                    urlDate[value.startKey] = date.start;
                    urlDate[value.endKey] = date.end;

                    _.extend(parsedData, urlDate);

                } else {
                    parsedData[key] = value;
                }

            });

            return parsedData;
        };

        var getFakedDateConfiguration = function(company) {
            var allCompaniesConfiguration = _.get(userInitData, 'settings.application.limitGridDates.configuration.*');
            var companyConfiguration =  _.get(userInitData, 'settings.application.limitGridDates.configuration.' + company);

            return companyConfiguration || allCompaniesConfiguration;
        };

        var getNonDefaultStartKeys = function() {
            // We need a map of non default start date keys since filters are almost never initialized before fillTable
            // Every new non-standard startKey needs to be added here
            return [
                'startDateDraw',
                'startDatePaidOut',
                'eventStartFrom',
                'startDateTime',
                'shiftStartFrom',
                'shiftEndFrom',
                'createdAtStartDate',
                'resolvedAtStartDate',
                'payoutAtStartDate',
                'sealedStartDate',
                'dateFrom',
                'dateTo'
            ]
        };

        var getNonDefaultEndKeys = function() {
            // We need a map of non default end date keys since filters are almost never initialized before fillTable
            // Every new non-standard startKey needs to be added here
            return [
                'endDateDraw',
                'endDatePaidOut',
                'eventStartTo',
                'endDateTime',
                'shiftEndTo',
                'createdAtEndDate',
                'resolvedAtEndDate',
                'payoutAtEndDate',
                'sealedEndDate'
            ]
        };

        var isParamStartDateParam = function(startKey) {
            var DEFAULT_START_KEY = 'startDate';

            return startKey === DEFAULT_START_KEY || getNonDefaultStartKeys().indexOf(startKey) !== -1;
        };

        var isParamEndDateParam = function(endKey) {
            var DEFAULT_END_KEY = 'endDate';

            return endKey === DEFAULT_END_KEY || getNonDefaultEndKeys().indexOf(endKey) !== -1;
        };

        var dateParamSatisfiesCondition = function(value, configuration) {
            var GRID_FILTER_DATE_FORMAT = "YYYY-MM-DD*HH:mm:ss";
            var date = moment(value, GRID_FILTER_DATE_FORMAT);
            var configurationDate = moment(configuration.value, GRID_FILTER_DATE_FORMAT);

            switch (configuration.condition) {
                case 'equal':
                    return date.isSame(configurationDate);
                case 'notEqual':
                    return !date.isSame(configurationDate);
                case 'greaterThan':
                    return date.isAfter(configurationDate);
                case 'lessThan':
                    return date.isBefore(configurationDate);
                case 'greaterThanOrEqualTo':
                    return date.isSameOrAfter(configurationDate);
                case 'lessThanOrEqualTo':
                    return date.isSameOrBefore(configurationDate);
                default:
                    console.warn('Invalid date condition');
                    return false;
            }
        };

        var createColumnDataFromGridResponse = function(grid) {
            var hasCurrencyColumn = _.has(grid, 'columns.currency');
            var overriddenCurrency = _.get(userInitData, 'settings.company.currencyDisplayValue');
            var realCurrency = _.get(userInitData, 'currentCompany.currency');

            // 🤮 hack for currency display in grids when override is set for company, check for existence of 'currency'
            // column and replace value of each row's currency value with overridden if it matches current company currency
            if (overriddenCurrency && hasCurrencyColumn) {
                _.each(grid.data, function(row) {
                    if (row.currency === realCurrency) {
                        row.currency = overriddenCurrency;
                    }
                });
            }

            return grid.data;
        };

        /**
         * Format and set backend response data to Service
         * @param response
         */
        this.setBackendData = function (response) {
            // Set data
            data = createColumnDataFromGridResponse(response);

            // Set columns
            columns = checkLocalColumns(response.columns);

            // Set titles
            titles = response.titles;

            // Set pagination
            pagination = response.pagination;

            // Set sums
            sums = response.sums;

            supportedExportFormats = response.supportedExportFormats || [];

            // It's side effect but makes most sense to do it this way so that it doesn't require adding more code to
            // controllers where filter delimiter is sent in grid response
            if (!_.isEmpty(response.delimiters)) {
                this.setTableConfig(_.merge({}, config, { filterDelimiters: response.delimiters }));
            }

            loadBackendActiveFilters(response.activeFilters, pagination, config.filterDelimiters);
        };

        this.setTableData = function (values) {
            data = values;
        };

        this.setMatchesData = function(data) {
            data = data;
        };

        /**
         * Set backend provided filters to fitlers object, using filter service
         * @param response
         */
        this.setBackendProvidedFilters = function (response, config) {

            // Format and set filters
            var fService = new filterService;

            fService.setBackendProvidedFilters(response);

            if((config && !config.removeSearch) || !config) {
                fService.setSearchFilter();
            }

            angular.forEach(fService.filtersContent, function (filter, key) {
                filters[key] = filter;
            });
        };

        /**
         * Initialize date filter only to filters object
         * @memberOf gridComponentService
         * @name setDateFilter
         * @param {DateFilterConfiguration|Array.<DateFilterConfiguration>} [config]
         */
        this.setDateFilter = function (config) {

            var fService = new filterService;

            fService.setNewDateFilter(config);
            var dateFilters = fService.dateFilters;

            for (var i = 0; i < dateFilters.length; i++) {
                filters['date_' + i] = dateFilters[i];
            }
        };

        /**
         * @typedef {'yes'} YES
         *
         * @typedef {object} TableConfig
         * @property {string} [columnSaveKey]
         * @property {function} [checkboxToggleDisabled] -
         * @property {YES} [disableExport] - removes export selector in table header
         * @property {YES} [disableStickyFooter]
         * @property {(YES|{multiple: number})} [editAction]
         * @property {(string|Array.<string>)} [editActionClass]
         * @property {(string|Array.<string>)}[editActionText]
         * @property {function} [isBoolCellEditable]
         * @property {(boolean|YES)} [sensitiveData]
         * @property {(number|Array.<number>)} [paginationSelectOptions]
         */

        /**
         * Set specific table config provided from controller\
         * Needs to be set at in controller before request for grid fires
         * @Object {TableConfig} data
         */
        this.setTableConfig = function (data) {
            if(userInitData.currentCompany && userInitData.currentCompany.uuid) {
                data.companyUuid = userInitData.currentCompany.uuid;
            }

            if (data.showCurrencyInFooter && userInitData.currentCompany)
                // Check if company has currency display override and use it instead of real currency
                data.currency = userInitData.settings.company.currencyDisplayValue || userInitData.currentCompany.currency;

            config = data;
        };


        this.getTableConfig = function () {
            return config;
        };

        /**
         * Sets url parameters for edit cell
         *
         * @function
         * @memberOf gridComponentService
         * @name setEditUrls
         * @param {(string|Array<string>)} toUrl - relative base link url
         * @param {(string|Array<string>)} urlKey - name of the table row property
         * @param {string|Array<string>} [editUrlAdditionalParams] - optional final parameter
         */
        this.setEditUrls = function (toUrl, urlKey, editUrlAdditionalParams) {
            config.toUrl = toUrl;
            config.urlKey = urlKey;
            config.editUrlAdditionalParams = editUrlAdditionalParams;
        };

        /**
         * Set filters to url provided as object
         * @Object data
         */
        this.setInitialFilters = function (data) {
            for (var i in data) {
                if (!$location.search()[i])
                    $location.search(i, data[i]);
            }
        };

        this.setAdditionalSums = function setAdditionalSums(data) {
            additionalSums = data;
        };

        /**
         * Add right click config to right click action list
         * Set rc action id, display name
         * Handle actions in controllers by id
         * @param {Object} data
         */
        this.addRightClickAction = function (data) {
            rcActions = data;
        };

        /**
         * Init grid
         * This method will be listened, and each time it's invoked, new grid should be rendered
         * @returns {{data: {}, columns: {}, titles: {}, filters: {}, pagination: {}}}
         */
        this.getData = function () {
            return {
                tableData: {
                    data: data,
                    columns: columns,
                    sums: sums,
                    titles: titles,
                    filters: filters,
                    pagination: pagination,
                    additionalSums: additionalSums,
                    rcActions: rcActions,
                    supportedExportFormats: supportedExportFormats
                },
                config: config,
                serverTime: serverTime,
                urlFilters: $location.search()
            };
        };

        this.init = function () {
            this.triggerTable = !this.triggerTable;
        };

        this.checkTableOverflow = function() {
            this.checkOverflow = !this.checkOverflow;
        };

        this.setViewName = function(name){
            viewName = name;
        };

        this.gridOriginEqual = function (name) {
            return viewName === name;
        };

        this.getRememberedFilterKey = function () {
            return companyId ?
            _.template('admin.filter_${companyId}_${key}')({key: viewName, companyId: companyId}):
            _.template('admin.filter_${key}')({key: viewName});
        }

        this.rememberFilters = function () {
            var url = _.template('${apiBaseUrl}/settings/users')({apiBaseUrl: appSettingsSvc.urls.gravityApi});
            var key = self.getRememberedFilterKey();
            var data = {};
            var selectedData;
            var selectedDateFilterPredefinedValue;
            var fs = new filterService;

            _.each(self.getData().tableData.filters, function (filter) {
                if (filter.type === 'search') return;

                if ((selectedData = $location.search()[filter.name]) && filter.type !== 'date') {
                    data[filter.name] = selectedData;
                }

                if (filter.type === 'date') {
                    if (selectedDateFilterPredefinedValue = fs.getPredefinedRangeFromDates(filter.selected.startDate, filter.selected.endDate)) {
                        // Date for date filters needs to contain both keys of url query parameters for start and end date and selected predefined value
                        data[filter.name] = {
                            value: selectedDateFilterPredefinedValue,
                            startKey: filter.startKey,
                            endKey: filter.endKey
                        }
                    }
                }
            });

            return $http.put(url, {
                key: key,
                value: data,
                type: 'object'
            }).then(function() {
                self.rememberedFilters[key] = parseRememberedFilterData(data);
            })
        };

        this.removeRememberedFilters = function () {
            var url = _.template('${apiBaseUrl}/settings/users')({apiBaseUrl: appSettingsSvc.urls.gravityApi});
            var key = companyId ?
                _.template('admin.filter_${companyId}_${key}')({key: viewName, companyId: companyId}):
                _.template('admin.filter_${key}')({key: viewName});

            return $http.put(url, {
                key: key,
                value: {},
                type: 'object'
            }).then(function() {
                self.rememberedFilters[key] = {};
            })
        };

        this.loadRememberedFilters = function () {
            var url = _.template('${apiBaseUrl}/settings/users')({
                apiBaseUrl: appSettingsSvc.urls.gravityApi
            });

            return $http({
                url : url,
                method: 'GET'
            }).then(function (response) {
                if (response.data) {
                    self.rememberedFilters = {};
                    _.each(response.data, function(value, key) {
                        if (key.match('admin.filter_')) {
                            self.rememberedFilters[key] = parseRememberedFilterData(value);
                        }
                    })
                }
            })
        };

        this.hasRememberedFilter = function() {
            var filters = self.getRememberedFilter(viewName);
            return filters && !_.isEmpty(filters);
        };

        this.getRememberedFilter = function() {
            var key = self.getRememberedFilterKey();

            return self.rememberedFilters && self.rememberedFilters[key];
        };

        this.isDateFakingEnabled = function() {
            var FAKE_FOR_ALL_COMPANIES = "*";
            var currentCompany = _.get(userInitData, 'currentCompany.uuid');
            var dateFakingCompanySetting = _.get(userInitData, 'settings.application.limitGridDates.companies');
            var companyInFakedCompanies = _.isArray(dateFakingCompanySetting) && _.includes(dateFakingCompanySetting, currentCompany);

            return dateFakingCompanySetting === FAKE_FOR_ALL_COMPANIES || companyInFakedCompanies
        };

        this.isDateFakingEnabledForView = function(viewName, company) {
            if (!this.isDateFakingEnabled()) return false;
            var configuration = getFakedDateConfiguration(company);

            var FAKE_FOR_ALL_VIEWS = '*';
            var dateFakingViewSetting = _.get(configuration, 'views');
            var viewInFakedViews = _.isArray(dateFakingViewSetting) && _.includes(dateFakingViewSetting, viewName);

            return dateFakingViewSetting === FAKE_FOR_ALL_VIEWS || viewInFakedViews;
        };

        this.getFakedDateParams = function(filterParams, company) {
            var fakedDateParam = {};
            var configuration = getFakedDateConfiguration(company);
            var startDateConfiguration = _.get(configuration, 'startDate');
            var endDateConfiguration = _.get(configuration, 'endDate');

            if (startDateConfiguration || endDateConfiguration) {
                _.each(filterParams, function(paramValue, paramKey) {
                    if (startDateConfiguration && isParamStartDateParam(paramKey) && dateParamSatisfiesCondition(paramValue, startDateConfiguration)) {
                        fakedDateParam[paramKey] = startDateConfiguration.replaceValue;
                    }

                    if(endDateConfiguration && isParamEndDateParam(paramKey) && dateParamSatisfiesCondition(paramValue, endDateConfiguration)) {
                        fakedDateParam[paramKey] = endDateConfiguration.replaceValue;
                    }
                })
            }

            return fakedDateParam;
        };

        this.getFakedExportDateParams = function(searchString) {
            if (!searchString) return '';

            var newSearchString;
            var searchStringArr = searchString.split('&');
            var newSearchStringArr;
            var searchParams = {};
            var currentCompany = _.get(userInitData, 'currentCompany.uuid');

            _.forEach(searchStringArr, function(searchFragment) {
                var keyAndValue = searchFragment.split('=');

                searchParams[keyAndValue[0]] = keyAndValue[1];
            });

            searchParams = _.extend({}, searchParams, self.getFakedDateParams(searchParams, currentCompany));

            newSearchStringArr =_.map(searchParams, function(value, key) {
                return key + '=' + value;
            });

            newSearchString = newSearchStringArr.join('&');

            return newSearchString;
        }

    }]);

reactGridModule.directive('reactGrid', function (gridComponentService, browserService, $location, $rootScope, $interval, userInitData) {
    return {
        restriction: 'E',
        template: '<div><div>',
        scope: false,
        link: function (scope, element, attrs) {
            var checkOverflowEvent = new CustomEvent('ReactGrid.CheckTableOverflow', {
                detail: {name: 'ReactGrid.CheckTableOverflow'},
                bubbles: true,
                cancelable: true
            });
            var refreshInterval = null;
            var dateFakingEnabledForView;
            var gridRequestParams;
            var currentCompany = _.get(userInitData, 'currentCompany.uuid');
            var sevenLocalInfo = {
                sevenLocal: userInitData.user.language || (userInitData.currentCompany && userInitData.currentCompany.language),
                sevenTimezone: userInitData.user.timezone || (userInitData.currentCompany && userInitData.currentCompany.timezone.name),
            };

            // Set translations to mixin
            TranslateMixin.setTranslation(userInitData.translations);

            // Clean up tree
            gridComponentService.resetAllData();
            gridComponentService.setViewName(attrs.viewName);
            dateFakingEnabledForView = gridComponentService.isDateFakingEnabledForView(attrs.viewName, currentCompany);
            ReactDOM.unmountComponentAtNode(element[0]);

            if (!gridComponentService.getTableConfig().disableRememberFilters) {
                var rememberedFilter;
                // Get all user's remembered filters if they don't exist in service
                if (_.isUndefined(gridComponentService.rememberedFilters)) {
                    gridComponentService.loadRememberedFilters(attrs.viewName).then(function () {
                        rememberedFilter = gridComponentService.getRememberedFilter(attrs.viewName);

                        if (!_.isEmpty(rememberedFilter)) {
                            $location.search(_.extend({}, $location.search(), rememberedFilter))
                        }

                        if (gridComponentService.getTableConfig().onRememberedFiltersLoad &&
                            typeof gridComponentService.getTableConfig().onRememberedFiltersLoad === 'function'
                        ) {
                            gridComponentService.getTableConfig().onRememberedFiltersLoad($location.search);
                        }
                    }).finally(function () {
                        gridRequestParams = dateFakingEnabledForView ?
                            _.extend({}, $location.search(), gridComponentService.getFakedDateParams($location.search(), currentCompany)) :
                            $location.search();

                        scope.fillTable(gridRequestParams);
                    });
                } else {
                    rememberedFilter = gridComponentService.getRememberedFilter(attrs.viewName);

                    if (!_.isEmpty(rememberedFilter)) {
                        $location.search(_.extend({}, $location.search(), rememberedFilter))
                    }

                    gridRequestParams = dateFakingEnabledForView ?
                        _.extend({}, $location.search(), gridComponentService.getFakedDateParams($location.search(), currentCompany)) :
                        $location.search();

                    scope.fillTable(gridRequestParams);
                }
            } else {
                gridRequestParams = dateFakingEnabledForView ?
                    _.extend({}, $location.search(), gridComponentService.getFakedDateParams($location.search(), currentCompany)) :
                    $location.search();

                scope.fillTable(gridRequestParams);
            }

            var changeAutoRefresh = function (key, duration) {
                $interval.cancel(refreshInterval);
                if (key === 0) return;

                refreshInterval = $interval(function () {
                    gridRequestParams = dateFakingEnabledForView ?
                        _.extend({}, $location.search(), gridComponentService.getFakedDateParams($location.search(), currentCompany)) :
                        $location.search();

                    scope.fillTable(gridRequestParams);
                }, duration * 1000);
            };

            var resetFilters = function () {
                var ignoreFilters = gridComponentService.getTableConfig().ignoreFilters || [],
                    filters = gridComponentService.getData().tableData.filters,
                    dateFilterOptions = {};

                _.forEach(filters, function (filter) {
                    if (filter.type === 'date') {
                        dateFilterOptions[filter.startKey] = {clear: filter.clearOnReset, type: "start", defaultValue: filter.startDateResetValue};
                        dateFilterOptions[filter.endKey] = {clear: filter.clearOnReset, type: "end", defaultValue: filter.endDateResetValue};
                    }
                });

                angular.forEach($location.search(), function (value, key) {
                    if (ignoreFilters && ignoreFilters.indexOf(key) === -1 && key !== 'tab') {
                        $location.search(key, null);
                    }

                    if(dateFilterOptions.hasOwnProperty(key) && !dateFilterOptions[key].clear) {
                        $location.search(key, dateFilterOptions[key].defaultValue);
                    }
                });

                if (scope.setDefaultFilters) {
                    scope.setDefaultFilters();
                }

                gridRequestParams = dateFakingEnabledForView ?
                    _.extend({}, $location.search(), gridComponentService.getFakedDateParams($location.search(), currentCompany)) :
                    $location.search();

                scope.fillTable(gridRequestParams);
            };

            /**
             * Save currently selected filters and trigger table reload
             * If filters param are provided use it as query params.
             * If filters param is empty object, use url filters
             * @Object filters
             */
            scope.updateFilters = function () {
                gridRequestParams = dateFakingEnabledForView ?
                    _.extend({}, $location.search(), gridComponentService.getFakedDateParams($location.search(), currentCompany)) :
                    $location.search();

                scope.fillTable(gridRequestParams);
                if (scope.filtersUpdated) {
                    scope.filtersUpdated();
                }
            };

            /**
             * Update location (url) with provided key and it's value
             * @String key
             * @String value
             */
            scope.updateLocationFilter = function (key, value) {
                value = value.length ? value : null;

                $location.search(key, value);
                scope.$apply();
            };

             /**
             * Update location (url) with provided params
             * @Object params
             */
            scope.updateLocationWithMultipleParams  = function (params) {
                for (var prop in params) {
                    if (Object.prototype.hasOwnProperty.call(params, prop)) {
                        $location.search(prop, params[prop]);
                    }
                }

                scope.$apply();
            };

            var rowSelectAction = function (data, key) {
                scope.showDetails(data, key);
                scope.$apply();
            };

            var renderHandler = function () {
                var params = gridComponentService.getData();

                if (Object.keys(params.tableData.columns).length === 0) return;

                if (!MainWrapper) return;

                // New react DOM component
                ReactDOM.render(React.createElement(MainWrapper,
                    {
                        data                    : params.tableData,
                        config                  : params.config,
                        urlFilters              : params.urlFilters,
                        serverTime              : params.serverTime,
                        dateFormat              : userInitData.user.dateFormat,
                        locale                  : userInitData.user.language,
                        sevenLocalInfo          : sevenLocalInfo,

                        tableEditAction         : scope.tableEditAction,
                        tableDeleteAction       : scope.tableDeleteAction,
                        rowSelectAction         : rowSelectAction,
                        inputAction             : scope.gridInputAction,
                        checkboxToggleAction    : scope.checkboxToggleAction,
                        contextMenuAction       : scope.contextMenuAction,
                        matchSelectionAction    : scope.matchSelectionAction,
                        previewOffer            : scope.previewOffer,
                        exportToExcel           : scope.exportToExcel,
                        handleSelectionChange   : scope.handleSelectionChange,
                        // Function used for approving and declining withdrawal requests
                        cellBinaryAction        : scope.binaryAction,
                        selectDisplay           : scope.selectDisplay,
                        ticketAuthActionChange  : scope.ticketAuthActionChange,
                        inputListClickAction    : scope.handleInputListClickAction,

                        changeTableWidth        : scope.changeTableWidth,
                        chartButtonClick        : scope.chartButtonClick,
                        changeAutoRefresh       : changeAutoRefresh,
                        rememberFilters         : gridComponentService.rememberFilters,
                        removeRememberedFilters : gridComponentService.removeRememberedFilters,
                        resetFilters            : resetFilters,
                        resetRememberedFilters  : gridComponentService.resetRememberedFilters,

                        dateFakingEnabledForView: dateFakingEnabledForView,
                        getFakedExportDateParams: gridComponentService.getFakedExportDateParams,
                        onExport                : scope.onExport,


                        updateFilters           : scope.updateFilters,
                        updateLocationFilter    : scope.updateLocationFilter,
                        updateLocationWithMultipleParams : scope.updateLocationWithMultipleParams
                    }),
                element[0]);
            };

            $rootScope.$on('forceTableUpdate', renderHandler);

            // Watch for changes in grid component service and reload component
            scope.$watch(function() { return gridComponentService.triggerTable; }, renderHandler, true);

            scope.$watch(function () {
                return gridComponentService.checkOverflow;
            }, function (value, previousValue) {
                if (value !== previousValue)
                    element[0].dispatchEvent(checkOverflowEvent);
            });

            scope.$on('$destroy', function() {
                $interval.cancel(refreshInterval);
                checkOverflowEvent = null;
                ReactDOM.unmountComponentAtNode(element[0]);
            });
        }
    }
});
;

// Translate mixin
var translations = {};
var TranslateMixin = {

    setTranslation: function (values) {
        translations = values;
    },

    // Global translate method
    translate: function (key, value) {
        // Return provided key if there is not translation
        if (typeof translations[key] === 'undefined') return key;

        // Dynamic values in translations
        // Replace {{ }} brackets with provided value
        if (typeof value !== 'undefined') {
            var tr = angular.copy(translations[key]),
                fIndex = tr.indexOf('{'),
                lIndex = tr.lastIndexOf('}');

            if (fIndex !== -1 && lIndex !== -1) {
                return tr.replace(tr.substring(fIndex, lIndex + 1), value);
            }
        }

        return translations[key];
    }
};

var DistributionSelectionChecker = {

    checkSelection: function (selected, shiftPressed, ctrlPressed, index, lastSelectedIndex) {
        if (ctrlPressed) {
            selected.indexOf(index) === -1 ? selected.push(index) : selected.splice(selected.indexOf(index), 1);
        }

        if (shiftPressed) {
            if (lastSelectedIndex < index) {
                for (var i = lastSelectedIndex; i <= index; i++) {
                    selected.indexOf(i) === -1 && selected.push(i);
                }
            } else if (lastSelectedIndex > index) {
                for (var j = index; j < lastSelectedIndex; j++) {
                    selected.indexOf(j) === -1 && selected.push(j);
                }
            } else {
                selected.indexOf(index) === -1 ? selected.push(index) : selected.splice(selected.indexOf(index), 1);
            }
        }

        if (!shiftPressed && !ctrlPressed) {
            return [index];
        }

        return selected;
    },
    
    deepCheckSelection: function (data) {
        var startI,
            endI,
            startEvtI,
            endEvtI,
            selectedMarkets = {
                eventMarkets: data.selectedEventMarkets,
                markets: data.selectedMarkets
            };
        // No shift or ctrl pressed -> Highlight single row
        if (!data.shiftPressed && !data.ctrlPressed) {
            selectedMarkets.eventMarkets = data.eventMarketId ? [data.eventMarketId] : [];
            selectedMarkets.markets = data.marketId ? [data.marketId] : [];
            return selectedMarkets;
        }

        // Ctrl pressed -> add clicked to selected list
        if (data.ctrlPressed && !data.shiftPressed) {
            if (!data.eventMarketId) return selectedMarkets;
            var index = selectedMarkets.eventMarkets.indexOf(data.eventMarketId);
            var marketIndex = selectedMarkets.markets.indexOf(data.marketId);
            index === -1 ? selectedMarkets.eventMarkets.push(data.eventMarketId) : selectedMarkets.eventMarkets.splice(index, 1);
            marketIndex === -1 ? selectedMarkets.markets.push(data.marketId) : selectedMarkets.markets.splice(marketIndex, 1);
            return selectedMarkets;
        }

        // Shift pressed -> Add selected range
        var foundMarketId = '';

        if (data.lastSelectedIndex < data.index) {
            for (var i = data.lastSelectedIndex; i <= data.index; i++) {
                foundMarketId = data.markets[i].id;
                selectedMarkets.markets.indexOf(foundMarketId) === -1 && selectedMarkets.markets.push(foundMarketId);
            }
        } else if (data.lastSelectedIndex > data.index) {
            for (var j = data.index; j < data.lastSelectedIndex; j++) {
                foundMarketId = data.markets[j].id;
                selectedMarkets.markets.indexOf(foundMarketId) === -1 && selectedMarkets.markets.push(foundMarketId);
            }
        } else {
            selectedMarkets.markets.indexOf(data.index) === -1 ? selectedMarkets.markets.push(data.marketId) : selectedMarkets.markets.splice(selectedMarkets.markets.indexOf(data.marketId), 1);
        }

        if (data.lastSelectedIndex === data.index) {
            if (data.lastEventMarketSelectedIndex < data.eventMarketIndex) {
                startEvtI = data.lastEventMarketSelectedIndex;
                endEvtI = data.eventMarketIndex;
            } else if (data.lastEventMarketSelectedIndex > data.eventMarketIndex) {
                startEvtI = data.eventMarketIndex;
                endEvtI = data.lastEventMarketSelectedIndex;
            }
            for (var a = startEvtI; a <= endEvtI; a++) {
                var eventMarketId = data.markets[data.index].eventMarkets[a].id;
                selectedMarkets.eventMarkets.indexOf(eventMarketId) === -1 && eventMarketId && selectedMarkets.eventMarkets.push(eventMarketId);
            }
            return selectedMarkets;
        }

        if (data.lastSelectedIndex < data.index) {
            startI = data.lastSelectedIndex;
            startEvtI = data.lastEventMarketSelectedIndex;
            endI = data.index;
            endEvtI = data.eventMarketIndex;
        } else if (data.lastSelectedIndex > data.index) {
            startI = data.index;
            startEvtI = data.eventMarketIndex;
            endI = data.lastSelectedIndex;
            endEvtI = data.lastEventMarketSelectedIndex;
        }

        for (var i = startI; i <= endI; i++) {
            if (i !== endI) {
                for (var j = 0; j <= data.markets[i].eventMarkets.length; j++) {
                    var eventMarketId = data.markets[i].eventMarkets[j] && data.markets[i].eventMarkets[j].id;
                    selectedMarkets.eventMarkets.indexOf(eventMarketId) === -1 && eventMarketId && selectedMarkets.eventMarkets.push(eventMarketId);
                }
            } else {
                for (var j = startEvtI; j <= endEvtI; j++) {
                    var eventMarketId = data.markets[i].eventMarkets[j] && data.markets[i].eventMarkets[j].id;
                    selectedMarkets.eventMarkets.indexOf(eventMarketId) === -1 && eventMarketId && selectedMarkets.eventMarkets.push(eventMarketId);
                }
            }
        }
        return selectedMarkets;
    }
};;
sevenAdminComponents.directive('sevenMap', [
    '$document',
    '$timeout',
    '$q',
    '$window',
    'browserService',
    'userInitData',
    function ($document, $timeout, $q, $window, browserService, userInitData) {
        var templateUrl = '/app/components/saven-map/seven-map.html';

        return {
            restrict: 'E',
            templateUrl: browserService.IE9OrLess ? templateUrl : templateUrl + '',
            scope: true,
            link: function($scope, $element){
                var NSOFT = {lat: 43.353138, lng: 17.793745};
                var mapLanguage = 'en';
                var mapsApiKay = 'AIzaSyCQbCjDIdW2o0TVP6OVo2r7n6P2Q3P2-S4';
                var mapsMapId = "f9585e2884633383";
                var mapsCallback = 'initMap';
                var mapsScripSrc = _.template('https://maps.googleapis.com/maps/api/js?language=${language}&key=${apiKey}&callback=${callback}&libraries=marker&loading=async')({
                    language: mapLanguage,
                    apiKey: mapsApiKay,
                    callback: mapsCallback
                });
                var map,
                    marker;

                $window.initMap = function () {
                    setMap()
                };

                if ($window.google && window.google.maps) {
                    setMap();
                } else {
                    var script = angular.element('<script>');

                    script.attr('src', mapsScripSrc);
                    script.attr('defer')
                    $document.find('body')[0].append(script[0]);
                }

                function setMap() {
                    var address = '',
                        geocoder;

                    if (!$scope.geoLocation) {
                        if ($scope.fieldValues.address)
                            address += $scope.fieldValues.address + ',';
                        if ($scope.fieldValues.city)
                            address += $scope.fieldValues.city + ',';
                        address += userInitData.currentCompany.countryName;

                        geocoder = new $window.google.maps.Geocoder();
                        geocoder.geocode({address: address}, function (results, status) {
                            var center;

                            if (status === 'ZERO_RESULTS') {
                                center = NSOFT;
                            } else {
                                center = {
                                    lat: results[0].geometry.location.lat(),
                                    lng: results[0].geometry.location.lng()
                                };
                            }
                            $scope.updateLocationData(center);
                            createMap(center, center)
                        })
                    } else {
                        // When user moves marker dialog window for some reason isn't displayed immediately so map
                        // doesn't initialize properly
                        $timeout(function () {
                            createMap($scope.geoLocation, $scope.geoLocation)
                        });
                    }
                }

                function createMap(center, markerPosition) {
                    map = new $window.google.maps.Map($element[0], {
                        zoom: 8,
                        center: center,
                        mapId: mapsMapId,
                    });

                    marker = new $window.google.maps.marker.AdvancedMarkerElement({
                        map: map,
                        gmpDraggable: true,
                        position: markerPosition
                    });

                    marker.addListener('dragend', function (event) {
                        $scope.updateLocationData({lat: event.latLng.lat(), lng: event.latLng.lng()});
                    });
                }

                $scope.$on('$destroy', function () {
                    if (marker) {
                        $window.google.maps.event.clearListeners(marker, 'dragend');
                    }
                });
            }
        }
    }
]);
;
sevenAdminComponents.directive('errSrc',  ['$rootScope', function($rootScope) {
    return {
        link: function(scope, element, attrs) {
            element.bind('error', function() {
                $rootScope.$broadcast('picError' , attrs.src);
                if (attrs.errSrc) element[0].setAttribute('src', attrs.errSrc);
            });

            element.bind('load', function() {
                $rootScope.$broadcast('picLoaded' , attrs.src);
            })
        }
    }
}]);;
sevenAdminComponents.directive('sevenGallery',['$location', 'appSettingsSvc', 'browserService', function($location, appSettingsSvc, browserService){

    var templateUrl = '/app/components/seven-gallery/seven-gallery.html';

    return {
        restrict: 'E',
        templateUrl: browserService.IE9OrLess ? templateUrl : templateUrl + '',
        scope:true,
        controller: function($scope, $element, $attrs, $document) {
            $scope.deleteEnabled = false;

            $scope.$watch("view.viewContent.fields.length", function(numberOfImages) {
                var isVerified = _.get($scope, 'fieldValues.verificationOptions.identity.isVerified');

                $scope.deleteEnabled = !isVerified || numberOfImages > 1;
            });

            $scope.$on('disableVerify', function (evt, data) {
                $scope.saveStates[data.name] = data.disabled;
            });

            $scope.lightbox = { visible: false };

            $scope.toggleImage = toggleImage;

            $scope.previousImage = previousImage;

            $scope.nextImage = nextImage;

            $document.on('keyup', changeImage);

            function toggleImage(img, visibility) {
                $scope.lightbox.image = img;
                $scope.lightbox.visible = visibility;
            }

            function changeImage(event) {
                var keyCode = event.which || event.keyCode;

                if(!$scope.lightbox.visible) return;

                switch (keyCode) {
                    case 39:
                        $scope.$apply(nextImage);
                        break;
                    case 37:
                        $scope.$apply(previousImage);
                        break;
                }
            }

            function previousImage() {
                var noOfPictures = $scope.view.viewContent.fields.length;
                var currentImageIndex = findCurrentImageIndex();
                var previousIndex = currentImageIndex - 1 < 0 ? noOfPictures - 1 : currentImageIndex - 1;

                $scope.lightbox.image = $scope.view.viewContent.fields[previousIndex].link;
            }

            function nextImage() {
                var noOfPictures = $scope.view.viewContent.fields.length;
                var currentImageImage = findCurrentImageIndex();
                var nextIndex = (currentImageImage + 1) % noOfPictures;

                $scope.lightbox.image = $scope.view.viewContent.fields[nextIndex].link;
            }

            function findCurrentImageIndex() {
                var currentIndex;
                angular.forEach($scope.view.viewContent.fields, function (img, index) {
                    if (img.link === $scope.lightbox.image) {
                        currentIndex = index;
                    }
                });
                return currentIndex;
            }

            $scope.$on('$destroy', function () {
                $document.off('keyup', changeImage);
            });
        }
    }
}]);
;
sevenAdminComponents.directive('unavailableImage',  ['$rootScope', function($rootScope) {
    return {
        restrict: 'A',
        link: function($scope, $element, $attr) {
            var unbindPicErrorListener = $rootScope.$on('picError', function(event, url) {
                if( $attr.unavailableImage === url) {
                    $scope.galleryImgUnavailable = true;
                    $scope.$digest();
                }
            });

            var unbindPicLoadListener = $rootScope.$on('picLoaded', function(event, url) {
                if( $attr.unavailableImage === url) {
                    $scope.galleryImgUnavailable = false;
                    $scope.$digest();
                }
            });

            $scope.$on('$destroy', function () {
                unbindPicErrorListener();
                unbindPicLoadListener();
            });
      }
    }
}]);
;
(function () {
  angular
    .module('seven-admin.components')
    .component('sevenWidget', {
      bindings: {
        widgetSettings: '<',
        widgetKey: '<',
        widgetLoading: '<',
        frameId: '@',
        data: '<', // In task description, data is composed in IntegrationController and passed to seven-widget
        onFinally: '<',
        scrolling: '@',
        autoResize: '<', // Should this be allowed?
        urlPath: '<',
      },
      controllerAs: 'vm',
      templateUrl: 'app/components/seven-widget/seven-widget.template.html',
      controller: SevenWidgetController
    });

    SevenWidgetController.$inject = [
      '$rootScope',
      '$state',
      '$element',
      '$sce',
      '$location',
      'gatewayService'
    ];

    function SevenWidgetController(
      $rootScope,
      $state,
      $element,
      $sce,
      $location,
      gatewayService
    ) {
      var vm = this,
          source;

      var init = function() {
        source = vm.widgetSettings && vm.widgetSettings.source[0];
        
        vm.frameId = vm.frameId || (source.config && source.config.frameId);
        vm.url = getSlaveUrl(source.url);

        if (source.config.useGateway !== false) {
          addSlave();
          addSubscriptions();
        } else {
          vm.onFinally();
        }
      };

      var addSlave = function() {
        var slaveConfig = {
          slaveId: vm.frameId,
          frameId: vm.frameId,
          autoResize: vm.autoResize !== false,
          loaded: vm.onFinally,
          data: vm.data
        };

        gatewayService.addSlave(slaveConfig);
      };

      // Subscriptions

      var addSubscriptions = function() {
        setClickPropagationSubscriber();
        setRouteChangeSubscriber();
      };

      /**
       * @name getCommonQuery
       * @param {string} url
       * @return {string}
       */
      var getCommonQuery = function (url) {
        var query = '';
        var params = {
          integrationType: 'gravityGateway',
          platform: 'seven',
          application: 'admin'
        };

        if (!url.includes('slaveId')) {
          params.slaveId = vm.frameId
        }

        for (var key in params) {
            var connectingCharacter = query.length ? '&' : '';
            query += connectingCharacter + key + '=' + params[key];
        }

        return query;
      };

      var getSlaveUrl = function (url) {
        var slaveUrl = parseUrlConfig(url);

        var query = getCommonQuery(url);
        var connectingCharacter = '&';

        if (!slaveUrl.includes('?')) {
            connectingCharacter = '?';
        }

        if (vm.urlPath) {
          slaveUrl += vm.urlPath;
        }

        slaveUrl += connectingCharacter + query;

        return $sce.trustAsResourceUrl(slaveUrl);
      };

      var parseUrlConfig = function (url) {
        return _.template(url)({
          tenantUuid: vm.data.tenant.uuid,
          language: vm.data.locale.iso1,
          token: vm.data.user.auth.token
        });
      };

      var setRouteChangeSubscriber = function () {
        gatewayService.gateway.subscribe('Router.ChangeRoute', function (message) {
          $state.go('.', { path: message.data.route }, { reload: false, notify: false });
        });

        $rootScope.$on('$locationChangeSuccess', function (event, url, oldUrl) {
          if (gatewayService.gateway) {
            gatewayService.gateway.sendMessage(vm.slaveId, {
              action: 'Router.RouteChanged',
              data: {
                route: url,
                oldRoute: oldUrl
              }
            });
          }
        });
      };

      var setClickPropagationSubscriber = function() {
        gatewayService.gateway.subscribe('Slave.Event', function (message) {
          if (message.event === 'click') {
            $element.click();
          }
        });
      };

      // Destroying component, removing subscriptions

      var onDestroy = function () {
        if (source.config.destroy === false) return;
        gatewayService.removeSlave(vm.slaveId);
        removeSubscriptions();
      };

      var removeSubscriptions = function() {
        gatewayService.gateway.unsubscribe('Router.ChangeRoute');
        gatewayService.gateway.unsubscribe('Slave.Event');
      };

      vm.$onInit = init;
      vm.$onDestroy = onDestroy;
    }
})();
;
sevenAdminComponents.directive('simpleList',['browserService', function (browserService) {

    var templateUrl = '/app/components/simple-list/simple-list.html';

    return {
        restrict: 'E',
        templateUrl: browserService.IE9OrLess ? templateUrl : templateUrl + '',
        scope: true,
        controller: function($scope){

        }
    }
}]);
;
sevenAdminComponents.directive('simpleTable',['$location','browserService', function ($location, browserService) {

    var templateUrl = '/app/components/simple-table/simple-table.html';

    return {
        restrict: 'E',
        templateUrl: browserService.IE9OrLess ? templateUrl : templateUrl + '',
        scope: true,
        controller: function($scope){

            $scope.changePageSize = function (count) {
                $location.search('count', count);
                $location.search('page', 1);
                $scope.app.pageCount = 1;
                $scope.view.viewContent.generateTable(count, $scope.app.pageCount);
            };

            $scope.changePage = function (page) {
                $scope.app.pageCount = page;
                $location.search('page', page);
                $scope.view.viewContent.generateTable($scope.app.selectCount, $scope.app.pageCount);
            };

            $scope.$watch('view.viewContent.table.pagination', function (pagination) {
                if (pagination)
                    $scope.pages = createPages(pagination);
            });

            function createPages(pagination) {
                var maxBlocks, maxPage, maxPivotPages, minPage, numPages, pages;
                maxBlocks = 11;
                pages = [];
                numPages = Math.ceil(pagination.total / pagination.count);
                if (numPages > 1) {
                    pages.push({
                        type: 'prev',
                        number: Math.max(1, pagination.page - 1),
                        active: pagination.page > 1
                    });
                    pages.push({
                        type: 'first',
                        number: 1,
                        active: pagination.page > 1
                    });
                    maxPivotPages = Math.round((maxBlocks - 5) / 2);
                    minPage = Math.max(2, pagination.page - maxPivotPages);
                    maxPage = Math.min(numPages - 1, pagination.page + maxPivotPages * 2 - (pagination.page - minPage));
                    minPage = Math.max(2, minPage - (maxPivotPages * 2 - (maxPage - minPage)));
                    var i = minPage;
                    while (i <= maxPage) {
                        if ((i === minPage && i !== 2) || (i === maxPage && i !== numPages - 1)) {
                            pages.push({
                                type: 'more',
                                active: false
                            });
                        } else {
                            pages.push({
                                type: 'page',
                                number: i,
                                active: pagination.page !== i
                            });
                        }
                        i++;
                    }
                    pages.push({
                        type: 'last',
                        number: numPages,
                        active: pagination.page !== numPages
                    });
                    pages.push({
                        type: 'next',
                        number: Math.min(numPages, pagination.page + 1),
                        active: pagination.page < numPages
                    });
                }

                return pages;
            }
        }
    }
}]);
;
sevenAdminComponents.directive('adminCharts', ['appSettingsSvc', 'notificationService', '$translate', 'browserService',
    function (appSettingsSvc, notificationService, $translate, browserService) {

    var templateUrl = '/app/components/tables/admin-charts/admin-charts.html';

    return {
        restrict: 'E',
        templateUrl: browserService.IE9OrLess ? templateUrl.split('#')[0] : templateUrl,
        scope: true,
        controller: function ($scope, $element, $attrs) {





        }
    }
}]);
;
sevenAdminComponents.factory('highChartAdminService', ['$location', '$filter', '$translate', 'userInitData', function ($location, $filter, $translate, userInitData) {

    // public stuff

    var chartData = {},
        gridData = {};

    /**
     * Hold list of properties for line chart drawing
     * @type {Object}}
     */
    var options = {
        chart: {
            type: 'spline',
            renderTo: 'container',
            heigth: '600px',
            zoomType: 'xy',
            ignoreHiddenSeries: true
        },
        credits: {
            enabled: false
        },
        title: {
            text: 'Reports',
            x: -20 //center
        },
        xAxis: {
            type: 'datetime',
            gridLineWidth: 1,
            labels: {
                y:20
            }
        },
        tooltip: {
            useHTML: true,
            formatter: function () {

                var index = this.point.index,
                    currentTooltipInfo = this.series.userOptions.tooltipInfo[index],
                    lineTranslations = this.series.userOptions.linesTransaltions;

                var tooltipContent = '<div class="chart-tooltip-header-date">' + Highcharts.dateFormat('%b %e, %H:%M', this.x) + '</div>' +
                                     '<div class="chart-tooltip-header-text">' + this.series.name + '</div>';


                angular.forEach (currentTooltipInfo, function (value, key) {
                    tooltipContent += '<div><div class="chart-tooltip-body-title">' + lineTranslations[key] +
                    ' :</div><div class="chart-tooltip-body-value">' + value +
                    '</div></div>';
                });

                return tooltipContent;
            }
        },
        yAxis: {
            title: {
                text: 'Tickets'
            },
            plotLines: [{
                color: '#cd6d6d',
                value: 0,
                width: 2
            }]
        },
        plotOptions: {
            spline: {
                marker: {
                    enabled: false
                },
                lineWidth: 2,
                shadow: false
            }
        },
        legend: {
            layout: 'vertical',
            align: 'right',
            shadow: true,
            y: 23,
            verticalAlign: 'top',
            borderWidth: 0
        },
        series: []
    };


    /**
     * Generate timestamp depending on selected type ('month', 'day', 'week', 'month')
     * @param {String} type
     * @returns {number}
     */
    var getTimeInterval = function (type) {
            var intervalTime = 1;

            switch( type )
            {
                case 'hour':
                    intervalTime = 1;
                    break;
                case 'day':
                    intervalTime = 24;
                    break;
                case 'week':
                    intervalTime = 168;
                    break;
                case 'month':
                    intervalTime = 720;
                    break;
                default:
                    intervalTime = 1;
                    break;
            }
            return (3600 * 1000 * intervalTime);
    };


    /**
     * Provide backend data and generate data compatible for chart
     * @param {Array} lineKeys - Array of keys from grid that should be displayed in chart
     * @returns {Array} chartData - Generated array of chart items by provided keys
     */
    var generateChartData = function (lineKeys) {

        // if there are no provided keys, no lines should be displayed
        if (lineKeys.length === 0) {
            return;
        }

        var seriesData = [],
            chartLines = [],
            tooltipInfo = [];

        var lines = chartData.lines,
            chartItems = chartData.chartItems,
            startPoint = null;

        var interval = getTimeInterval(chartData.type);

        for (var i = 0; i < lines.length; i++) {

            seriesData = [];
            tooltipInfo = [];
            startPoint = chartData.startPoint * 1000;

            for (var z = 0; z < chartItems.length; z++) {
                seriesData.push([ startPoint , chartItems[z][i][chartData.totalField]]);
                tooltipInfo.push(chartItems[z][i]);

                startPoint += interval;

            }

            // Add only series that are matching provided keys ( Checked in grid )
            if (lineKeys.indexOf(chartData.lineKeys[i]) !== -1) {
                chartLines.push({
                    name: lines[i],
                    data: seriesData,
                    tooltipInfo: tooltipInfo,
                    linesTransaltions: chartData.linesTransaltions,
                    id: chartData.lineKeys[i],
                    pointInterval: interval
                });
            }

        }

        return chartLines;

    };


    return {

        /**
         * Set grid response data for further use of selecting and deselecting all chart series by grid id's
         * @param {Object} response
         */
        setGridResponseData: function (response) {
            gridData = response;
        },

        /**
         * Generate chart data and options depending on backend response and selected line keys
         * @param responseData - Backend response data
         * @param lineKeys - Array of keys from grid that should be displayed in chart
         * @param reportName - Provided name for current report
         * @returns {Object} - Formatted options for chart drawing
         */
        initChart: function (responseData, lineKeys, reportName) {

            chartData = responseData;

            options.series = generateChartData(lineKeys);
            options.title.text = reportName;

            return options;

        },


        /**
        * Add single series by selected key (checkbox toggle in grid)
        * @param {String} key - Key that represent single series that should be displayed in chart
        * @returns {Object} series
        */
        addSeriesByKey: function (key) {

            var series = generateChartData([key]);

            return series[0];

        },


        /**
        * Add all series to chart from backend response
        * @returns {Object} options
        */
        addAllSeries: function () {

            options.series = generateChartData(chartData.lineKeys);

            return options;

        },


        /**
        * Return object containing all keys used in chart series
        * @returns {Object} lines
        */
        selectAllGridCheckboxes: function () {
            var lines = {},
                line = '';


            for (var i = 0; i < chartData.lineKeys.length; i++) {
                line = chartData.lineKeys[i];

                lines[line] = true;
            }

            return lines;
        },


        /**
         * Get list of all chart series id's
         * @returns {Array}
         */
        getAllKeysFromData: function () {
            return chartData.lineKeys;
        }



    };




}]);
;
sevenAdminComponents.service('filterService', ['$location', '$translate', 'dataSvc', function ($location, $translate, dataSvc) {

    function filterService(locationEnabled) {

        /**
         * Keeps all backend filter response
         * @type {Object}
         */
        this.data = {};

        /**
         * Keeps all filter content data
         * @type {Object}
         */
        this.filtersContent = {};

        /**
         * Keeps date filters
         * @type {Array}
         */
        this.dateFilters = [];

        this.locationEnabled = locationEnabled;

    }


    /**
     * Initialize date start general.time
     * yyyy/MM/dd HH:mm:ss (the only valid date string that works in both firefox and chrome)
     * @param {Object} date
     */
    function formatStartDate (date) {

        date = date.replace(/-/g, '/');
        date = date.replace('*', ' ');

        return new Date(date);
    }


    /**
     * Initialize date end time
     * yyyy/MM/dd HH:mm:ss (the only valid date string that works in both firefox and chrome)
     * if timepicker is enabled return set date and time, else set time to 23:59:59
     * @param {Object} date
     * @param {Boolean} enableTime
     */
    function formatEndDate (date, enableTime) {

        date = date.replace(/-/g, '/');
        date = date.replace('*', ' ');

        if (enableTime) {
            return new Date(date);
        } else {
            var d = new Date(date);

            d.setHours(23);
            d.setMinutes(59);
            d.setSeconds(59);

            return new Date(d);
        }
    }


    /**
     * Extract only hours from given date string
     * @param date
     * @returns {number}
     */
    function getHours (date) {

        return date.split('*')[1].split(':')[0];
/*
        date = date.replace(/-/g, '/');
        date = date.replace('*', ' ');

        return new Date(date).getHours();*/
    }


    /**
     * Extract only minutes from given date string
     * @param date
     * @returns {number}
     */
    function getMinutes (date) {

        return date.split('*')[1].split(':')[1];

       /* date = date.replace(/-/g, '/');
        date = date.replace('*', ' ');

        return new Date(date).getMinutes();*/
    }



    filterService.prototype = {


        /**
         * Initialize reset, search and backend provided filters
         * @param {Object} data
         * @returns {null}
         */
        fullFilterInit: function (data) {
            this.data = data || this.data;

            this.setBackendProvidedFilters();
            this.setSearchFilter();
            this.setResetFilter();
        },


        /**
         * Initialize backend provided filters only
         * @param {Object} data
         * @returns {null}
         */
        setBackendProvidedFilters: function (data) {
            this.data = data || this.data;
            var self = this;
            var positionCounter = 1;

            angular.forEach(this.data.filters, function (val, key) {

                self.filtersContent[key] = {
                    'name': key,
                    'displayName': self.data.filterDisplayName[key],
                    'type': self.data.filterTypes[key],
                    'data': val,
                    'filterOpened': false,
                    'position': positionCounter++,
                    'selected': self.formatSelectedFilter(key, self.data.filterTypes[key]),
                    'class': 'n-i n-i-' + key,
                    'overridenParams': self.data.overridenParams && self.data.overridenParams[key] ? self.data.overridenParams[key] : null
                }
            });

            angular.forEach(self.data.activeFilters, function (activeFilterItems, key) {
                /*
                Backend is sending numerical keys of selected filter items as integers.
                In all filters those numerical keys are stringified, so they can't be matched.
                That's why we are stringifying 'em here.
                */

                for (var i = 0; i < activeFilterItems.length; i++) {
                    if (typeof activeFilterItems[i] === 'number') {
                        activeFilterItems[i] = String(activeFilterItems[i]);
                    }
                }

                if (self.locationEnabled) {
                    $location.search(key, activeFilterItems.join(','));
                }


                if (['multi', 'single'].indexOf(self.filtersContent[key].type) !== -1) {
                    self.filtersContent[key].selected = activeFilterItems;
                    return;
                }

                if (self.filtersContent[key].type === 'range') {
                    self.filtersContent[key].selected = {}; // override default behaviour to keep selected filters watcher simple
                    self.filtersContent[key].selected.fromValue = (activeFilterItems.fromValue || '');
                    self.filtersContent[key].selected.toValue = (activeFilterItems.toValue || '');
                }
            });
        },


        /**
         * @typedef {Object} DateFilterConfiguration
         * @property {string} [displayName]
         * @property {boolean} [disableTime]
         * @property {string} [startKey]
         * @property {string} [endKey]
         * @property {number} [position]
         * @property {boolean} [removeClear]
         * @property {boolean} [clearOnReset]
         * @property {string} [startDateResetValue]
         * @property {string} [endDateResetValue]
         */

        /**
         * Initialize date filter only
         * @param {DateFilterConfiguration|Array.<DateFilterConfiguration>} [config]
         * Provide config object or array of objects if some specific data is needed. Config:
         * Display name (displayName) , default: Date
         * Start date key (startKey) , default: startDate
         * End date key (endKey) , default: endDate
         * Disabled time (disableTime) , default: 'no'
         * Remove clear button from filter (removeClear), default: false
         * Clear filter values on reset (clearOnReset), default: false
         * @returns {null}
         */
        setNewDateFilter: function (config) {
            if (!Array.isArray(config)) {
                config = config || {};

                this.dateFilters.push({
                    name: 'date_' + this.dateFilters.length,
                    type: 'date',
                    displayName: config.displayName || $translate.instant('general.date'),
                    disableTime: config.disableTime ? 'yes' : 'no',
                    filterOpened: false,
                    startKey: config.startKey || 'startDate',
                    endKey: config.endKey || 'endDate',
                    selected: this.formatSelectedDateFilter(config),
                    position: config.position || 0,
                    'class': 'n-i n-i-calendar',
                    predefinedValue: null,
                    removeClear: false || config.removeClear,
                    clearOnReset: config.clearOnReset || false,
                    startDateResetValue: config.startDateResetValue || dataSvc.getStartDate(0, 0, 0),
                    endDateResetValue: config.endDateResetValue || dataSvc.getEndDate(0, 0, 0)
                });
            } else {
                var noOfFilters = config.length;

                for (var i = 0; i < noOfFilters; i++) {
                    config[i] = config[i] || {};

                    this.dateFilters.push({
                        name: 'date_' + this.dateFilters.length,
                        type: 'date',
                        displayName: config[i].displayName || $translate.instant('general.date'),
                        disableTime: config[i].disableTime ? 'yes' : 'no',
                        filterOpened: false,
                        startKey: config[i].startKey || 'startDate',
                        endKey: config[i].endKey || 'endDate',
                        selected: this.formatSelectedDateFilter(config[i]),
                        position: config[i].position || 0,
                        'class': 'n-i n-i-calendar',
                        predefinedValue: null,
                        removeClear: false || config.removeClear,
                        clearOnReset: config[i].clearOnReset || false,
                        startDateResetValue: config[i].startDateResetValue || dataSvc.getStartDate(0, 0, 0),
                        endDateResetValue: config[i].endDateResetValue || dataSvc.getEndDate(0, 0, 0)
                    });
                }
            }
        },


        /**
         * Set specific date filter display names. Default is "Start date" and "End date"
         * @param startDateName
         * @param endDateName
         * @param $index
         */
        setDateFilterDisplayNames: function (startDateName, endDateName, $index) {

            this.dateFilters[$index].selected.startName = startDateName;
            this.dateFilters[$index].selected.endName = endDateName;

        },



        /**
         * Initialize reset filter only
         * @returns {null}
         */
        setResetFilter: function () {

            this.filtersContent['reset'] = {
                'name': 'reset',
                'text': $translate.instant('general.filter_reset'),
                'type': 'reset',
                'position': 20
            };
        },



        /**
         * Initialize search filter only
         * @returns {null}
         */
        setSearchFilter: function () {

            this.filtersContent['search'] = {
                'name': 'search',
                'placeholder': $translate.instant('general.search'),
                'type': 'search',
                'showFilter': 'no',
                'selected': $location.search().search
            };
        },



        /**
         * Format selected filter object by it's type
         * @param  {String} key
         * @param {String} type
         * @returns {Object}
         */
        formatSelectedFilter: function (key, type) {
            switch(type) {
                case 'multi': return $location.search()[key] ? $location.search()[key].split(',') : []; break;
                case 'single': return $location.search()[key] ? $location.search()[key] : []; break;
                default: 
                    break;
            }
        },



        /**
         * Format selected date filter
         * @param config
         * @returns {Object}
         */
        formatSelectedDateFilter: function (config) {

            var startDate = config.startKey ? $location.search()[config.startKey] : $location.search()['startDate'],
                endDate = config.endKey ? $location.search()[config.endKey] : $location.search()['endDate'];

            return {
                'startDate': startDate ? formatStartDate(startDate) : null,
                'startName': $translate.instant('general.date_start'),
                'startHours': startDate ? getHours(startDate) : null,
                'startMinutes': startDate ? getMinutes(startDate) : null,

                'endDate': endDate ? formatEndDate(endDate, config) : null,
                'endName': $translate.instant('general.date_end'),
                'endHours': endDate ? getHours(endDate) : null,
                'endMinutes': endDate ? getMinutes(endDate) : null
            };
        },

        /**
         * Takes start and end date and determines if they match predefined range
         * @param startDate
         * @param endDate
         * @returns {*}
         */
        getPredefinedRangeFromDates: function(startDate, endDate) {
            if (!(startDate && endDate)) return null;

            var selected = null;
            var sD = moment(startDate).milliseconds(0);
            var eD = moment(endDate).milliseconds(0);
            var dates = {
                today: {
                    start: moment().hour(0).minutes(0).seconds(0).milliseconds(0),
                    end: moment().hour(23).minutes(59).seconds(59).milliseconds(0),
                    key: 'currDay'
                },
                yesterday: {
                    start: moment().subtract(1, 'day').hour(0).minutes(0).seconds(0).milliseconds(0),
                    end: moment().subtract(1, 'day').hour(23).minutes(59).seconds(59).milliseconds(0),
                    key: 'prevDay'
                },
                currentWeek: {
                    start: moment().day(1).hour(0).minutes(0).seconds(0).milliseconds(0),
                    end: moment().hour(23).minutes(59).seconds(59).milliseconds(0),
                    key: 'currWeek'
                },
                previousWeek: {
                    start: moment().day(1).subtract(7, 'days').hour(0).minutes(0).seconds(0).milliseconds(0),
                    end: moment().day(0).hour(23).minutes(59).seconds(59).milliseconds(0),
                    key: 'prevWeek'
                },
                currentMonth: {
                    start: moment().date(1).hour(0).minutes(0).seconds(0).milliseconds(0),
                    end: moment().hour(23).minutes(59).seconds(59).milliseconds(0),
                    key: 'currMonth'
                },
                previousMonth: {
                    start: moment().subtract(1, 'month').date(1).hour(0).minutes(0).seconds(0).milliseconds(0),
                    end: moment().date(0).hour(23).minutes(59).seconds(59).milliseconds(0),
                    key: 'prevMonth'
                }
            };

            _.each(dates, function (date) {
                if (sD.isSame(date.start) && eD.isSame(date.end))
                    selected = date.key;
            });

            return selected;
        },

        getUrlFormatedDatesFromPredefinedValue: function(predefinedValue) {
            var format = 'YYYY-MM-DD*HH:mm:ss';
            var dates = {
                currDay: {
                    start: moment().hour(0).minutes(0).seconds(0).milliseconds(0).format(format),
                    end: moment().hour(23).minutes(59).seconds(59).milliseconds(0).format(format)
                },
                prevDay: {
                    start: moment().subtract(1, 'day').hour(0).minutes(0).seconds(0).milliseconds(0).format(format),
                    end: moment().subtract(1, 'day').hour(23).minutes(59).seconds(59).milliseconds(0).format(format)
                },
                currWeek: {
                    start: moment().day(1).hour(0).minutes(0).seconds(0).milliseconds(0).format(format),
                    end: moment().hour(23).minutes(59).seconds(59).milliseconds(0).format(format)
                },
                prevWeek: {
                    start: moment().day(1).subtract(7, 'days').hour(0).minutes(0).seconds(0).milliseconds(0).format(format),
                    end: moment().day(0).hour(23).minutes(59).seconds(59).milliseconds(0).format(format)
                },
                currMonth: {
                    start: moment().date(1).hour(0).minutes(0).seconds(0).milliseconds(0).format(format),
                    end: moment().hour(23).minutes(59).seconds(59).milliseconds(0).format(format)
                },
                prevMonth: {
                    start: moment().subtract(1, 'month').date(1).hour(0).minutes(0).seconds(0).milliseconds(0).format(format),
                    end: moment().date(0).hour(23).minutes(59).seconds(59).milliseconds(0).format(format)
                }
            };

            return  _.find(dates, function(date, key) {
                return key === predefinedValue;
            });
        }

    };

    return filterService;

}]);
;
sevenAdminComponents.directive('viewDetailsAccordion', [
    '$rootScope', '$location', 'userInitData', 'appSettingsSvc', 'browserService',
    function ($rootScope, $location, userInitData, appSettingsSvc, browserService) {

        var templateUrl = '/app/components/tables/table-accordion-details/table-accordion-details.html';

        return {
            restrict: 'E',
            templateUrl: browserService.IE9OrLess ? templateUrl.split('#')[0] : templateUrl,
            scope: true,
            link: function ($window) {
                angular.element(window).bind('scroll', function () {
                    var stickPanel = angular.element(document.getElementsByClassName('stick-panel'));

                    if (this.pageYOffset < 110) {
                        stickPanel.css('top', 160 - this.pageYOffset + 'px');
                    } else {
                        stickPanel.css('top', '50px');
                    }
                });
            },
            controller: function ($scope, $element, $attrs, $timeout, $window) {

                $scope.superMode = userInitData.mode === 'SUPER';

                $scope.successfulUpdateTrans = {};
                $scope.selectedTranslation = {};

                var shownLength = 6;
                $scope.shownPart = 0;
                $scope.partializedData = [];

                $scope.transDetailsOpen = {};
                $scope.betDetailsOpen = {};
                $scope.drawDetailsOpen = {};

                $scope.updateTranslation = function (translation, inputType, tgKey, trKey) {
                    $scope.updateRowTranslation(translation, trKey).then(function () {
                        setNextRowFocus(inputType, translation.id, tgKey, trKey);
                        setTransRowHighlight(tgKey, trKey);
                    }, function (error) {
                        // maybe add some error highlighting later
                    });
                };

                $scope.setSelectedTranslation = function (tgKey, trKey) {
                    $scope.selectedTranslation = {};
                    $scope.selectedTranslation[trKey] = tgKey;
                };

                var setNextRowFocus = function (inputType, translationId, tgKey, trKey) {
                    var nextFieldKey = trKey + 1,
                        nextField = document.getElementById('cell_' + inputType + '_' + translationId + '_' + nextFieldKey);

                    if (nextField) {
                        angular.element(nextField.focus());
                        $scope.setSelectedTranslation(tgKey, nextFieldKey);
                    }
                };

                var setTransRowHighlight = function (tgKey, trKey) {
                    $scope.successfulUpdateTrans[tgKey][trKey] = true;
                    $timeout(function () {
                        $scope.successfulUpdateTrans[tgKey] = {};
                    }, 400);
                };

                $scope.$on('gotDetails', function () {
                    $scope.shownPart = 0;
                    $scope.drawDetailsData = {};
                    if($scope.detailData.bets) {
                        breakDataIntoParts($scope.detailData.bets.data, shownLength);
                    }
                });

                $scope.$on('resetSelectedTranslations', function () {
                    $scope.transDetailsOpen = {};
                });

                $scope.subitem = false;

                $scope.setBetDisplay = function(allAccordionStates) {

                    var openAccordionNum = 0,
                        innerHeight = $window.innerHeight;

                    angular.forEach(allAccordionStates, function(accordionState, accordion) {
                        if (accordionState) {
                            ++openAccordionNum;
                        }
                    });

                    if (innerHeight < 740) {
                        setShownBetsLength(openAccordionNum, 1);
                    } else if (innerHeight < 860) {
                        setShownBetsLength(openAccordionNum, 1.5);
                    } else {
                        setShownBetsLength(openAccordionNum, 2);
                    }
                };

                function setShownBetsLength (openAccordionNum, param) {

                    if (openAccordionNum === 0) {
                        shownLength = Math.floor(9 * param);
                    } else if (openAccordionNum === 1) {
                        shownLength = Math.floor(5 * param);
                    } else {
                        shownLength = Math.floor(3 * param);
                    }
                    if($scope.detailData.bets) {
                        breakDataIntoParts($scope.detailData.bets.data, shownLength);
                    }
                }

                $scope.moveThroughBets = function (moveForward) {
                    if (moveForward) {
                        $scope.shownPart += 1;
                    } else {
                        $scope.shownPart -= 1;
                    }

                    $scope.shownBets = $scope.partializedData[$scope.shownPart];
                };

                var breakDataIntoParts = function (detailData, length) {
                    $scope.partializedData = [];

                    for (var i = 0, j = detailData.length; i < j; i += length) {
                        $scope.partializedData.push(detailData.slice(i, i + length));
                    }

                    $scope.shownBets = $scope.partializedData[0];
                };

                $scope.setSelectedBet = function (data) {
                    $scope.updateBet(data).then(function () {
                    }, function (error) {

                    });
                };

                $scope.selectDraw = function (draw) {
                    if ($scope.drawDetailsOpen[draw.no]) {
                        $scope.getDrawDetails(draw).then(function (response) {
                            $scope.drawDetailsData[draw.no] = response;
                        });
                    }
                };

                $('#accordion-table-details').css('max-height', ((window.innerHeight - 180) + 'px'));
            }
        }
    }]);
;
sevenAdminComponents.directive('tableDetails', [
    '$location', '$rootScope', '$timeout', '$window', 'browserService', 'dataSvc',
    function ($location, $rootScope, $timeout, $window, browserService, dataSvc) {

        var templateUrl = '/app/components/tables/table-details-wrapper/table-details-wrapper.html';

        return {
            restrict: 'E',
            templateUrl: browserService.IE9OrLess ? templateUrl.split('#')[0] : templateUrl,
            scope: true,
            controller: function ($scope) {

                $scope.changeDetailsColumn = function (event, viewKey) {
                    event.stopPropagation();

                    var linkKey = dataSvc.getLinkKeys() + '-view-' + viewKey;
                    var columns = $scope.viewList.details.views[viewKey].visibility;

                    localStorage.setItem(linkKey, JSON.stringify(columns));
                    $scope.viewList.details.views[viewKey].colAppearance = !$scope.viewList.details.views[viewKey].colAppearance;
                };

                $scope.resetDetailsLocalStorage = function (viewKey) {

                    var linkKey = dataSvc.getLinkKeys() + '-view-' + viewKey;
                    delete localStorage[linkKey];

                    $scope.showDetails();

                };

                $scope.selectDetailsColumns = function (e, key) {
                    e.stopPropagation();
                    $scope.viewList.details.views[key].colAppearance = !$scope.viewList.details.views[key].colAppearance;
                };
            },
            link: function($scope, $element) {
                var calculatedBreakpoint;
                var unregisterSevenRendered;
                var headerHeight = 45;

                if ($scope.viewList.stickyDetails === 'yes') {
                    // When $scope.viewList.useElementPositionForStickyDetails is truthy use element real position for
                    // determining when will details become fixed
                    if ($scope.viewList.useElementPositionForStickyDetails) {
                        unregisterSevenRendered = $scope.$on("SEVEN.Rendered", function() {
                            calculatedBreakpoint = $element[0].getBoundingClientRect().top + $window.pageYOffset - headerHeight;
                            unregisterSevenRendered();
                        });
                    }

                    var checkAndToggleDetailStickiness = function () {
                        var fixedDetailsClass = $scope.viewList.type === 'tabs' ? 'fixed-details-tab-views' : 'fixed-details';
                        // TODO: $scope.viewList.type === 'tabs'
                        //                                     ? 193
                        //                                     : 115;
                        // This is too static and does not take into account if main tabs break into 2 rows so it's prone to bugs
                        // Use `useElementPositionForStickyDetails` everywhere
                        var fixedDetailsBreakpoint = calculatedBreakpoint ?
                                calculatedBreakpoint :
                                $scope.viewList.type === 'tabs'
                                    ? 193
                                    : 115;

                        if (parseInt($window.pageYOffset) > fixedDetailsBreakpoint && !$scope.viewList.details.hideStickyHeader) {
                            $element[0].classList.add(fixedDetailsClass);
                        } else {
                            $element[0].classList.remove(fixedDetailsClass);
                        }
                    };

                    var destroyListener = function() {
                        angular.element($window).unbind('scroll', checkAndToggleDetailStickiness);
                    };

                    var createListeners = function() {
                        angular.element($window).bind('scroll', checkAndToggleDetailStickiness);
                        $scope.$on('$destroy', destroyListener);
                    };

                    createListeners();
                }
            }
        }
    }
]
);
;
sevenAdminComponents.directive('viewDetailsTable', ['browserService', function (browserService) {

    var templateUrl = '/app/components/tables/table-details/table-details.html';

    return {
        restrict: 'E',
        templateUrl: browserService.IE9OrLess ? templateUrl.split('#')[0] : templateUrl,
        scope: true,
        controller: function ($scope, $element, $attrs, $location, $rootScope) {
            var unbindGlobalClickEvt;

            //Prevents closing column selector if user clicks on column selecor checbox
            unbindGlobalClickEvt = $rootScope.$on('globalClickEvt', function (emmitEvent, data) {
                var clickEvent = data.clickEvent,
                    clickedElement = angular.element(clickEvent.target);

                // TODO: find better way to do it, don't rely on checbox label class
                if (clickedElement.hasClass('details-column-select-checkbox')) {
                    angular.forEach($scope.viewList.details.views, function (val) {
                        val.colAppearance = true;
                    });
                }
            });

            $scope.isLive = $rootScope.$state.params.hasOwnProperty('id')
                ? $rootScope.$state.params.id.indexOf('LiveBetting-v1') > -1
                : false;

            $scope.$on('$destroy', function () {
                unbindGlobalClickEvt();
            });
        },

        link: function ($scope, $element) {

            var $table_wrapper = document.querySelector('.details-table-wrapper'),
                $table_header = document.querySelectorAll('thead#details-table-header')[0].getElementsByTagName('th');

            var oldHeight = 0,
                firstLoad = true;

            angular.element(window).on('resize', setDetailsTableMaxHeight);
            angular.element(window).on('scroll', setDetailsTableMaxHeight);

            angular.element($table_wrapper).on('scroll', stickyHeader);


            if($scope.viewList.details.stickyDetailsHeader) {

                var observer = new MutationObserver(function () {
                    initiateStickyHeader();
                });

                observer.observe($element[0].querySelectorAll('thead:not(#sticky-details-header)')[0].getElementsByTagName('tr')[0],{
                    childList: true,
                    attributes: true,
                    subtree: true
                });
            }

            setDetailsTableMaxHeight();

            function initiateStickyHeader() {

                for (var i = 0; i < $table_header.length; i++) {

                    if ($table_header[i].style.position === 'relative') continue;

                    angular.element( $table_header[i] ).css('position', 'relative');
                }
            }

            function stickyHeader() {
                if($scope.viewList.details.stickyDetailsHeader) {

                    for (var i = 0; i < $table_header.length; i++) {
                        angular.element( $table_header[i] ).css('top', $table_wrapper.scrollTop);
                    }
                }
            }

            function setDetailsTableMaxHeight() {
                var maxHeight,
                    ticketHeaderInfo = document.getElementsByClassName('ticket-header-info-wrapper')[0].getBoundingClientRect();

                maxHeight = window.innerHeight - ticketHeaderInfo.bottom - 40;

                if (firstLoad) {
                    maxHeight -= 150;
                    firstLoad = false;
                }

                if (oldHeight !== maxHeight) {
                    angular.element($table_wrapper).css('max-height', maxHeight + "px");
                    oldHeight = maxHeight;
                }
            }


            $scope.$on('$destroy', function () {
                angular.element(window).off('resize', setDetailsTableMaxHeight);
                angular.element(window).off('scroll', setDetailsTableMaxHeight);
                angular.element($table_wrapper).off('scroll', stickyHeader);
                if (observer) observer.disconnect();
            });

        }
    }
}]);
;
sevenAdminComponents.directive('viewDetailsPanel', ['browserService', function (browserService) {

    var templateUrl = '/app/components/tables/table-panel-details/table-panel-details.html';

    return {
        restrict: 'E',
        templateUrl: browserService.IE9OrLess ? templateUrl.split('#')[0] : templateUrl,
        scope: true,
        controller: function ($scope, $element, $attrs) {

        }
    }
}]);
;
sevenAdminComponents.directive('outcomeTranslations', ['appSettingsSvc', 'browserService', function (appSettingsSvc, browserService) {

    var templateUrl = '/app/components/tables/translations-grid/outcome-translations-grid.html';

    return {
        restrict: 'E',
        templateUrl: browserService.IE9OrLess ? templateUrl.split('#')[0] : templateUrl,
        scope: true,
        controller: function ($scope) {
            $scope.hostUrl = appSettingsSvc.urls.host;
        }
    }
}]);
;
sevenAdminComponents.directive('viewTranslations', ['appSettingsSvc', 'browserService', function (appSettingsSvc, browserService) {

    var templateUrl = '/app/components/tables/translations-grid/translations-grid.html';

    return {
        restrict: 'E',
        templateUrl: browserService.IE9OrLess ? templateUrl.split('#')[0] : templateUrl,
        scope: true,
        controller: function ($scope) {
            $scope.hostUrl = appSettingsSvc.urls.host;
        }
    }
}]);
;
(function () {
    angular
        .module('seven-admin.components')
        .factory('terminalTurnOffSvc', [
            '$http',
            'ENV_CFG',
            function ($http, ENV_CFG) {
                this.globalTurnOff = function (deviceId, isGlobalTurnOffEnabled) {
                    return $http.patch(ENV_CFG.api.backend + '/admin/devices/' + deviceId + '/global-turn-off', {
                        isGlobalTurnOffEnabled: isGlobalTurnOffEnabled
                    });
                };

                this.automaticTurnOff = function (deviceId, automaticTurnOffEnabledStatus, automaticTurnOffTime) {
                    return $http.patch(ENV_CFG.api.backend + '/admin/devices/' + deviceId + '/automatic-turn-off', {
                        automaticTurnOffEnabledStatus: automaticTurnOffEnabledStatus,
                        automaticTurnOffTime: automaticTurnOffTime
                    });
                };
                return this;
            }]);
}());
;
(function () {
  angular
    .module('seven-admin.components')
    .component('terminalTurnOff', {
      templateUrl: '/app/components/terminal-turn-off/terminal-turn-off.html',
      controller: TerminalTurnOffController,
      bindings: {
        deviceConfiguration: '<'
      }
    });

  TerminalTurnOffController.inject = [
    '$scope',
    '$translate',
    'notificationService',
    'terminalTurnOffSvc'
  ];

  function TerminalTurnOffController(
    $scope,
    $translate,
    notificationService,
    terminalTurnOffSvc
  ) {
    var $ctrl = this;
    $ctrl.$onInit = function () {
      $ctrl.powerConfig = $ctrl.deviceConfiguration.device.powerConfig;

      $ctrl.automaticTurnOff = angular.copy($ctrl.powerConfig.isAutomaticTurnOffEnabled);
      $ctrl.globalTurnOff = angular.copy(!$ctrl.powerConfig.isGlobalTurnOffEnabled);
      $ctrl.automaticTurnOffTime = angular.copy($ctrl.powerConfig.automaticTurnOffTime);
      $ctrl.firstLoad = true;

      $scope.infoMessages = {
        success: {
          type: 'info',
          title: $translate.instant('general.changes_saved'),
        },
        error: {
          type: 'error',
          title: $translate.instant('general.save_error'),
        },
        timeFormatError: {
          type: 'error',
          title: $translate.instant('validation.messages.invalid_time_format', { format: 'hh:mm' }),
        },
      };
    };

    var saveChanges = function () {
      if (!$ctrl.automaticTurnOffTime) {
        $ctrl.firstLoad = false;
        terminalTurnOffSvc.globalTurnOff(
          $ctrl.deviceConfiguration.device.id,
          !$ctrl.globalTurnOff
        ).then(function (response) {
          if (notificationService.serverResponseValid(response.status)) {
            notificationService.showInfoNotification($scope.infoMessages.success, 5000);
          } else {
            notificationService.showInfoNotification($scope.infoMessages.error, 5000);
          }
        }).catch(function () {
          notificationService.showInfoNotification($scope.infoMessages.error, 5000);
        });

        terminalTurnOffSvc.automaticTurnOff(
          $ctrl.deviceConfiguration.device.id,
          false,
          null
        ).then(function (response) {
          if (notificationService.serverResponseValid(response.status)) {
            notificationService.showInfoNotification($scope.infoMessages.success, 5000);
          } else {
            notificationService.showInfoNotification($scope.infoMessages.error, 5000);
          }
        }).catch(function () {
          notificationService.showInfoNotification($scope.infoMessages.error, 5000);
        });
      } else {
        // Validate time
        var time = $ctrl.automaticTurnOffTime && $ctrl.automaticTurnOffTime.split(':');
        if (time.length !== 2 || parseInt(time[0], 10) > 23 || parseInt(time[0], 10) < 0 || parseInt(time[1], 10) > 59 || parseInt(time[1], 10) < 0) {
          notificationService.showInfoNotification($scope.infoMessages.timeFormatError, 5000);
        } else {
          $ctrl.firstLoad = false;
          terminalTurnOffSvc.globalTurnOff(
            $ctrl.deviceConfiguration.device.id,
            !$ctrl.globalTurnOff
          ).then(function (response) {
            if (notificationService.serverResponseValid(response.status)) {
              notificationService.showInfoNotification($scope.infoMessages.success, 5000);
            } else {
              notificationService.showInfoNotification($scope.infoMessages.error, 5000);
            }
          }).catch(function () {
            notificationService.showInfoNotification($scope.infoMessages.error, 5000);
          });
          
          terminalTurnOffSvc.automaticTurnOff(
            $ctrl.deviceConfiguration.device.id,
            $ctrl.automaticTurnOff,
            $ctrl.automaticTurnOffTime
          ).then(function (response) {
            if (notificationService.serverResponseValid(response.status)) {
              notificationService.showInfoNotification($scope.infoMessages.success, 5000);
            } else {
              notificationService.showInfoNotification($scope.infoMessages.error, 5000);
            }
          }).catch(function () {
            notificationService.showInfoNotification($scope.infoMessages.error, 5000);
          });
        }
      }
    };

    $ctrl.toggleGlobalTurnOff = function () {
      if (!$ctrl.globalTurnOff) {
        $ctrl.automaticTurnOff = false;
        $ctrl.automaticTurnOffTime = null;
      }
    };

    $ctrl.toggleAutomaticTurnOff = function () {
      if (!$ctrl.automaticTurnOff) {
        $ctrl.automaticTurnOffTime = null;
      }
    };

    $ctrl.saveAction = function () {
      saveChanges();
    };

    $ctrl.cancelAction = function () {
      // Take backe initial state
      $ctrl.automaticTurnOff = $ctrl.powerConfig.isAutomaticTurnOffEnabled;
      $ctrl.globalTurnOff = !$ctrl.powerConfig.isGlobalTurnOffEnabled;
      $ctrl.turnOffTime = $ctrl.powerConfig.automaticTurnOffTime;

      saveChanges();
    };

    $ctrl.isSaveDisabled = function () {
      return $ctrl.automaticTurnOff == $ctrl.powerConfig.isAutomaticTurnOffEnabled 
        && $ctrl.globalTurnOff != $ctrl.powerConfig.isGlobalTurnOffEnabled
        && $ctrl.automaticTurnOffTime == $ctrl.powerConfig.automaticTurnOffTime
        && $ctrl.firstLoad;
    };
  }
}());
;
(function () {
    angular
        .module('seven-admin.components')
        .directive('sevenTransclude', sevenTransclude);

    sevenTransclude.$inject = ['$compile', '$templateRequest'];

    function sevenTransclude($compile, $templateRequest) {
        return {
            transclude: true,
            template: '<div></div>',
            controller: function ($scope, $element, $attrs,  $transclude) {
                var transcludedContent, transclusionScope;

                $attrs.$observe('transcludedContentTemplateUrl', function (templateUrl) {
                    $templateRequest(templateUrl).then(function (template) {
                        if (transcludedContent) transcludedContent.remove();
                        if (transclusionScope) transclusionScope.$destroy();

                        $transclude(function (clone, scope) {
                            var el = $compile(template)(scope);
                            $element.append(el);

                            transcludedContent = el;
                            transclusionScope = scope;
                        })
                    })
                });

                $scope.$on('$destroy', function () {
                    transcludedContent.remove();
                    transclusionScope.$destroy();
                });
            }
        }
    }
}());;
sevenAdminComponents.directive('translationSync',['browserService', function (browserService) {

    var templateUrl = '/app/components/translation-sync/translation-sync.html';

    return {
        restrict: 'E',
        templateUrl: browserService.IE9OrLess ? templateUrl : templateUrl + '',
        scope: true,
        controller: function($scope){

        }
    }
}]);
;
(function() {
    angular
        .module('seven-admin.components')
        .component('workingTime', {
            templateUrl: 'app/components/working-time/working-time.template.html',
            controller: WorkingTimeComponentController,
            controllerAs: 'workingTimeVm',
            bindings: {
                workingTimes: '<',
                onSave: '&',
                onSlotCreationError: '&'
            }
        });

    WorkingTimeComponentController.$inject = [
        '$analytics',
        '$timeout',
        'userInitData'
    ];

    function WorkingTimeComponentController(
        $analytics,
        $timeout,
        userInitData
    ) {
        var workingTimeVm = this;
        var dayOffsets = {
            sunday: 0,
            monday: 1,
            tuesday: 2,
            wednesday: 3,
            thursday: 4,
            friday: 5,
            saturday: 6
        };
        var timeSlotTimeFormat = 'HH:mm:ss';
        var zeroTime = moment('00:00:00', timeSlotTimeFormat);
        var MAX_SLOTS_PER_DAY = 5;
        var initialSlots;

        function creteTimePickerOptions() {
            var useMeridian = !userInitData.user.timeFormat24;

            return {
                timeFormat: useMeridian ? "hh:mm:ss a" : "HH:mm:ss",
                buttonBar: {
                    show: true,
                    cancel: { show: false },
                    clear: { show: false },
                    close: { show: true },
                    date: { show: false },
                    now: { show: false },
                    today: { show: false },
                },
                options: {
                    showMeridian: useMeridian,
                    showSeconds: true
                },
                end: {
                    datePickerOptions: {}
                },
                start: {
                    datePickerOptions: {}
                }
            };
        }

        var init = function() {
            workingTimeVm.analyticsCategory = 'SEVEN.Settings.WorkingTime';
            workingTimeVm.slotResizeOptions = {
                edges: {
                    left: true,
                    right: true
                }
            };
            workingTimeVm.timeSlots = [];
            workingTimeVm.dayHours = ['03', '06', '09', '12', '15', '18', '21'];

            workingTimeVm.hourLines = createHourLines();
            workingTimeVm.weekDays = createWeekdays();
            workingTimeVm.timePicker = creteTimePickerOptions();

            workingTimeVm.createNewTimeSlot = createNewTimeSlot;
            workingTimeVm.editTimeSlot = editTimeSlot;
            workingTimeVm.removeTimeSlot = removeTimeSlot;
            workingTimeVm.undoRemove = undoRemove;
            workingTimeVm.onTimeChange = onTimeChange;
            workingTimeVm.onDayChange = onDayChange;
            workingTimeVm.dayDisabled = dayDisabled;
            workingTimeVm.cancel = cancel;
            workingTimeVm.save = save;
            workingTimeVm.onTimeSlotResize = onTimeSlotResize;
            workingTimeVm.onTimeSlotResizeStart = onTimeSlotResizeStart;
            workingTimeVm.onTimeSlotResizeEnd = onTimeSlotResizeEnd;

            createTimeSlotsFormWorkingTimes(workingTimeVm.workingTimes);
        };

        var onChanges = function(changes) {
            createTimeSlotsFormWorkingTimes(changes.workingTimes.currentValue)
        };

        var createTimeSlotsFormWorkingTimes = function(workingTimes) {
            if (!_.isEmpty(workingTimes)) {
                var newTimeSlots = [];

                var lastIndex;

                _.each(workingTimes, function(timeSlots, day) {
                    timeSlots.forEach(function(timeSlot) {
                        var dayOffset = dayOffsets[day];

                        var zeroStartDay = moment(zeroTime).day(dayOffset);

                        var start = moment(timeSlot.start, timeSlotTimeFormat).day(dayOffset);
                        var end = moment(timeSlot.end, timeSlotTimeFormat).day(dayOffset);

                        var endStartUtcOffsetDifference = end.utcOffset() - start.utcOffset();
                        var startZeroUtcOffsetDifference = start.utcOffset() - zeroStartDay.utcOffset();

                        var startEndTimeDifference = moment(end).add(endStartUtcOffsetDifference, 'minutes').diff(start, 'hours', true);
                        var startZeroTimeDifference =  moment(start).add(startZeroUtcOffsetDifference, 'minutes').diff(zeroStartDay, 'hours', true);

                        var slotContinuousWithLast = false;

                        if (lastIndex >= 0) {
                            var lastSlotEnd = newTimeSlots[lastIndex].time.momentEndDate;
                            var lastSlotEndTimeSecondsDifference = start.diff(lastSlotEnd, 'seconds', true);

                            if (lastSlotEndTimeSecondsDifference === 1) {
                                slotContinuousWithLast = true;
                                endStartUtcOffsetDifference = end.utcOffset() - newTimeSlots[lastIndex].time.momentStartDate.utcOffset();
                                startEndTimeDifference = moment(end).add(endStartUtcOffsetDifference, 'hours').diff(newTimeSlots[lastIndex].time.momentStartDate, 'hours' , true)
                            }
                        }

                        var width = (startEndTimeDifference * 100) / (24*7);

                        if (slotContinuousWithLast) {
                            var updatedTimeSlot = {
                                ui: {
                                    width: width,
                                },
                                day: {
                                    end: day
                                },
                                time: {
                                    end: timeSlot.end,
                                    momentEndDate: end,
                                    endDateObject: end.toDate()
                                }
                            };
                            _.merge(newTimeSlots[lastIndex], updatedTimeSlot);
                        } else {
                            var x = ((dayOffset * 24 + startZeroTimeDifference) * 100) / (24*7);
                            var timeSlotUI = {
                                width: width,
                                x: x
                            };

                            lastIndex = newTimeSlots.push({
                                ui: timeSlotUI,
                                time: {
                                    start: timeSlot.start,
                                    momentStartDate: start,
                                    startDateObject: start.toDate(),
                                    end: timeSlot.end,
                                    momentEndDate: end,
                                    endDateObject: end.toDate()
                                },
                                day: {
                                    start: day,
                                    end: day,
                                }
                            }) - 1;
                        }
                    });
                });

                workingTimeVm.timeSlots = newTimeSlots;

                if (!initialSlots) {
                    initialSlots = _.cloneDeep(workingTimeVm.timeSlots);
                }
            }
        };

        var save = function() {
            purgeSavedRemovedSlot();
            var start = '00:00:00';
            var end = '23:59:59';
            var days = {
                sunday: [],
                monday: [],
                tuesday: [],
                wednesday: [],
                thursday: [],
                friday: [],
                saturday: [],
            };

            _.each(workingTimeVm.timeSlots, function(timeSlot) {
                if (timeSlot.day.start === timeSlot.day.end) {
                    days[timeSlot.day.start].push({
                        start: timeSlot.time.start,
                        end: timeSlot.time.end,
                    })
                } else {
                    for (var i = dayOffsets[timeSlot.day.start]; i <= dayOffsets[timeSlot.day.end]; i++) {
                        var day = findKey(dayOffsets, i);

                        days[day].push({
                            start: day === timeSlot.day.start ? timeSlot.time.start : start,
                            end: day === timeSlot.day.end ? timeSlot.time.end : end
                        })
                    }
                }
            });

            workingTimeVm.onSave({days: days});
        };

        var cancel = function() {
            if (initialSlots) {
                purgeSavedRemovedSlot();
                closeEdit();
                workingTimeVm.editedSlot = null;
                workingTimeVm.timeSlots = _.cloneDeep(initialSlots);
            }
        };

        var createHourLines = function() {
            var range = Array(23);

            _.fill(range);

            return range.map(function(value, index) {
                return {
                    x1: ((index + 1) * 100 / 24) + "%",
                    x2: ((index + 1) * 100 / 24) + "%",
                    y1: (index + 1) % 3 === 0 ? 0 : '25%',
                    y2: (index + 1) % 3 === 0 ? '100%': '75%'
                }
            })
        };

        var createWeekdays = function() {
            var weekdays = {};
            var weekdayKeys = [
                'sunday',
                'monday',
                'tuesday',
                'wednesday',
                'thursday',
                'friday',
                'saturday'
            ];

            weekdayKeys.forEach(function(weekday, index) {
                weekdays[weekday] = moment.weekdays(index);
            });

            return weekdays;
        };

        var createNewTimeSlot = function(event) {
            if (workingTimeVm.resizing) return;

            var position = (event.offsetX / event.target.clientWidth) * 100;
            var defaultTime = 3;
            var defaultWidth = (defaultTime * 100 / (24*7));
            var timeSlotUI = {
                x: position,
                width: defaultWidth
            };

            var startDate = createStartDateFromPosition(event.offsetX, event.target.clientWidth, defaultTime);
            var endDate = createEndDateFromStartAndHourOffset(startDate.start, defaultTime);

            var startDaySlotCount = countSlotsForDay(startDate.day);
            var endDaySlotCount = countSlotsForDay(endDate.day);

            if (startDaySlotCount === MAX_SLOTS_PER_DAY || endDaySlotCount === MAX_SLOTS_PER_DAY) {
                workingTimeVm.onSlotCreationError({
                    error: {
                        messageKey: 'working_time.maximum_number_of_slots_per_day_exceeded'
                    }
                });
                return;
            }

            var timeSlot = {
                ui: timeSlotUI,
                time: {
                    start: startDate.start.format(timeSlotTimeFormat),
                    momentStartDate: startDate.start,
                    startDateObject: startDate.start.toDate(),
                    end: endDate.end.format(timeSlotTimeFormat),
                    momentEndDate: endDate.end,
                    endDateObject: endDate.end.toDate()
                },
                day: {
                    start: startDate.day,
                    end: endDate.day,
                }
            };

            if (workingTimeVm.timeSlots.length) {
                var last = workingTimeVm.timeSlots.length - 1;

                for (var i = 0; i <= last; i++) {
                    var currentSlotUI = workingTimeVm.timeSlots[i].ui;

                    if (timeSlotUI.x < currentSlotUI.x) {
                        workingTimeVm.timeSlots.splice(i, 0 , timeSlot);
                        break;
                    }

                    if (i === last) {
                        workingTimeVm.timeSlots.push(timeSlot)
                    }

                }
            } else {
                workingTimeVm.timeSlots.push(timeSlot)
            }

            editTimeSlot(timeSlot)
        };

        var countSlotsForDay = function(day) {
            var count = 0;

            workingTimeVm.timeSlots.forEach(function(timeSlot) {
                if (timeSlot.day.start === day || timeSlot.day.end === day) {
                    count++;
                }
            });

            return count;
        };

        var removeTimeSlot = function(timeSlot) {
            closeEdit();
            var index = workingTimeVm.timeSlots.indexOf(timeSlot);
            var removed = workingTimeVm.timeSlots.splice(index, 1);

            saveRemovedSlot(removed[0], index)
        };

        var purgeSavedRemovedSlot = function() {
            workingTimeVm.removedSlot = null;
            workingTimeVm.canUndoRemove = false;
        };

        var saveRemovedSlot = function(timeSlot, index) {
            workingTimeVm.canUndoRemove = true;
            workingTimeVm.removedSlot = {
                timeSlot: timeSlot,
                index: index
            };
        };

        var undoRemove = function() {
            workingTimeVm.timeSlots.splice(workingTimeVm.removedSlot.index, 0, workingTimeVm.removedSlot.timeSlot);
            purgeSavedRemovedSlot();
        };

        var createEndDateFromStartAndHourOffset = function(startDate, hourOffset) {
            var end = moment(startDate).add(hourOffset, 'hours');
            var day = findKey(dayOffsets, end.weekday());

            return {
                end: end,
                day: day
            }
        };

        var createStartDateFromPosition = function(x, width) {
            var sectionWidth = width / 7;
            var dayIndex = Math.floor(x / sectionWidth);
            var day = findKey(dayOffsets, dayIndex);
            var decimalHours = (x % sectionWidth / sectionWidth) * 24;
            var hours = Math.floor(decimalHours);
            var decimalMinutes = decimalHours % 1 * 60;
            var minutes = Math.floor(decimalMinutes);
            var seconds = Math.floor(decimalMinutes % 1 * 60);

            return {
                start: moment({ hours: hours, minutes: minutes, seconds: seconds }).day(dayIndex),
                day: day
            };
        };

        var editTimeSlot = function(timeSlot) {
            purgeSavedRemovedSlot();
            setDateTimePickerValidation(timeSlot);
            workingTimeVm.editedSlot = timeSlot;
            workingTimeVm.editedSlotIndex = workingTimeVm.timeSlots.indexOf(timeSlot);
            workingTimeVm.editingSlot = true;
        };

        var setDateTimePickerValidation = function(timeSlot) {
            var index = workingTimeVm.timeSlots.indexOf(timeSlot);
            var previousSlotExists = index !== 0;
            var nextSlotExists = index !== workingTimeVm.timeSlots.length - 1;

            var minStartTime = previousSlotExists && moment(workingTimeVm.timeSlots[index -1].time.endDateObject).add(1, 'second').toDate();
            var maxStartTime = moment(timeSlot.time.endDateObject).subtract(10, 'minutes').toDate();

            var minEndTime = moment(timeSlot.time.startDateObject).add(10, 'minutes').toDate();
            var maxEndTime = nextSlotExists && moment(workingTimeVm.timeSlots[index + 1].time.startDateObject).subtract(1, 'second').toDate();

            workingTimeVm.timePicker.start.datePickerOptions.minDate = minStartTime || null;
            workingTimeVm.timePicker.start.datePickerOptions.maxDate = maxStartTime;

            workingTimeVm.timePicker.end.datePickerOptions.maxDate = maxEndTime || null;
            workingTimeVm.timePicker.end.datePickerOptions.minDate = minEndTime;
        };

        var onTimeChange = function(timeSlot) {
            updateTimeSlotMoment(timeSlot);
            updateTimeSlotTimes(timeSlot);
            updateTimeSlotUI(timeSlot);
            setDateTimePickerValidation(timeSlot);
        };

        var onDayChange = function(timeSlot) {
            updateTimeSlotDates(timeSlot);
            updateTimeSlotUI(timeSlot);
            setDateTimePickerValidation(timeSlot);
            // When day is changed and time model is updated, view value for stays the same and validators are run only
            // when view value changes so we need to run them. Also use $timeout because model is not updated immediately
            $timeout(runDateTimeValidators)
        };

        var runDateTimeValidators = function() {
            workingTimeVm.form.startTime.$validate();
            workingTimeVm.form.endTime.$validate();
        };

        var onTimeSlotResize = function(event, timeSlot) {
            setTimeSlotUIFromResizeEvent(event, timeSlot);
            updateTimeSlotDayAndTimeFromUIData(timeSlot, event);
            setDateTimePickerValidation(timeSlot);
        };


        var onTimeSlotResizeStart = function(event, timeSlot) {
            $analytics.eventTrack('SlotResize', { category: workingTimeVm.analyticsCategory , label: 'Working time slot resize'});
            workingTimeVm.resizing = true;
            editTimeSlot(timeSlot);
        };

        var onTimeSlotResizeEnd = function() {
            $timeout(function() {
                workingTimeVm.resizing = false;
            });
        };


        var setTimeSlotUIFromResizeEvent = function(event, timeSlot) {
            var parentWidth = event.target.parentElement.clientWidth;
            var width = (event.rect.width / parentWidth) * 100;

            timeSlot.ui.width = width;

            if (event.deltaRect.left) {
                var deltaX = (event.deltaRect.left / parentWidth) * 100;

                timeSlot.ui.x += deltaX;
            }
        };

        var updateTimeSlotDayAndTimeFromUIData = function(timeSlot, event) {
            var totalTimelineWidth = event.target.parentElement.clientWidth;
            var startX = timeSlot.ui.x * totalTimelineWidth / 100;
            var endX = startX + (timeSlot.ui.width * totalTimelineWidth / 100);

            var startDate = createDateFromPosition(startX, totalTimelineWidth, 'start');
            var endDate = createDateFromPosition(endX, totalTimelineWidth, 'end');

            _.assign(timeSlot, {
                time: {
                    start: startDate.start.format(timeSlotTimeFormat),
                    momentStartDate: startDate.start,
                    startDateObject: startDate.start.toDate(),
                    end: endDate.end.format(timeSlotTimeFormat),
                    momentEndDate: endDate.end,
                    endDateObject: endDate.end.toDate()
                },
                day: {
                    start: startDate.day,
                    end: endDate.day,
                }
            })

        };

        /**
         * @name createDateFromPosition
         * @param x
         * @param totalTimelineWidth
         * @param type {'start'|'end'}
         * @returns {{day: T}}
         */
        var createDateFromPosition = function(x, totalTimelineWidth, type) {
            var sectionWidth = totalTimelineWidth / 7;
            var dayIndex = Math.floor(x / sectionWidth);
            var day = findKey(dayOffsets, dayIndex);
            var decimalHours = (x % sectionWidth / sectionWidth) * 24;
            var hours = Math.floor(decimalHours);
            var decimalMinutes = decimalHours % 1 * 60;
            var minutes = Math.floor(decimalMinutes);
            var seconds = Math.floor(decimalMinutes % 1 * 60);

            var date = {
                day: day
            };

            date[type] = moment({ hours: hours, minutes: minutes, seconds: seconds }).day(dayIndex);

            return date;
        };


        var updateTimeSlotMoment = function(timeSlot) {
            timeSlot.time.momentStartDate = moment(timeSlot.time.startDateObject);
            timeSlot.time.momentEndDate = moment(timeSlot.time.endDateObject);
        };

        var updateTimeSlotDates = function(timeSlot) {
            var startDayOffset = dayOffsets[timeSlot.day.start];
            var endDayOffset = dayOffsets[timeSlot.day.end];

            timeSlot.time.momentStartDate.day(startDayOffset);
            timeSlot.time.momentEndDate.day(endDayOffset);

            timeSlot.time.startDateObject = timeSlot.time.momentStartDate.toDate();
            timeSlot.time.endDateObject = timeSlot.time.momentEndDate.toDate();
        };

        var updateTimeSlotTimes = function(timeSlot) {
            timeSlot.time.start = moment(timeSlot.time.startDateObject).format(timeSlotTimeFormat);
            timeSlot.time.end = moment(timeSlot.time.endDateObject).format(timeSlotTimeFormat);
        };

        var updateTimeSlotUI = function(timeSlot) {
            timeSlot.ui = createTimeSlotUIData(timeSlot);
        };

        var createTimeSlotUIData = function(timeSlot) {
            var startDayOffset = dayOffsets[timeSlot.day.start];
            var endDayOffset = dayOffsets[timeSlot.day.end];

            var zeroStartDay = moment(zeroTime).day(startDayOffset);

            var start = moment(timeSlot.time.start, timeSlotTimeFormat).day(startDayOffset);
            var end = moment(timeSlot.time.end, timeSlotTimeFormat).day(endDayOffset);

            var endStartUtcOffsetDifference = end.utcOffset() - start.utcOffset();
            var startZeroUtcOffsetDifference = start.utcOffset() - zeroStartDay.utcOffset();

            var startEndTimeDifference = moment(end).add(endStartUtcOffsetDifference, 'minutes').diff(start, 'hours', true);
            var startZeroTimeDifference =  moment(start).add(startZeroUtcOffsetDifference, 'minutes').diff(zeroStartDay, 'hours', true);

            var width = ((startEndTimeDifference) * 100) / (24*7);
            var x = ((dayOffsets[timeSlot.day.start] * 24 + startZeroTimeDifference) * 100) / (24*7);

            return {
                width: width,
                x: x
            };
        };

        var closeEdit = function() {
            workingTimeVm.editingSlot = false;
            workingTimeVm.editedSlotIndex = undefined;
        };

        var dayDisabled = function(timeSlot, day, type) {
            var index = workingTimeVm.timeSlots.indexOf(timeSlot);

            if (type === 'start') {
                var dayStartDate = moment(timeSlot.time.momentStartDate).day(dayOffsets[day]);
                var previousEndDate = index === 0 ?
                    null :
                    workingTimeVm.timeSlots[index -1].time.momentEndDate;

                return previousEndDate ?
                    !dayStartDate.isBetween(previousEndDate, timeSlot.time.momentEndDate) :
                    !dayStartDate.isBefore(timeSlot.time.momentEndDate);

            } else {
                var dayEndDate = moment(timeSlot.time.momentEndDate).day(dayOffsets[day]);
                var nextStartDate = index === workingTimeVm.timeSlots.length - 1 ?
                    null :
                    workingTimeVm.timeSlots[index + 1].time.momentStartDate;

                return nextStartDate ?
                    !dayEndDate.isBetween(timeSlot.time.momentStartDate, nextStartDate) :
                    !dayEndDate.isAfter(timeSlot.time.momentStartDate);
            }
        };

        var findKey = function(object, predicate) {
            return Object.keys(object).find(key => object[key] === predicate)
        };

        workingTimeVm.$onInit = init;
        workingTimeVm.$onChanges = onChanges;
    }
}());
;
(function () {
    'use strict';

    angular
        .module('seven-admin.zodiac')
        .component('zodiacChat', {
            templateUrl: '/app/components/zodiac/component/zodiac.template.html',
            controllerAs: 'model',
            controller: [
                '$rootScope',
                '$scope',
                '$location',
                'zodiacService',
                'zodiacHttpService',
                'zodiacSocketConnection',
                'userInitData',
                'tokenAuthService',
                'ENV_CFG',
                function (
                    $rootScope,
                    $scope,
                    $location,
                    zodiacService,
                    zodiacHttpService,
                    zodiacSocketConnection,
                    userInitData,
                    tokenAuthService,
                    ENV_CFG
                ) {
                    var vm = this,
                        userData = setUserData(),
                        typingIndicatorTimeout = null,
                        audioPlayTester = new Audio(),
                        canPlayMP3 = audioPlayTester.canPlayType('audio/mpeg') === 'probably',
                        MP3AudioSource = 'assets/audio/chatNotification.mp3',
                        AACAudioSource = 'assets/audio/chatNotification.mp4',
                        notificationSound = new Audio(canPlayMP3 ? MP3AudioSource : AACAudioSource);

                    function init() {
                        vm.chatWindow = zodiacService.chatWindow;
                        vm.addUserOverlayShown = false;
                        vm.onlineUserListShown = false;
                        vm.onlineUsers = [];
                        vm.dateFormat = userInitData.user.dateFormat;
                        vm.userData = {
                            id: userInitData.user.uuid
                        };
                        vm.conversationStartedByAdmin = false;

                        connect();
                    }

                    vm.toggleOnlineStatus = function () {
                        var userOnline = zodiacService.chatWindow.userOnline = !zodiacService.chatWindow.userOnline;

                        const status = {
                            online: userOnline,
                        };

                        zodiacSocketConnection.changeOnlineStatus(status);
                    }

                    vm.toggleChat = function () {
                        vm.closeAddUserOverlay();
                        zodiacService.toggleChatWindow();
                    };

                    vm.submitMessage = function (message) {
                        if (!message || !message.length) return;

                        zodiacSocketConnection.sendMessage(vm.chatWindow.selectedConversation, message);
                    };

                    vm.selectConversation = function (conversation) {
                        if (!conversation.active) return;

                        vm.closeAddUserOverlay();
                        zodiacService.selectConversation(conversation.id, true);
                    }

                    vm.onConversationSelect = function (conversation) {
                        if (!isAdministratorInConversation(conversation, vm.userData.id)) {
                            zodiacSocketConnection.joinConversation(conversation.id, vm.userData.id);

                        }

                        this.selectConversation(conversation);
                    }

                    vm.closeChat = function () {
                        zodiacService.closeChatWindow();
                    };

                    vm.closeConversation = function (conversationId) {
                        zodiacService.closeConversation(conversationId);
                        zodiacSocketConnection.leaveConversation(conversationId);
                        vm.conversationStartedByAdmin = !vm.noActiveConversations();
                    };

                    vm.closeAddUserOverlay = function () {
                        vm.addUserOverlayShown = false;
                    };

                    vm.openAddUserOverlay = function () {
                        const selectedConversation = this.chatWindow.conversations[vm.chatWindow.selectedConversation];
                        const groupId = selectedConversation.group.id;

                        zodiacHttpService.getGroupOnlineAdministrators(groupId).then(function(users) {
                            vm.onlineUsers = users.filter((user) => {
                                return !selectedConversation.users.find((selectedConversationUser) => selectedConversationUser.id === user.id)
                            });
                        });

                        vm.addUserOverlayShown = true;
                    };

                    vm.acceptAssistanceRequest = function (request, requestIndex) {
                        zodiacSocketConnection.joinConversation(request.id);
                        zodiacService.closeAssistanceRequest(requestIndex);
                        vm.selectConversation(request.id);
                    };

                    vm.rejectAssistanceRequest = function (requestIndex) {
                        zodiacService.closeAssistanceRequest(requestIndex);
                    };

                    vm.addUserToConversation = function (user) {
                        vm.closeAddUserOverlay();

                        zodiacSocketConnection.addUserToConversation({
                            id: vm.chatWindow.selectedConversation,
                            operator: this.chatWindow.conversations[vm.chatWindow.selectedConversation].operator,
                            betshop: this.chatWindow.conversations[vm.chatWindow.selectedConversation].betshop
                        }, user.id);
                    };

                    vm.getOnlineConversationUsers = function (conversationId) {
                        zodiacHttpService.getOnlineConversationUsers(conversationId)
                            .then((function (conversationUsers) {
                                zodiacService.setConversationUserList(conversationId, conversationUsers);
                            }));
                    };

                    vm.noActiveConversations = function() {
                        return _.isEqual({}, vm.chatWindow.conversations) && !vm.chatWindow.assistanceRequests.length;
                    };

                    var isAdministratorInConversation = function (conversation, administratorId) {
                        return !!conversation.users.find(function (user) {
                            return user.id === administratorId;
                        })
                    }
                    function connect() {
                        zodiacSocketConnection.connect(ENV_CFG.api.zodiac, userData, function() {
                            setSocketListeners();

                            if (!$rootScope.chatLoaded) {
                                setAppEventListeners();

                                $rootScope.chatLoaded = true;
                            }
                        })
                    }

                    function setSocketListeners() {
                        zodiacSocketConnection.on('connect_error', function () {
                            zodiacService.setUserOffline();
                        });

                        zodiacSocketConnection.on('disconnect', function () {
                            zodiacService.setUserOffline();
                        });

                        zodiacSocketConnection.on('error', function () {
                            zodiacService.setUserOffline();
                        });

                        // Zodiac events
                        zodiacSocketConnection.on('OnlineStatus', function(data) {
                            if (zodiacService.chatWindow.userOnline === data.online) return;

                            zodiacService.chatWindow.userOnline = data.online;

                            if (data.online) {
                                zodiacService.setConversations();
                            }
                        });

                        zodiacSocketConnection.on('ConversationExpanded', function(data) {
                            zodiacService.handleUserAddEvent(data);
                            vm.getOnlineConversationUsers(data.conversation.id);
                        });

                        zodiacSocketConnection.on('ConversationJoined', function (data) {
                            var isSelfAdd = vm.userData.id === data.addedByUser.id;

                            zodiacService.setChatConversation(data, isSelfAdd);
                            vm.getOnlineConversationUsers(data.conversation.id);

                            if (isSelfAdd) vm.selectConversation(data.conversation.id);
                        });

                        zodiacSocketConnection.on('MessageSent', function (data) {
                            zodiacService.handleMessageEvent(data);

                            if (zodiacService.chatWindow.userOnline) {
                                playNotificationSoundForHiddenTab();
                            }
                        });

                        zodiacSocketConnection.on('OperatorMessageSent', function (data) {
                            if (!zodiacService.chatWindow.userOnline) return;

                            var conversation = vm.chatWindow.conversations[data.conversation.id];

                            if (vm.noActiveConversations() || !conversation) {
                                zodiacService.setConversation(data.conversation.id).then(function () {
                                    playNotificationSoundForHiddenTab();
                                    zodiacService.setTotalUnread();
                                });
                            } else if (conversation && conversation.unread){
                                playNotificationSoundForHiddenTab();
                                zodiacService.handleMessageEvent(data)
                                zodiacService.setTotalUnread();
                            }
                        });

                        zodiacSocketConnection.on('AssistanceRequested', function (data) {
                            playNotificationSound();
                            zodiacService.handleNewAssistanceRequest(data)
                        });

                        zodiacSocketConnection.on('ConversationLeft', function (data) {
                            if (vm.userData.id === data.user.id) {
                                zodiacService.closeConversation(data.conversation.id);
                                vm.conversationStartedByAdmin = !vm.noActiveConversations();
                            } else {
                                zodiacService.handleUserLeaveEvent(data);
                                vm.getOnlineConversationUsers(data.conversation.id);
                            }
                        });

                        zodiacSocketConnection.on('UserInvited', function (data) {
                            zodiacSocketConnection.joinConversation(data.conversation.id);
                        });

                        zodiacSocketConnection.on('OperatorLeft', function (data) {
                            zodiacService.disableConversation(data.conversation.id);
                        });

                        zodiacSocketConnection.on('OperatorJoined', function (data) {
                            zodiacService.enableConversation(data.conversation.id);
                        });

                        zodiacSocketConnection.on('UserTyped', function (data) {
                            if (vm.userData.id === data.user.id) return;

                            zodiacService.handleTypingIndicator(data.conversation.id, data.user);
                        });
                    }

                    vm.sendTypingIndicator = function(conversationId) {
                        if (typingIndicatorTimeout) return;

                        typingIndicatorTimeout = setTimeout(function() {
                            zodiacSocketConnection.sendTypingIndicator(conversationId, userData.user);
                            typingIndicatorTimeout = null;
                        }, 1000);
                    };

                    function setAppEventListeners() {
                        $rootScope.$on('GravityConversationStarted', function (event, data) {
                            zodiacSocketConnection.joinConversation(data.conversationId, vm.userData.id);
                            vm.conversationStartedByAdmin = true;
                        });
                    }

                    function setUserData() {
                        return {
                            user: {
                                id: userInitData.user.uuid,
                                type: 'administrator',
                                name: userInitData.user.firstname + ' ' + userInitData.user.lastname,
                                superUser: !!userInitData.hasSuperAdminMode
                            },
                            company: {
                                id: userInitData.currentCompany.uuid,
                                name: userInitData.currentCompany.name,
                                dc: ENV_CFG.dc || null
                            },
                            token: tokenAuthService.getAccessToken()
                        };
                    }

                    function playNotificationSoundForHiddenTab() {
                        if (document.visibilityState === 'visible') return;

                        playNotificationSound();
                    }

                    function playNotificationSound() {
                        notificationSound.play();
                    }

                    init();
                }]
        });
})();
;
(function () {
    'use strict';

    angular
        .module('seven-admin.zodiac')
        .directive('scrollToBottom', scrollToBottom);

    function scrollToBottom (
        $timeout
    ) {
        return {
            scope: {
                scrollToBottom: "="
            },
            restrict: 'A',
            link: function (scope, element) {
                scope.$watchCollection('scrollToBottom', function (newVal) {
                    if (newVal) {
                        $timeout(function() {
                            element[0].scrollTop =  element[0].scrollHeight;
                        }, 0);
                    }
                });
            }
        }
    }
})();;
(function () {
    'use strict';

    angular
        .module('seven-admin.zodiac')
        .service('zodiacHttpService', zodiacHttpService);

    zodiacHttpService.$inject = ['$http', 'ENV_CFG', 'userInitData', 'appSettingsSvc'];

    function zodiacHttpService($http, ENV_CFG, userInitData, appSettingsSvc) {

        var userId = userInitData.user.uuid,
            headers = {};

        if (ENV_CFG.dc) {
            headers['X-Nsft-SCD-DC'] = ENV_CFG.dc;
        }

        return {
            getOnlineAdministrators: function () {
                return $http({
                    url: appSettingsSvc.urls.zodiac + '/administrators/online',
                    method: 'GET',
                    ignoreLoader: '!yes',
                    headers: headers
                }).then(function (response) {
                    return (_.filter(response.data.administrators, function(admin) {
                        return admin.id !== userId;
                    }));
                });
            },

            getGroupOnlineAdministrators: function (groupId) {
                return $http({
                   url: appSettingsSvc.urls.zodiac + '/administrators/groups/' + groupId + '/online',
                    method: 'GET',
                    ignoreLoader: '!yes',
                    headers,
                    params: {
                       excludeSelf: true
                    }
                }).then(function (response) {
                    return response.data.administrators
                });
            },

            getOnlineOperators: function () {
                return $http({
                    url: appSettingsSvc.urls.zodiac + '/operators/online',
                    method: 'GET',
                    ignoreLoader: '!yes',
                    headers: headers
                }).then(function (response) {
                    return response.data;
                });
            },

            getOwnConversations: function () {
                return $http({
                    url: appSettingsSvc.urls.zodiac + '/user/conversations',
                    method: 'GET',
                    ignoreLoader: '!yes',
                    headers: headers
                }).then(function (response) {
                    return response.data;
                });
            },

            getOnlineConversationUsers: function (conversationId) {
                return $http({
                    url: appSettingsSvc.urls.zodiac + '/conversations/' + conversationId + '/users',
                    method: 'GET',
                    ignoreLoader: '!yes',
                    headers: headers
                }).then(function (response) {
                    return response.data.users;
                });
            },

            getConversation: function (conversationId) {
                return $http({
                    url: appSettingsSvc.urls.zodiac + '/conversations/' + conversationId,
                    method: 'GET',
                    ignoreLoader: '!yes',
                    headers: headers
                }).then(function (response) {
                    return response.data;
                });
            },

            getChatHistory: function (conversationId, params) {
                return $http({
                    url: appSettingsSvc.urls.zodiac + '/conversations/' + conversationId + '/history',
                    method: 'GET',
                    params: params,
                    ignoreLoader: '!yes',
                    headers: headers
                }).then(function (response) {
                    return response.data.history;
                });
            }
        }
    }
})();
;
(function () {
    'use strict';

    angular
        .module('seven-admin.zodiac')
        .service('zodiacSocketConnection', zodiacSocketConnection);

    zodiacSocketConnection.$inject = ['$rootScope'];

    function zodiacSocketConnection($rootScope) {
        var socket = null;

        function emit(eventName, data, callback) {
            socket.emit(eventName, data, function () {
                var args = arguments;

                $rootScope.$evalAsync(function () {
                    if (callback) {
                        callback.apply(socket, args);
                    }
                });
            })
        }

        return {
            isConnected: function () {
                return !!(socket && socket.connected)
            },
            connect: function (url, data, callback) {
                if (socket && socket.connected) {
                    return socket;
                } else if (socket && !socket.connected) {
                    socket.connect()
                } else {
                    socket = io.connect(url, {
                        query: {
                            data: JSON.stringify(data)
                        },
                        'sync disconnect on unload': true
                    });
                }

                if (callback) callback();

                return socket;
            },
            disconnect: function () {
                if (!socket) return;

                return socket.disconnect();
            },

            on: function (eventName, callback) {
                socket.emit('subscribe', eventName);

                socket.on(eventName, function () {
                    var args = arguments;

                    $rootScope.$evalAsync(function () {
                        callback.apply(socket, args);
                    });
                });
            },

            joinConversation: function(conversationId, addedByUserId) {
                emit('JoinConversation', {
                    conversation: {
                        id: conversationId
                    },
                    addedByUser: {
                        id: addedByUserId
                    }
                });
            },

            rejoinConversation: function(conversationId, addedByUserId) {
                emit('RejoinConversation', {
                    conversation: {
                        id: conversationId
                    },
                    addedByUser: {
                        id: addedByUserId
                    }
                });
            },

            leaveConversation: function (conversationId) {
                emit('LeaveConversation', {
                    conversation: {
                        id: conversationId
                    }
                });
            },

            sendMessage: function (conversationId, message) {
                emit('SendMessage', {
                    conversation: {
                        id: conversationId
                    },
                    message: message
                });
            },

            addUserToConversation: function(conversation, userId) {
                emit('InviteUser', {
                    conversation: {
                        id: conversation.id
                    },
                    user: {
                        id: userId
                    }
                });
            },

            sendTypingIndicator: function (conversationId, user) {
                emit('UserTyped', {
                    conversation: {
                        id: conversationId
                    },
                    user: {
                        id: user.id,
                        user: user.name
                    }
                });
            },

            changeOnlineStatus(status) {
                emit('ChangeOnlineStatus', status)
            }
        }
    }
})();
;
(function () {
    'use strict';

    angular
        .module('seven-admin.zodiac')
        .service('zodiacService', zodiacService);

    zodiacService.$inject = ['$rootScope', '$timeout', '$translate', '$q', 'zodiacHttpService'];

    function zodiacService($rootScope, $timeout, $translate, $q, zodiacHttpService) {
        this.chatWindow = {
            open: false,
            userOnline: false,
            selectedConversation: null,
            totalUnread: false,
            conversations: {},
            assistanceRequests: [],
            typingIndicator: {
                users: {},
                message: ''
            }
        };

        this.setChatConversation = function (config, openWindow) {
            var conversations = this.chatWindow.conversations,
                conversationId = config.conversation.id,
                self = this;

            if (openWindow) {
                this.chatWindow.open = true;
            }

            $q.when(self.createNewConversation(config)).then(function () {
                self.selectConversation(conversationId);
                conversations[conversationId].unread = false;
            })
        };

        this.createNewConversation = function (config) {
            var conversation = config.conversation,
                conversations = this.chatWindow.conversations,
                conversationName = conversation.betshopName,
                group = conversation.group;
            
            if (conversations[conversation.id]) {
                return false;
            }

            if (group) {
                var groupName = group.id === 'ALL' ? $translate.instant('general.all') : group.name;

                conversationName += (' | ' + groupName)
            }

            this.chatWindow.conversations[conversation.id] = {
                id: conversation.id,
                operator: conversation.operatorName,
                betshop: conversation.betshopName,
                name: conversationName,
                group: group,
                unread: true,
                events: [],
                users: [],
                active: conversation.active
            };

            this.addConversationEvent(conversation.id, {
                type: 'info',
                icon: 'n-i-info',
                content: $translate.instant('chat.all_messages_recorded')
            }, config.alreadyRead);

            return this.setChatHistory(conversation.id, config.alreadyRead);
        };

        this.setChatHistory = function (conversationId, alreadyRead) {
            var self = this;
            return zodiacHttpService.getChatHistory(conversationId, {orderBy: 'asc'}).then(function (history) {
                if (!history || !history.length) return false;

                angular.forEach(history, function (message) {
                    self.addConversationEvent(conversationId, {
                        type: 'message',
                        content: message.content,
                        timestamp: message.timestamp,
                        user: {
                            name: message.userName + ' (' + $translate.instant('chat.user_type_' + message.type) + ')',
                            id: message.userId
                        }
                    }, alreadyRead);
                });
            });
        }

        this.setConversationUserList = function (conversationId, conversationUsers) {
            this.chatWindow.conversations[conversationId].users = conversationUsers;
        };

        this.startConversation = function (config) {
            $rootScope.$broadcast('GravityConversationStarted', {
                conversationId: config.id
            });
        };

        this.closeChatWindow = function () {
            this.chatWindow.open = false;
        };

        this.toggleChatWindow = function () {
            this.chatWindow.open = !this.chatWindow.open;

            if (this.chatWindow.open) {
                this.chatWindow.totalUnread = false;
            }
        };

        this.selectConversation = function (conversationId, resetUnreadCount) {
            this.chatWindow.selectedConversation = conversationId;

            if (resetUnreadCount) {
                this.chatWindow.conversations[conversationId].unread = false;
            }
        };

        this.closeConversation = function (conversationId) {
            delete this.chatWindow.conversations[conversationId];

            if (this.chatWindow.selectedConversation === conversationId) {
                this.chatWindow.selectedConversation = null;
            }
        };

        this.disableConversation = function (conversationId) {
            this.chatWindow.conversations[conversationId].active = false;
        };

        this.enableConversation = function (conversationId) {
            this.chatWindow.conversations[conversationId].active = true;
        };

        this.handleMessageEvent = function (data) {
            this.addConversationEvent(data.conversation.id, {
                type: 'message',
                content: data.message.content,
                timestamp: data.timestamp,
                user: {
                    name: data.user.name + ' (' + $translate.instant('chat.user_type_' + data.user.type) + ')',
                    id: data.user.id
                }
            });
        };

        this.handleUserAddEvent = function (data) {
            var conversationId = data.conversation.id;

            this.addOnlineConversationUser(conversationId, data.user);
            this.addConversationEvent(conversationId, {
                type: 'info',
                icon: 'n-i-new-user',
                subject: data.user.name,
                content: $translate.instant('chat.joined_conversation')
            });
        };

        this.handleUserLeaveEvent = function (data) {
            this.removeOnlineConversationUser(data.conversation.id, data.user);
            this.addConversationEvent(data.conversation.id, {
                type: 'info',
                icon: 'n-i-logout',
                subject: data.user.name,
                content: $translate.instant('chat.left_conversation')
            });
        };

        this.addConversationEvent = function (conversationId, eventData, alreadyRead) {
            if (!this.chatWindow.conversations[conversationId]) return;

            this.chatWindow.conversations[conversationId].events.push(eventData);

            if (!alreadyRead && (conversationId !== this.chatWindow.selectedConversation || !this.chatWindow.open)) {
                this.chatWindow.conversations[conversationId].unread = true;
                this.setTotalUnread();
            }
        };

        this.setConversationAsRead = function (conversationId) {
            this.chatWindow.conversations[conversationId].unread = false;
        };

        this.handleNewAssistanceRequest = function (data) {
            var conversationId = data.conversation.id,
                conversation = this.chatWindow.conversations[conversationId];

            if (conversation) {
                conversation.unread = true;

                this.addConversationEvent(conversationId, {
                    type: 'info',
                    icon: 'n-i-status-b',
                    subject: data.conversation.operatorName,
                    content: $translate.instant('chat.assistance_requested')
                });

                return;
            }

            // Prevent conversation duplication
            if (!_.isEmpty(_.find(this.chatWindow.assistanceRequests, { id: conversationId }))) {
                return;
            }

            this.setTotalUnread();

            this.chatWindow.assistanceRequests.push({
                id: conversationId,
                operatorName: data.conversation.operatorName
            });
        };

        this.removeOnlineConversationUser = function (conversationId, user) {
            var userIndex = this.chatWindow.conversations[conversationId].users.indexOf(user.id);

            if (userIndex !== -1) {
                this.chatWindow.conversations[conversationId].users.splice(userIndex, 1);
            }
        };

        this.addOnlineConversationUser = function (conversationId, user) {
            if (this.chatWindow.conversations[conversationId].users.indexOf(user.id) !== -1) {
                this.chatWindow.conversations[conversationId].users.push(user);
            }
        };

        this.handleTypingIndicator = function (conversationId, user) {
            if (this.chatWindow.selectedConversation !== conversationId) return;

            if (this.chatWindow.typingIndicator.users[user.id]) {
                clearTimeout(this.chatWindow.typingIndicator.users[user.id].timeout);
            }

            this.chatWindow.typingIndicator.users[user.id] = {
                name: user.name,
                timeout: setTimeout(function() {
                    delete this.chatWindow.typingIndicator.users[user.id];
                    this.handleTypingMessage();
                }.bind(this), 1600)
            };

            this.handleTypingMessage();
        };

        this.handleTypingMessage = function() {
            var typingIndicator = this.chatWindow.typingIndicator;
            var typingUsers = _.values(_.mapValues(typingIndicator.users, 'name'));

            switch(typingUsers.length) {
                case 0:
                    typingIndicator.message = null;
                    break;
                case 1:
                    typingIndicator.message = typingUsers[0] + ' ' + $translate.instant('chat.is_typing');
                    break;
                case 2:
                    typingIndicator.message = typingUsers.join(', ') + ' ' + $translate.instant('chat.are_typing');
                    break;
                default:
                    typingIndicator.message = $translate.instant('chat.multiple_users_typing');
            }

            $timeout(0);
        };

        this.acceptAssistanceRequest = function (data, index) {
            this.setChatConversation(data);
            this.closeAssistanceRequest(index);
        };

        this.closeAssistanceRequest = function (requestIndex) {
            this.chatWindow.assistanceRequests.splice(requestIndex, 1);
        };

        this.setUserOffline = function () {
            this.chatWindow.userOnline = false;
        };

        this.setTotalUnread = function () {
            if (!this.chatWindow.open) {
                this.chatWindow.totalUnread = true;
            }
        };

        this.setConversation = function (conversationId) {
            var self = this;
            return zodiacHttpService.getConversation(conversationId)
                .then(function (conversation) {
                    self.createNewConversation({conversation: conversation});
                })
        }

        this.setConversations = function () {
            var self = this;

            return zodiacHttpService
                .getOwnConversations()
                .then(function (conversationData) {
                    conversationData.conversations.forEach(conversation => {
                        self.createNewConversation({conversation: conversation, alreadyRead: true});
                    })
                })
        }

        return this;
    }
})();
;
var sevenAdminCertifications = angular.module('seven-admin-certifications', [
]);

sevenAdminCertifications.config(['$stateProvider', function ($stateProvider) {

$stateProvider
    .state('certifications', {
        url: '/certifications',
        templateUrl: '/app/certifications/certifications.index.html',
        parent: 'main',
        controller: 'certificationsCtrl',
        resolve: {
            loadController: ['$ocLazyLoad', function($ocLazyLoad) {
                return $ocLazyLoad.load('[DIST_PATH]js/seven-admin-certifications.js')
            }]
        },
        data: {
            module: 'certifications'
        }
    })
    .state('certifications.list', {
        url: '/list',
        parentView: 'certifications.list',
        views: {
            '': {
                templateUrl: '/app/certifications/list/certificationList.html',
                controller: 'certificationListCtrl'
            }
        },
        resolve: {
            loadController: ['$ocLazyLoad', function($ocLazyLoad) {
                return $ocLazyLoad.load('[DIST_PATH]js/seven-admin-certifications.js')
            }]
        },
    })
}]);
;
(function(){
    angular
        .module('seven-admin.operations')
        .config(config);

    config.$inject = ['$stateProvider'];

    function config ($stateProvider) {
        $stateProvider
            .state('operations', {
                url: '/operations',
                templateUrl: '/app/operations/operations.index.html',
                parent: 'main',
                controller: 'OperationsController',
                resolve: {
                    loadController: ['$ocLazyLoad', function($ocLazyLoad) {
                        return $ocLazyLoad.load('[DIST_PATH]js/seven-admin.operations.js')
                    }]
                },
                data: {
                    module: 'operations'
                }
            })
            .state('operations.translations', {
                url: '/translations',
                parentView: 'operations.translations',
                views: {
                    '': {
                        templateUrl: '/app/operations/translations/translations.html',
                        controller: 'TranslationsController'
                    }
                },
                resolve: {
                    loadController: ['$ocLazyLoad', function($ocLazyLoad) {
                        return $ocLazyLoad.load('[DIST_PATH]js/seven-admin.operations.js')
                    }]
                }
            })
            .state('operations.ticketResolve', {
                url: '/ticket-resolve',
                parentView: 'operations.ticketResolve',
                redirectTo: 'operations.ticketResolve.resolve',
                views: {
                    '': {
                        templateUrl: '/app/operations/ticket-resolve/ticket-resolve.html',
                        controller: 'TicketResolveController'
                    }
                },
                resolve: {
                    loadController: ['$ocLazyLoad', function($ocLazyLoad) {
                        return $ocLazyLoad.load('[DIST_PATH]js/seven-admin.operations.js')
                    }]
                }
            })
            .state('operations.ticketResolve.resolve', {
                url: '/resolve',
                parentView: 'operations.ticketResolve',
                views: {
                    '': {
                        templateUrl: '/app/operations/ticket-resolve/resolve/resolve-action.html',
                        controller: 'TicketResolveActionController'
                    }
                },
                resolve: {
                    loadController: ['$ocLazyLoad', function($ocLazyLoad) {
                        return $ocLazyLoad.load('[DIST_PATH]js/seven-admin.operations.js')
                    }]
                }
            })
            .state('operations.ticketResolve.list', {
                url: '/list',
                parentView: 'operations.ticketResolve',
                views: {
                    '': {
                        templateUrl: '/app/operations/ticket-resolve/list/resolve-list.html',
                        controller: 'TicketResolveListController'
                    }
                },
                resolve: {
                    loadController: ['$ocLazyLoad', function($ocLazyLoad) {
                        return $ocLazyLoad.load('[DIST_PATH]js/seven-admin.operations.js')
                    }]
                }
            })
            .state('operations.ticketResolve.payoutCheck', {
                url: '/payout-check',
                parentView: 'operations.ticketResolve',
                views: {
                    '': {
                        templateUrl: '/app/operations/ticket-resolve/payout-check/payout-check.html',
                        controller: 'TicketResolvePayoutCheckController'
                    }
                },
                resolve: {
                    loadController: ['$ocLazyLoad', function($ocLazyLoad) {
                        return $ocLazyLoad.load('[DIST_PATH]js/seven-admin.operations.js')
                    }]
                }
            });
    }
}());
;
(function() {
    angular
        .module('seven-admin.tools', []);
}());
;
(function () {
    angular
        .module('seven-admin.tools')
        .config(config);

    config.$inject = ['$stateProvider'];

    function config($stateProvider) {
        $stateProvider
            .state('tools', {
                url: '/tools',
                template:
                    '<div><div class="main-content-header clearfix" data-content-header></div>' +
                    '<div class="main-content-body" data-ui-view=""></div></div>',
                parent: 'main',
                controller: 'ToolsController',
                data: {
                    module: 'tools'
                }
            })
            .state('tools.maintenance', {
                url: '/maintenance',
                parentView: 'tools.maintenance',
                views: {
                    '': {
                        templateUrl: '/app/tools/maintenance/maintenance.template.html',
                        controller: 'MaintenanceController',
                        controllerAs: 'model'
                    }
                },
                resolve: {
                    loadController: ['$ocLazyLoad', function($ocLazyLoad) {
                        return $ocLazyLoad.load('[DIST_PATH]js/seven-admin.tools.js')
                    }]
                }
            })
            .state('tools.notifications', {
                url: '/notifications?currentPage&pageSize',
                parentView: 'tools.notifications',
                reloadOnSearch: false,
                views: {
                    '': {
                        templateUrl: '/app/tools/notifications/notifications.template.html',
                        controller: 'NotificationsController',
                        controllerAs: 'vm'
                    }
                },
                resolve: {
                    loadController: ['$ocLazyLoad', function($ocLazyLoad) {
                        return $ocLazyLoad.load('[DIST_PATH]js/seven-admin.tools.js')
                    }]
                },
                params: {
                    currentPage: '1',
                    pageSize: '25'
                }

            })
            .state('tools.newNotification', {
                url: '/new-notification',
                parentView: 'tools.notifications',
                views: {
                    '': {
                        templateUrl: '/app/tools/notifications/new-notification.template.html',
                        controller: 'NewNotificationController',
                        controllerAs: 'vm'
                    }
                },
                resolve: {
                    loadController: ['$ocLazyLoad', function($ocLazyLoad) {
                        return $ocLazyLoad.load([
                            '[DIST_PATH]js/seven-admin.tools.js',
                            '[DIST_PATH]js/seven-admin-shopmgmt.js'
                        ])
                    }]
                }
            })
            .state('tools.tags', {
                url: '/tags',
                parentView: 'tools.tags',
                views: {
                    '': {
                        templateUrl: '/app/tools/tags/tags.template.html',
                        controller: 'TagsController',
                        controllerAs: 'vm'
                    }
                },
                resolve: {
                    loadController: ['$ocLazyLoad', function($ocLazyLoad) {
                        return $ocLazyLoad.load('[DIST_PATH]js/seven-admin.tools.js')
                    }]
                }
            })
            .state('tools.support', {
                url: '/support',
                parentView: 'tools.support',
                views: {
                    '': {
                        templateUrl: '/app/tools/support/support.template.html',
                        controller: 'SupportController',
                        controllerAs: 'model'
                    }
                },
                resolve: {
                    loadController: ['$ocLazyLoad', function($ocLazyLoad) {
                        return $ocLazyLoad.load('[DIST_PATH]js/seven-admin.tools.js')
                    }]
                }
            });
    }
}());
;
(function() {
  angular
      .module('seven-admin.audit', []);
}());
;
(function () {
  angular
      .module('seven-admin.audit')
      .config(config);

  config.$inject = ['$stateProvider'];

  function config($stateProvider) {
      $stateProvider
          .state('audit', {
              url: '/audit',
              template:
                  '<div><div class="main-content-header clearfix" data-content-header></div>' +
                  '<div class="main-content-body" data-ui-view=""></div></div>',
              parent: 'main',
              controller: 'AuditController',
              controllerAs: 'vm',
              data: {
                  module: 'audit'
              },
              resolve: {
                loadController: ['$ocLazyLoad', function($ocLazyLoad) {
                    return $ocLazyLoad.load('[DIST_PATH]js/seven-admin.audit.js')
                }]
            }
          })
          .state('audit.logs', {
              url: '/logs',
              parentView: 'audit.logs',
              views: {
                '': {
                    templateUrl: '/app/shared/integration/integration.template.html',
                    controller: 'IntegrationController',
                    controllerAs: 'vm'
                }
              },
              data: {
                widgetKey: 'Audit',
                breadcrumbs: [
                    {
                        name: 'menus.audit',
                        link: 'audit.logs'
                    },
                    {
                        name: 'menus.audit_logs',
                        link: 'audit.logs'
                    }
                ]
            }
          });
  }
}());
;
(function() {
    angular
        .module('ui.select.seven-decorator', [])
}());
;
(function() {
    angular
        .module("ui.select.seven-decorator")
        .config(config);

    config.$inject = ["$provide"];

    function config($provide) {
        $provide.decorator("uiSelectMatchDirective", uiSelectMatchDirectiveDecorator);

        uiSelectMatchDirectiveDecorator.$inject = ["$delegate"];

        function uiSelectMatchDirectiveDecorator($delegate) {
            $delegate[0].compile = function() {
                return function(scope, element, attrs, $select) {
                    $select.lockChoiceExpression = attrs.uiLockChoice;

                    attrs.$observe("placeholder", function(placeholder) {
                        $select.placeholder = placeholder !== undefined ? placeholder : uiSelectConfig.placeholder;
                    });

                    // $select.allowClear was only set once in original uiSelectMatch directive so it would't change if
                    // bound value changed
                    attrs.$observe("allowClear", function() {
                        $select.allowClear =
                            (angular.isDefined(attrs.allowClear)) ?
                                (attrs.allowClear === "") ?
                                    true :
                                    (attrs.allowClear.toLowerCase() === "true")
                                : false;
                    });

                    if ($select.multiple) {
                        $select.sizeSearchInput();
                    }
                };
            };

            delete $delegate[0].link;

            return $delegate;
        }
    }
}());

//# sourceMappingURL=app.js.map